"use strict";
var libmpvLoader = (() => {
    var _scriptName = typeof document != 'undefined' ? document.currentScript?.src : undefined;
    return (function (moduleArg = {}) {
        var moduleRtn;
        // include: shell.js
        // The Module object: Our interface to the outside world. We import
        // and export values on it. There are various ways Module can be used:
        // 1. Not defined. We create it here
        // 2. A function parameter, function(moduleArg) => Promise<Module>
        // 3. pre-run appended it, var Module = {}; ..generated code..
        // 4. External script tag defines var Module.
        // We need to check if Module already exists (e.g. case 3 above).
        // Substitution will be replaced with actual code on later stage of the build,
        // this way Closure Compiler will not mangle it (e.g. case 4. above).
        // Note that if you want to run closure, and also to use Module
        // after the generated code, you will need to define   var Module = {};
        // before the code. Then that object will be used in the code, and you
        // can continue to use Module afterwards as well.
        var Module = moduleArg;
        // Set up the promise that indicates the Module is initialized
        var readyPromiseResolve, readyPromiseReject;
        var readyPromise = new Promise((resolve, reject) => {
            readyPromiseResolve = resolve;
            readyPromiseReject = reject;
        });
        ["___indirect_function_table", "_ff_h264_cabac_tables", "___em_lib_deps_sdlaudio", "___em_lib_deps_sdlcamera", "___em_lib_deps_sdlmouse", "__emscripten_proxy_main", "_main", "onRuntimeInitialized"].forEach((prop) => {
            if (!Object.getOwnPropertyDescriptor(readyPromise, prop)) {
                Object.defineProperty(readyPromise, prop, {
                    get: () => abort('You are getting ' + prop + ' on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js'),
                    set: () => abort('You are setting ' + prop + ' on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js'),
                });
            }
        });
        // Determine the runtime environment we are in. You can customize this by
        // setting the ENVIRONMENT setting at compile time (see settings.js).
        // Attempt to auto-detect the environment
        var ENVIRONMENT_IS_WEB = typeof window == 'object';
        var ENVIRONMENT_IS_WORKER = typeof importScripts == 'function';
        // N.b. Electron.js environment is simultaneously a NODE-environment, but
        // also a web environment.
        var ENVIRONMENT_IS_NODE = typeof process == 'object' && typeof process.versions == 'object' && typeof process.versions.node == 'string';
        var ENVIRONMENT_IS_SHELL = !ENVIRONMENT_IS_WEB && !ENVIRONMENT_IS_NODE && !ENVIRONMENT_IS_WORKER;
        if (Module['ENVIRONMENT']) {
            throw new Error('Module.ENVIRONMENT has been deprecated. To force the environment, use the ENVIRONMENT compile-time option (for example, -sENVIRONMENT=web or -sENVIRONMENT=node)');
        }
        // Three configurations we can be running in:
        // 1) We could be the application main() thread running in the main JS UI thread. (ENVIRONMENT_IS_WORKER == false and ENVIRONMENT_IS_PTHREAD == false)
        // 2) We could be the application main() thread proxied to worker. (with Emscripten -sPROXY_TO_WORKER) (ENVIRONMENT_IS_WORKER == true, ENVIRONMENT_IS_PTHREAD == false)
        // 3) We could be an application pthread running in a worker. (ENVIRONMENT_IS_WORKER == true and ENVIRONMENT_IS_PTHREAD == true)
        // The way we signal to a worker that it is hosting a pthread is to construct
        // it with a specific name.
        var ENVIRONMENT_IS_PTHREAD = ENVIRONMENT_IS_WORKER && self.name == 'em-pthread';
        if (ENVIRONMENT_IS_PTHREAD) {
            assert(!globalThis.moduleLoaded, 'module should only be loaded once on each pthread worker');
            globalThis.moduleLoaded = true;
        }
        // --pre-jses are emitted after the Module integration code, so that they can
        // refer to Module (if they choose; they can also define Module)
        // include: /tmp/tmpmlyv_z6l.js
        if (!Module.expectedDataFileDownloads) {
            Module.expectedDataFileDownloads = 0;
        }
        Module.expectedDataFileDownloads++;
        (() => {
            // Do not attempt to redownload the virtual filesystem data when in a pthread or a Wasm Worker context.
            var isPthread = typeof ENVIRONMENT_IS_PTHREAD != 'undefined' && ENVIRONMENT_IS_PTHREAD;
            var isWasmWorker = typeof ENVIRONMENT_IS_WASM_WORKER != 'undefined' && ENVIRONMENT_IS_WASM_WORKER;
            if (isPthread || isWasmWorker)
                return;
            function loadPackage(metadata) {
                var PACKAGE_PATH = '';
                if (typeof window === 'object') {
                    PACKAGE_PATH = window['encodeURIComponent'](window.location.pathname.toString().substring(0, window.location.pathname.toString().lastIndexOf('/')) + '/');
                }
                else if (typeof process === 'undefined' && typeof location !== 'undefined') {
                    // web worker
                    PACKAGE_PATH = encodeURIComponent(location.pathname.toString().substring(0, location.pathname.toString().lastIndexOf('/')) + '/');
                }
                var PACKAGE_NAME = 'libmpv.data';
                var REMOTE_PACKAGE_BASE = 'libmpv.data';
                if (typeof Module['locateFilePackage'] === 'function' && !Module['locateFile']) {
                    Module['locateFile'] = Module['locateFilePackage'];
                    err('warning: you defined Module.locateFilePackage, that has been renamed to Module.locateFile (using your locateFilePackage for now)');
                }
                var REMOTE_PACKAGE_NAME = Module['locateFile'] ? Module['locateFile'](REMOTE_PACKAGE_BASE, '') : REMOTE_PACKAGE_BASE;
                var REMOTE_PACKAGE_SIZE = metadata['remote_package_size'];
                function fetchRemotePackage(packageName, packageSize, callback, errback) {
                    var xhr = new XMLHttpRequest();
                    xhr.open('GET', packageName, true);
                    xhr.responseType = 'arraybuffer';
                    xhr.onprogress = function (event) {
                        var url = packageName;
                        var size = packageSize;
                        if (event.total)
                            size = event.total;
                        if (event.loaded) {
                            if (!xhr.addedTotal) {
                                xhr.addedTotal = true;
                                if (!Module.dataFileDownloads)
                                    Module.dataFileDownloads = {};
                                Module.dataFileDownloads[url] = {
                                    loaded: event.loaded,
                                    total: size
                                };
                            }
                            else {
                                Module.dataFileDownloads[url].loaded = event.loaded;
                            }
                            var total = 0;
                            var loaded = 0;
                            var num = 0;
                            for (var download in Module.dataFileDownloads) {
                                var data = Module.dataFileDownloads[download];
                                total += data.total;
                                loaded += data.loaded;
                                num++;
                            }
                            total = Math.ceil(total * Module.expectedDataFileDownloads / num);
                            Module['setStatus']?.(`Downloading data... (${loaded}/${total})`);
                        }
                        else if (!Module.dataFileDownloads) {
                            Module['setStatus']?.('Downloading data...');
                        }
                    };
                    xhr.onerror = function (event) {
                        throw new Error("NetworkError for: " + packageName);
                    };
                    xhr.onload = function (event) {
                        if (xhr.status == 200 || xhr.status == 304 || xhr.status == 206 || (xhr.status == 0 && xhr.response)) { // file URLs can return 0
                            var packageData = xhr.response;
                            callback(packageData);
                        }
                        else {
                            throw new Error(xhr.statusText + " : " + xhr.responseURL);
                        }
                    };
                    xhr.send(null);
                }
                ;
                function handleError(error) {
                    console.error('package error:', error);
                }
                ;
                var fetchedCallback = null;
                var fetched = Module['getPreloadedPackage'] ? Module['getPreloadedPackage'](REMOTE_PACKAGE_NAME, REMOTE_PACKAGE_SIZE) : null;
                if (!fetched)
                    fetchRemotePackage(REMOTE_PACKAGE_NAME, REMOTE_PACKAGE_SIZE, function (data) {
                        if (fetchedCallback) {
                            fetchedCallback(data);
                            fetchedCallback = null;
                        }
                        else {
                            fetched = data;
                        }
                    }, handleError);
                function runWithFS(Module) {
                    function assert(check, msg) {
                        if (!check)
                            throw msg + new Error().stack;
                    }
                    Module['FS_createPath']("/", "shaders", true, true);
                    /** @constructor */
                    function DataRequest(start, end, audio) {
                        this.start = start;
                        this.end = end;
                        this.audio = audio;
                    }
                    DataRequest.prototype = {
                        requests: {},
                        open: function (mode, name) {
                            this.name = name;
                            this.requests[name] = this;
                            Module['addRunDependency'](`fp ${this.name}`);
                        },
                        send: function () { },
                        onload: function () {
                            var byteArray = this.byteArray.subarray(this.start, this.end);
                            this.finish(byteArray);
                        },
                        finish: function (byteArray) {
                            var that = this;
                            // canOwn this data in the filesystem, it is a slide into the heap that will never change
                            Module['FS_createDataFile'](this.name, null, byteArray, true, true, true);
                            Module['removeRunDependency'](`fp ${that.name}`);
                            this.requests[this.name] = null;
                        }
                    };
                    var files = metadata['files'];
                    for (var i = 0; i < files.length; ++i) {
                        new DataRequest(files[i]['start'], files[i]['end'], files[i]['audio'] || 0).open('GET', files[i]['filename']);
                    }
                    function processPackageData(arrayBuffer) {
                        assert(arrayBuffer, 'Loading data file failed.');
                        assert(arrayBuffer.constructor.name === ArrayBuffer.name, 'bad input to processPackageData');
                        var byteArray = new Uint8Array(arrayBuffer);
                        var curr;
                        // Reuse the bytearray from the XHR as the source for file reads.
                        DataRequest.prototype.byteArray = byteArray;
                        var files = metadata['files'];
                        for (var i = 0; i < files.length; ++i) {
                            DataRequest.prototype.requests[files[i].filename].onload();
                        }
                        Module['removeRunDependency']('datafile_libmpv.data');
                    }
                    ;
                    Module['addRunDependency']('datafile_libmpv.data');
                    if (!Module.preloadResults)
                        Module.preloadResults = {};
                    Module.preloadResults[PACKAGE_NAME] = { fromCache: false };
                    if (fetched) {
                        processPackageData(fetched);
                        fetched = null;
                    }
                    else {
                        fetchedCallback = processPackageData;
                    }
                }
                if (Module['calledRun']) {
                    runWithFS(Module);
                }
                else {
                    if (!Module['preRun'])
                        Module['preRun'] = [];
                    Module["preRun"].push(runWithFS); // FS is not initialized yet, wait for it
                }
            }
            loadPackage({ "files": [{ "filename": "/shaders/.keep", "start": 0, "end": 0 }, { "filename": "/shaders/Anime4K_AutoDownscalePre_x2.glsl", "start": 0, "end": 1596 }, { "filename": "/shaders/Anime4K_AutoDownscalePre_x4.glsl", "start": 1596, "end": 3200 }, { "filename": "/shaders/Anime4K_Clamp_Highlights.glsl", "start": 3200, "end": 6084 }, { "filename": "/shaders/Anime4K_Darken_Fast.glsl", "start": 6084, "end": 12678 }, { "filename": "/shaders/Anime4K_Darken_HQ.glsl", "start": 12678, "end": 18857 }, { "filename": "/shaders/Anime4K_Darken_VeryFast.glsl", "start": 18857, "end": 25517 }, { "filename": "/shaders/Anime4K_Deblur_DoG.glsl", "start": 25517, "end": 30222 }, { "filename": "/shaders/Anime4K_Deblur_Original.glsl", "start": 30222, "end": 36917 }, { "filename": "/shaders/Anime4K_Denoise_Bilateral_Mean.glsl", "start": 36917, "end": 39765 }, { "filename": "/shaders/Anime4K_Denoise_Bilateral_Median.glsl", "start": 39765, "end": 44105 }, { "filename": "/shaders/Anime4K_Denoise_Bilateral_Mode.glsl", "start": 44105, "end": 48028 }, { "filename": "/shaders/Anime4K_Restore_CNN_L.glsl", "start": 48028, "end": 117949 }, { "filename": "/shaders/Anime4K_Restore_CNN_M.glsl", "start": 117949, "end": 153865 }, { "filename": "/shaders/Anime4K_Restore_CNN_S.glsl", "start": 153865, "end": 171001 }, { "filename": "/shaders/Anime4K_Restore_CNN_Soft_L.glsl", "start": 171001, "end": 241021 }, { "filename": "/shaders/Anime4K_Restore_CNN_Soft_M.glsl", "start": 241021, "end": 277037 }, { "filename": "/shaders/Anime4K_Restore_CNN_Soft_S.glsl", "start": 277037, "end": 294235 }, { "filename": "/shaders/Anime4K_Restore_CNN_Soft_UL.glsl", "start": 294235, "end": 603108 }, { "filename": "/shaders/Anime4K_Restore_CNN_Soft_VL.glsl", "start": 603108, "end": 747312 }, { "filename": "/shaders/Anime4K_Restore_CNN_UL.glsl", "start": 747312, "end": 1055972 }, { "filename": "/shaders/Anime4K_Restore_CNN_VL.glsl", "start": 1055972, "end": 1200047 }, { "filename": "/shaders/Anime4K_Thin_Fast.glsl", "start": 1200047, "end": 1206529 }, { "filename": "/shaders/Anime4K_Thin_HQ.glsl", "start": 1206529, "end": 1212713 }, { "filename": "/shaders/Anime4K_Thin_VeryFast.glsl", "start": 1212713, "end": 1219284 }, { "filename": "/shaders/Anime4K_Upscale_CNN_x2_L.glsl", "start": 1219284, "end": 1292727 }, { "filename": "/shaders/Anime4K_Upscale_CNN_x2_M.glsl", "start": 1292727, "end": 1330412 }, { "filename": "/shaders/Anime4K_Upscale_CNN_x2_S.glsl", "start": 1330412, "end": 1349050 }, { "filename": "/shaders/Anime4K_Upscale_CNN_x2_UL.glsl", "start": 1349050, "end": 1639307 }, { "filename": "/shaders/Anime4K_Upscale_CNN_x2_VL.glsl", "start": 1639307, "end": 1786050 }, { "filename": "/shaders/Anime4K_Upscale_DTD_x2.glsl", "start": 1786050, "end": 1802113 }, { "filename": "/shaders/Anime4K_Upscale_Deblur_DoG_x2.glsl", "start": 1802113, "end": 1807101 }, { "filename": "/shaders/Anime4K_Upscale_Deblur_Original_x2.glsl", "start": 1807101, "end": 1813691 }, { "filename": "/shaders/Anime4K_Upscale_Denoise_CNN_x2_L.glsl", "start": 1813691, "end": 1887275 }, { "filename": "/shaders/Anime4K_Upscale_Denoise_CNN_x2_M.glsl", "start": 1887275, "end": 1924989 }, { "filename": "/shaders/Anime4K_Upscale_Denoise_CNN_x2_S.glsl", "start": 1924989, "end": 1943656 }, { "filename": "/shaders/Anime4K_Upscale_Denoise_CNN_x2_UL.glsl", "start": 1943656, "end": 2233696 }, { "filename": "/shaders/Anime4K_Upscale_Denoise_CNN_x2_VL.glsl", "start": 2233696, "end": 2380507 }, { "filename": "/shaders/Anime4K_Upscale_DoG_x2.glsl", "start": 2380507, "end": 2384666 }, { "filename": "/shaders/Anime4K_Upscale_Original_x2.glsl", "start": 2384666, "end": 2391214 }], "remote_package_size": 2391214 });
        })();
        // end include: /tmp/tmpmlyv_z6l.js
        // include: /tmp/tmpk0d_v32p.js
        // All the pre-js content up to here must remain later on, we need to run
        // it.
        if (Module['$ww'] || (typeof ENVIRONMENT_IS_PTHREAD != 'undefined' && ENVIRONMENT_IS_PTHREAD))
            Module['preRun'] = [];
        var necessaryPreJSTasks = Module['preRun'].slice();
        // end include: /tmp/tmpk0d_v32p.js
        // include: /tmp/tmp8f3b19g7.js
        if (!Module['preRun'])
            throw 'Module.preRun should exist because file support used it; did a pre-js delete it?';
        necessaryPreJSTasks.forEach((task) => {
            if (Module['preRun'].indexOf(task) < 0)
                throw 'All preRun tasks that exist before user pre-js code should remain after; did you replace Module or modify Module.preRun?';
        });
        // end include: /tmp/tmp8f3b19g7.js
        // Sometimes an existing Module object exists with properties
        // meant to overwrite the default module functionality. Here
        // we collect those properties and reapply _after_ we configure
        // the current environment's defaults to avoid having to be so
        // defensive during initialization.
        var moduleOverrides = Object.assign({}, Module);
        var arguments_ = [];
        var thisProgram = './this.program';
        var quit_ = (status, toThrow) => {
            throw toThrow;
        };
        // `/` should be present at the end if `scriptDirectory` is not empty
        var scriptDirectory = '';
        function locateFile(path) {
            if (Module['locateFile']) {
                return Module['locateFile'](path, scriptDirectory);
            }
            return scriptDirectory + path;
        }
        // Hooks that are implemented differently in different runtime environments.
        var readAsync, readBinary;
        if (ENVIRONMENT_IS_SHELL) {
            if ((typeof process == 'object' && typeof require === 'function') || typeof window == 'object' || typeof importScripts == 'function')
                throw new Error('not compiled for this environment (did you build to HTML and try to run it not on the web, or set ENVIRONMENT to something - like node - and run it someplace else - like on the web?)');
        }
        else 
        // Note that this includes Node.js workers when relevant (pthreads is enabled).
        // Node.js workers are detected as a combination of ENVIRONMENT_IS_WORKER and
        // ENVIRONMENT_IS_NODE.
        if (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER) {
            if (ENVIRONMENT_IS_WORKER) { // Check worker, not web, since window could be polyfilled
                scriptDirectory = self.location.href;
            }
            else if (typeof document != 'undefined' && document.currentScript) { // web
                scriptDirectory = document.currentScript.src;
            }
            // When MODULARIZE, this JS may be executed later, after document.currentScript
            // is gone, so we saved it, and we use it here instead of any other info.
            if (_scriptName) {
                scriptDirectory = _scriptName;
            }
            // blob urls look like blob:http://site.com/etc/etc and we cannot infer anything from them.
            // otherwise, slice off the final part of the url to find the script directory.
            // if scriptDirectory does not contain a slash, lastIndexOf will return -1,
            // and scriptDirectory will correctly be replaced with an empty string.
            // If scriptDirectory contains a query (starting with ?) or a fragment (starting with #),
            // they are removed because they could contain a slash.
            if (scriptDirectory.startsWith('blob:')) {
                scriptDirectory = '';
            }
            else {
                scriptDirectory = scriptDirectory.substr(0, scriptDirectory.replace(/[?#].*/, '').lastIndexOf('/') + 1);
            }
            if (!(typeof window == 'object' || typeof importScripts == 'function'))
                throw new Error('not compiled for this environment (did you build to HTML and try to run it not on the web, or set ENVIRONMENT to something - like node - and run it someplace else - like on the web?)');
            {
                // include: web_or_worker_shell_read.js
                if (ENVIRONMENT_IS_WORKER) {
                    readBinary = (url) => {
                        var xhr = new XMLHttpRequest();
                        xhr.open('GET', url, false);
                        xhr.responseType = 'arraybuffer';
                        xhr.send(null);
                        return new Uint8Array(/** @type{!ArrayBuffer} */ (xhr.response));
                    };
                }
                readAsync = (url) => {
                    assert(!isFileURI(url), "readAsync does not work with file:// URLs");
                    return fetch(url, { credentials: 'same-origin' })
                        .then((response) => {
                        if (response.ok) {
                            return response.arrayBuffer();
                        }
                        return Promise.reject(new Error(response.status + ' : ' + response.url));
                    });
                };
                // end include: web_or_worker_shell_read.js
            }
        }
        else {
            throw new Error('environment detection error');
        }
        var out = Module['print'] || console.log.bind(console);
        var err = Module['printErr'] || console.error.bind(console);
        // Merge back in the overrides
        Object.assign(Module, moduleOverrides);
        // Free the object hierarchy contained in the overrides, this lets the GC
        // reclaim data used.
        moduleOverrides = null;
        checkIncomingModuleAPI();
        // Emit code to handle expected values on the Module object. This applies Module.x
        // to the proper local x. This has two benefits: first, we only emit it if it is
        // expected to arrive, and second, by using a local everywhere else that can be
        // minified.
        if (Module['arguments'])
            arguments_ = Module['arguments'];
        legacyModuleProp('arguments', 'arguments_');
        if (Module['thisProgram'])
            thisProgram = Module['thisProgram'];
        legacyModuleProp('thisProgram', 'thisProgram');
        if (Module['quit'])
            quit_ = Module['quit'];
        legacyModuleProp('quit', 'quit_');
        // perform assertions in shell.js after we set up out() and err(), as otherwise if an assertion fails it cannot print the message
        // Assertions on removed incoming Module JS APIs.
        assert(typeof Module['memoryInitializerPrefixURL'] == 'undefined', 'Module.memoryInitializerPrefixURL option was removed, use Module.locateFile instead');
        assert(typeof Module['pthreadMainPrefixURL'] == 'undefined', 'Module.pthreadMainPrefixURL option was removed, use Module.locateFile instead');
        assert(typeof Module['cdInitializerPrefixURL'] == 'undefined', 'Module.cdInitializerPrefixURL option was removed, use Module.locateFile instead');
        assert(typeof Module['filePackagePrefixURL'] == 'undefined', 'Module.filePackagePrefixURL option was removed, use Module.locateFile instead');
        assert(typeof Module['read'] == 'undefined', 'Module.read option was removed');
        assert(typeof Module['readAsync'] == 'undefined', 'Module.readAsync option was removed (modify readAsync in JS)');
        assert(typeof Module['readBinary'] == 'undefined', 'Module.readBinary option was removed (modify readBinary in JS)');
        assert(typeof Module['setWindowTitle'] == 'undefined', 'Module.setWindowTitle option was removed (modify emscripten_set_window_title in JS)');
        assert(typeof Module['TOTAL_MEMORY'] == 'undefined', 'Module.TOTAL_MEMORY has been renamed Module.INITIAL_MEMORY');
        legacyModuleProp('asm', 'wasmExports');
        legacyModuleProp('readAsync', 'readAsync');
        legacyModuleProp('readBinary', 'readBinary');
        legacyModuleProp('setWindowTitle', 'setWindowTitle');
        var IDBFS = 'IDBFS is no longer included by default; build with -lidbfs.js';
        var PROXYFS = 'PROXYFS is no longer included by default; build with -lproxyfs.js';
        var WORKERFS = 'WORKERFS is no longer included by default; build with -lworkerfs.js';
        var FETCHFS = 'FETCHFS is no longer included by default; build with -lfetchfs.js';
        var ICASEFS = 'ICASEFS is no longer included by default; build with -licasefs.js';
        var JSFILEFS = 'JSFILEFS is no longer included by default; build with -ljsfilefs.js';
        var OPFS = 'OPFS is no longer included by default; build with -lopfs.js';
        var NODEFS = 'NODEFS is no longer included by default; build with -lnodefs.js';
        assert(ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER || ENVIRONMENT_IS_NODE, 'Pthreads do not work in this environment yet (need Web Workers, or an alternative to them)');
        assert(!ENVIRONMENT_IS_NODE, 'node environment detected but not enabled at build time.  Add `node` to `-sENVIRONMENT` to enable.');
        assert(!ENVIRONMENT_IS_SHELL, 'shell environment detected but not enabled at build time.  Add `shell` to `-sENVIRONMENT` to enable.');
        // end include: shell.js
        // include: preamble.js
        // === Preamble library stuff ===
        // Documentation for the public APIs defined in this file must be updated in:
        //    site/source/docs/api_reference/preamble.js.rst
        // A prebuilt local version of the documentation is available at:
        //    site/build/text/docs/api_reference/preamble.js.txt
        // You can also build docs locally as HTML or other formats in site/
        // An online HTML version (which may be of a different version of Emscripten)
        //    is up at http://kripken.github.io/emscripten-site/docs/api_reference/preamble.js.html
        // include: runtime_pthread.js
        // Pthread Web Worker handling code.
        // This code runs only on pthread web workers and handles pthread setup
        // and communication with the main thread via postMessage.
        // Unique ID of the current pthread worker (zero on non-pthread-workers
        // including the main thread).
        var workerID = 0;
        if (ENVIRONMENT_IS_PTHREAD) {
            var wasmPromiseResolve;
            var wasmPromiseReject;
            var receivedWasmModule;
            // Thread-local guard variable for one-time init of the JS state
            var initializedJS = false;
            function threadPrintErr(...args) {
                var text = args.join(' ');
                console.error(text);
            }
            if (!Module['printErr'])
                err = threadPrintErr;
            dbg = threadPrintErr;
            function threadAlert(...args) {
                var text = args.join(' ');
                postMessage({ cmd: 'alert', text, threadId: _pthread_self() });
            }
            self.alert = threadAlert;
            Module['instantiateWasm'] = (info, receiveInstance) => {
                return new Promise((resolve, reject) => {
                    wasmPromiseResolve = (module) => {
                        // Instantiate from the module posted from the main thread.
                        // We can just use sync instantiation in the worker.
                        var instance = new WebAssembly.Instance(module, getWasmImports());
                        // TODO: Due to Closure regression https://github.com/google/closure-compiler/issues/3193,
                        // the above line no longer optimizes out down to the following line.
                        // When the regression is fixed, we can remove this if/else.
                        receiveInstance(instance);
                        resolve();
                    };
                    wasmPromiseReject = reject;
                });
            };
            // Turn unhandled rejected promises into errors so that the main thread will be
            // notified about them.
            self.onunhandledrejection = (e) => { throw e.reason || e; };
            function handleMessage(e) {
                try {
                    var msgData = e['data'];
                    //dbg('msgData: ' + Object.keys(msgData));
                    var cmd = msgData['cmd'];
                    if (cmd === 'load') { // Preload command that is called once per worker to parse and load the Emscripten code.
                        workerID = msgData['workerID'];
                        // Until we initialize the runtime, queue up any further incoming messages.
                        let messageQueue = [];
                        self.onmessage = (e) => messageQueue.push(e);
                        // And add a callback for when the runtime is initialized.
                        self.startWorker = (instance) => {
                            // Notify the main thread that this thread has loaded.
                            postMessage({ 'cmd': 'loaded' });
                            // Process any messages that were queued before the thread was ready.
                            for (let msg of messageQueue) {
                                handleMessage(msg);
                            }
                            // Restore the real message handler.
                            self.onmessage = handleMessage;
                        };
                        // Use `const` here to ensure that the variable is scoped only to
                        // that iteration, allowing safe reference from a closure.
                        for (const handler of msgData['handlers']) {
                            // The the main module has a handler for a certain even, but no
                            // handler exists on the pthread worker, then proxy that handler
                            // back to the main thread.
                            if (!Module[handler] || Module[handler].proxy) {
                                Module[handler] = (...args) => {
                                    postMessage({ cmd: 'callHandler', handler, args: args });
                                };
                                // Rebind the out / err handlers if needed
                                if (handler == 'print')
                                    out = Module[handler];
                                if (handler == 'printErr')
                                    err = Module[handler];
                            }
                        }
                        wasmMemory = msgData['wasmMemory'];
                        updateMemoryViews();
                        wasmPromiseResolve(msgData['wasmModule']);
                    }
                    else if (cmd === 'run') {
                        // Pass the thread address to wasm to store it for fast access.
                        __emscripten_thread_init(msgData['pthread_ptr'], /*is_main=*/ 0, /*is_runtime=*/ 0, /*can_block=*/ 1, 0, 0);
                        // Await mailbox notifications with `Atomics.waitAsync` so we can start
                        // using the fast `Atomics.notify` notification path.
                        __emscripten_thread_mailbox_await(msgData['pthread_ptr']);
                        assert(msgData['pthread_ptr']);
                        // Also call inside JS module to set up the stack frame for this pthread in JS module scope
                        establishStackSpace();
                        PThread.receiveObjectTransfer(msgData);
                        PThread.threadInitTLS();
                        if (!initializedJS) {
                            // Embind must initialize itself on all threads, as it generates support JS.
                            // We only do this once per worker since they get reused
                            __embind_initialize_bindings();
                            initializedJS = true;
                        }
                        try {
                            invokeEntryPoint(msgData['start_routine'], msgData['arg']);
                        }
                        catch (ex) {
                            if (ex != 'unwind') {
                                // The pthread "crashed".  Do not call `_emscripten_thread_exit` (which
                                // would make this thread joinable).  Instead, re-throw the exception
                                // and let the top level handler propagate it back to the main thread.
                                throw ex;
                            }
                        }
                    }
                    else if (cmd === 'cancel') { // Main thread is asking for a pthread_cancel() on this thread.
                        if (_pthread_self()) {
                            __emscripten_thread_exit(-1);
                        }
                    }
                    else if (msgData.target === 'setimmediate') {
                        // no-op
                    }
                    else if (cmd === 'checkMailbox') {
                        if (initializedJS) {
                            checkMailbox();
                        }
                    }
                    else if (cmd) {
                        // The received message looks like something that should be handled by this message
                        // handler, (since there is a cmd field present), but is not one of the
                        // recognized commands:
                        err(`worker: received unknown command ${cmd}`);
                        err(msgData);
                    }
                }
                catch (ex) {
                    err(`worker: onmessage() captured an uncaught exception: ${ex}`);
                    if (ex?.stack)
                        err(ex.stack);
                    __emscripten_thread_crashed();
                    throw ex;
                }
            }
            ;
            self.onmessage = handleMessage;
        } // ENVIRONMENT_IS_PTHREAD
        // end include: runtime_pthread.js
        var wasmBinary;
        if (Module['wasmBinary'])
            wasmBinary = Module['wasmBinary'];
        legacyModuleProp('wasmBinary', 'wasmBinary');
        if (typeof WebAssembly != 'object') {
            err('no native wasm support detected');
        }
        // include: base64Utils.js
        // Converts a string of base64 into a byte array (Uint8Array).
        function intArrayFromBase64(s) {
            var decoded = atob(s);
            var bytes = new Uint8Array(decoded.length);
            for (var i = 0; i < decoded.length; ++i) {
                bytes[i] = decoded.charCodeAt(i);
            }
            return bytes;
        }
        // If filename is a base64 data URI, parses and returns data (Buffer on node,
        // Uint8Array otherwise). If filename is not a base64 data URI, returns undefined.
        function tryParseAsDataURI(filename) {
            if (!isDataURI(filename)) {
                return;
            }
            return intArrayFromBase64(filename.slice(dataURIPrefix.length));
        }
        // end include: base64Utils.js
        // Wasm globals
        var wasmMemory;
        // For sending to workers.
        var wasmModule;
        //========================================
        // Runtime essentials
        //========================================
        // whether we are quitting the application. no code should run after this.
        // set in exit() and abort()
        var ABORT = false;
        // set by exit() and abort().  Passed to 'onExit' handler.
        // NOTE: This is also used as the process return code code in shell environments
        // but only when noExitRuntime is false.
        var EXITSTATUS;
        // In STRICT mode, we only define assert() when ASSERTIONS is set.  i.e. we
        // don't define it at all in release modes.  This matches the behaviour of
        // MINIMAL_RUNTIME.
        // TODO(sbc): Make this the default even without STRICT enabled.
        /** @type {function(*, string=)} */
        function assert(condition, text) {
            if (!condition) {
                abort('Assertion failed' + (text ? ': ' + text : ''));
            }
        }
        // We used to include malloc/free by default in the past. Show a helpful error in
        // builds with assertions.
        // Memory management
        var HEAP, 
        /** @type {!Int8Array} */
        HEAP8, 
        /** @type {!Uint8Array} */
        HEAPU8, 
        /** @type {!Int16Array} */
        HEAP16, 
        /** @type {!Uint16Array} */
        HEAPU16, 
        /** @type {!Int32Array} */
        HEAP32, 
        /** @type {!Uint32Array} */
        HEAPU32, 
        /** @type {!Float32Array} */
        HEAPF32, 
        /* BigInt64Array type is not correctly defined in closure
        /** not-@type {!BigInt64Array} */
        HEAP64, 
        /* BigUInt64Array type is not correctly defined in closure
        /** not-t@type {!BigUint64Array} */
        HEAPU64, 
        /** @type {!Float64Array} */
        HEAPF64;
        // include: runtime_shared.js
        function updateMemoryViews() {
            var b = wasmMemory.buffer;
            Module['HEAP8'] = HEAP8 = new Int8Array(b);
            Module['HEAP16'] = HEAP16 = new Int16Array(b);
            Module['HEAPU8'] = HEAPU8 = new Uint8Array(b);
            Module['HEAPU16'] = HEAPU16 = new Uint16Array(b);
            Module['HEAP32'] = HEAP32 = new Int32Array(b);
            Module['HEAPU32'] = HEAPU32 = new Uint32Array(b);
            Module['HEAPF32'] = HEAPF32 = new Float32Array(b);
            Module['HEAPF64'] = HEAPF64 = new Float64Array(b);
            Module['HEAP64'] = HEAP64 = new BigInt64Array(b);
            Module['HEAPU64'] = HEAPU64 = new BigUint64Array(b);
        }
        // end include: runtime_shared.js
        assert(!Module['STACK_SIZE'], 'STACK_SIZE can no longer be set at runtime.  Use -sSTACK_SIZE at link time');
        assert(typeof Int32Array != 'undefined' && typeof Float64Array !== 'undefined' && Int32Array.prototype.subarray != undefined && Int32Array.prototype.set != undefined, 'JS engine does not provide full typed array support');
        // In non-standalone/normal mode, we create the memory here.
        // include: runtime_init_memory.js
        // Create the wasm memory. (Note: this only applies if IMPORTED_MEMORY is defined)
        // check for full engine support (use string 'subarray' to avoid closure compiler confusion)
        if (!ENVIRONMENT_IS_PTHREAD) {
            if (Module['wasmMemory']) {
                wasmMemory = Module['wasmMemory'];
            }
            else {
                var INITIAL_MEMORY = Module['INITIAL_MEMORY'] || 2147483648;
                legacyModuleProp('INITIAL_MEMORY', 'INITIAL_MEMORY');
                assert(INITIAL_MEMORY >= 65536, 'INITIAL_MEMORY should be larger than STACK_SIZE, was ' + INITIAL_MEMORY + '! (STACK_SIZE=' + 65536 + ')');
                wasmMemory = new WebAssembly.Memory({
                    'initial': INITIAL_MEMORY / 65536,
                    'maximum': INITIAL_MEMORY / 65536,
                    'shared': true,
                });
                if (!(wasmMemory.buffer instanceof SharedArrayBuffer)) {
                    err('requested a shared WebAssembly.Memory but the returned buffer is not a SharedArrayBuffer, indicating that while the browser has SharedArrayBuffer it does not have WebAssembly threads support - you may need to set a flag');
                    if (ENVIRONMENT_IS_NODE) {
                        err('(on node you may need: --experimental-wasm-threads --experimental-wasm-bulk-memory and/or recent version)');
                    }
                    throw Error('bad memory');
                }
            }
            updateMemoryViews();
        }
        // end include: runtime_init_memory.js
        // include: runtime_stack_check.js
        // Initializes the stack cookie. Called at the startup of main and at the startup of each thread in pthreads mode.
        function writeStackCookie() {
            var max = _emscripten_stack_get_end();
            assert((max & 3) == 0);
            // If the stack ends at address zero we write our cookies 4 bytes into the
            // stack.  This prevents interference with SAFE_HEAP and ASAN which also
            // monitor writes to address zero.
            if (max == 0) {
                max += 4;
            }
            // The stack grow downwards towards _emscripten_stack_get_end.
            // We write cookies to the final two words in the stack and detect if they are
            // ever overwritten.
            HEAPU32[((max) >> 2)] = 0x02135467;
            HEAPU32[(((max) + (4)) >> 2)] = 0x89BACDFE;
            // Also test the global address 0 for integrity.
            HEAPU32[((0) >> 2)] = 1668509029;
        }
        function checkStackCookie() {
            if (ABORT)
                return;
            var max = _emscripten_stack_get_end();
            // See writeStackCookie().
            if (max == 0) {
                max += 4;
            }
            var cookie1 = HEAPU32[((max) >> 2)];
            var cookie2 = HEAPU32[(((max) + (4)) >> 2)];
            if (cookie1 != 0x02135467 || cookie2 != 0x89BACDFE) {
                abort(`Stack overflow! Stack cookie has been overwritten at ${ptrToString(max)}, expected hex dwords 0x89BACDFE and 0x2135467, but received ${ptrToString(cookie2)} ${ptrToString(cookie1)}`);
            }
            // Also test the global address 0 for integrity.
            if (HEAPU32[((0) >> 2)] != 0x63736d65 /* 'emsc' */) {
                abort('Runtime error: The application has corrupted its heap memory area (address zero)!');
            }
        }
        // end include: runtime_stack_check.js
        // include: runtime_assertions.js
        // Endianness check
        (function () {
            var h16 = new Int16Array(1);
            var h8 = new Int8Array(h16.buffer);
            h16[0] = 0x6373;
            if (h8[0] !== 0x73 || h8[1] !== 0x63)
                throw 'Runtime error: expected the system to be little-endian! (Run with -sSUPPORT_BIG_ENDIAN to bypass)';
        })();
        // end include: runtime_assertions.js
        var __ATPRERUN__ = []; // functions called before the runtime is initialized
        var __ATINIT__ = []; // functions called during startup
        var __ATMAIN__ = []; // functions called when main() is to be run
        var __ATEXIT__ = []; // functions called during shutdown
        var __ATPOSTRUN__ = []; // functions called after the main() is called
        var runtimeInitialized = false;
        function preRun() {
            assert(!ENVIRONMENT_IS_PTHREAD); // PThreads reuse the runtime from the main thread.
            if (Module['preRun']) {
                if (typeof Module['preRun'] == 'function')
                    Module['preRun'] = [Module['preRun']];
                while (Module['preRun'].length) {
                    addOnPreRun(Module['preRun'].shift());
                }
            }
            callRuntimeCallbacks(__ATPRERUN__);
        }
        function initRuntime() {
            assert(!runtimeInitialized);
            runtimeInitialized = true;
            if (ENVIRONMENT_IS_PTHREAD)
                return;
            checkStackCookie();
            callRuntimeCallbacks(__ATINIT__);
        }
        function preMain() {
            checkStackCookie();
            if (ENVIRONMENT_IS_PTHREAD)
                return; // PThreads reuse the runtime from the main thread.
            callRuntimeCallbacks(__ATMAIN__);
        }
        function postRun() {
            checkStackCookie();
            if (ENVIRONMENT_IS_PTHREAD)
                return; // PThreads reuse the runtime from the main thread.
            if (Module['postRun']) {
                if (typeof Module['postRun'] == 'function')
                    Module['postRun'] = [Module['postRun']];
                while (Module['postRun'].length) {
                    addOnPostRun(Module['postRun'].shift());
                }
            }
            callRuntimeCallbacks(__ATPOSTRUN__);
        }
        function addOnPreRun(cb) {
            __ATPRERUN__.unshift(cb);
        }
        function addOnInit(cb) {
            __ATINIT__.unshift(cb);
        }
        function addOnPreMain(cb) {
            __ATMAIN__.unshift(cb);
        }
        function addOnExit(cb) {
        }
        function addOnPostRun(cb) {
            __ATPOSTRUN__.unshift(cb);
        }
        // include: runtime_math.js
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/imul
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/fround
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/clz32
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/trunc
        assert(Math.imul, 'This browser does not support Math.imul(), build with LEGACY_VM_SUPPORT or POLYFILL_OLD_MATH_FUNCTIONS to add in a polyfill');
        assert(Math.fround, 'This browser does not support Math.fround(), build with LEGACY_VM_SUPPORT or POLYFILL_OLD_MATH_FUNCTIONS to add in a polyfill');
        assert(Math.clz32, 'This browser does not support Math.clz32(), build with LEGACY_VM_SUPPORT or POLYFILL_OLD_MATH_FUNCTIONS to add in a polyfill');
        assert(Math.trunc, 'This browser does not support Math.trunc(), build with LEGACY_VM_SUPPORT or POLYFILL_OLD_MATH_FUNCTIONS to add in a polyfill');
        // end include: runtime_math.js
        // A counter of dependencies for calling run(). If we need to
        // do asynchronous work before running, increment this and
        // decrement it. Incrementing must happen in a place like
        // Module.preRun (used by emcc to add file preloading).
        // Note that you can add dependencies in preRun, even though
        // it happens right before run - run will be postponed until
        // the dependencies are met.
        var runDependencies = 0;
        var runDependencyWatcher = null;
        var dependenciesFulfilled = null; // overridden to take different actions when all run dependencies are fulfilled
        var runDependencyTracking = {};
        function getUniqueRunDependency(id) {
            var orig = id;
            while (1) {
                if (!runDependencyTracking[id])
                    return id;
                id = orig + Math.random();
            }
        }
        function addRunDependency(id) {
            runDependencies++;
            Module['monitorRunDependencies']?.(runDependencies);
            if (id) {
                assert(!runDependencyTracking[id]);
                runDependencyTracking[id] = 1;
                if (runDependencyWatcher === null && typeof setInterval != 'undefined') {
                    // Check for missing dependencies every few seconds
                    runDependencyWatcher = setInterval(() => {
                        if (ABORT) {
                            clearInterval(runDependencyWatcher);
                            runDependencyWatcher = null;
                            return;
                        }
                        var shown = false;
                        for (var dep in runDependencyTracking) {
                            if (!shown) {
                                shown = true;
                                err('still waiting on run dependencies:');
                            }
                            err(`dependency: ${dep}`);
                        }
                        if (shown) {
                            err('(end of list)');
                        }
                    }, 10000);
                }
            }
            else {
                err('warning: run dependency added without ID');
            }
        }
        function removeRunDependency(id) {
            runDependencies--;
            Module['monitorRunDependencies']?.(runDependencies);
            if (id) {
                assert(runDependencyTracking[id]);
                delete runDependencyTracking[id];
            }
            else {
                err('warning: run dependency removed without ID');
            }
            if (runDependencies == 0) {
                if (runDependencyWatcher !== null) {
                    clearInterval(runDependencyWatcher);
                    runDependencyWatcher = null;
                }
                if (dependenciesFulfilled) {
                    var callback = dependenciesFulfilled;
                    dependenciesFulfilled = null;
                    callback(); // can add another dependenciesFulfilled
                }
            }
        }
        /** @param {string|number=} what */
        function abort(what) {
            Module['onAbort']?.(what);
            what = 'Aborted(' + what + ')';
            // TODO(sbc): Should we remove printing and leave it up to whoever
            // catches the exception?
            err(what);
            ABORT = true;
            EXITSTATUS = 1;
            // Use a wasm runtime error, because a JS error might be seen as a foreign
            // exception, which means we'd run destructors on it. We need the error to
            // simply make the program stop.
            // FIXME This approach does not work in Wasm EH because it currently does not assume
            // all RuntimeErrors are from traps; it decides whether a RuntimeError is from
            // a trap or not based on a hidden field within the object. So at the moment
            // we don't have a way of throwing a wasm trap from JS. TODO Make a JS API that
            // allows this in the wasm spec.
            // Suppress closure compiler warning here. Closure compiler's builtin extern
            // definition for WebAssembly.RuntimeError claims it takes no arguments even
            // though it can.
            // TODO(https://github.com/google/closure-compiler/pull/3913): Remove if/when upstream closure gets fixed.
            /** @suppress {checkTypes} */
            var e = new WebAssembly.RuntimeError(what);
            readyPromiseReject(e);
            // Throw the error whether or not MODULARIZE is set because abort is used
            // in code paths apart from instantiation where an exception is expected
            // to be thrown when abort is called.
            throw e;
        }
        // include: memoryprofiler.js
        // end include: memoryprofiler.js
        // include: URIUtils.js
        // Prefix of data URIs emitted by SINGLE_FILE and related options.
        var dataURIPrefix = 'data:application/octet-stream;base64,';
        /**
         * Indicates whether filename is a base64 data URI.
         * @noinline
         */
        var isDataURI = (filename) => filename.startsWith(dataURIPrefix);
        /**
         * Indicates whether filename is delivered via file protocol (as opposed to http/https)
         * @noinline
         */
        var isFileURI = (filename) => filename.startsWith('file://');
        // end include: URIUtils.js
        function createExportWrapper(name, nargs) {
            return (...args) => {
                assert(runtimeInitialized, `native function \`${name}\` called before runtime initialization`);
                var f = wasmExports[name];
                assert(f, `exported native function \`${name}\` not found`);
                // Only assert for too many arguments. Too few can be valid since the missing arguments will be zero filled.
                assert(args.length <= nargs, `native function \`${name}\` called with ${args.length} args but expects ${nargs}`);
                return f(...args);
            };
        }
        // include: runtime_exceptions.js
        // end include: runtime_exceptions.js
        function findWasmBinary() {
            var f = 'libmpv.wasm';
            if (!isDataURI(f)) {
                return locateFile(f);
            }
            return f;
        }
        var wasmBinaryFile;
        function getBinarySync(file) {
            if (file == wasmBinaryFile && wasmBinary) {
                return new Uint8Array(wasmBinary);
            }
            if (readBinary) {
                return readBinary(file);
            }
            throw 'both async and sync fetching of the wasm failed';
        }
        function getBinaryPromise(binaryFile) {
            // If we don't have the binary yet, load it asynchronously using readAsync.
            if (!wasmBinary) {
                // Fetch the binary using readAsync
                return readAsync(binaryFile).then((response) => new Uint8Array(/** @type{!ArrayBuffer} */ (response)), 
                // Fall back to getBinarySync if readAsync fails
                () => getBinarySync(binaryFile));
            }
            // Otherwise, getBinarySync should be able to get it synchronously
            return Promise.resolve().then(() => getBinarySync(binaryFile));
        }
        function instantiateArrayBuffer(binaryFile, imports, receiver) {
            return getBinaryPromise(binaryFile).then((binary) => {
                return WebAssembly.instantiate(binary, imports);
            }).then(receiver, (reason) => {
                err(`failed to asynchronously prepare wasm: ${reason}`);
                // Warn on some common problems.
                if (isFileURI(wasmBinaryFile)) {
                    err(`warning: Loading from a file URI (${wasmBinaryFile}) is not supported in most browsers. See https://emscripten.org/docs/getting_started/FAQ.html#how-do-i-run-a-local-webserver-for-testing-why-does-my-program-stall-in-downloading-or-preparing`);
                }
                abort(reason);
            });
        }
        function instantiateAsync(binary, binaryFile, imports, callback) {
            if (!binary &&
                typeof WebAssembly.instantiateStreaming == 'function' &&
                !isDataURI(binaryFile) &&
                typeof fetch == 'function') {
                return fetch(binaryFile, { credentials: 'same-origin' }).then((response) => {
                    // Suppress closure warning here since the upstream definition for
                    // instantiateStreaming only allows Promise<Repsponse> rather than
                    // an actual Response.
                    // TODO(https://github.com/google/closure-compiler/pull/3913): Remove if/when upstream closure is fixed.
                    /** @suppress {checkTypes} */
                    var result = WebAssembly.instantiateStreaming(response, imports);
                    return result.then(callback, function (reason) {
                        // We expect the most common failure cause to be a bad MIME type for the binary,
                        // in which case falling back to ArrayBuffer instantiation should work.
                        err(`wasm streaming compile failed: ${reason}`);
                        err('falling back to ArrayBuffer instantiation');
                        return instantiateArrayBuffer(binaryFile, imports, callback);
                    });
                });
            }
            return instantiateArrayBuffer(binaryFile, imports, callback);
        }
        function getWasmImports() {
            assignWasmImports();
            // prepare imports
            return {
                'env': wasmImports,
                'wasi_snapshot_preview1': wasmImports,
            };
        }
        // Create the wasm instance.
        // Receives the wasm imports, returns the exports.
        function createWasm() {
            var info = getWasmImports();
            // Load the wasm module and create an instance of using native support in the JS engine.
            // handle a generated wasm instance, receiving its exports and
            // performing other necessary setup
            /** @param {WebAssembly.Module=} module*/
            function receiveInstance(instance, module) {
                wasmExports = instance.exports;
                registerTLSInit(wasmExports['_emscripten_tls_init']);
                wasmTable = wasmExports['__indirect_function_table'];
                assert(wasmTable, 'table not found in wasm exports');
                addOnInit(wasmExports['__wasm_call_ctors']);
                // We now have the Wasm module loaded up, keep a reference to the compiled module so we can post it to the workers.
                wasmModule = module;
                removeRunDependency('wasm-instantiate');
                return wasmExports;
            }
            // wait for the pthread pool (if any)
            addRunDependency('wasm-instantiate');
            // Prefer streaming instantiation if available.
            // Async compilation can be confusing when an error on the page overwrites Module
            // (for example, if the order of elements is wrong, and the one defining Module is
            // later), so we save Module and check it later.
            var trueModule = Module;
            function receiveInstantiationResult(result) {
                // 'result' is a ResultObject object which has both the module and instance.
                // receiveInstance() will swap in the exports (to Module.asm) so they can be called
                assert(Module === trueModule, 'the Module object should not be replaced during async compilation - perhaps the order of HTML elements is wrong?');
                trueModule = null;
                receiveInstance(result['instance'], result['module']);
            }
            // User shell pages can write their own Module.instantiateWasm = function(imports, successCallback) callback
            // to manually instantiate the Wasm module themselves. This allows pages to
            // run the instantiation parallel to any other async startup actions they are
            // performing.
            // Also pthreads and wasm workers initialize the wasm instance through this
            // path.
            if (Module['instantiateWasm']) {
                try {
                    return Module['instantiateWasm'](info, receiveInstance);
                }
                catch (e) {
                    err(`Module.instantiateWasm callback failed with error: ${e}`);
                    // If instantiation fails, reject the module ready promise.
                    readyPromiseReject(e);
                }
            }
            if (!wasmBinaryFile)
                wasmBinaryFile = findWasmBinary();
            // If instantiation fails, reject the module ready promise.
            instantiateAsync(wasmBinary, wasmBinaryFile, info, receiveInstantiationResult).catch(readyPromiseReject);
            return {}; // no exports yet; we'll fill them in later
        }
        // include: runtime_debug.js
        function legacyModuleProp(prop, newName, incoming = true) {
            if (!Object.getOwnPropertyDescriptor(Module, prop)) {
                Object.defineProperty(Module, prop, {
                    configurable: true,
                    get() {
                        let extra = incoming ? ' (the initial value can be provided on Module, but after startup the value is only looked for on a local variable of that name)' : '';
                        abort(`\`Module.${prop}\` has been replaced by \`${newName}\`` + extra);
                    }
                });
            }
        }
        function ignoredModuleProp(prop) {
            if (Object.getOwnPropertyDescriptor(Module, prop)) {
                abort(`\`Module.${prop}\` was supplied but \`${prop}\` not included in INCOMING_MODULE_JS_API`);
            }
        }
        // forcing the filesystem exports a few things by default
        function isExportedByForceFilesystem(name) {
            return name === 'FS_createPath' ||
                name === 'FS_createDataFile' ||
                name === 'FS_createPreloadedFile' ||
                name === 'FS_unlink' ||
                name === 'addRunDependency' ||
                name === 'removeRunDependency';
        }
        function missingGlobal(sym, msg) {
            if (typeof globalThis != 'undefined') {
                Object.defineProperty(globalThis, sym, {
                    configurable: true,
                    get() {
                        warnOnce(`\`${sym}\` is not longer defined by emscripten. ${msg}`);
                        return undefined;
                    }
                });
            }
        }
        missingGlobal('buffer', 'Please use HEAP8.buffer or wasmMemory.buffer');
        missingGlobal('asm', 'Please use wasmExports instead');
        function missingLibrarySymbol(sym) {
            if (typeof globalThis != 'undefined' && !Object.getOwnPropertyDescriptor(globalThis, sym)) {
                Object.defineProperty(globalThis, sym, {
                    configurable: true,
                    get() {
                        // Can't `abort()` here because it would break code that does runtime
                        // checks.  e.g. `if (typeof SDL === 'undefined')`.
                        var msg = `\`${sym}\` is a library symbol and not included by default; add it to your library.js __deps or to DEFAULT_LIBRARY_FUNCS_TO_INCLUDE on the command line`;
                        // DEFAULT_LIBRARY_FUNCS_TO_INCLUDE requires the name as it appears in
                        // library.js, which means $name for a JS name with no prefix, or name
                        // for a JS name like _name.
                        var librarySymbol = sym;
                        if (!librarySymbol.startsWith('_')) {
                            librarySymbol = '$' + sym;
                        }
                        msg += ` (e.g. -sDEFAULT_LIBRARY_FUNCS_TO_INCLUDE='${librarySymbol}')`;
                        if (isExportedByForceFilesystem(sym)) {
                            msg += '. Alternatively, forcing filesystem support (-sFORCE_FILESYSTEM) can export this for you';
                        }
                        warnOnce(msg);
                        return undefined;
                    }
                });
            }
            // Any symbol that is not included from the JS library is also (by definition)
            // not exported on the Module object.
            unexportedRuntimeSymbol(sym);
        }
        function unexportedRuntimeSymbol(sym) {
            if (ENVIRONMENT_IS_PTHREAD) {
                return;
            }
            if (!Object.getOwnPropertyDescriptor(Module, sym)) {
                Object.defineProperty(Module, sym, {
                    configurable: true,
                    get() {
                        var msg = `'${sym}' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the Emscripten FAQ)`;
                        if (isExportedByForceFilesystem(sym)) {
                            msg += '. Alternatively, forcing filesystem support (-sFORCE_FILESYSTEM) can export this for you';
                        }
                        abort(msg);
                    }
                });
            }
        }
        // Used by XXXXX_DEBUG settings to output debug messages.
        function dbg(...args) {
            // TODO(sbc): Make this configurable somehow.  Its not always convenient for
            // logging to show up as warnings.
            console.warn(...args);
        }
        // end include: runtime_debug.js
        // === Body ===
        var ASM_CONSTS = {
            5420892: ($0) => { postMessage(JSON.stringify({ type: 'idle', shaderCount: $0 })); },
            5420960: () => { postMessage(JSON.stringify({ type: 'file-start' })); },
            5421013: () => { postMessage(JSON.stringify({ type: 'file-end' })); },
            5421064: ($0) => { postMessage(JSON.stringify({ type: 'property-change', name: UTF8ToString($0), value: 0 })); },
            5421160: ($0, $1) => { postMessage(JSON.stringify({ type: 'property-change', name: UTF8ToString($0), value: UTF8ToString($1) })); },
            5421271: ($0, $1) => { postMessage(JSON.stringify({ type: 'property-change', name: UTF8ToString($0), value: $1 })); },
            5421368: ($0, $1) => { postMessage(JSON.stringify({ type: 'property-change', name: UTF8ToString($0), value: $1 })); },
            5421465: ($0, $1) => { postMessage(JSON.stringify({ type: 'property-change', name: UTF8ToString($0), value: $1.toString() })); },
            5421573: () => { arr = []; },
            5421583: () => { arr.push(obj); },
            5421598: () => { postMessage(JSON.stringify({ type: 'track-list', tracks: arr })); },
            5421668: () => { postMessage(JSON.stringify({ type: 'chapter-list', chapters: arr })); },
            5421742: () => { obj = {}; },
            5421752: ($0, $1) => { obj[UTF8ToString($0)] = $1.toString(); },
            5421795: ($0, $1) => { obj[UTF8ToString($0)] = UTF8ToString($1); },
            5421841: ($0, $1) => { obj[UTF8ToString($0)] = $1; },
            5421873: ($0, $1) => { obj[UTF8ToString($0)] = $1; },
            5421905: ($0) => { if (!$0) {
                AL.alcErr = 0xA004;
                return 1;
            } },
            5421953: ($0) => { if (!AL.currentCtx) {
                err("alGetProcAddress() called without a valid context");
                return 1;
            } if (!$0) {
                AL.currentCtx.err = 0xA003;
                return 1;
            } },
            5422101: ($0) => { var str = UTF8ToString($0) + '\n\n' + 'Abort/Retry/Ignore/AlwaysIgnore? [ariA] :'; var reply = window.prompt(str, "i"); if (reply === null) {
                reply = "i";
            } return allocate(intArrayFromString(reply), 'i8', ALLOC_NORMAL); },
            5422326: () => { if (typeof (AudioContext) !== 'undefined') {
                return true;
            }
            else if (typeof (webkitAudioContext) !== 'undefined') {
                return true;
            } return false; },
            5422473: () => { if ((typeof (navigator.mediaDevices) !== 'undefined') && (typeof (navigator.mediaDevices.getUserMedia) !== 'undefined')) {
                return true;
            }
            else if (typeof (navigator.webkitGetUserMedia) !== 'undefined') {
                return true;
            } return false; },
            5422707: ($0) => { if (typeof (Module['SDL3']) === 'undefined') {
                Module['SDL3'] = {};
            } var SDL3 = Module['SDL3']; if (!$0) {
                SDL3.audio_playback = {};
            }
            else {
                SDL3.audio_recording = {};
            } if (!SDL3.audioContext) {
                if (typeof (AudioContext) !== 'undefined') {
                    SDL3.audioContext = new AudioContext();
                }
                else if (typeof (webkitAudioContext) !== 'undefined') {
                    SDL3.audioContext = new webkitAudioContext();
                }
                if (SDL3.audioContext) {
                    if ((typeof navigator.userActivation) === 'undefined') {
                        autoResumeAudioContext(SDL3.audioContext);
                    }
                }
            } return SDL3.audioContext === undefined ? -1 : 0; },
            5423277: () => { return Module['SDL3'].audioContext.sampleRate; },
            5423328: ($0, $1, $2, $3) => { var SDL3 = Module['SDL3']; var have_microphone = function (stream) { if (SDL3.audio_recording.silenceTimer !== undefined) {
                clearInterval(SDL3.audio_recording.silenceTimer);
                SDL3.audio_recording.silenceTimer = undefined;
                SDL3.audio_recording.silenceBuffer = undefined;
            } SDL3.audio_recording.mediaStreamNode = SDL3.audioContext.createMediaStreamSource(stream); SDL3.audio_recording.scriptProcessorNode = SDL3.audioContext.createScriptProcessor($1, $0, 1); SDL3.audio_recording.scriptProcessorNode.onaudioprocess = function (audioProcessingEvent) { if ((SDL3 === undefined) || (SDL3.audio_recording === undefined)) {
                return;
            } audioProcessingEvent.outputBuffer.getChannelData(0).fill(0.0); SDL3.audio_recording.currentRecordingBuffer = audioProcessingEvent.inputBuffer; dynCall('vi', $2, [$3]); }; SDL3.audio_recording.mediaStreamNode.connect(SDL3.audio_recording.scriptProcessorNode); SDL3.audio_recording.scriptProcessorNode.connect(SDL3.audioContext.destination); SDL3.audio_recording.stream = stream; }; var no_microphone = function (error) { }; SDL3.audio_recording.silenceBuffer = SDL3.audioContext.createBuffer($0, $1, SDL3.audioContext.sampleRate); SDL3.audio_recording.silenceBuffer.getChannelData(0).fill(0.0); var silence_callback = function () { SDL3.audio_recording.currentRecordingBuffer = SDL3.audio_recording.silenceBuffer; dynCall('vi', $2, [$3]); }; SDL3.audio_recording.silenceTimer = setInterval(silence_callback, ($1 / SDL3.audioContext.sampleRate) * 1000); if ((navigator.mediaDevices !== undefined) && (navigator.mediaDevices.getUserMedia !== undefined)) {
                navigator.mediaDevices.getUserMedia({ audio: true, video: false }).then(have_microphone).catch(no_microphone);
            }
            else if (navigator.webkitGetUserMedia !== undefined) {
                navigator.webkitGetUserMedia({ audio: true, video: false }, have_microphone, no_microphone);
            } },
            5425169: ($0, $1, $2, $3) => { var SDL3 = Module['SDL3']; SDL3.audio_playback.scriptProcessorNode = SDL3.audioContext['createScriptProcessor']($1, 0, $0); SDL3.audio_playback.scriptProcessorNode['onaudioprocess'] = function (e) { if ((SDL3 === undefined) || (SDL3.audio_playback === undefined)) {
                return;
            } if (SDL3.audio_playback.silenceTimer !== undefined) {
                clearInterval(SDL3.audio_playback.silenceTimer);
                SDL3.audio_playback.silenceTimer = undefined;
                SDL3.audio_playback.silenceBuffer = undefined;
            } SDL3.audio_playback.currentPlaybackBuffer = e['outputBuffer']; dynCall('vi', $2, [$3]); }; SDL3.audio_playback.scriptProcessorNode['connect'](SDL3.audioContext['destination']); if (SDL3.audioContext.state === 'suspended') {
                SDL3.audio_playback.silenceBuffer = SDL3.audioContext.createBuffer($0, $1, SDL3.audioContext.sampleRate);
                SDL3.audio_playback.silenceBuffer.getChannelData(0).fill(0.0);
                var silence_callback = function () { if ((typeof navigator.userActivation) !== 'undefined') {
                    if (navigator.userActivation.hasBeenActive) {
                        SDL3.audioContext.resume();
                    }
                } SDL3.audio_playback.currentPlaybackBuffer = SDL3.audio_playback.silenceBuffer; dynCall('vi', $2, [$3]); SDL3.audio_playback.currentPlaybackBuffer = undefined; };
                SDL3.audio_playback.silenceTimer = setInterval(silence_callback, ($1 / SDL3.audioContext.sampleRate) * 1000);
            } },
            5426485: ($0) => { var SDL3 = Module['SDL3']; if ($0) {
                if (SDL3.audio_recording.silenceTimer !== undefined) {
                    clearInterval(SDL3.audio_recording.silenceTimer);
                }
                if (SDL3.audio_recording.stream !== undefined) {
                    var tracks = SDL3.audio_recording.stream.getAudioTracks();
                    for (var i = 0; i < tracks.length; i++) {
                        SDL3.audio_recording.stream.removeTrack(tracks[i]);
                    }
                }
                if (SDL3.audio_recording.scriptProcessorNode !== undefined) {
                    SDL3.audio_recording.scriptProcessorNode.onaudioprocess = function (audioProcessingEvent) { };
                    SDL3.audio_recording.scriptProcessorNode.disconnect();
                }
                if (SDL3.audio_recording.mediaStreamNode !== undefined) {
                    SDL3.audio_recording.mediaStreamNode.disconnect();
                }
                SDL3.audio_recording = undefined;
            }
            else {
                if (SDL3.audio_playback.scriptProcessorNode != undefined) {
                    SDL3.audio_playback.scriptProcessorNode.disconnect();
                }
                if (SDL3.audio_playback.silenceTimer !== undefined) {
                    clearInterval(SDL3.audio_playback.silenceTimer);
                }
                SDL3.audio_playback = undefined;
            } if ((SDL3.audioContext !== undefined) && (SDL3.audio_playback === undefined) && (SDL3.audio_recording === undefined)) {
                SDL3.audioContext.close();
                SDL3.audioContext = undefined;
            } },
            5427641: ($0, $1) => { var SDL3 = Module['SDL3']; var numChannels = SDL3.audio_playback.currentPlaybackBuffer['numberOfChannels']; for (var c = 0; c < numChannels; ++c) {
                var channelData = SDL3.audio_playback.currentPlaybackBuffer['getChannelData'](c);
                if (channelData.length != $1) {
                    throw 'Web Audio playback buffer length mismatch! Destination size: ' + channelData.length + ' samples vs expected ' + $1 + ' samples!';
                }
                for (var j = 0; j < $1; ++j) {
                    channelData[j] = HEAPF32[$0 + ((j * numChannels + c) << 2) >> 2];
                }
            } },
            5428145: ($0, $1) => { var SDL3 = Module['SDL3']; var numChannels = SDL3.audio_recording.currentRecordingBuffer.numberOfChannels; for (var c = 0; c < numChannels; ++c) {
                var channelData = SDL3.audio_recording.currentRecordingBuffer.getChannelData(c);
                if (channelData.length != $1) {
                    throw 'Web Audio recording buffer length mismatch! Destination size: ' + channelData.length + ' samples vs expected ' + $1 + ' samples!';
                }
                if (numChannels == 1) {
                    for (var j = 0; j < $1; ++j) {
                        setValue($0 + (j * 4), channelData[j], 'float');
                    }
                }
                else {
                    for (var j = 0; j < $1; ++j) {
                        setValue($0 + (((j * numChannels) + c) * 4), channelData[j], 'float');
                    }
                }
            } },
            5428772: () => { if (typeof (Module['SDL3']) === 'undefined') {
                Module['SDL3'] = {};
            } Module['SDL3'].camera = {}; },
            5428873: () => { return (navigator.mediaDevices === undefined) ? 0 : 1; },
            5428932: ($0, $1, $2, $3, $4, $5, $6) => { const device = $0; const w = $1; const h = $2; const interval_numerator = $3; const interval_denominator = $4; const outcome = $5; const iterate = $6; const constraints = {}; if ((w <= 0) || (h <= 0)) {
                constraints.video = true;
            }
            else {
                constraints.video = {};
                constraints.video.width = w;
                constraints.video.height = h;
            } if ((interval_numerator > 0) && (interval_denominator > 0)) {
                var fps = interval_denominator / interval_numerator;
                constraints.video.frameRate = { ideal: fps };
            } function grabNextCameraFrame() { const SDL3 = Module['SDL3']; if ((typeof (SDL3) === 'undefined') || (typeof (SDL3.camera) === 'undefined') || (typeof (SDL3.camera.stream) === 'undefined')) {
                return;
            } const nextframems = SDL3.camera.next_frame_time; const now = performance.now(); if (now >= nextframems) {
                dynCall('vi', iterate, [device]);
                while (SDL3.camera.next_frame_time < now) {
                    SDL3.camera.next_frame_time += SDL3.camera.fpsincrms;
                }
            } requestAnimationFrame(grabNextCameraFrame); } navigator.mediaDevices.getUserMedia(constraints).then((stream) => { const settings = stream.getVideoTracks()[0].getSettings(); const actualw = settings.width; const actualh = settings.height; const actualfps = settings.frameRate; console.log("Camera is opened! Actual spec: (" + actualw + "x" + actualh + "), fps=" + actualfps); dynCall('viiiii', outcome, [device, 1, actualw, actualh, actualfps]); const video = document.createElement("video"); video.width = actualw; video.height = actualh; video.style.display = 'none'; video.srcObject = stream; const canvas = document.createElement("canvas"); canvas.width = actualw; canvas.height = actualh; canvas.style.display = 'none'; const ctx2d = canvas.getContext('2d'); const SDL3 = Module['SDL3']; SDL3.camera.width = actualw; SDL3.camera.height = actualh; SDL3.camera.fps = actualfps; SDL3.camera.fpsincrms = 1000.0 / actualfps; SDL3.camera.stream = stream; SDL3.camera.video = video; SDL3.camera.canvas = canvas; SDL3.camera.ctx2d = ctx2d; SDL3.camera.rgba = 0; SDL3.camera.next_frame_time = performance.now(); video.play(); video.addEventListener('loadedmetadata', () => { grabNextCameraFrame(); }); }).catch((err) => { console.error("Tried to open camera but it threw an error! " + err.name + ": " + err.message); dynCall('viiiii', outcome, [device, 0, 0, 0, 0]); }); },
            5431231: () => { const SDL3 = Module['SDL3']; if ((typeof (SDL3) === 'undefined') || (typeof (SDL3.camera) === 'undefined') || (typeof (SDL3.camera.stream) === 'undefined')) {
                return;
            } SDL3.camera.stream.getTracks().forEach(track => track.stop()); _SDL_free(SDL3.camera.rgba); SDL3.camera = {}; },
            5431511: ($0, $1, $2) => { const w = $0; const h = $1; const rgba = $2; const SDL3 = Module['SDL3']; if ((typeof (SDL3) === 'undefined') || (typeof (SDL3.camera) === 'undefined') || (typeof (SDL3.camera.ctx2d) === 'undefined')) {
                return 0;
            } SDL3.camera.ctx2d.drawImage(SDL3.camera.video, 0, 0, w, h); const imgrgba = SDL3.camera.ctx2d.getImageData(0, 0, w, h).data; Module.HEAPU8.set(imgrgba, rgba); return 1; },
            5431896: () => { if (typeof (Module['SDL3']) !== 'undefined') {
                Module['SDL3'].camera = undefined;
            } },
            5431983: ($0, $1, $2, $3) => { var w = $0; var h = $1; var pixels = $2; var canvasId = UTF8ToString($3); var canvas = document.querySelector(canvasId); if (!Module['SDL3'])
                Module['SDL3'] = {}; var SDL3 = Module['SDL3']; if (SDL3.ctxCanvas !== canvas) {
                SDL3.ctx = Module['createContext'](canvas, false, true);
                SDL3.ctxCanvas = canvas;
            } if (SDL3.w !== w || SDL3.h !== h || SDL3.imageCtx !== SDL3.ctx) {
                SDL3.image = SDL3.ctx.createImageData(w, h);
                SDL3.w = w;
                SDL3.h = h;
                SDL3.imageCtx = SDL3.ctx;
            } var data = SDL3.image.data; var src = pixels >> 2; var dst = 0; var num; if (SDL3.data32Data !== data) {
                SDL3.data32 = new Int32Array(data.buffer);
                SDL3.data8 = new Uint8Array(data.buffer);
                SDL3.data32Data = data;
            } var data32 = SDL3.data32; num = data32.length; data32.set(HEAP32.subarray(src, src + num)); var data8 = SDL3.data8; var i = 3; var j = i + 4 * num; if (num % 8 == 0) {
                while (i < j) {
                    data8[i] = 0xff;
                    i = i + 4 | 0;
                    data8[i] = 0xff;
                    i = i + 4 | 0;
                    data8[i] = 0xff;
                    i = i + 4 | 0;
                    data8[i] = 0xff;
                    i = i + 4 | 0;
                    data8[i] = 0xff;
                    i = i + 4 | 0;
                    data8[i] = 0xff;
                    i = i + 4 | 0;
                    data8[i] = 0xff;
                    i = i + 4 | 0;
                    data8[i] = 0xff;
                    i = i + 4 | 0;
                }
            }
            else {
                while (i < j) {
                    data8[i] = 0xff;
                    i = i + 4 | 0;
                }
            } SDL3.ctx.putImageData(SDL3.image, 0, 0); },
            5433215: ($0, $1, $2, $3, $4) => { var w = $0; var h = $1; var hot_x = $2; var hot_y = $3; var pixels = $4; var canvas = document.createElement("canvas"); canvas.width = w; canvas.height = h; var ctx = canvas.getContext("2d"); var image = ctx.createImageData(w, h); var data = image.data; var src = pixels >> 2; var data32 = new Int32Array(data.buffer); data32.set(HEAP32.subarray(src, src + data32.length)); ctx.putImageData(image, 0, 0); var url = hot_x === 0 && hot_y === 0 ? "url(" + canvas.toDataURL() + "), auto" : "url(" + canvas.toDataURL() + ") " + hot_x + " " + hot_y + ", auto"; var urlBuf = _malloc(url.length + 1); stringToUTF8(url, urlBuf, url.length + 1); return urlBuf; },
            5433870: ($0) => { if (Module['canvas']) {
                Module['canvas'].style['cursor'] = UTF8ToString($0);
            } },
            5433953: () => { if (Module['canvas']) {
                Module['canvas'].style['cursor'] = 'none';
            } },
            5434022: () => { return window.innerWidth; },
            5434052: () => { return window.innerHeight; }
        };
        // end include: preamble.js
        /** @constructor */
        function ExitStatus(status) {
            this.name = 'ExitStatus';
            this.message = `Program terminated with exit(${status})`;
            this.status = status;
        }
        var terminateWorker = (worker) => {
            worker.terminate();
            // terminate() can be asynchronous, so in theory the worker can continue
            // to run for some amount of time after termination.  However from our POV
            // the worker now dead and we don't want to hear from it again, so we stub
            // out its message handler here.  This avoids having to check in each of
            // the onmessage handlers if the message was coming from valid worker.
            worker.onmessage = (e) => {
                var cmd = e['data']['cmd'];
                err(`received "${cmd}" command from terminated worker: ${worker.workerID}`);
            };
        };
        var killThread = (pthread_ptr) => {
            assert(!ENVIRONMENT_IS_PTHREAD, 'Internal Error! killThread() can only ever be called from main application thread!');
            assert(pthread_ptr, 'Internal Error! Null pthread_ptr in killThread!');
            var worker = PThread.pthreads[pthread_ptr];
            delete PThread.pthreads[pthread_ptr];
            terminateWorker(worker);
            __emscripten_thread_free_data(pthread_ptr);
            // The worker was completely nuked (not just the pthread execution it was hosting), so remove it from running workers
            // but don't put it back to the pool.
            PThread.runningWorkers.splice(PThread.runningWorkers.indexOf(worker), 1); // Not a running Worker anymore.
            worker.pthread_ptr = 0;
        };
        var cancelThread = (pthread_ptr) => {
            assert(!ENVIRONMENT_IS_PTHREAD, 'Internal Error! cancelThread() can only ever be called from main application thread!');
            assert(pthread_ptr, 'Internal Error! Null pthread_ptr in cancelThread!');
            var worker = PThread.pthreads[pthread_ptr];
            worker.postMessage({ 'cmd': 'cancel' });
        };
        var cleanupThread = (pthread_ptr) => {
            assert(!ENVIRONMENT_IS_PTHREAD, 'Internal Error! cleanupThread() can only ever be called from main application thread!');
            assert(pthread_ptr, 'Internal Error! Null pthread_ptr in cleanupThread!');
            var worker = PThread.pthreads[pthread_ptr];
            assert(worker);
            PThread.returnWorkerToPool(worker);
        };
        var zeroMemory = (address, size) => {
            HEAPU8.fill(0, address, address + size);
            return address;
        };
        var spawnThread = (threadParams) => {
            assert(!ENVIRONMENT_IS_PTHREAD, 'Internal Error! spawnThread() can only ever be called from main application thread!');
            assert(threadParams.pthread_ptr, 'Internal error, no pthread ptr!');
            var worker = PThread.getNewWorker();
            if (!worker) {
                // No available workers in the PThread pool.
                return 6;
            }
            assert(!worker.pthread_ptr, 'Internal error!');
            PThread.runningWorkers.push(worker);
            // Add to pthreads map
            PThread.pthreads[threadParams.pthread_ptr] = worker;
            worker.pthread_ptr = threadParams.pthread_ptr;
            var msg = {
                'cmd': 'run',
                'start_routine': threadParams.startRoutine,
                'arg': threadParams.arg,
                'pthread_ptr': threadParams.pthread_ptr,
            };
            // Note that we do not need to quote these names because they are only used
            // in this file, and not from the external worker.js.
            msg.moduleCanvasId = threadParams.moduleCanvasId;
            msg.offscreenCanvases = threadParams.offscreenCanvases;
            // Ask the worker to start executing its pthread entry point function.
            worker.postMessage(msg, threadParams.transferList);
            return 0;
        };
        var runtimeKeepaliveCounter = 0;
        var keepRuntimeAlive = () => noExitRuntime || runtimeKeepaliveCounter > 0;
        var stackSave = () => _emscripten_stack_get_current();
        var stackRestore = (val) => __emscripten_stack_restore(val);
        var stackAlloc = (sz) => __emscripten_stack_alloc(sz);
        var MAX_INT53 = 9007199254740992;
        var MIN_INT53 = -9007199254740992;
        var bigintToI53Checked = (num) => (num < MIN_INT53 || num > MAX_INT53) ? NaN : Number(num);
        /** @type{function(number, (number|boolean), ...number)} */
        var proxyToMainThread = (funcIndex, emAsmAddr, sync, ...callArgs) => {
            // EM_ASM proxying is done by passing a pointer to the address of the EM_ASM
            // content as `emAsmAddr`.  JS library proxying is done by passing an index
            // into `proxiedJSCallArgs` as `funcIndex`. If `emAsmAddr` is non-zero then
            // `funcIndex` will be ignored.
            // Additional arguments are passed after the first three are the actual
            // function arguments.
            // The serialization buffer contains the number of call params, and then
            // all the args here.
            // We also pass 'sync' to C separately, since C needs to look at it.
            // Allocate a buffer, which will be copied by the C code.
            //
            // First passed parameter specifies the number of arguments to the function.
            // When BigInt support is enabled, we must handle types in a more complex
            // way, detecting at runtime if a value is a BigInt or not (as we have no
            // type info here). To do that, add a "prefix" before each value that
            // indicates if it is a BigInt, which effectively doubles the number of
            // values we serialize for proxying. TODO: pack this?
            var serializedNumCallArgs = callArgs.length * 2;
            var sp = stackSave();
            var args = stackAlloc(serializedNumCallArgs * 8);
            var b = ((args) >> 3);
            for (var i = 0; i < callArgs.length; i++) {
                var arg = callArgs[i];
                if (typeof arg == 'bigint') {
                    // The prefix is non-zero to indicate a bigint.
                    HEAP64[b + 2 * i] = 1n;
                    HEAP64[b + 2 * i + 1] = arg;
                }
                else {
                    // The prefix is zero to indicate a JS Number.
                    HEAP64[b + 2 * i] = 0n;
                    HEAPF64[b + 2 * i + 1] = arg;
                }
            }
            var rtn = __emscripten_run_on_main_thread_js(funcIndex, emAsmAddr, serializedNumCallArgs, args, sync);
            stackRestore(sp);
            return rtn;
        };
        function _proc_exit(code) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(0, 0, 1, code);
            EXITSTATUS = code;
            if (!keepRuntimeAlive()) {
                PThread.terminateAllThreads();
                Module['onExit']?.(code);
                ABORT = true;
            }
            quit_(code, new ExitStatus(code));
        }
        var handleException = (e) => {
            // Certain exception types we do not treat as errors since they are used for
            // internal control flow.
            // 1. ExitStatus, which is thrown by exit()
            // 2. "unwind", which is thrown by emscripten_unwind_to_js_event_loop() and others
            //    that wish to return to JS event loop.
            if (e instanceof ExitStatus || e == 'unwind') {
                return EXITSTATUS;
            }
            checkStackCookie();
            if (e instanceof WebAssembly.RuntimeError) {
                if (_emscripten_stack_get_current() <= 0) {
                    err('Stack overflow detected.  You can try increasing -sSTACK_SIZE (currently set to 65536)');
                }
            }
            quit_(1, e);
        };
        var runtimeKeepalivePop = () => {
            assert(runtimeKeepaliveCounter > 0);
            runtimeKeepaliveCounter -= 1;
        };
        function exitOnMainThread(returnCode) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(1, 0, 0, returnCode);
            runtimeKeepalivePop();
            ;
            _exit(returnCode);
        }
        /** @suppress {duplicate } */
        /** @param {boolean|number=} implicit */
        var exitJS = (status, implicit) => {
            EXITSTATUS = status;
            checkUnflushedContent();
            if (ENVIRONMENT_IS_PTHREAD) {
                // implicit exit can never happen on a pthread
                assert(!implicit);
                // When running in a pthread we propagate the exit back to the main thread
                // where it can decide if the whole process should be shut down or not.
                // The pthread may have decided not to exit its own runtime, for example
                // because it runs a main loop, but that doesn't affect the main thread.
                exitOnMainThread(status);
                throw 'unwind';
            }
            // if exit() was called explicitly, warn the user if the runtime isn't actually being shut down
            if (keepRuntimeAlive() && !implicit) {
                var msg = `program exited (with status: ${status}), but keepRuntimeAlive() is set (counter=${runtimeKeepaliveCounter}) due to an async operation, so halting execution but not exiting the runtime or preventing further async execution (you can use emscripten_force_exit, if you want to force a true shutdown)`;
                readyPromiseReject(msg);
                err(msg);
            }
            _proc_exit(status);
        };
        var _exit = exitJS;
        var ptrToString = (ptr) => {
            assert(typeof ptr === 'number');
            // With CAN_ADDRESS_2GB or MEMORY64, pointers are already unsigned.
            ptr >>>= 0;
            return '0x' + ptr.toString(16).padStart(8, '0');
        };
        var PThread = {
            unusedWorkers: [],
            runningWorkers: [],
            tlsInitFunctions: [],
            pthreads: {},
            nextWorkerID: 1,
            debugInit() {
                function pthreadLogPrefix() {
                    var t = 0;
                    if (runtimeInitialized && typeof _pthread_self != 'undefined') {
                        t = _pthread_self();
                    }
                    return 'w:' + workerID + ',t:' + ptrToString(t) + ': ';
                }
                // Prefix all err()/dbg() messages with the calling thread ID.
                var origDbg = dbg;
                dbg = (...args) => origDbg(pthreadLogPrefix() + args.join(' '));
            },
            init() {
                PThread.debugInit();
                if (ENVIRONMENT_IS_PTHREAD) {
                    PThread.initWorker();
                }
                else {
                    PThread.initMainThread();
                }
            },
            initMainThread() {
                var pthreadPoolSize = 20;
                // Start loading up the Worker pool, if requested.
                while (pthreadPoolSize--) {
                    PThread.allocateUnusedWorker();
                }
                // MINIMAL_RUNTIME takes care of calling loadWasmModuleToAllWorkers
                // in postamble_minimal.js
                addOnPreRun(() => {
                    addRunDependency('loading-workers');
                    PThread.loadWasmModuleToAllWorkers(() => removeRunDependency('loading-workers'));
                });
            },
            initWorker() {
                // The default behaviour for pthreads is always to exit once they return
                // from their entry point (or call pthread_exit).  If we set noExitRuntime
                // to true here on pthreads they would never complete and attempt to
                // pthread_join to them would block forever.
                // pthreads can still choose to set `noExitRuntime` explicitly, or
                // call emscripten_unwind_to_js_event_loop to extend their lifetime beyond
                // their main function.  See comment in src/runtime_pthread.js for more.
                noExitRuntime = false;
            },
            setExitStatus: (status) => EXITSTATUS = status,
            terminateAllThreads__deps: ["$terminateWorker"],
            terminateAllThreads: () => {
                assert(!ENVIRONMENT_IS_PTHREAD, 'Internal Error! terminateAllThreads() can only ever be called from main application thread!');
                // Attempt to kill all workers.  Sadly (at least on the web) there is no
                // way to terminate a worker synchronously, or to be notified when a
                // worker in actually terminated.  This means there is some risk that
                // pthreads will continue to be executing after `worker.terminate` has
                // returned.  For this reason, we don't call `returnWorkerToPool` here or
                // free the underlying pthread data structures.
                for (var worker of PThread.runningWorkers) {
                    terminateWorker(worker);
                }
                for (var worker of PThread.unusedWorkers) {
                    terminateWorker(worker);
                }
                PThread.unusedWorkers = [];
                PThread.runningWorkers = [];
                PThread.pthreads = [];
            },
            returnWorkerToPool: (worker) => {
                // We don't want to run main thread queued calls here, since we are doing
                // some operations that leave the worker queue in an invalid state until
                // we are completely done (it would be bad if free() ends up calling a
                // queued pthread_create which looks at the global data structures we are
                // modifying). To achieve that, defer the free() til the very end, when
                // we are all done.
                var pthread_ptr = worker.pthread_ptr;
                delete PThread.pthreads[pthread_ptr];
                // Note: worker is intentionally not terminated so the pool can
                // dynamically grow.
                PThread.unusedWorkers.push(worker);
                PThread.runningWorkers.splice(PThread.runningWorkers.indexOf(worker), 1);
                // Not a running Worker anymore
                // Detach the worker from the pthread object, and return it to the
                // worker pool as an unused worker.
                worker.pthread_ptr = 0;
                // Finally, free the underlying (and now-unused) pthread structure in
                // linear memory.
                __emscripten_thread_free_data(pthread_ptr);
            },
            receiveObjectTransfer(data) {
                if (typeof GL != 'undefined') {
                    Object.assign(GL.offscreenCanvases, data.offscreenCanvases);
                    if (!Module['canvas'] && data.moduleCanvasId && GL.offscreenCanvases[data.moduleCanvasId]) {
                        Module['canvas'] = GL.offscreenCanvases[data.moduleCanvasId].offscreenCanvas;
                        Module['canvas'].id = data.moduleCanvasId;
                    }
                }
            },
            threadInitTLS() {
                // Call thread init functions (these are the _emscripten_tls_init for each
                // module loaded.
                PThread.tlsInitFunctions.forEach((f) => f());
            },
            loadWasmModuleToWorker: (worker) => new Promise((onFinishedLoading) => {
                worker.onmessage = (e) => {
                    var d = e['data'];
                    var cmd = d['cmd'];
                    // If this message is intended to a recipient that is not the main
                    // thread, forward it to the target thread.
                    if (d['targetThread'] && d['targetThread'] != _pthread_self()) {
                        var targetWorker = PThread.pthreads[d['targetThread']];
                        if (targetWorker) {
                            targetWorker.postMessage(d, d['transferList']);
                        }
                        else {
                            err(`Internal error! Worker sent a message "${cmd}" to target pthread ${d['targetThread']}, but that thread no longer exists!`);
                        }
                        return;
                    }
                    if (cmd === 'checkMailbox') {
                        checkMailbox();
                    }
                    else if (cmd === 'spawnThread') {
                        spawnThread(d);
                    }
                    else if (cmd === 'cleanupThread') {
                        cleanupThread(d['thread']);
                    }
                    else if (cmd === 'killThread') {
                        killThread(d['thread']);
                    }
                    else if (cmd === 'cancelThread') {
                        cancelThread(d['thread']);
                    }
                    else if (cmd === 'loaded') {
                        worker.loaded = true;
                        onFinishedLoading(worker);
                    }
                    else if (cmd === 'alert') {
                        alert(`Thread ${d['threadId']}: ${d['text']}`);
                    }
                    else if (d.target === 'setimmediate') {
                        // Worker wants to postMessage() to itself to implement setImmediate()
                        // emulation.
                        worker.postMessage(d);
                    }
                    else if (cmd === 'callHandler') {
                        Module[d['handler']](...d['args']);
                    }
                    else if (cmd) {
                        // The received message looks like something that should be handled by this message
                        // handler, (since there is a e.data.cmd field present), but is not one of the
                        // recognized commands:
                        err(`worker sent an unknown command ${cmd}`);
                    }
                };
                worker.onerror = (e) => {
                    var message = 'worker sent an error!';
                    if (worker.pthread_ptr) {
                        message = `Pthread ${ptrToString(worker.pthread_ptr)} sent an error!`;
                    }
                    err(`${message} ${e.filename}:${e.lineno}: ${e.message}`);
                    throw e;
                };
                assert(wasmMemory instanceof WebAssembly.Memory, 'WebAssembly memory should have been loaded by now!');
                assert(wasmModule instanceof WebAssembly.Module, 'WebAssembly Module should have been loaded by now!');
                // When running on a pthread, none of the incoming parameters on the module
                // object are present. Proxy known handlers back to the main thread if specified.
                var handlers = [];
                var knownHandlers = [
                    'onExit',
                    'onAbort',
                    'print',
                    'printErr',
                ];
                for (var handler of knownHandlers) {
                    if (Module.propertyIsEnumerable(handler)) {
                        handlers.push(handler);
                    }
                }
                worker.workerID = PThread.nextWorkerID++;
                // Ask the new worker to load up the Emscripten-compiled page. This is a heavy operation.
                worker.postMessage({
                    'cmd': 'load',
                    'handlers': handlers,
                    'wasmMemory': wasmMemory,
                    'wasmModule': wasmModule,
                    'workerID': worker.workerID,
                });
            }),
            loadWasmModuleToAllWorkers(onMaybeReady) {
                // Instantiation is synchronous in pthreads.
                if (ENVIRONMENT_IS_PTHREAD) {
                    return onMaybeReady();
                }
                let pthreadPoolReady = Promise.all(PThread.unusedWorkers.map(PThread.loadWasmModuleToWorker));
                pthreadPoolReady.then(onMaybeReady);
            },
            allocateUnusedWorker() {
                var worker;
                var workerOptions = {
                    // This is the way that we signal to the Web Worker that it is hosting
                    // a pthread.
                    'name': 'em-pthread',
                };
                var pthreadMainJs = _scriptName;
                // We can't use makeModuleReceiveWithVar here since we want to also
                // call URL.createObjectURL on the mainScriptUrlOrBlob.
                if (Module['mainScriptUrlOrBlob']) {
                    pthreadMainJs = Module['mainScriptUrlOrBlob'];
                    if (typeof pthreadMainJs != 'string') {
                        pthreadMainJs = URL.createObjectURL(pthreadMainJs);
                    }
                }
                worker = new Worker(pthreadMainJs, workerOptions);
                PThread.unusedWorkers.push(worker);
            },
            getNewWorker() {
                if (PThread.unusedWorkers.length == 0) {
                    // PTHREAD_POOL_SIZE_STRICT should show a warning and, if set to level `2`, return from the function.
                    PThread.allocateUnusedWorker();
                    PThread.loadWasmModuleToWorker(PThread.unusedWorkers[0]);
                }
                return PThread.unusedWorkers.pop();
            },
        };
        var callRuntimeCallbacks = (callbacks) => {
            while (callbacks.length > 0) {
                // Pass the module as the first argument.
                callbacks.shift()(Module);
            }
        };
        var establishStackSpace = () => {
            var pthread_ptr = _pthread_self();
            var stackHigh = HEAPU32[(((pthread_ptr) + (52)) >> 2)];
            var stackSize = HEAPU32[(((pthread_ptr) + (56)) >> 2)];
            var stackLow = stackHigh - stackSize;
            assert(stackHigh != 0);
            assert(stackLow != 0);
            assert(stackHigh > stackLow, 'stackHigh must be higher then stackLow');
            // Set stack limits used by `emscripten/stack.h` function.  These limits are
            // cached in wasm-side globals to make checks as fast as possible.
            _emscripten_stack_set_limits(stackHigh, stackLow);
            // Call inside wasm module to set up the stack frame for this pthread in wasm module scope
            stackRestore(stackHigh);
            // Write the stack cookie last, after we have set up the proper bounds and
            // current position of the stack.
            writeStackCookie();
        };
        /**
         * @param {number} ptr
         * @param {string} type
         */
        function getValue(ptr, type = 'i8') {
            if (type.endsWith('*'))
                type = '*';
            switch (type) {
                case 'i1': return HEAP8[ptr];
                case 'i8': return HEAP8[ptr];
                case 'i16': return HEAP16[((ptr) >> 1)];
                case 'i32': return HEAP32[((ptr) >> 2)];
                case 'i64': return HEAP64[((ptr) >> 3)];
                case 'float': return HEAPF32[((ptr) >> 2)];
                case 'double': return HEAPF64[((ptr) >> 3)];
                case '*': return HEAPU32[((ptr) >> 2)];
                default: abort(`invalid type for getValue: ${type}`);
            }
        }
        var wasmTableMirror = [];
        /** @type {WebAssembly.Table} */
        var wasmTable;
        var getWasmTableEntry = (funcPtr) => {
            var func = wasmTableMirror[funcPtr];
            if (!func) {
                if (funcPtr >= wasmTableMirror.length)
                    wasmTableMirror.length = funcPtr + 1;
                wasmTableMirror[funcPtr] = func = wasmTable.get(funcPtr);
            }
            assert(wasmTable.get(funcPtr) == func, 'JavaScript-side Wasm function table mirror is out of date!');
            return func;
        };
        var invokeEntryPoint = (ptr, arg) => {
            // An old thread on this worker may have been canceled without returning the
            // `runtimeKeepaliveCounter` to zero. Reset it now so the new thread won't
            // be affected.
            runtimeKeepaliveCounter = 0;
            // pthread entry points are always of signature 'void *ThreadMain(void *arg)'
            // Native codebases sometimes spawn threads with other thread entry point
            // signatures, such as void ThreadMain(void *arg), void *ThreadMain(), or
            // void ThreadMain().  That is not acceptable per C/C++ specification, but
            // x86 compiler ABI extensions enable that to work. If you find the
            // following line to crash, either change the signature to "proper" void
            // *ThreadMain(void *arg) form, or try linking with the Emscripten linker
            // flag -sEMULATE_FUNCTION_POINTER_CASTS to add in emulation for this x86
            // ABI extension.
            var result = getWasmTableEntry(ptr)(arg);
            checkStackCookie();
            function finish(result) {
                if (keepRuntimeAlive()) {
                    PThread.setExitStatus(result);
                }
                else {
                    __emscripten_thread_exit(result);
                }
            }
            finish(result);
        };
        var noExitRuntime = Module['noExitRuntime'] || true;
        var registerTLSInit = (tlsInitFunc) => PThread.tlsInitFunctions.push(tlsInitFunc);
        var runtimeKeepalivePush = () => {
            runtimeKeepaliveCounter += 1;
        };
        /**
         * @param {number} ptr
         * @param {number} value
         * @param {string} type
         */
        function setValue(ptr, value, type = 'i8') {
            if (type.endsWith('*'))
                type = '*';
            switch (type) {
                case 'i1':
                    HEAP8[ptr] = value;
                    break;
                case 'i8':
                    HEAP8[ptr] = value;
                    break;
                case 'i16':
                    HEAP16[((ptr) >> 1)] = value;
                    break;
                case 'i32':
                    HEAP32[((ptr) >> 2)] = value;
                    break;
                case 'i64':
                    HEAP64[((ptr) >> 3)] = BigInt(value);
                    break;
                case 'float':
                    HEAPF32[((ptr) >> 2)] = value;
                    break;
                case 'double':
                    HEAPF64[((ptr) >> 3)] = value;
                    break;
                case '*':
                    HEAPU32[((ptr) >> 2)] = value;
                    break;
                default: abort(`invalid type for setValue: ${type}`);
            }
        }
        var warnOnce = (text) => {
            warnOnce.shown ||= {};
            if (!warnOnce.shown[text]) {
                warnOnce.shown[text] = 1;
                err(text);
            }
        };
        var UTF8Decoder = typeof TextDecoder != 'undefined' ? new TextDecoder() : undefined;
        /**
         * Given a pointer 'idx' to a null-terminated UTF8-encoded string in the given
         * array that contains uint8 values, returns a copy of that string as a
         * Javascript String object.
         * heapOrArray is either a regular array, or a JavaScript typed array view.
         * @param {number} idx
         * @param {number=} maxBytesToRead
         * @return {string}
         */
        var UTF8ArrayToString = (heapOrArray, idx, maxBytesToRead) => {
            var endIdx = idx + maxBytesToRead;
            var endPtr = idx;
            // TextDecoder needs to know the byte length in advance, it doesn't stop on
            // null terminator by itself.  Also, use the length info to avoid running tiny
            // strings through TextDecoder, since .subarray() allocates garbage.
            // (As a tiny code save trick, compare endPtr against endIdx using a negation,
            // so that undefined means Infinity)
            while (heapOrArray[endPtr] && !(endPtr >= endIdx))
                ++endPtr;
            if (endPtr - idx > 16 && heapOrArray.buffer && UTF8Decoder) {
                return UTF8Decoder.decode(heapOrArray.buffer instanceof SharedArrayBuffer ? heapOrArray.slice(idx, endPtr) : heapOrArray.subarray(idx, endPtr));
            }
            var str = '';
            // If building with TextDecoder, we have already computed the string length
            // above, so test loop end condition against that
            while (idx < endPtr) {
                // For UTF8 byte structure, see:
                // http://en.wikipedia.org/wiki/UTF-8#Description
                // https://www.ietf.org/rfc/rfc2279.txt
                // https://tools.ietf.org/html/rfc3629
                var u0 = heapOrArray[idx++];
                if (!(u0 & 0x80)) {
                    str += String.fromCharCode(u0);
                    continue;
                }
                var u1 = heapOrArray[idx++] & 63;
                if ((u0 & 0xE0) == 0xC0) {
                    str += String.fromCharCode(((u0 & 31) << 6) | u1);
                    continue;
                }
                var u2 = heapOrArray[idx++] & 63;
                if ((u0 & 0xF0) == 0xE0) {
                    u0 = ((u0 & 15) << 12) | (u1 << 6) | u2;
                }
                else {
                    if ((u0 & 0xF8) != 0xF0)
                        warnOnce('Invalid UTF-8 leading byte ' + ptrToString(u0) + ' encountered when deserializing a UTF-8 string in wasm memory to a JS string!');
                    u0 = ((u0 & 7) << 18) | (u1 << 12) | (u2 << 6) | (heapOrArray[idx++] & 63);
                }
                if (u0 < 0x10000) {
                    str += String.fromCharCode(u0);
                }
                else {
                    var ch = u0 - 0x10000;
                    str += String.fromCharCode(0xD800 | (ch >> 10), 0xDC00 | (ch & 0x3FF));
                }
            }
            return str;
        };
        /**
         * Given a pointer 'ptr' to a null-terminated UTF8-encoded string in the
         * emscripten HEAP, returns a copy of that string as a Javascript String object.
         *
         * @param {number} ptr
         * @param {number=} maxBytesToRead - An optional length that specifies the
         *   maximum number of bytes to read. You can omit this parameter to scan the
         *   string until the first 0 byte. If maxBytesToRead is passed, and the string
         *   at [ptr, ptr+maxBytesToReadr[ contains a null byte in the middle, then the
         *   string will cut short at that byte index (i.e. maxBytesToRead will not
         *   produce a string of exact length [ptr, ptr+maxBytesToRead[) N.B. mixing
         *   frequent uses of UTF8ToString() with and without maxBytesToRead may throw
         *   JS JIT optimizations off, so it is worth to consider consistently using one
         * @return {string}
         */
        var UTF8ToString = (ptr, maxBytesToRead) => {
            assert(typeof ptr == 'number', `UTF8ToString expects a number (got ${typeof ptr})`);
            return ptr ? UTF8ArrayToString(HEAPU8, ptr, maxBytesToRead) : '';
        };
        var ___assert_fail = (condition, filename, line, func) => {
            abort(`Assertion failed: ${UTF8ToString(condition)}, at: ` + [filename ? UTF8ToString(filename) : 'unknown filename', line, func ? UTF8ToString(func) : 'unknown function']);
        };
        var ___call_sighandler = (fp, sig) => getWasmTableEntry(fp)(sig);
        class ExceptionInfo {
            // excPtr - Thrown object pointer to wrap. Metadata pointer is calculated from it.
            constructor(excPtr) {
                this.excPtr = excPtr;
                this.ptr = excPtr - 24;
            }
            set_type(type) {
                HEAPU32[(((this.ptr) + (4)) >> 2)] = type;
            }
            get_type() {
                return HEAPU32[(((this.ptr) + (4)) >> 2)];
            }
            set_destructor(destructor) {
                HEAPU32[(((this.ptr) + (8)) >> 2)] = destructor;
            }
            get_destructor() {
                return HEAPU32[(((this.ptr) + (8)) >> 2)];
            }
            set_caught(caught) {
                caught = caught ? 1 : 0;
                HEAP8[(this.ptr) + (12)] = caught;
            }
            get_caught() {
                return HEAP8[(this.ptr) + (12)] != 0;
            }
            set_rethrown(rethrown) {
                rethrown = rethrown ? 1 : 0;
                HEAP8[(this.ptr) + (13)] = rethrown;
            }
            get_rethrown() {
                return HEAP8[(this.ptr) + (13)] != 0;
            }
            // Initialize native structure fields. Should be called once after allocated.
            init(type, destructor) {
                this.set_adjusted_ptr(0);
                this.set_type(type);
                this.set_destructor(destructor);
            }
            set_adjusted_ptr(adjustedPtr) {
                HEAPU32[(((this.ptr) + (16)) >> 2)] = adjustedPtr;
            }
            get_adjusted_ptr() {
                return HEAPU32[(((this.ptr) + (16)) >> 2)];
            }
            // Get pointer which is expected to be received by catch clause in C++ code. It may be adjusted
            // when the pointer is casted to some of the exception object base classes (e.g. when virtual
            // inheritance is used). When a pointer is thrown this method should return the thrown pointer
            // itself.
            get_exception_ptr() {
                // Work around a fastcomp bug, this code is still included for some reason in a build without
                // exceptions support.
                var isPointer = ___cxa_is_pointer_type(this.get_type());
                if (isPointer) {
                    return HEAPU32[((this.excPtr) >> 2)];
                }
                var adjusted = this.get_adjusted_ptr();
                if (adjusted !== 0)
                    return adjusted;
                return this.excPtr;
            }
        }
        var exceptionLast = 0;
        var uncaughtExceptionCount = 0;
        var ___cxa_throw = (ptr, type, destructor) => {
            var info = new ExceptionInfo(ptr);
            // Initialize ExceptionInfo content after it was allocated in __cxa_allocate_exception.
            info.init(type, destructor);
            exceptionLast = ptr;
            uncaughtExceptionCount++;
            assert(false, 'Exception thrown, but exception catching is not enabled. Compile with -sNO_DISABLE_EXCEPTION_CATCHING or -sEXCEPTION_CATCHING_ALLOWED=[..] to catch.');
        };
        function pthreadCreateProxied(pthread_ptr, attr, startRoutine, arg) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(2, 0, 1, pthread_ptr, attr, startRoutine, arg);
            return ___pthread_create_js(pthread_ptr, attr, startRoutine, arg);
        }
        var ___pthread_create_js = (pthread_ptr, attr, startRoutine, arg) => {
            if (typeof SharedArrayBuffer == 'undefined') {
                err('Current environment does not support SharedArrayBuffer, pthreads are not available!');
                return 6;
            }
            // List of JS objects that will transfer ownership to the Worker hosting the thread
            var transferList = [];
            var error = 0;
            // Deduce which WebGL canvases (HTMLCanvasElements or OffscreenCanvases) should be passed over to the
            // Worker that hosts the spawned pthread.
            // Comma-delimited list of CSS selectors that must identify canvases by IDs: "#canvas1, #canvas2, ..."
            var transferredCanvasNames = attr ? HEAPU32[(((attr) + (40)) >> 2)] : 0;
            // Proxied canvases string pointer -1/MAX_PTR is used as a special token to
            // fetch whatever canvases were passed to build in
            // -sOFFSCREENCANVASES_TO_PTHREAD= command line.
            if (transferredCanvasNames == 4294967295) {
                transferredCanvasNames = '#canvas';
            }
            else
                transferredCanvasNames &&= UTF8ToString(transferredCanvasNames).trim();
            transferredCanvasNames &&= transferredCanvasNames.split(',');
            var offscreenCanvases = {}; // Dictionary of OffscreenCanvas objects we'll transfer to the created thread to own
            var moduleCanvasId = Module['canvas'] ? Module['canvas'].id : '';
            // Note that transferredCanvasNames might be null (so we cannot do a for-of loop).
            for (var i in transferredCanvasNames) {
                var name = transferredCanvasNames[i].trim();
                var offscreenCanvasInfo;
                try {
                    if (name == '#canvas') {
                        if (!Module['canvas']) {
                            err(`pthread_create: could not find canvas with ID "${name}" to transfer to thread!`);
                            error = 28;
                            break;
                        }
                        name = Module['canvas'].id;
                    }
                    assert(typeof GL == 'object', 'OFFSCREENCANVAS_SUPPORT assumes GL is in use (you can force-include it with \'-sDEFAULT_LIBRARY_FUNCS_TO_INCLUDE=$GL\')');
                    if (GL.offscreenCanvases[name]) {
                        offscreenCanvasInfo = GL.offscreenCanvases[name];
                        GL.offscreenCanvases[name] = null; // This thread no longer owns this canvas.
                        if (Module['canvas'] instanceof OffscreenCanvas && name === Module['canvas'].id)
                            Module['canvas'] = null;
                    }
                    else if (!ENVIRONMENT_IS_PTHREAD) {
                        var canvas = (Module['canvas'] && Module['canvas'].id === name) ? Module['canvas'] : document.querySelector(name);
                        if (!canvas) {
                            err(`pthread_create: could not find canvas with ID "${name}" to transfer to thread!`);
                            error = 28;
                            break;
                        }
                        if (canvas.controlTransferredOffscreen) {
                            err(`pthread_create: cannot transfer canvas with ID "${name}" to thread, since the current thread does not have control over it!`);
                            error = 63; // Operation not permitted, some other thread is accessing the canvas.
                            break;
                        }
                        if (canvas.transferControlToOffscreen) {
                            // Create a shared information block in heap so that we can control
                            // the canvas size from any thread.
                            if (!canvas.canvasSharedPtr) {
                                canvas.canvasSharedPtr = _malloc(12);
                                HEAP32[((canvas.canvasSharedPtr) >> 2)] = canvas.width;
                                HEAP32[(((canvas.canvasSharedPtr) + (4)) >> 2)] = canvas.height;
                                HEAPU32[(((canvas.canvasSharedPtr) + (8)) >> 2)] = 0; // pthread ptr to the thread that owns this canvas, filled in below.
                            }
                            offscreenCanvasInfo = {
                                offscreenCanvas: canvas.transferControlToOffscreen(),
                                canvasSharedPtr: canvas.canvasSharedPtr,
                                id: canvas.id
                            };
                            // After calling canvas.transferControlToOffscreen(), it is no
                            // longer possible to access certain operations on the canvas, such
                            // as resizing it or obtaining GL contexts via it.
                            // Use this field to remember that we have permanently converted
                            // this Canvas to be controlled via an OffscreenCanvas (there is no
                            // way to undo this in the spec)
                            canvas.controlTransferredOffscreen = true;
                        }
                        else {
                            err(`pthread_create: cannot transfer control of canvas "${name}" to pthread, because current browser does not support OffscreenCanvas!`);
                            // If building with OFFSCREEN_FRAMEBUFFER=1 mode, we don't need to
                            // be able to transfer control to offscreen, but WebGL can be
                            // proxied from worker to main thread.
                            err('pthread_create: Build with -sOFFSCREEN_FRAMEBUFFER to enable fallback proxying of GL commands from pthread to main thread.');
                            return 52; // Function not implemented, browser doesn't have support for this.
                        }
                    }
                    if (offscreenCanvasInfo) {
                        transferList.push(offscreenCanvasInfo.offscreenCanvas);
                        offscreenCanvases[offscreenCanvasInfo.id] = offscreenCanvasInfo;
                    }
                }
                catch (e) {
                    err(`pthread_create: failed to transfer control of canvas "${name}" to OffscreenCanvas! Error: ${e}`);
                    return 28; // Hitting this might indicate an implementation bug or some other internal error
                }
            }
            // Synchronously proxy the thread creation to main thread if possible. If we
            // need to transfer ownership of objects, then proxy asynchronously via
            // postMessage.
            if (ENVIRONMENT_IS_PTHREAD && (transferList.length === 0 || error)) {
                return pthreadCreateProxied(pthread_ptr, attr, startRoutine, arg);
            }
            // If on the main thread, and accessing Canvas/OffscreenCanvas failed, abort
            // with the detected error.
            if (error)
                return error;
            // Register for each of the transferred canvases that the new thread now
            // owns the OffscreenCanvas.
            for (var canvas of Object.values(offscreenCanvases)) {
                // pthread ptr to the thread that owns this canvas.
                HEAPU32[(((canvas.canvasSharedPtr) + (8)) >> 2)] = pthread_ptr;
            }
            var threadParams = {
                startRoutine,
                pthread_ptr,
                arg,
                moduleCanvasId,
                offscreenCanvases,
                transferList,
            };
            if (ENVIRONMENT_IS_PTHREAD) {
                // The prepopulated pool of web workers that can host pthreads is stored
                // in the main JS thread. Therefore if a pthread is attempting to spawn a
                // new thread, the thread creation must be deferred to the main JS thread.
                threadParams.cmd = 'spawnThread';
                postMessage(threadParams, transferList);
                // When we defer thread creation this way, we have no way to detect thread
                // creation synchronously today, so we have to assume success and return 0.
                return 0;
            }
            // We are the main thread, so we have the pthread warmup pool in this
            // thread and can fire off JS thread creation directly ourselves.
            return spawnThread(threadParams);
        };
        var ___pthread_kill_js = (thread, signal) => {
            if (signal === 33) { // Used by pthread_cancel in musl
                if (!ENVIRONMENT_IS_PTHREAD)
                    cancelThread(thread);
                else
                    postMessage({ 'cmd': 'cancelThread', 'thread': thread });
            }
            else {
                if (!ENVIRONMENT_IS_PTHREAD)
                    killThread(thread);
                else
                    postMessage({ 'cmd': 'killThread', 'thread': thread });
            }
            return 0;
        };
        var __abort_js = () => {
            abort('native code called abort()');
        };
        var structRegistrations = {};
        var runDestructors = (destructors) => {
            while (destructors.length) {
                var ptr = destructors.pop();
                var del = destructors.pop();
                del(ptr);
            }
        };
        /** @suppress {globalThis} */
        function readPointer(pointer) {
            return this['fromWireType'](HEAPU32[((pointer) >> 2)]);
        }
        var awaitingDependencies = {};
        var registeredTypes = {};
        var typeDependencies = {};
        var InternalError;
        var throwInternalError = (message) => { throw new InternalError(message); };
        var whenDependentTypesAreResolved = (myTypes, dependentTypes, getTypeConverters) => {
            myTypes.forEach(function (type) {
                typeDependencies[type] = dependentTypes;
            });
            function onComplete(typeConverters) {
                var myTypeConverters = getTypeConverters(typeConverters);
                if (myTypeConverters.length !== myTypes.length) {
                    throwInternalError('Mismatched type converter count');
                }
                for (var i = 0; i < myTypes.length; ++i) {
                    registerType(myTypes[i], myTypeConverters[i]);
                }
            }
            var typeConverters = new Array(dependentTypes.length);
            var unregisteredTypes = [];
            var registered = 0;
            dependentTypes.forEach((dt, i) => {
                if (registeredTypes.hasOwnProperty(dt)) {
                    typeConverters[i] = registeredTypes[dt];
                }
                else {
                    unregisteredTypes.push(dt);
                    if (!awaitingDependencies.hasOwnProperty(dt)) {
                        awaitingDependencies[dt] = [];
                    }
                    awaitingDependencies[dt].push(() => {
                        typeConverters[i] = registeredTypes[dt];
                        ++registered;
                        if (registered === unregisteredTypes.length) {
                            onComplete(typeConverters);
                        }
                    });
                }
            });
            if (0 === unregisteredTypes.length) {
                onComplete(typeConverters);
            }
        };
        var __embind_finalize_value_object = (structType) => {
            var reg = structRegistrations[structType];
            delete structRegistrations[structType];
            var rawConstructor = reg.rawConstructor;
            var rawDestructor = reg.rawDestructor;
            var fieldRecords = reg.fields;
            var fieldTypes = fieldRecords.map((field) => field.getterReturnType).
                concat(fieldRecords.map((field) => field.setterArgumentType));
            whenDependentTypesAreResolved([structType], fieldTypes, (fieldTypes) => {
                var fields = {};
                fieldRecords.forEach((field, i) => {
                    var fieldName = field.fieldName;
                    var getterReturnType = fieldTypes[i];
                    var getter = field.getter;
                    var getterContext = field.getterContext;
                    var setterArgumentType = fieldTypes[i + fieldRecords.length];
                    var setter = field.setter;
                    var setterContext = field.setterContext;
                    fields[fieldName] = {
                        read: (ptr) => getterReturnType['fromWireType'](getter(getterContext, ptr)),
                        write: (ptr, o) => {
                            var destructors = [];
                            setter(setterContext, ptr, setterArgumentType['toWireType'](destructors, o));
                            runDestructors(destructors);
                        }
                    };
                });
                return [{
                        name: reg.name,
                        'fromWireType': (ptr) => {
                            var rv = {};
                            for (var i in fields) {
                                rv[i] = fields[i].read(ptr);
                            }
                            rawDestructor(ptr);
                            return rv;
                        },
                        'toWireType': (destructors, o) => {
                            // todo: Here we have an opportunity for -O3 level "unsafe" optimizations:
                            // assume all fields are present without checking.
                            for (var fieldName in fields) {
                                if (!(fieldName in o)) {
                                    throw new TypeError(`Missing field: "${fieldName}"`);
                                }
                            }
                            var ptr = rawConstructor();
                            for (fieldName in fields) {
                                fields[fieldName].write(ptr, o[fieldName]);
                            }
                            if (destructors !== null) {
                                destructors.push(rawDestructor, ptr);
                            }
                            return ptr;
                        },
                        'argPackAdvance': GenericWireTypeSize,
                        'readValueFromPointer': readPointer,
                        destructorFunction: rawDestructor,
                    }];
            });
        };
        var embindRepr = (v) => {
            if (v === null) {
                return 'null';
            }
            var t = typeof v;
            if (t === 'object' || t === 'array' || t === 'function') {
                return v.toString();
            }
            else {
                return '' + v;
            }
        };
        var embind_init_charCodes = () => {
            var codes = new Array(256);
            for (var i = 0; i < 256; ++i) {
                codes[i] = String.fromCharCode(i);
            }
            embind_charCodes = codes;
        };
        var embind_charCodes;
        var readLatin1String = (ptr) => {
            var ret = "";
            var c = ptr;
            while (HEAPU8[c]) {
                ret += embind_charCodes[HEAPU8[c++]];
            }
            return ret;
        };
        var BindingError;
        var throwBindingError = (message) => { throw new BindingError(message); };
        /** @param {Object=} options */
        function sharedRegisterType(rawType, registeredInstance, options = {}) {
            var name = registeredInstance.name;
            if (!rawType) {
                throwBindingError(`type "${name}" must have a positive integer typeid pointer`);
            }
            if (registeredTypes.hasOwnProperty(rawType)) {
                if (options.ignoreDuplicateRegistrations) {
                    return;
                }
                else {
                    throwBindingError(`Cannot register type '${name}' twice`);
                }
            }
            registeredTypes[rawType] = registeredInstance;
            delete typeDependencies[rawType];
            if (awaitingDependencies.hasOwnProperty(rawType)) {
                var callbacks = awaitingDependencies[rawType];
                delete awaitingDependencies[rawType];
                callbacks.forEach((cb) => cb());
            }
        }
        /** @param {Object=} options */
        function registerType(rawType, registeredInstance, options = {}) {
            if (!('argPackAdvance' in registeredInstance)) {
                throw new TypeError('registerType registeredInstance requires argPackAdvance');
            }
            return sharedRegisterType(rawType, registeredInstance, options);
        }
        var integerReadValueFromPointer = (name, width, signed) => {
            // integers are quite common, so generate very specialized functions
            switch (width) {
                case 1: return signed ?
                    (pointer) => HEAP8[pointer] :
                    (pointer) => HEAPU8[pointer];
                case 2: return signed ?
                    (pointer) => HEAP16[((pointer) >> 1)] :
                    (pointer) => HEAPU16[((pointer) >> 1)];
                case 4: return signed ?
                    (pointer) => HEAP32[((pointer) >> 2)] :
                    (pointer) => HEAPU32[((pointer) >> 2)];
                case 8: return signed ?
                    (pointer) => HEAP64[((pointer) >> 3)] :
                    (pointer) => HEAPU64[((pointer) >> 3)];
                default:
                    throw new TypeError(`invalid integer width (${width}): ${name}`);
            }
        };
        /** @suppress {globalThis} */
        var __embind_register_bigint = (primitiveType, name, size, minRange, maxRange) => {
            name = readLatin1String(name);
            var isUnsignedType = (name.indexOf('u') != -1);
            // maxRange comes through as -1 for uint64_t (see issue 13902). Work around that temporarily
            if (isUnsignedType) {
                maxRange = (1n << 64n) - 1n;
            }
            registerType(primitiveType, {
                name,
                'fromWireType': (value) => value,
                'toWireType': function (destructors, value) {
                    if (typeof value != "bigint" && typeof value != "number") {
                        throw new TypeError(`Cannot convert "${embindRepr(value)}" to ${this.name}`);
                    }
                    if (typeof value == "number") {
                        value = BigInt(value);
                    }
                    if (value < minRange || value > maxRange) {
                        throw new TypeError(`Passing a number "${embindRepr(value)}" from JS side to C/C++ side to an argument of type "${name}", which is outside the valid range [${minRange}, ${maxRange}]!`);
                    }
                    return value;
                },
                'argPackAdvance': GenericWireTypeSize,
                'readValueFromPointer': integerReadValueFromPointer(name, size, !isUnsignedType),
                destructorFunction: null, // This type does not need a destructor
            });
        };
        var GenericWireTypeSize = 8;
        /** @suppress {globalThis} */
        var __embind_register_bool = (rawType, name, trueValue, falseValue) => {
            name = readLatin1String(name);
            registerType(rawType, {
                name,
                'fromWireType': function (wt) {
                    // ambiguous emscripten ABI: sometimes return values are
                    // true or false, and sometimes integers (0 or 1)
                    return !!wt;
                },
                'toWireType': function (destructors, o) {
                    return o ? trueValue : falseValue;
                },
                'argPackAdvance': GenericWireTypeSize,
                'readValueFromPointer': function (pointer) {
                    return this['fromWireType'](HEAPU8[pointer]);
                },
                destructorFunction: null, // This type does not need a destructor
            });
        };
        var shallowCopyInternalPointer = (o) => {
            return {
                count: o.count,
                deleteScheduled: o.deleteScheduled,
                preservePointerOnDelete: o.preservePointerOnDelete,
                ptr: o.ptr,
                ptrType: o.ptrType,
                smartPtr: o.smartPtr,
                smartPtrType: o.smartPtrType,
            };
        };
        var throwInstanceAlreadyDeleted = (obj) => {
            function getInstanceTypeName(handle) {
                return handle.$$.ptrType.registeredClass.name;
            }
            throwBindingError(getInstanceTypeName(obj) + ' instance already deleted');
        };
        var finalizationRegistry = false;
        var detachFinalizer = (handle) => { };
        var runDestructor = ($$) => {
            if ($$.smartPtr) {
                $$.smartPtrType.rawDestructor($$.smartPtr);
            }
            else {
                $$.ptrType.registeredClass.rawDestructor($$.ptr);
            }
        };
        var releaseClassHandle = ($$) => {
            $$.count.value -= 1;
            var toDelete = 0 === $$.count.value;
            if (toDelete) {
                runDestructor($$);
            }
        };
        var downcastPointer = (ptr, ptrClass, desiredClass) => {
            if (ptrClass === desiredClass) {
                return ptr;
            }
            if (undefined === desiredClass.baseClass) {
                return null; // no conversion
            }
            var rv = downcastPointer(ptr, ptrClass, desiredClass.baseClass);
            if (rv === null) {
                return null;
            }
            return desiredClass.downcast(rv);
        };
        var registeredPointers = {};
        var getInheritedInstanceCount = () => Object.keys(registeredInstances).length;
        var getLiveInheritedInstances = () => {
            var rv = [];
            for (var k in registeredInstances) {
                if (registeredInstances.hasOwnProperty(k)) {
                    rv.push(registeredInstances[k]);
                }
            }
            return rv;
        };
        var deletionQueue = [];
        var flushPendingDeletes = () => {
            while (deletionQueue.length) {
                var obj = deletionQueue.pop();
                obj.$$.deleteScheduled = false;
                obj['delete']();
            }
        };
        var delayFunction;
        var setDelayFunction = (fn) => {
            delayFunction = fn;
            if (deletionQueue.length && delayFunction) {
                delayFunction(flushPendingDeletes);
            }
        };
        var init_embind = () => {
            Module['getInheritedInstanceCount'] = getInheritedInstanceCount;
            Module['getLiveInheritedInstances'] = getLiveInheritedInstances;
            Module['flushPendingDeletes'] = flushPendingDeletes;
            Module['setDelayFunction'] = setDelayFunction;
        };
        var registeredInstances = {};
        var getBasestPointer = (class_, ptr) => {
            if (ptr === undefined) {
                throwBindingError('ptr should not be undefined');
            }
            while (class_.baseClass) {
                ptr = class_.upcast(ptr);
                class_ = class_.baseClass;
            }
            return ptr;
        };
        var getInheritedInstance = (class_, ptr) => {
            ptr = getBasestPointer(class_, ptr);
            return registeredInstances[ptr];
        };
        var makeClassHandle = (prototype, record) => {
            if (!record.ptrType || !record.ptr) {
                throwInternalError('makeClassHandle requires ptr and ptrType');
            }
            var hasSmartPtrType = !!record.smartPtrType;
            var hasSmartPtr = !!record.smartPtr;
            if (hasSmartPtrType !== hasSmartPtr) {
                throwInternalError('Both smartPtrType and smartPtr must be specified');
            }
            record.count = { value: 1 };
            return attachFinalizer(Object.create(prototype, {
                $$: {
                    value: record,
                    writable: true,
                },
            }));
        };
        /** @suppress {globalThis} */
        function RegisteredPointer_fromWireType(ptr) {
            // ptr is a raw pointer (or a raw smartpointer)
            // rawPointer is a maybe-null raw pointer
            var rawPointer = this.getPointee(ptr);
            if (!rawPointer) {
                this.destructor(ptr);
                return null;
            }
            var registeredInstance = getInheritedInstance(this.registeredClass, rawPointer);
            if (undefined !== registeredInstance) {
                // JS object has been neutered, time to repopulate it
                if (0 === registeredInstance.$$.count.value) {
                    registeredInstance.$$.ptr = rawPointer;
                    registeredInstance.$$.smartPtr = ptr;
                    return registeredInstance['clone']();
                }
                else {
                    // else, just increment reference count on existing object
                    // it already has a reference to the smart pointer
                    var rv = registeredInstance['clone']();
                    this.destructor(ptr);
                    return rv;
                }
            }
            function makeDefaultHandle() {
                if (this.isSmartPointer) {
                    return makeClassHandle(this.registeredClass.instancePrototype, {
                        ptrType: this.pointeeType,
                        ptr: rawPointer,
                        smartPtrType: this,
                        smartPtr: ptr,
                    });
                }
                else {
                    return makeClassHandle(this.registeredClass.instancePrototype, {
                        ptrType: this,
                        ptr,
                    });
                }
            }
            var actualType = this.registeredClass.getActualType(rawPointer);
            var registeredPointerRecord = registeredPointers[actualType];
            if (!registeredPointerRecord) {
                return makeDefaultHandle.call(this);
            }
            var toType;
            if (this.isConst) {
                toType = registeredPointerRecord.constPointerType;
            }
            else {
                toType = registeredPointerRecord.pointerType;
            }
            var dp = downcastPointer(rawPointer, this.registeredClass, toType.registeredClass);
            if (dp === null) {
                return makeDefaultHandle.call(this);
            }
            if (this.isSmartPointer) {
                return makeClassHandle(toType.registeredClass.instancePrototype, {
                    ptrType: toType,
                    ptr: dp,
                    smartPtrType: this,
                    smartPtr: ptr,
                });
            }
            else {
                return makeClassHandle(toType.registeredClass.instancePrototype, {
                    ptrType: toType,
                    ptr: dp,
                });
            }
        }
        var attachFinalizer = (handle) => {
            if ('undefined' === typeof FinalizationRegistry) {
                attachFinalizer = (handle) => handle;
                return handle;
            }
            // If the running environment has a FinalizationRegistry (see
            // https://github.com/tc39/proposal-weakrefs), then attach finalizers
            // for class handles.  We check for the presence of FinalizationRegistry
            // at run-time, not build-time.
            finalizationRegistry = new FinalizationRegistry((info) => {
                console.warn(info.leakWarning.stack.replace(/^Error: /, ''));
                releaseClassHandle(info.$$);
            });
            attachFinalizer = (handle) => {
                var $$ = handle.$$;
                var hasSmartPtr = !!$$.smartPtr;
                if (hasSmartPtr) {
                    // We should not call the destructor on raw pointers in case other code expects the pointee to live
                    var info = { $$: $$ };
                    // Create a warning as an Error instance in advance so that we can store
                    // the current stacktrace and point to it when / if a leak is detected.
                    // This is more useful than the empty stacktrace of `FinalizationRegistry`
                    // callback.
                    var cls = $$.ptrType.registeredClass;
                    info.leakWarning = new Error(`Embind found a leaked C++ instance ${cls.name} <${ptrToString($$.ptr)}>.\n` +
                        "We'll free it automatically in this case, but this functionality is not reliable across various environments.\n" +
                        "Make sure to invoke .delete() manually once you're done with the instance instead.\n" +
                        "Originally allocated"); // `.stack` will add "at ..." after this sentence
                    if ('captureStackTrace' in Error) {
                        Error.captureStackTrace(info.leakWarning, RegisteredPointer_fromWireType);
                    }
                    finalizationRegistry.register(handle, info, handle);
                }
                return handle;
            };
            detachFinalizer = (handle) => finalizationRegistry.unregister(handle);
            return attachFinalizer(handle);
        };
        var init_ClassHandle = () => {
            Object.assign(ClassHandle.prototype, {
                "isAliasOf"(other) {
                    if (!(this instanceof ClassHandle)) {
                        return false;
                    }
                    if (!(other instanceof ClassHandle)) {
                        return false;
                    }
                    var leftClass = this.$$.ptrType.registeredClass;
                    var left = this.$$.ptr;
                    other.$$ = /** @type {Object} */ (other.$$);
                    var rightClass = other.$$.ptrType.registeredClass;
                    var right = other.$$.ptr;
                    while (leftClass.baseClass) {
                        left = leftClass.upcast(left);
                        leftClass = leftClass.baseClass;
                    }
                    while (rightClass.baseClass) {
                        right = rightClass.upcast(right);
                        rightClass = rightClass.baseClass;
                    }
                    return leftClass === rightClass && left === right;
                },
                "clone"() {
                    if (!this.$$.ptr) {
                        throwInstanceAlreadyDeleted(this);
                    }
                    if (this.$$.preservePointerOnDelete) {
                        this.$$.count.value += 1;
                        return this;
                    }
                    else {
                        var clone = attachFinalizer(Object.create(Object.getPrototypeOf(this), {
                            $$: {
                                value: shallowCopyInternalPointer(this.$$),
                            }
                        }));
                        clone.$$.count.value += 1;
                        clone.$$.deleteScheduled = false;
                        return clone;
                    }
                },
                "delete"() {
                    if (!this.$$.ptr) {
                        throwInstanceAlreadyDeleted(this);
                    }
                    if (this.$$.deleteScheduled && !this.$$.preservePointerOnDelete) {
                        throwBindingError('Object already scheduled for deletion');
                    }
                    detachFinalizer(this);
                    releaseClassHandle(this.$$);
                    if (!this.$$.preservePointerOnDelete) {
                        this.$$.smartPtr = undefined;
                        this.$$.ptr = undefined;
                    }
                },
                "isDeleted"() {
                    return !this.$$.ptr;
                },
                "deleteLater"() {
                    if (!this.$$.ptr) {
                        throwInstanceAlreadyDeleted(this);
                    }
                    if (this.$$.deleteScheduled && !this.$$.preservePointerOnDelete) {
                        throwBindingError('Object already scheduled for deletion');
                    }
                    deletionQueue.push(this);
                    if (deletionQueue.length === 1 && delayFunction) {
                        delayFunction(flushPendingDeletes);
                    }
                    this.$$.deleteScheduled = true;
                    return this;
                },
            });
        };
        /** @constructor */
        function ClassHandle() {
        }
        var createNamedFunction = (name, body) => Object.defineProperty(body, 'name', {
            value: name
        });
        var ensureOverloadTable = (proto, methodName, humanName) => {
            if (undefined === proto[methodName].overloadTable) {
                var prevFunc = proto[methodName];
                // Inject an overload resolver function that routes to the appropriate overload based on the number of arguments.
                proto[methodName] = function (...args) {
                    // TODO This check can be removed in -O3 level "unsafe" optimizations.
                    if (!proto[methodName].overloadTable.hasOwnProperty(args.length)) {
                        throwBindingError(`Function '${humanName}' called with an invalid number of arguments (${args.length}) - expects one of (${proto[methodName].overloadTable})!`);
                    }
                    return proto[methodName].overloadTable[args.length].apply(this, args);
                };
                // Move the previous function into the overload table.
                proto[methodName].overloadTable = [];
                proto[methodName].overloadTable[prevFunc.argCount] = prevFunc;
            }
        };
        /** @param {number=} numArguments */
        var exposePublicSymbol = (name, value, numArguments) => {
            if (Module.hasOwnProperty(name)) {
                if (undefined === numArguments || (undefined !== Module[name].overloadTable && undefined !== Module[name].overloadTable[numArguments])) {
                    throwBindingError(`Cannot register public name '${name}' twice`);
                }
                // We are exposing a function with the same name as an existing function. Create an overload table and a function selector
                // that routes between the two.
                ensureOverloadTable(Module, name, name);
                if (Module.hasOwnProperty(numArguments)) {
                    throwBindingError(`Cannot register multiple overloads of a function with the same number of arguments (${numArguments})!`);
                }
                // Add the new function into the overload table.
                Module[name].overloadTable[numArguments] = value;
            }
            else {
                Module[name] = value;
                if (undefined !== numArguments) {
                    Module[name].numArguments = numArguments;
                }
            }
        };
        var char_0 = 48;
        var char_9 = 57;
        var makeLegalFunctionName = (name) => {
            if (undefined === name) {
                return '_unknown';
            }
            name = name.replace(/[^a-zA-Z0-9_]/g, '$');
            var f = name.charCodeAt(0);
            if (f >= char_0 && f <= char_9) {
                return `_${name}`;
            }
            return name;
        };
        /** @constructor */
        function RegisteredClass(name, constructor, instancePrototype, rawDestructor, baseClass, getActualType, upcast, downcast) {
            this.name = name;
            this.constructor = constructor;
            this.instancePrototype = instancePrototype;
            this.rawDestructor = rawDestructor;
            this.baseClass = baseClass;
            this.getActualType = getActualType;
            this.upcast = upcast;
            this.downcast = downcast;
            this.pureVirtualFunctions = [];
        }
        var upcastPointer = (ptr, ptrClass, desiredClass) => {
            while (ptrClass !== desiredClass) {
                if (!ptrClass.upcast) {
                    throwBindingError(`Expected null or instance of ${desiredClass.name}, got an instance of ${ptrClass.name}`);
                }
                ptr = ptrClass.upcast(ptr);
                ptrClass = ptrClass.baseClass;
            }
            return ptr;
        };
        /** @suppress {globalThis} */
        function constNoSmartPtrRawPointerToWireType(destructors, handle) {
            if (handle === null) {
                if (this.isReference) {
                    throwBindingError(`null is not a valid ${this.name}`);
                }
                return 0;
            }
            if (!handle.$$) {
                throwBindingError(`Cannot pass "${embindRepr(handle)}" as a ${this.name}`);
            }
            if (!handle.$$.ptr) {
                throwBindingError(`Cannot pass deleted object as a pointer of type ${this.name}`);
            }
            var handleClass = handle.$$.ptrType.registeredClass;
            var ptr = upcastPointer(handle.$$.ptr, handleClass, this.registeredClass);
            return ptr;
        }
        /** @suppress {globalThis} */
        function genericPointerToWireType(destructors, handle) {
            var ptr;
            if (handle === null) {
                if (this.isReference) {
                    throwBindingError(`null is not a valid ${this.name}`);
                }
                if (this.isSmartPointer) {
                    ptr = this.rawConstructor();
                    if (destructors !== null) {
                        destructors.push(this.rawDestructor, ptr);
                    }
                    return ptr;
                }
                else {
                    return 0;
                }
            }
            if (!handle || !handle.$$) {
                throwBindingError(`Cannot pass "${embindRepr(handle)}" as a ${this.name}`);
            }
            if (!handle.$$.ptr) {
                throwBindingError(`Cannot pass deleted object as a pointer of type ${this.name}`);
            }
            if (!this.isConst && handle.$$.ptrType.isConst) {
                throwBindingError(`Cannot convert argument of type ${(handle.$$.smartPtrType ? handle.$$.smartPtrType.name : handle.$$.ptrType.name)} to parameter type ${this.name}`);
            }
            var handleClass = handle.$$.ptrType.registeredClass;
            ptr = upcastPointer(handle.$$.ptr, handleClass, this.registeredClass);
            if (this.isSmartPointer) {
                // TODO: this is not strictly true
                // We could support BY_EMVAL conversions from raw pointers to smart pointers
                // because the smart pointer can hold a reference to the handle
                if (undefined === handle.$$.smartPtr) {
                    throwBindingError('Passing raw pointer to smart pointer is illegal');
                }
                switch (this.sharingPolicy) {
                    case 0: // NONE
                        // no upcasting
                        if (handle.$$.smartPtrType === this) {
                            ptr = handle.$$.smartPtr;
                        }
                        else {
                            throwBindingError(`Cannot convert argument of type ${(handle.$$.smartPtrType ? handle.$$.smartPtrType.name : handle.$$.ptrType.name)} to parameter type ${this.name}`);
                        }
                        break;
                    case 1: // INTRUSIVE
                        ptr = handle.$$.smartPtr;
                        break;
                    case 2: // BY_EMVAL
                        if (handle.$$.smartPtrType === this) {
                            ptr = handle.$$.smartPtr;
                        }
                        else {
                            var clonedHandle = handle['clone']();
                            ptr = this.rawShare(ptr, Emval.toHandle(() => clonedHandle['delete']()));
                            if (destructors !== null) {
                                destructors.push(this.rawDestructor, ptr);
                            }
                        }
                        break;
                    default:
                        throwBindingError('Unsupporting sharing policy');
                }
            }
            return ptr;
        }
        /** @suppress {globalThis} */
        function nonConstNoSmartPtrRawPointerToWireType(destructors, handle) {
            if (handle === null) {
                if (this.isReference) {
                    throwBindingError(`null is not a valid ${this.name}`);
                }
                return 0;
            }
            if (!handle.$$) {
                throwBindingError(`Cannot pass "${embindRepr(handle)}" as a ${this.name}`);
            }
            if (!handle.$$.ptr) {
                throwBindingError(`Cannot pass deleted object as a pointer of type ${this.name}`);
            }
            if (handle.$$.ptrType.isConst) {
                throwBindingError(`Cannot convert argument of type ${handle.$$.ptrType.name} to parameter type ${this.name}`);
            }
            var handleClass = handle.$$.ptrType.registeredClass;
            var ptr = upcastPointer(handle.$$.ptr, handleClass, this.registeredClass);
            return ptr;
        }
        var init_RegisteredPointer = () => {
            Object.assign(RegisteredPointer.prototype, {
                getPointee(ptr) {
                    if (this.rawGetPointee) {
                        ptr = this.rawGetPointee(ptr);
                    }
                    return ptr;
                },
                destructor(ptr) {
                    this.rawDestructor?.(ptr);
                },
                'argPackAdvance': GenericWireTypeSize,
                'readValueFromPointer': readPointer,
                'fromWireType': RegisteredPointer_fromWireType,
            });
        };
        /** @constructor
            @param {*=} pointeeType,
            @param {*=} sharingPolicy,
            @param {*=} rawGetPointee,
            @param {*=} rawConstructor,
            @param {*=} rawShare,
            @param {*=} rawDestructor,
             */
        function RegisteredPointer(name, registeredClass, isReference, isConst, 
        // smart pointer properties
        isSmartPointer, pointeeType, sharingPolicy, rawGetPointee, rawConstructor, rawShare, rawDestructor) {
            this.name = name;
            this.registeredClass = registeredClass;
            this.isReference = isReference;
            this.isConst = isConst;
            // smart pointer properties
            this.isSmartPointer = isSmartPointer;
            this.pointeeType = pointeeType;
            this.sharingPolicy = sharingPolicy;
            this.rawGetPointee = rawGetPointee;
            this.rawConstructor = rawConstructor;
            this.rawShare = rawShare;
            this.rawDestructor = rawDestructor;
            if (!isSmartPointer && registeredClass.baseClass === undefined) {
                if (isConst) {
                    this['toWireType'] = constNoSmartPtrRawPointerToWireType;
                    this.destructorFunction = null;
                }
                else {
                    this['toWireType'] = nonConstNoSmartPtrRawPointerToWireType;
                    this.destructorFunction = null;
                }
            }
            else {
                this['toWireType'] = genericPointerToWireType;
                // Here we must leave this.destructorFunction undefined, since whether genericPointerToWireType returns
                // a pointer that needs to be freed up is runtime-dependent, and cannot be evaluated at registration time.
                // TODO: Create an alternative mechanism that allows removing the use of var destructors = []; array in
                //       craftInvokerFunction altogether.
            }
        }
        /** @param {number=} numArguments */
        var replacePublicSymbol = (name, value, numArguments) => {
            if (!Module.hasOwnProperty(name)) {
                throwInternalError('Replacing nonexistent public symbol');
            }
            // If there's an overload table for this symbol, replace the symbol in the overload table instead.
            if (undefined !== Module[name].overloadTable && undefined !== numArguments) {
                Module[name].overloadTable[numArguments] = value;
            }
            else {
                Module[name] = value;
                Module[name].argCount = numArguments;
            }
        };
        var embind__requireFunction = (signature, rawFunction) => {
            signature = readLatin1String(signature);
            function makeDynCaller() {
                return getWasmTableEntry(rawFunction);
            }
            var fp = makeDynCaller();
            if (typeof fp != "function") {
                throwBindingError(`unknown function pointer with signature ${signature}: ${rawFunction}`);
            }
            return fp;
        };
        var extendError = (baseErrorType, errorName) => {
            var errorClass = createNamedFunction(errorName, function (message) {
                this.name = errorName;
                this.message = message;
                var stack = (new Error(message)).stack;
                if (stack !== undefined) {
                    this.stack = this.toString() + '\n' +
                        stack.replace(/^Error(:[^\n]*)?\n/, '');
                }
            });
            errorClass.prototype = Object.create(baseErrorType.prototype);
            errorClass.prototype.constructor = errorClass;
            errorClass.prototype.toString = function () {
                if (this.message === undefined) {
                    return this.name;
                }
                else {
                    return `${this.name}: ${this.message}`;
                }
            };
            return errorClass;
        };
        var UnboundTypeError;
        var getTypeName = (type) => {
            var ptr = ___getTypeName(type);
            var rv = readLatin1String(ptr);
            _free(ptr);
            return rv;
        };
        var throwUnboundTypeError = (message, types) => {
            var unboundTypes = [];
            var seen = {};
            function visit(type) {
                if (seen[type]) {
                    return;
                }
                if (registeredTypes[type]) {
                    return;
                }
                if (typeDependencies[type]) {
                    typeDependencies[type].forEach(visit);
                    return;
                }
                unboundTypes.push(type);
                seen[type] = true;
            }
            types.forEach(visit);
            throw new UnboundTypeError(`${message}: ` + unboundTypes.map(getTypeName).join([', ']));
        };
        var __embind_register_class = (rawType, rawPointerType, rawConstPointerType, baseClassRawType, getActualTypeSignature, getActualType, upcastSignature, upcast, downcastSignature, downcast, name, destructorSignature, rawDestructor) => {
            name = readLatin1String(name);
            getActualType = embind__requireFunction(getActualTypeSignature, getActualType);
            upcast &&= embind__requireFunction(upcastSignature, upcast);
            downcast &&= embind__requireFunction(downcastSignature, downcast);
            rawDestructor = embind__requireFunction(destructorSignature, rawDestructor);
            var legalFunctionName = makeLegalFunctionName(name);
            exposePublicSymbol(legalFunctionName, function () {
                // this code cannot run if baseClassRawType is zero
                throwUnboundTypeError(`Cannot construct ${name} due to unbound types`, [baseClassRawType]);
            });
            whenDependentTypesAreResolved([rawType, rawPointerType, rawConstPointerType], baseClassRawType ? [baseClassRawType] : [], (base) => {
                base = base[0];
                var baseClass;
                var basePrototype;
                if (baseClassRawType) {
                    baseClass = base.registeredClass;
                    basePrototype = baseClass.instancePrototype;
                }
                else {
                    basePrototype = ClassHandle.prototype;
                }
                var constructor = createNamedFunction(name, function (...args) {
                    if (Object.getPrototypeOf(this) !== instancePrototype) {
                        throw new BindingError("Use 'new' to construct " + name);
                    }
                    if (undefined === registeredClass.constructor_body) {
                        throw new BindingError(name + " has no accessible constructor");
                    }
                    var body = registeredClass.constructor_body[args.length];
                    if (undefined === body) {
                        throw new BindingError(`Tried to invoke ctor of ${name} with invalid number of parameters (${args.length}) - expected (${Object.keys(registeredClass.constructor_body).toString()}) parameters instead!`);
                    }
                    return body.apply(this, args);
                });
                var instancePrototype = Object.create(basePrototype, {
                    constructor: { value: constructor },
                });
                constructor.prototype = instancePrototype;
                var registeredClass = new RegisteredClass(name, constructor, instancePrototype, rawDestructor, baseClass, getActualType, upcast, downcast);
                if (registeredClass.baseClass) {
                    // Keep track of class hierarchy. Used to allow sub-classes to inherit class functions.
                    registeredClass.baseClass.__derivedClasses ??= [];
                    registeredClass.baseClass.__derivedClasses.push(registeredClass);
                }
                var referenceConverter = new RegisteredPointer(name, registeredClass, true, false, false);
                var pointerConverter = new RegisteredPointer(name + '*', registeredClass, false, false, false);
                var constPointerConverter = new RegisteredPointer(name + ' const*', registeredClass, false, true, false);
                registeredPointers[rawType] = {
                    pointerType: pointerConverter,
                    constPointerType: constPointerConverter
                };
                replacePublicSymbol(legalFunctionName, constructor);
                return [referenceConverter, pointerConverter, constPointerConverter];
            });
        };
        var heap32VectorToArray = (count, firstElement) => {
            var array = [];
            for (var i = 0; i < count; i++) {
                // TODO(https://github.com/emscripten-core/emscripten/issues/17310):
                // Find a way to hoist the `>> 2` or `>> 3` out of this loop.
                array.push(HEAPU32[(((firstElement) + (i * 4)) >> 2)]);
            }
            return array;
        };
        function usesDestructorStack(argTypes) {
            // Skip return value at index 0 - it's not deleted here.
            for (var i = 1; i < argTypes.length; ++i) {
                // The type does not define a destructor function - must use dynamic stack
                if (argTypes[i] !== null && argTypes[i].destructorFunction === undefined) {
                    return true;
                }
            }
            return false;
        }
        function newFunc(constructor, argumentList) {
            if (!(constructor instanceof Function)) {
                throw new TypeError(`new_ called with constructor type ${typeof (constructor)} which is not a function`);
            }
            /*
             * Previously, the following line was just:
             *   function dummy() {};
             * Unfortunately, Chrome was preserving 'dummy' as the object's name, even
             * though at creation, the 'dummy' has the correct constructor name.  Thus,
             * objects created with IMVU.new would show up in the debugger as 'dummy',
             * which isn't very helpful.  Using IMVU.createNamedFunction addresses the
             * issue.  Doubly-unfortunately, there's no way to write a test for this
             * behavior.  -NRD 2013.02.22
             */
            var dummy = createNamedFunction(constructor.name || 'unknownFunctionName', function () { });
            dummy.prototype = constructor.prototype;
            var obj = new dummy;
            var r = constructor.apply(obj, argumentList);
            return (r instanceof Object) ? r : obj;
        }
        function createJsInvoker(argTypes, isClassMethodFunc, returns, isAsync) {
            var needsDestructorStack = usesDestructorStack(argTypes);
            var argCount = argTypes.length;
            var argsList = "";
            var argsListWired = "";
            for (var i = 0; i < argCount - 2; ++i) {
                argsList += (i !== 0 ? ", " : "") + "arg" + i;
                argsListWired += (i !== 0 ? ", " : "") + "arg" + i + "Wired";
            }
            var invokerFnBody = `
        return function (${argsList}) {
        if (arguments.length !== ${argCount - 2}) {
          throwBindingError('function ' + humanName + ' called with ' + arguments.length + ' arguments, expected ${argCount - 2}');
        }`;
            if (needsDestructorStack) {
                invokerFnBody += "var destructors = [];\n";
            }
            var dtorStack = needsDestructorStack ? "destructors" : "null";
            var args1 = ["humanName", "throwBindingError", "invoker", "fn", "runDestructors", "retType", "classParam"];
            if (isClassMethodFunc) {
                invokerFnBody += "var thisWired = classParam['toWireType'](" + dtorStack + ", this);\n";
            }
            for (var i = 0; i < argCount - 2; ++i) {
                invokerFnBody += "var arg" + i + "Wired = argType" + i + "['toWireType'](" + dtorStack + ", arg" + i + ");\n";
                args1.push("argType" + i);
            }
            if (isClassMethodFunc) {
                argsListWired = "thisWired" + (argsListWired.length > 0 ? ", " : "") + argsListWired;
            }
            invokerFnBody +=
                (returns || isAsync ? "var rv = " : "") + "invoker(fn" + (argsListWired.length > 0 ? ", " : "") + argsListWired + ");\n";
            var returnVal = returns ? "rv" : "";
            if (needsDestructorStack) {
                invokerFnBody += "runDestructors(destructors);\n";
            }
            else {
                for (var i = isClassMethodFunc ? 1 : 2; i < argTypes.length; ++i) { // Skip return value at index 0 - it's not deleted here. Also skip class type if not a method.
                    var paramName = (i === 1 ? "thisWired" : ("arg" + (i - 2) + "Wired"));
                    if (argTypes[i].destructorFunction !== null) {
                        invokerFnBody += `${paramName}_dtor(${paramName});\n`;
                        args1.push(`${paramName}_dtor`);
                    }
                }
            }
            if (returns) {
                invokerFnBody += "var ret = retType['fromWireType'](rv);\n" +
                    "return ret;\n";
            }
            else {
            }
            invokerFnBody += "}\n";
            invokerFnBody = `if (arguments.length !== ${args1.length}){ throw new Error(humanName + "Expected ${args1.length} closure arguments " + arguments.length + " given."); }\n${invokerFnBody}`;
            return [args1, invokerFnBody];
        }
        function craftInvokerFunction(humanName, argTypes, classType, cppInvokerFunc, cppTargetFunc, /** boolean= */ isAsync) {
            // humanName: a human-readable string name for the function to be generated.
            // argTypes: An array that contains the embind type objects for all types in the function signature.
            //    argTypes[0] is the type object for the function return value.
            //    argTypes[1] is the type object for function this object/class type, or null if not crafting an invoker for a class method.
            //    argTypes[2...] are the actual function parameters.
            // classType: The embind type object for the class to be bound, or null if this is not a method of a class.
            // cppInvokerFunc: JS Function object to the C++-side function that interops into C++ code.
            // cppTargetFunc: Function pointer (an integer to FUNCTION_TABLE) to the target C++ function the cppInvokerFunc will end up calling.
            // isAsync: Optional. If true, returns an async function. Async bindings are only supported with JSPI.
            var argCount = argTypes.length;
            if (argCount < 2) {
                throwBindingError("argTypes array size mismatch! Must at least get return value and 'this' types!");
            }
            assert(!isAsync, 'Async bindings are only supported with JSPI.');
            var isClassMethodFunc = (argTypes[1] !== null && classType !== null);
            // Free functions with signature "void function()" do not need an invoker that marshalls between wire types.
            // TODO: This omits argument count check - enable only at -O3 or similar.
            //    if (ENABLE_UNSAFE_OPTS && argCount == 2 && argTypes[0].name == "void" && !isClassMethodFunc) {
            //       return FUNCTION_TABLE[fn];
            //    }
            // Determine if we need to use a dynamic stack to store the destructors for the function parameters.
            // TODO: Remove this completely once all function invokers are being dynamically generated.
            var needsDestructorStack = usesDestructorStack(argTypes);
            var returns = (argTypes[0].name !== "void");
            // Builld the arguments that will be passed into the closure around the invoker
            // function.
            var closureArgs = [humanName, throwBindingError, cppInvokerFunc, cppTargetFunc, runDestructors, argTypes[0], argTypes[1]];
            for (var i = 0; i < argCount - 2; ++i) {
                closureArgs.push(argTypes[i + 2]);
            }
            if (!needsDestructorStack) {
                for (var i = isClassMethodFunc ? 1 : 2; i < argTypes.length; ++i) { // Skip return value at index 0 - it's not deleted here. Also skip class type if not a method.
                    if (argTypes[i].destructorFunction !== null) {
                        closureArgs.push(argTypes[i].destructorFunction);
                    }
                }
            }
            let [args, invokerFnBody] = createJsInvoker(argTypes, isClassMethodFunc, returns, isAsync);
            args.push(invokerFnBody);
            var invokerFn = newFunc(Function, args)(...closureArgs);
            return createNamedFunction(humanName, invokerFn);
        }
        var __embind_register_class_constructor = (rawClassType, argCount, rawArgTypesAddr, invokerSignature, invoker, rawConstructor) => {
            assert(argCount > 0);
            var rawArgTypes = heap32VectorToArray(argCount, rawArgTypesAddr);
            invoker = embind__requireFunction(invokerSignature, invoker);
            var args = [rawConstructor];
            var destructors = [];
            whenDependentTypesAreResolved([], [rawClassType], (classType) => {
                classType = classType[0];
                var humanName = `constructor ${classType.name}`;
                if (undefined === classType.registeredClass.constructor_body) {
                    classType.registeredClass.constructor_body = [];
                }
                if (undefined !== classType.registeredClass.constructor_body[argCount - 1]) {
                    throw new BindingError(`Cannot register multiple constructors with identical number of parameters (${argCount - 1}) for class '${classType.name}'! Overload resolution is currently only performed using the parameter count, not actual type info!`);
                }
                classType.registeredClass.constructor_body[argCount - 1] = () => {
                    throwUnboundTypeError(`Cannot construct ${classType.name} due to unbound types`, rawArgTypes);
                };
                whenDependentTypesAreResolved([], rawArgTypes, (argTypes) => {
                    // Insert empty slot for context type (argTypes[1]).
                    argTypes.splice(1, 0, null);
                    classType.registeredClass.constructor_body[argCount - 1] = craftInvokerFunction(humanName, argTypes, null, invoker, rawConstructor);
                    return [];
                });
                return [];
            });
        };
        var getFunctionName = (signature) => {
            signature = signature.trim();
            const argsIndex = signature.indexOf("(");
            if (argsIndex !== -1) {
                assert(signature[signature.length - 1] == ")", "Parentheses for argument names should match.");
                return signature.substr(0, argsIndex);
            }
            else {
                return signature;
            }
        };
        var __embind_register_class_function = (rawClassType, methodName, argCount, rawArgTypesAddr, // [ReturnType, ThisType, Args...]
        invokerSignature, rawInvoker, context, isPureVirtual, isAsync) => {
            var rawArgTypes = heap32VectorToArray(argCount, rawArgTypesAddr);
            methodName = readLatin1String(methodName);
            methodName = getFunctionName(methodName);
            rawInvoker = embind__requireFunction(invokerSignature, rawInvoker);
            whenDependentTypesAreResolved([], [rawClassType], (classType) => {
                classType = classType[0];
                var humanName = `${classType.name}.${methodName}`;
                if (methodName.startsWith("@@")) {
                    methodName = Symbol[methodName.substring(2)];
                }
                if (isPureVirtual) {
                    classType.registeredClass.pureVirtualFunctions.push(methodName);
                }
                function unboundTypesHandler() {
                    throwUnboundTypeError(`Cannot call ${humanName} due to unbound types`, rawArgTypes);
                }
                var proto = classType.registeredClass.instancePrototype;
                var method = proto[methodName];
                if (undefined === method || (undefined === method.overloadTable && method.className !== classType.name && method.argCount === argCount - 2)) {
                    // This is the first overload to be registered, OR we are replacing a
                    // function in the base class with a function in the derived class.
                    unboundTypesHandler.argCount = argCount - 2;
                    unboundTypesHandler.className = classType.name;
                    proto[methodName] = unboundTypesHandler;
                }
                else {
                    // There was an existing function with the same name registered. Set up
                    // a function overload routing table.
                    ensureOverloadTable(proto, methodName, humanName);
                    proto[methodName].overloadTable[argCount - 2] = unboundTypesHandler;
                }
                whenDependentTypesAreResolved([], rawArgTypes, (argTypes) => {
                    var memberFunction = craftInvokerFunction(humanName, argTypes, classType, rawInvoker, context, isAsync);
                    // Replace the initial unbound-handler-stub function with the
                    // appropriate member function, now that all types are resolved. If
                    // multiple overloads are registered for this function, the function
                    // goes into an overload table.
                    if (undefined === proto[methodName].overloadTable) {
                        // Set argCount in case an overload is registered later
                        memberFunction.argCount = argCount - 2;
                        proto[methodName] = memberFunction;
                    }
                    else {
                        proto[methodName].overloadTable[argCount - 2] = memberFunction;
                    }
                    return [];
                });
                return [];
            });
        };
        var emval_freelist = [];
        var emval_handles = [];
        var __emval_decref = (handle) => {
            if (handle > 9 && 0 === --emval_handles[handle + 1]) {
                assert(emval_handles[handle] !== undefined, `Decref for unallocated handle.`);
                emval_handles[handle] = undefined;
                emval_freelist.push(handle);
            }
        };
        var count_emval_handles = () => {
            return emval_handles.length / 2 - 5 - emval_freelist.length;
        };
        var init_emval = () => {
            // reserve 0 and some special values. These never get de-allocated.
            emval_handles.push(0, 1, undefined, 1, null, 1, true, 1, false, 1);
            assert(emval_handles.length === 5 * 2);
            Module['count_emval_handles'] = count_emval_handles;
        };
        var Emval = {
            toValue: (handle) => {
                if (!handle) {
                    throwBindingError('Cannot use deleted val. handle = ' + handle);
                }
                // handle 2 is supposed to be `undefined`.
                assert(handle === 2 || emval_handles[handle] !== undefined && handle % 2 === 0, `invalid handle: ${handle}`);
                return emval_handles[handle];
            },
            toHandle: (value) => {
                switch (value) {
                    case undefined: return 2;
                    case null: return 4;
                    case true: return 6;
                    case false: return 8;
                    default: {
                        const handle = emval_freelist.pop() || emval_handles.length;
                        emval_handles[handle] = value;
                        emval_handles[handle + 1] = 1;
                        return handle;
                    }
                }
            },
        };
        var EmValType = {
            name: 'emscripten::val',
            'fromWireType': (handle) => {
                var rv = Emval.toValue(handle);
                __emval_decref(handle);
                return rv;
            },
            'toWireType': (destructors, value) => Emval.toHandle(value),
            'argPackAdvance': GenericWireTypeSize,
            'readValueFromPointer': readPointer,
            destructorFunction: null, // This type does not need a destructor
            // TODO: do we need a deleteObject here?  write a test where
            // emval is passed into JS via an interface
        };
        var __embind_register_emval = (rawType) => registerType(rawType, EmValType);
        var floatReadValueFromPointer = (name, width) => {
            switch (width) {
                case 4: return function (pointer) {
                    return this['fromWireType'](HEAPF32[((pointer) >> 2)]);
                };
                case 8: return function (pointer) {
                    return this['fromWireType'](HEAPF64[((pointer) >> 3)]);
                };
                default:
                    throw new TypeError(`invalid float width (${width}): ${name}`);
            }
        };
        var __embind_register_float = (rawType, name, size) => {
            name = readLatin1String(name);
            registerType(rawType, {
                name,
                'fromWireType': (value) => value,
                'toWireType': (destructors, value) => {
                    if (typeof value != "number" && typeof value != "boolean") {
                        throw new TypeError(`Cannot convert ${embindRepr(value)} to ${this.name}`);
                    }
                    // The VM will perform JS to Wasm value conversion, according to the spec:
                    // https://www.w3.org/TR/wasm-js-api-1/#towebassemblyvalue
                    return value;
                },
                'argPackAdvance': GenericWireTypeSize,
                'readValueFromPointer': floatReadValueFromPointer(name, size),
                destructorFunction: null, // This type does not need a destructor
            });
        };
        var __embind_register_function = (name, argCount, rawArgTypesAddr, signature, rawInvoker, fn, isAsync) => {
            var argTypes = heap32VectorToArray(argCount, rawArgTypesAddr);
            name = readLatin1String(name);
            name = getFunctionName(name);
            rawInvoker = embind__requireFunction(signature, rawInvoker);
            exposePublicSymbol(name, function () {
                throwUnboundTypeError(`Cannot call ${name} due to unbound types`, argTypes);
            }, argCount - 1);
            whenDependentTypesAreResolved([], argTypes, (argTypes) => {
                var invokerArgsArray = [argTypes[0] /* return value */, null /* no class 'this'*/].concat(argTypes.slice(1) /* actual params */);
                replacePublicSymbol(name, craftInvokerFunction(name, invokerArgsArray, null /* no class 'this'*/, rawInvoker, fn, isAsync), argCount - 1);
                return [];
            });
        };
        /** @suppress {globalThis} */
        var __embind_register_integer = (primitiveType, name, size, minRange, maxRange) => {
            name = readLatin1String(name);
            // LLVM doesn't have signed and unsigned 32-bit types, so u32 literals come
            // out as 'i32 -1'. Always treat those as max u32.
            if (maxRange === -1) {
                maxRange = 4294967295;
            }
            var fromWireType = (value) => value;
            if (minRange === 0) {
                var bitshift = 32 - 8 * size;
                fromWireType = (value) => (value << bitshift) >>> bitshift;
            }
            var isUnsignedType = (name.includes('unsigned'));
            var checkAssertions = (value, toTypeName) => {
                if (typeof value != "number" && typeof value != "boolean") {
                    throw new TypeError(`Cannot convert "${embindRepr(value)}" to ${toTypeName}`);
                }
                if (value < minRange || value > maxRange) {
                    throw new TypeError(`Passing a number "${embindRepr(value)}" from JS side to C/C++ side to an argument of type "${name}", which is outside the valid range [${minRange}, ${maxRange}]!`);
                }
            };
            var toWireType;
            if (isUnsignedType) {
                toWireType = function (destructors, value) {
                    checkAssertions(value, this.name);
                    return value >>> 0;
                };
            }
            else {
                toWireType = function (destructors, value) {
                    checkAssertions(value, this.name);
                    // The VM will perform JS to Wasm value conversion, according to the spec:
                    // https://www.w3.org/TR/wasm-js-api-1/#towebassemblyvalue
                    return value;
                };
            }
            registerType(primitiveType, {
                name,
                'fromWireType': fromWireType,
                'toWireType': toWireType,
                'argPackAdvance': GenericWireTypeSize,
                'readValueFromPointer': integerReadValueFromPointer(name, size, minRange !== 0),
                destructorFunction: null, // This type does not need a destructor
            });
        };
        var __embind_register_memory_view = (rawType, dataTypeIndex, name) => {
            var typeMapping = [
                Int8Array,
                Uint8Array,
                Int16Array,
                Uint16Array,
                Int32Array,
                Uint32Array,
                Float32Array,
                Float64Array,
                BigInt64Array,
                BigUint64Array,
            ];
            var TA = typeMapping[dataTypeIndex];
            function decodeMemoryView(handle) {
                var size = HEAPU32[((handle) >> 2)];
                var data = HEAPU32[(((handle) + (4)) >> 2)];
                return new TA(HEAP8.buffer, data, size);
            }
            name = readLatin1String(name);
            registerType(rawType, {
                name,
                'fromWireType': decodeMemoryView,
                'argPackAdvance': GenericWireTypeSize,
                'readValueFromPointer': decodeMemoryView,
            }, {
                ignoreDuplicateRegistrations: true,
            });
        };
        var __embind_register_optional = (rawOptionalType, rawType) => {
            __embind_register_emval(rawOptionalType);
        };
        var stringToUTF8Array = (str, heap, outIdx, maxBytesToWrite) => {
            assert(typeof str === 'string', `stringToUTF8Array expects a string (got ${typeof str})`);
            // Parameter maxBytesToWrite is not optional. Negative values, 0, null,
            // undefined and false each don't write out any bytes.
            if (!(maxBytesToWrite > 0))
                return 0;
            var startIdx = outIdx;
            var endIdx = outIdx + maxBytesToWrite - 1; // -1 for string null terminator.
            for (var i = 0; i < str.length; ++i) {
                // Gotcha: charCodeAt returns a 16-bit word that is a UTF-16 encoded code
                // unit, not a Unicode code point of the character! So decode
                // UTF16->UTF32->UTF8.
                // See http://unicode.org/faq/utf_bom.html#utf16-3
                // For UTF8 byte structure, see http://en.wikipedia.org/wiki/UTF-8#Description
                // and https://www.ietf.org/rfc/rfc2279.txt
                // and https://tools.ietf.org/html/rfc3629
                var u = str.charCodeAt(i); // possibly a lead surrogate
                if (u >= 0xD800 && u <= 0xDFFF) {
                    var u1 = str.charCodeAt(++i);
                    u = 0x10000 + ((u & 0x3FF) << 10) | (u1 & 0x3FF);
                }
                if (u <= 0x7F) {
                    if (outIdx >= endIdx)
                        break;
                    heap[outIdx++] = u;
                }
                else if (u <= 0x7FF) {
                    if (outIdx + 1 >= endIdx)
                        break;
                    heap[outIdx++] = 0xC0 | (u >> 6);
                    heap[outIdx++] = 0x80 | (u & 63);
                }
                else if (u <= 0xFFFF) {
                    if (outIdx + 2 >= endIdx)
                        break;
                    heap[outIdx++] = 0xE0 | (u >> 12);
                    heap[outIdx++] = 0x80 | ((u >> 6) & 63);
                    heap[outIdx++] = 0x80 | (u & 63);
                }
                else {
                    if (outIdx + 3 >= endIdx)
                        break;
                    if (u > 0x10FFFF)
                        warnOnce('Invalid Unicode code point ' + ptrToString(u) + ' encountered when serializing a JS string to a UTF-8 string in wasm memory! (Valid unicode code points should be in range 0-0x10FFFF).');
                    heap[outIdx++] = 0xF0 | (u >> 18);
                    heap[outIdx++] = 0x80 | ((u >> 12) & 63);
                    heap[outIdx++] = 0x80 | ((u >> 6) & 63);
                    heap[outIdx++] = 0x80 | (u & 63);
                }
            }
            // Null-terminate the pointer to the buffer.
            heap[outIdx] = 0;
            return outIdx - startIdx;
        };
        var stringToUTF8 = (str, outPtr, maxBytesToWrite) => {
            assert(typeof maxBytesToWrite == 'number', 'stringToUTF8(str, outPtr, maxBytesToWrite) is missing the third parameter that specifies the length of the output buffer!');
            return stringToUTF8Array(str, HEAPU8, outPtr, maxBytesToWrite);
        };
        var lengthBytesUTF8 = (str) => {
            var len = 0;
            for (var i = 0; i < str.length; ++i) {
                // Gotcha: charCodeAt returns a 16-bit word that is a UTF-16 encoded code
                // unit, not a Unicode code point of the character! So decode
                // UTF16->UTF32->UTF8.
                // See http://unicode.org/faq/utf_bom.html#utf16-3
                var c = str.charCodeAt(i); // possibly a lead surrogate
                if (c <= 0x7F) {
                    len++;
                }
                else if (c <= 0x7FF) {
                    len += 2;
                }
                else if (c >= 0xD800 && c <= 0xDFFF) {
                    len += 4;
                    ++i;
                }
                else {
                    len += 3;
                }
            }
            return len;
        };
        var __embind_register_std_string = (rawType, name) => {
            name = readLatin1String(name);
            var stdStringIsUTF8 
            //process only std::string bindings with UTF8 support, in contrast to e.g. std::basic_string<unsigned char>
            = (name === "std::string");
            registerType(rawType, {
                name,
                // For some method names we use string keys here since they are part of
                // the public/external API and/or used by the runtime-generated code.
                'fromWireType'(value) {
                    var length = HEAPU32[((value) >> 2)];
                    var payload = value + 4;
                    var str;
                    if (stdStringIsUTF8) {
                        var decodeStartPtr = payload;
                        // Looping here to support possible embedded '0' bytes
                        for (var i = 0; i <= length; ++i) {
                            var currentBytePtr = payload + i;
                            if (i == length || HEAPU8[currentBytePtr] == 0) {
                                var maxRead = currentBytePtr - decodeStartPtr;
                                var stringSegment = UTF8ToString(decodeStartPtr, maxRead);
                                if (str === undefined) {
                                    str = stringSegment;
                                }
                                else {
                                    str += String.fromCharCode(0);
                                    str += stringSegment;
                                }
                                decodeStartPtr = currentBytePtr + 1;
                            }
                        }
                    }
                    else {
                        var a = new Array(length);
                        for (var i = 0; i < length; ++i) {
                            a[i] = String.fromCharCode(HEAPU8[payload + i]);
                        }
                        str = a.join('');
                    }
                    _free(value);
                    return str;
                },
                'toWireType'(destructors, value) {
                    if (value instanceof ArrayBuffer) {
                        value = new Uint8Array(value);
                    }
                    var length;
                    var valueIsOfTypeString = (typeof value == 'string');
                    if (!(valueIsOfTypeString || value instanceof Uint8Array || value instanceof Uint8ClampedArray || value instanceof Int8Array)) {
                        throwBindingError('Cannot pass non-string to std::string');
                    }
                    if (stdStringIsUTF8 && valueIsOfTypeString) {
                        length = lengthBytesUTF8(value);
                    }
                    else {
                        length = value.length;
                    }
                    // assumes POINTER_SIZE alignment
                    var base = _malloc(4 + length + 1);
                    var ptr = base + 4;
                    HEAPU32[((base) >> 2)] = length;
                    if (stdStringIsUTF8 && valueIsOfTypeString) {
                        stringToUTF8(value, ptr, length + 1);
                    }
                    else {
                        if (valueIsOfTypeString) {
                            for (var i = 0; i < length; ++i) {
                                var charCode = value.charCodeAt(i);
                                if (charCode > 255) {
                                    _free(ptr);
                                    throwBindingError('String has UTF-16 code units that do not fit in 8 bits');
                                }
                                HEAPU8[ptr + i] = charCode;
                            }
                        }
                        else {
                            for (var i = 0; i < length; ++i) {
                                HEAPU8[ptr + i] = value[i];
                            }
                        }
                    }
                    if (destructors !== null) {
                        destructors.push(_free, base);
                    }
                    return base;
                },
                'argPackAdvance': GenericWireTypeSize,
                'readValueFromPointer': readPointer,
                destructorFunction(ptr) {
                    _free(ptr);
                },
            });
        };
        var UTF16Decoder = typeof TextDecoder != 'undefined' ? new TextDecoder('utf-16le') : undefined;
        ;
        var UTF16ToString = (ptr, maxBytesToRead) => {
            assert(ptr % 2 == 0, 'Pointer passed to UTF16ToString must be aligned to two bytes!');
            var endPtr = ptr;
            // TextDecoder needs to know the byte length in advance, it doesn't stop on
            // null terminator by itself.
            // Also, use the length info to avoid running tiny strings through
            // TextDecoder, since .subarray() allocates garbage.
            var idx = endPtr >> 1;
            var maxIdx = idx + maxBytesToRead / 2;
            // If maxBytesToRead is not passed explicitly, it will be undefined, and this
            // will always evaluate to true. This saves on code size.
            while (!(idx >= maxIdx) && HEAPU16[idx])
                ++idx;
            endPtr = idx << 1;
            if (endPtr - ptr > 32 && UTF16Decoder)
                return UTF16Decoder.decode(HEAPU8.slice(ptr, endPtr));
            // Fallback: decode without UTF16Decoder
            var str = '';
            // If maxBytesToRead is not passed explicitly, it will be undefined, and the
            // for-loop's condition will always evaluate to true. The loop is then
            // terminated on the first null char.
            for (var i = 0; !(i >= maxBytesToRead / 2); ++i) {
                var codeUnit = HEAP16[(((ptr) + (i * 2)) >> 1)];
                if (codeUnit == 0)
                    break;
                // fromCharCode constructs a character from a UTF-16 code unit, so we can
                // pass the UTF16 string right through.
                str += String.fromCharCode(codeUnit);
            }
            return str;
        };
        var stringToUTF16 = (str, outPtr, maxBytesToWrite) => {
            assert(outPtr % 2 == 0, 'Pointer passed to stringToUTF16 must be aligned to two bytes!');
            assert(typeof maxBytesToWrite == 'number', 'stringToUTF16(str, outPtr, maxBytesToWrite) is missing the third parameter that specifies the length of the output buffer!');
            // Backwards compatibility: if max bytes is not specified, assume unsafe unbounded write is allowed.
            maxBytesToWrite ??= 0x7FFFFFFF;
            if (maxBytesToWrite < 2)
                return 0;
            maxBytesToWrite -= 2; // Null terminator.
            var startPtr = outPtr;
            var numCharsToWrite = (maxBytesToWrite < str.length * 2) ? (maxBytesToWrite / 2) : str.length;
            for (var i = 0; i < numCharsToWrite; ++i) {
                // charCodeAt returns a UTF-16 encoded code unit, so it can be directly written to the HEAP.
                var codeUnit = str.charCodeAt(i); // possibly a lead surrogate
                HEAP16[((outPtr) >> 1)] = codeUnit;
                outPtr += 2;
            }
            // Null-terminate the pointer to the HEAP.
            HEAP16[((outPtr) >> 1)] = 0;
            return outPtr - startPtr;
        };
        var lengthBytesUTF16 = (str) => {
            return str.length * 2;
        };
        var UTF32ToString = (ptr, maxBytesToRead) => {
            assert(ptr % 4 == 0, 'Pointer passed to UTF32ToString must be aligned to four bytes!');
            var i = 0;
            var str = '';
            // If maxBytesToRead is not passed explicitly, it will be undefined, and this
            // will always evaluate to true. This saves on code size.
            while (!(i >= maxBytesToRead / 4)) {
                var utf32 = HEAP32[(((ptr) + (i * 4)) >> 2)];
                if (utf32 == 0)
                    break;
                ++i;
                // Gotcha: fromCharCode constructs a character from a UTF-16 encoded code (pair), not from a Unicode code point! So encode the code point to UTF-16 for constructing.
                // See http://unicode.org/faq/utf_bom.html#utf16-3
                if (utf32 >= 0x10000) {
                    var ch = utf32 - 0x10000;
                    str += String.fromCharCode(0xD800 | (ch >> 10), 0xDC00 | (ch & 0x3FF));
                }
                else {
                    str += String.fromCharCode(utf32);
                }
            }
            return str;
        };
        var stringToUTF32 = (str, outPtr, maxBytesToWrite) => {
            assert(outPtr % 4 == 0, 'Pointer passed to stringToUTF32 must be aligned to four bytes!');
            assert(typeof maxBytesToWrite == 'number', 'stringToUTF32(str, outPtr, maxBytesToWrite) is missing the third parameter that specifies the length of the output buffer!');
            // Backwards compatibility: if max bytes is not specified, assume unsafe unbounded write is allowed.
            maxBytesToWrite ??= 0x7FFFFFFF;
            if (maxBytesToWrite < 4)
                return 0;
            var startPtr = outPtr;
            var endPtr = startPtr + maxBytesToWrite - 4;
            for (var i = 0; i < str.length; ++i) {
                // Gotcha: charCodeAt returns a 16-bit word that is a UTF-16 encoded code unit, not a Unicode code point of the character! We must decode the string to UTF-32 to the heap.
                // See http://unicode.org/faq/utf_bom.html#utf16-3
                var codeUnit = str.charCodeAt(i); // possibly a lead surrogate
                if (codeUnit >= 0xD800 && codeUnit <= 0xDFFF) {
                    var trailSurrogate = str.charCodeAt(++i);
                    codeUnit = 0x10000 + ((codeUnit & 0x3FF) << 10) | (trailSurrogate & 0x3FF);
                }
                HEAP32[((outPtr) >> 2)] = codeUnit;
                outPtr += 4;
                if (outPtr + 4 > endPtr)
                    break;
            }
            // Null-terminate the pointer to the HEAP.
            HEAP32[((outPtr) >> 2)] = 0;
            return outPtr - startPtr;
        };
        var lengthBytesUTF32 = (str) => {
            var len = 0;
            for (var i = 0; i < str.length; ++i) {
                // Gotcha: charCodeAt returns a 16-bit word that is a UTF-16 encoded code unit, not a Unicode code point of the character! We must decode the string to UTF-32 to the heap.
                // See http://unicode.org/faq/utf_bom.html#utf16-3
                var codeUnit = str.charCodeAt(i);
                if (codeUnit >= 0xD800 && codeUnit <= 0xDFFF)
                    ++i; // possibly a lead surrogate, so skip over the tail surrogate.
                len += 4;
            }
            return len;
        };
        var __embind_register_std_wstring = (rawType, charSize, name) => {
            name = readLatin1String(name);
            var decodeString, encodeString, readCharAt, lengthBytesUTF;
            if (charSize === 2) {
                decodeString = UTF16ToString;
                encodeString = stringToUTF16;
                lengthBytesUTF = lengthBytesUTF16;
                readCharAt = (pointer) => HEAPU16[((pointer) >> 1)];
            }
            else if (charSize === 4) {
                decodeString = UTF32ToString;
                encodeString = stringToUTF32;
                lengthBytesUTF = lengthBytesUTF32;
                readCharAt = (pointer) => HEAPU32[((pointer) >> 2)];
            }
            registerType(rawType, {
                name,
                'fromWireType': (value) => {
                    // Code mostly taken from _embind_register_std_string fromWireType
                    var length = HEAPU32[((value) >> 2)];
                    var str;
                    var decodeStartPtr = value + 4;
                    // Looping here to support possible embedded '0' bytes
                    for (var i = 0; i <= length; ++i) {
                        var currentBytePtr = value + 4 + i * charSize;
                        if (i == length || readCharAt(currentBytePtr) == 0) {
                            var maxReadBytes = currentBytePtr - decodeStartPtr;
                            var stringSegment = decodeString(decodeStartPtr, maxReadBytes);
                            if (str === undefined) {
                                str = stringSegment;
                            }
                            else {
                                str += String.fromCharCode(0);
                                str += stringSegment;
                            }
                            decodeStartPtr = currentBytePtr + charSize;
                        }
                    }
                    _free(value);
                    return str;
                },
                'toWireType': (destructors, value) => {
                    if (!(typeof value == 'string')) {
                        throwBindingError(`Cannot pass non-string to C++ string type ${name}`);
                    }
                    // assumes POINTER_SIZE alignment
                    var length = lengthBytesUTF(value);
                    var ptr = _malloc(4 + length + charSize);
                    HEAPU32[((ptr) >> 2)] = length / charSize;
                    encodeString(value, ptr + 4, length + charSize);
                    if (destructors !== null) {
                        destructors.push(_free, ptr);
                    }
                    return ptr;
                },
                'argPackAdvance': GenericWireTypeSize,
                'readValueFromPointer': readPointer,
                destructorFunction(ptr) {
                    _free(ptr);
                }
            });
        };
        var __embind_register_value_object = (rawType, name, constructorSignature, rawConstructor, destructorSignature, rawDestructor) => {
            structRegistrations[rawType] = {
                name: readLatin1String(name),
                rawConstructor: embind__requireFunction(constructorSignature, rawConstructor),
                rawDestructor: embind__requireFunction(destructorSignature, rawDestructor),
                fields: [],
            };
        };
        var __embind_register_value_object_field = (structType, fieldName, getterReturnType, getterSignature, getter, getterContext, setterArgumentType, setterSignature, setter, setterContext) => {
            structRegistrations[structType].fields.push({
                fieldName: readLatin1String(fieldName),
                getterReturnType,
                getter: embind__requireFunction(getterSignature, getter),
                getterContext,
                setterArgumentType,
                setter: embind__requireFunction(setterSignature, setter),
                setterContext,
            });
        };
        var __embind_register_void = (rawType, name) => {
            name = readLatin1String(name);
            registerType(rawType, {
                isVoid: true, // void return values can be optimized out sometimes
                name,
                'argPackAdvance': 0,
                'fromWireType': () => undefined,
                // TODO: assert if anything else is given?
                'toWireType': (destructors, o) => undefined,
            });
        };
        var nowIsMonotonic = 1;
        var __emscripten_get_now_is_monotonic = () => nowIsMonotonic;
        var __emscripten_init_main_thread_js = (tb) => {
            // Pass the thread address to the native code where they stored in wasm
            // globals which act as a form of TLS. Global constructors trying
            // to access this value will read the wrong value, but that is UB anyway.
            __emscripten_thread_init(tb, 
            /*is_main=*/ !ENVIRONMENT_IS_WORKER, 
            /*is_runtime=*/ 1, 
            /*can_block=*/ !ENVIRONMENT_IS_WEB, 
            /*default_stacksize=*/ 65536, 
            /*start_profiling=*/ false);
            PThread.threadInitTLS();
        };
        var maybeExit = () => {
            if (!keepRuntimeAlive()) {
                try {
                    if (ENVIRONMENT_IS_PTHREAD)
                        __emscripten_thread_exit(EXITSTATUS);
                    else
                        _exit(EXITSTATUS);
                }
                catch (e) {
                    handleException(e);
                }
            }
        };
        var callUserCallback = (func) => {
            if (ABORT) {
                err('user callback triggered after runtime exited or application aborted.  Ignoring.');
                return;
            }
            try {
                func();
                maybeExit();
            }
            catch (e) {
                handleException(e);
            }
        };
        var __emscripten_thread_mailbox_await = (pthread_ptr) => {
            if (typeof Atomics.waitAsync === 'function') {
                // Wait on the pthread's initial self-pointer field because it is easy and
                // safe to access from sending threads that need to notify the waiting
                // thread.
                // TODO: How to make this work with wasm64?
                var wait = Atomics.waitAsync(HEAP32, ((pthread_ptr) >> 2), pthread_ptr);
                assert(wait.async);
                wait.value.then(checkMailbox);
                var waitingAsync = pthread_ptr + 128;
                Atomics.store(HEAP32, ((waitingAsync) >> 2), 1);
            }
            // If `Atomics.waitAsync` is not implemented, then we will always fall back
            // to postMessage and there is no need to do anything here.
        };
        var checkMailbox = () => {
            // Only check the mailbox if we have a live pthread runtime. We implement
            // pthread_self to return 0 if there is no live runtime.
            var pthread_ptr = _pthread_self();
            if (pthread_ptr) {
                // If we are using Atomics.waitAsync as our notification mechanism, wait
                // for a notification before processing the mailbox to avoid missing any
                // work that could otherwise arrive after we've finished processing the
                // mailbox and before we're ready for the next notification.
                __emscripten_thread_mailbox_await(pthread_ptr);
                callUserCallback(__emscripten_check_mailbox);
            }
        };
        var __emscripten_notify_mailbox_postmessage = (targetThreadId, currThreadId, mainThreadId) => {
            if (targetThreadId == currThreadId) {
                setTimeout(checkMailbox);
            }
            else if (ENVIRONMENT_IS_PTHREAD) {
                postMessage({ 'targetThread': targetThreadId, 'cmd': 'checkMailbox' });
            }
            else {
                var worker = PThread.pthreads[targetThreadId];
                if (!worker) {
                    err(`Cannot send message to thread with ID ${targetThreadId}, unknown thread ID!`);
                    return;
                }
                worker.postMessage({ 'cmd': 'checkMailbox' });
            }
        };
        var proxiedJSCallArgs = [];
        var __emscripten_receive_on_main_thread_js = (funcIndex, emAsmAddr, callingThread, numCallArgs, args) => {
            // Sometimes we need to backproxy events to the calling thread (e.g.
            // HTML5 DOM events handlers such as
            // emscripten_set_mousemove_callback()), so keep track in a globally
            // accessible variable about the thread that initiated the proxying.
            numCallArgs /= 2;
            proxiedJSCallArgs.length = numCallArgs;
            var b = ((args) >> 3);
            for (var i = 0; i < numCallArgs; i++) {
                if (HEAP64[b + 2 * i]) {
                    // It's a BigInt.
                    proxiedJSCallArgs[i] = HEAP64[b + 2 * i + 1];
                }
                else {
                    // It's a Number.
                    proxiedJSCallArgs[i] = HEAPF64[b + 2 * i + 1];
                }
            }
            // Proxied JS library funcs use funcIndex and EM_ASM functions use emAsmAddr
            var func = emAsmAddr ? ASM_CONSTS[emAsmAddr] : proxiedFunctionTable[funcIndex];
            assert(!(funcIndex && emAsmAddr));
            assert(func.length == numCallArgs, 'Call args mismatch in _emscripten_receive_on_main_thread_js');
            PThread.currentProxiedOperationCallerThread = callingThread;
            var rtn = func(...proxiedJSCallArgs);
            PThread.currentProxiedOperationCallerThread = 0;
            // Proxied functions can return any type except bigint.  All other types
            // cooerce to f64/double (the return type of this function in C) but not
            // bigint.
            assert(typeof rtn != "bigint");
            return rtn;
        };
        function __emscripten_runtime_keepalive_clear() {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(3, 0, 1);
            noExitRuntime = false;
            runtimeKeepaliveCounter = 0;
        }
        var JSEvents = {
            removeAllEventListeners() {
                while (JSEvents.eventHandlers.length) {
                    JSEvents._removeHandler(JSEvents.eventHandlers.length - 1);
                }
                JSEvents.deferredCalls = [];
            },
            inEventHandler: 0,
            deferredCalls: [],
            deferCall(targetFunction, precedence, argsList) {
                function arraysHaveEqualContent(arrA, arrB) {
                    if (arrA.length != arrB.length)
                        return false;
                    for (var i in arrA) {
                        if (arrA[i] != arrB[i])
                            return false;
                    }
                    return true;
                }
                // Test if the given call was already queued, and if so, don't add it again.
                for (var i in JSEvents.deferredCalls) {
                    var call = JSEvents.deferredCalls[i];
                    if (call.targetFunction == targetFunction && arraysHaveEqualContent(call.argsList, argsList)) {
                        return;
                    }
                }
                JSEvents.deferredCalls.push({
                    targetFunction,
                    precedence,
                    argsList
                });
                JSEvents.deferredCalls.sort((x, y) => x.precedence < y.precedence);
            },
            removeDeferredCalls(targetFunction) {
                for (var i = 0; i < JSEvents.deferredCalls.length; ++i) {
                    if (JSEvents.deferredCalls[i].targetFunction == targetFunction) {
                        JSEvents.deferredCalls.splice(i, 1);
                        --i;
                    }
                }
            },
            canPerformEventHandlerRequests() {
                if (navigator.userActivation) {
                    // Verify against transient activation status from UserActivation API
                    // whether it is possible to perform a request here without needing to defer. See
                    // https://developer.mozilla.org/en-US/docs/Web/Security/User_activation#transient_activation
                    // and https://caniuse.com/mdn-api_useractivation
                    // At the time of writing, Firefox does not support this API: https://bugzilla.mozilla.org/show_bug.cgi?id=1791079
                    return navigator.userActivation.isActive;
                }
                return JSEvents.inEventHandler && JSEvents.currentEventHandler.allowsDeferredCalls;
            },
            runDeferredCalls() {
                if (!JSEvents.canPerformEventHandlerRequests()) {
                    return;
                }
                for (var i = 0; i < JSEvents.deferredCalls.length; ++i) {
                    var call = JSEvents.deferredCalls[i];
                    JSEvents.deferredCalls.splice(i, 1);
                    --i;
                    call.targetFunction(...call.argsList);
                }
            },
            eventHandlers: [],
            removeAllHandlersOnTarget: (target, eventTypeString) => {
                for (var i = 0; i < JSEvents.eventHandlers.length; ++i) {
                    if (JSEvents.eventHandlers[i].target == target &&
                        (!eventTypeString || eventTypeString == JSEvents.eventHandlers[i].eventTypeString)) {
                        JSEvents._removeHandler(i--);
                    }
                }
            },
            _removeHandler(i) {
                var h = JSEvents.eventHandlers[i];
                h.target.removeEventListener(h.eventTypeString, h.eventListenerFunc, h.useCapture);
                JSEvents.eventHandlers.splice(i, 1);
            },
            registerOrRemoveHandler(eventHandler) {
                if (!eventHandler.target) {
                    err('registerOrRemoveHandler: the target element for event handler registration does not exist, when processing the following event handler registration:');
                    console.dir(eventHandler);
                    return -4;
                }
                if (eventHandler.callbackfunc) {
                    eventHandler.eventListenerFunc = function (event) {
                        // Increment nesting count for the event handler.
                        ++JSEvents.inEventHandler;
                        JSEvents.currentEventHandler = eventHandler;
                        // Process any old deferred calls the user has placed.
                        JSEvents.runDeferredCalls();
                        // Process the actual event, calls back to user C code handler.
                        eventHandler.handlerFunc(event);
                        // Process any new deferred calls that were placed right now from this event handler.
                        JSEvents.runDeferredCalls();
                        // Out of event handler - restore nesting count.
                        --JSEvents.inEventHandler;
                    };
                    eventHandler.target.addEventListener(eventHandler.eventTypeString, eventHandler.eventListenerFunc, eventHandler.useCapture);
                    JSEvents.eventHandlers.push(eventHandler);
                }
                else {
                    for (var i = 0; i < JSEvents.eventHandlers.length; ++i) {
                        if (JSEvents.eventHandlers[i].target == eventHandler.target
                            && JSEvents.eventHandlers[i].eventTypeString == eventHandler.eventTypeString) {
                            JSEvents._removeHandler(i--);
                        }
                    }
                }
                return 0;
            },
            getTargetThreadForEventCallback(targetThread) {
                switch (targetThread) {
                    case 1:
                        // The event callback for the current event should be called on the
                        // main browser thread. (0 == don't proxy)
                        return 0;
                    case 2:
                        // The event callback for the current event should be backproxied to
                        // the thread that is registering the event.
                        // This can be 0 in the case that the caller uses
                        // EM_CALLBACK_THREAD_CONTEXT_CALLING_THREAD but on the main thread
                        // itself.
                        return PThread.currentProxiedOperationCallerThread;
                    default:
                        // The event callback for the current event should be proxied to the
                        // given specific thread.
                        return targetThread;
                }
            },
            getNodeNameForTarget(target) {
                if (!target)
                    return '';
                if (target == window)
                    return '#window';
                if (target == screen)
                    return '#screen';
                return target?.nodeName || '';
            },
            fullscreenEnabled() {
                return document.fullscreenEnabled
                    // Safari 13.0.3 on macOS Catalina 10.15.1 still ships with prefixed webkitFullscreenEnabled.
                    // TODO: If Safari at some point ships with unprefixed version, update the version check above.
                    || document.webkitFullscreenEnabled;
            },
        };
        var stringToNewUTF8 = (str) => {
            var size = lengthBytesUTF8(str) + 1;
            var ret = _malloc(size);
            if (ret)
                stringToUTF8(str, ret, size);
            return ret;
        };
        var setOffscreenCanvasSizeOnTargetThread = (targetThread, targetCanvas, width, height) => {
            targetCanvas = targetCanvas ? UTF8ToString(targetCanvas) : '';
            var targetCanvasPtr = 0;
            if (targetCanvas) {
                targetCanvasPtr = stringToNewUTF8(targetCanvas);
            }
            __emscripten_set_offscreencanvas_size_on_thread(targetThread, targetCanvasPtr, width, height);
        };
        var webgl_enable_ANGLE_instanced_arrays = (ctx) => {
            // Extension available in WebGL 1 from Firefox 26 and Google Chrome 30 onwards. Core feature in WebGL 2.
            var ext = ctx.getExtension('ANGLE_instanced_arrays');
            if (ext) {
                ctx['vertexAttribDivisor'] = (index, divisor) => ext['vertexAttribDivisorANGLE'](index, divisor);
                ctx['drawArraysInstanced'] = (mode, first, count, primcount) => ext['drawArraysInstancedANGLE'](mode, first, count, primcount);
                ctx['drawElementsInstanced'] = (mode, count, type, indices, primcount) => ext['drawElementsInstancedANGLE'](mode, count, type, indices, primcount);
                return 1;
            }
        };
        var webgl_enable_OES_vertex_array_object = (ctx) => {
            // Extension available in WebGL 1 from Firefox 25 and WebKit 536.28/desktop Safari 6.0.3 onwards. Core feature in WebGL 2.
            var ext = ctx.getExtension('OES_vertex_array_object');
            if (ext) {
                ctx['createVertexArray'] = () => ext['createVertexArrayOES']();
                ctx['deleteVertexArray'] = (vao) => ext['deleteVertexArrayOES'](vao);
                ctx['bindVertexArray'] = (vao) => ext['bindVertexArrayOES'](vao);
                ctx['isVertexArray'] = (vao) => ext['isVertexArrayOES'](vao);
                return 1;
            }
        };
        var webgl_enable_WEBGL_draw_buffers = (ctx) => {
            // Extension available in WebGL 1 from Firefox 28 onwards. Core feature in WebGL 2.
            var ext = ctx.getExtension('WEBGL_draw_buffers');
            if (ext) {
                ctx['drawBuffers'] = (n, bufs) => ext['drawBuffersWEBGL'](n, bufs);
                return 1;
            }
        };
        var webgl_enable_WEBGL_draw_instanced_base_vertex_base_instance = (ctx) => 
        // Closure is expected to be allowed to minify the '.dibvbi' property, so not accessing it quoted.
        !!(ctx.dibvbi = ctx.getExtension('WEBGL_draw_instanced_base_vertex_base_instance'));
        var webgl_enable_WEBGL_multi_draw_instanced_base_vertex_base_instance = (ctx) => {
            // Closure is expected to be allowed to minify the '.mdibvbi' property, so not accessing it quoted.
            return !!(ctx.mdibvbi = ctx.getExtension('WEBGL_multi_draw_instanced_base_vertex_base_instance'));
        };
        var webgl_enable_WEBGL_multi_draw = (ctx) => {
            // Closure is expected to be allowed to minify the '.multiDrawWebgl' property, so not accessing it quoted.
            return !!(ctx.multiDrawWebgl = ctx.getExtension('WEBGL_multi_draw'));
        };
        var getEmscriptenSupportedExtensions = (ctx) => {
            // Restrict the list of advertised extensions to those that we actually
            // support.
            var supportedExtensions = [
                // WebGL 1 extensions
                'ANGLE_instanced_arrays',
                'EXT_blend_minmax',
                'EXT_disjoint_timer_query',
                'EXT_frag_depth',
                'EXT_shader_texture_lod',
                'EXT_sRGB',
                'OES_element_index_uint',
                'OES_fbo_render_mipmap',
                'OES_standard_derivatives',
                'OES_texture_float',
                'OES_texture_half_float',
                'OES_texture_half_float_linear',
                'OES_vertex_array_object',
                'WEBGL_color_buffer_float',
                'WEBGL_depth_texture',
                'WEBGL_draw_buffers',
                // WebGL 2 extensions
                'EXT_color_buffer_float',
                'EXT_conservative_depth',
                'EXT_disjoint_timer_query_webgl2',
                'EXT_texture_norm16',
                'NV_shader_noperspective_interpolation',
                'WEBGL_clip_cull_distance',
                // WebGL 1 and WebGL 2 extensions
                'EXT_color_buffer_half_float',
                'EXT_depth_clamp',
                'EXT_float_blend',
                'EXT_texture_compression_bptc',
                'EXT_texture_compression_rgtc',
                'EXT_texture_filter_anisotropic',
                'KHR_parallel_shader_compile',
                'OES_texture_float_linear',
                'WEBGL_blend_func_extended',
                'WEBGL_compressed_texture_astc',
                'WEBGL_compressed_texture_etc',
                'WEBGL_compressed_texture_etc1',
                'WEBGL_compressed_texture_s3tc',
                'WEBGL_compressed_texture_s3tc_srgb',
                'WEBGL_debug_renderer_info',
                'WEBGL_debug_shaders',
                'WEBGL_lose_context',
                'WEBGL_multi_draw',
            ];
            // .getSupportedExtensions() can return null if context is lost, so coerce to empty array.
            return (ctx.getSupportedExtensions() || []).filter(ext => supportedExtensions.includes(ext));
        };
        var GL = {
            counter: 1,
            buffers: [],
            mappedBuffers: {},
            programs: [],
            framebuffers: [],
            renderbuffers: [],
            textures: [],
            shaders: [],
            vaos: [],
            contexts: {},
            offscreenCanvases: {},
            queries: [],
            samplers: [],
            transformFeedbacks: [],
            syncs: [],
            byteSizeByTypeRoot: 5120,
            byteSizeByType: [1, 1, 2, 2, 4, 4, 4, 2, 3, 4, 8],
            stringCache: {},
            stringiCache: {},
            unpackAlignment: 4,
            unpackRowLength: 0,
            recordError: (errorCode) => {
                if (!GL.lastError) {
                    GL.lastError = errorCode;
                }
            },
            getNewId: (table) => {
                var ret = GL.counter++;
                for (var i = table.length; i < ret; i++) {
                    table[i] = null;
                }
                return ret;
            },
            genObject: (n, buffers, createFunction, objectTable) => {
                for (var i = 0; i < n; i++) {
                    var buffer = GLctx[createFunction]();
                    var id = buffer && GL.getNewId(objectTable);
                    if (buffer) {
                        buffer.name = id;
                        objectTable[id] = buffer;
                    }
                    else {
                        GL.recordError(0x502 /* GL_INVALID_OPERATION */);
                    }
                    HEAP32[(((buffers) + (i * 4)) >> 2)] = id;
                }
            },
            MAX_TEMP_BUFFER_SIZE: 2097152,
            numTempVertexBuffersPerSize: 64,
            log2ceilLookup: (i) => 32 - Math.clz32(i === 0 ? 0 : i - 1),
            generateTempBuffers: (quads, context) => {
                var largestIndex = GL.log2ceilLookup(GL.MAX_TEMP_BUFFER_SIZE);
                context.tempVertexBufferCounters1 = [];
                context.tempVertexBufferCounters2 = [];
                context.tempVertexBufferCounters1.length = context.tempVertexBufferCounters2.length = largestIndex + 1;
                context.tempVertexBuffers1 = [];
                context.tempVertexBuffers2 = [];
                context.tempVertexBuffers1.length = context.tempVertexBuffers2.length = largestIndex + 1;
                context.tempIndexBuffers = [];
                context.tempIndexBuffers.length = largestIndex + 1;
                for (var i = 0; i <= largestIndex; ++i) {
                    context.tempIndexBuffers[i] = null; // Created on-demand
                    context.tempVertexBufferCounters1[i] = context.tempVertexBufferCounters2[i] = 0;
                    var ringbufferLength = GL.numTempVertexBuffersPerSize;
                    context.tempVertexBuffers1[i] = [];
                    context.tempVertexBuffers2[i] = [];
                    var ringbuffer1 = context.tempVertexBuffers1[i];
                    var ringbuffer2 = context.tempVertexBuffers2[i];
                    ringbuffer1.length = ringbuffer2.length = ringbufferLength;
                    for (var j = 0; j < ringbufferLength; ++j) {
                        ringbuffer1[j] = ringbuffer2[j] = null; // Created on-demand
                    }
                }
                if (quads) {
                    // GL_QUAD indexes can be precalculated
                    context.tempQuadIndexBuffer = GLctx.createBuffer();
                    context.GLctx.bindBuffer(0x8893 /*GL_ELEMENT_ARRAY_BUFFER*/, context.tempQuadIndexBuffer);
                    var numIndexes = GL.MAX_TEMP_BUFFER_SIZE >> 1;
                    var quadIndexes = new Uint16Array(numIndexes);
                    var i = 0, v = 0;
                    while (1) {
                        quadIndexes[i++] = v;
                        if (i >= numIndexes)
                            break;
                        quadIndexes[i++] = v + 1;
                        if (i >= numIndexes)
                            break;
                        quadIndexes[i++] = v + 2;
                        if (i >= numIndexes)
                            break;
                        quadIndexes[i++] = v;
                        if (i >= numIndexes)
                            break;
                        quadIndexes[i++] = v + 2;
                        if (i >= numIndexes)
                            break;
                        quadIndexes[i++] = v + 3;
                        if (i >= numIndexes)
                            break;
                        v += 4;
                    }
                    context.GLctx.bufferData(0x8893 /*GL_ELEMENT_ARRAY_BUFFER*/, quadIndexes, 0x88E4 /*GL_STATIC_DRAW*/);
                    context.GLctx.bindBuffer(0x8893 /*GL_ELEMENT_ARRAY_BUFFER*/, null);
                }
            },
            getTempVertexBuffer: (sizeBytes) => {
                var idx = GL.log2ceilLookup(sizeBytes);
                var ringbuffer = GL.currentContext.tempVertexBuffers1[idx];
                var nextFreeBufferIndex = GL.currentContext.tempVertexBufferCounters1[idx];
                GL.currentContext.tempVertexBufferCounters1[idx] = (GL.currentContext.tempVertexBufferCounters1[idx] + 1) & (GL.numTempVertexBuffersPerSize - 1);
                var vbo = ringbuffer[nextFreeBufferIndex];
                if (vbo) {
                    return vbo;
                }
                var prevVBO = GLctx.getParameter(0x8894 /*GL_ARRAY_BUFFER_BINDING*/);
                ringbuffer[nextFreeBufferIndex] = GLctx.createBuffer();
                GLctx.bindBuffer(0x8892 /*GL_ARRAY_BUFFER*/, ringbuffer[nextFreeBufferIndex]);
                GLctx.bufferData(0x8892 /*GL_ARRAY_BUFFER*/, 1 << idx, 0x88E8 /*GL_DYNAMIC_DRAW*/);
                GLctx.bindBuffer(0x8892 /*GL_ARRAY_BUFFER*/, prevVBO);
                return ringbuffer[nextFreeBufferIndex];
            },
            getTempIndexBuffer: (sizeBytes) => {
                var idx = GL.log2ceilLookup(sizeBytes);
                var ibo = GL.currentContext.tempIndexBuffers[idx];
                if (ibo) {
                    return ibo;
                }
                var prevIBO = GLctx.getParameter(0x8895 /*ELEMENT_ARRAY_BUFFER_BINDING*/);
                GL.currentContext.tempIndexBuffers[idx] = GLctx.createBuffer();
                GLctx.bindBuffer(0x8893 /*GL_ELEMENT_ARRAY_BUFFER*/, GL.currentContext.tempIndexBuffers[idx]);
                GLctx.bufferData(0x8893 /*GL_ELEMENT_ARRAY_BUFFER*/, 1 << idx, 0x88E8 /*GL_DYNAMIC_DRAW*/);
                GLctx.bindBuffer(0x8893 /*GL_ELEMENT_ARRAY_BUFFER*/, prevIBO);
                return GL.currentContext.tempIndexBuffers[idx];
            },
            newRenderingFrameStarted: () => {
                if (!GL.currentContext) {
                    return;
                }
                var vb = GL.currentContext.tempVertexBuffers1;
                GL.currentContext.tempVertexBuffers1 = GL.currentContext.tempVertexBuffers2;
                GL.currentContext.tempVertexBuffers2 = vb;
                vb = GL.currentContext.tempVertexBufferCounters1;
                GL.currentContext.tempVertexBufferCounters1 = GL.currentContext.tempVertexBufferCounters2;
                GL.currentContext.tempVertexBufferCounters2 = vb;
                var largestIndex = GL.log2ceilLookup(GL.MAX_TEMP_BUFFER_SIZE);
                for (var i = 0; i <= largestIndex; ++i) {
                    GL.currentContext.tempVertexBufferCounters1[i] = 0;
                }
            },
            getSource: (shader, count, string, length) => {
                var source = '';
                for (var i = 0; i < count; ++i) {
                    var len = length ? HEAPU32[(((length) + (i * 4)) >> 2)] : undefined;
                    source += UTF8ToString(HEAPU32[(((string) + (i * 4)) >> 2)], len);
                }
                return source;
            },
            calcBufLength: (size, type, stride, count) => {
                if (stride > 0) {
                    return count * stride; // XXXvlad this is not exactly correct I don't think
                }
                var typeSize = GL.byteSizeByType[type - GL.byteSizeByTypeRoot];
                return size * typeSize * count;
            },
            usedTempBuffers: [],
            preDrawHandleClientVertexAttribBindings: (count) => {
                GL.resetBufferBinding = false;
                // TODO: initial pass to detect ranges we need to upload, might not need
                // an upload per attrib
                for (var i = 0; i < GL.currentContext.maxVertexAttribs; ++i) {
                    var cb = GL.currentContext.clientBuffers[i];
                    if (!cb.clientside || !cb.enabled)
                        continue;
                    GL.resetBufferBinding = true;
                    var size = GL.calcBufLength(cb.size, cb.type, cb.stride, count);
                    var buf = GL.getTempVertexBuffer(size);
                    GLctx.bindBuffer(0x8892 /*GL_ARRAY_BUFFER*/, buf);
                    GLctx.bufferSubData(0x8892 /*GL_ARRAY_BUFFER*/, 0, HEAPU8.subarray(cb.ptr, cb.ptr + size));
                    cb.vertexAttribPointerAdaptor.call(GLctx, i, cb.size, cb.type, cb.normalized, cb.stride, 0);
                }
            },
            postDrawHandleClientVertexAttribBindings: () => {
                if (GL.resetBufferBinding) {
                    GLctx.bindBuffer(0x8892 /*GL_ARRAY_BUFFER*/, GL.buffers[GLctx.currentArrayBufferBinding]);
                }
            },
            createContext: (/** @type {HTMLCanvasElement} */ canvas, webGLContextAttributes) => {
                // BUG: Workaround Safari WebGL issue: After successfully acquiring WebGL
                // context on a canvas, calling .getContext() will always return that
                // context independent of which 'webgl' or 'webgl2'
                // context version was passed. See:
                //   https://bugs.webkit.org/show_bug.cgi?id=222758
                // and:
                //   https://github.com/emscripten-core/emscripten/issues/13295.
                // TODO: Once the bug is fixed and shipped in Safari, adjust the Safari
                // version field in above check.
                if (!canvas.getContextSafariWebGL2Fixed) {
                    canvas.getContextSafariWebGL2Fixed = canvas.getContext;
                    /** @type {function(this:HTMLCanvasElement, string, (Object|null)=): (Object|null)} */
                    function fixedGetContext(ver, attrs) {
                        var gl = canvas.getContextSafariWebGL2Fixed(ver, attrs);
                        return ((ver == 'webgl') == (gl instanceof WebGLRenderingContext)) ? gl : null;
                    }
                    canvas.getContext = fixedGetContext;
                }
                var ctx = (webGLContextAttributes.majorVersion > 1)
                    ?
                        canvas.getContext("webgl2", webGLContextAttributes)
                    :
                        (canvas.getContext("webgl", webGLContextAttributes)
                        // https://caniuse.com/#feat=webgl
                        );
                if (!ctx)
                    return 0;
                var handle = GL.registerContext(ctx, webGLContextAttributes);
                return handle;
            },
            registerContext: (ctx, webGLContextAttributes) => {
                // with pthreads a context is a location in memory with some synchronized
                // data between threads
                var handle = _malloc(8);
                HEAPU32[(((handle) + (4)) >> 2)] = _pthread_self(); // the thread pointer of the thread that owns the control of the context
                var context = {
                    handle,
                    attributes: webGLContextAttributes,
                    version: webGLContextAttributes.majorVersion,
                    GLctx: ctx
                };
                // Store the created context object so that we can access the context
                // given a canvas without having to pass the parameters again.
                if (ctx.canvas)
                    ctx.canvas.GLctxObject = context;
                GL.contexts[handle] = context;
                if (typeof webGLContextAttributes.enableExtensionsByDefault == 'undefined' || webGLContextAttributes.enableExtensionsByDefault) {
                    GL.initExtensions(context);
                }
                context.maxVertexAttribs = context.GLctx.getParameter(0x8869 /*GL_MAX_VERTEX_ATTRIBS*/);
                context.clientBuffers = [];
                for (var i = 0; i < context.maxVertexAttribs; i++) {
                    context.clientBuffers[i] = {
                        enabled: false,
                        clientside: false,
                        size: 0,
                        type: 0,
                        normalized: 0,
                        stride: 0,
                        ptr: 0,
                        vertexAttribPointerAdaptor: null,
                    };
                }
                GL.generateTempBuffers(false, context);
                return handle;
            },
            makeContextCurrent: (contextHandle) => {
                // Active Emscripten GL layer context object.
                GL.currentContext = GL.contexts[contextHandle];
                // Active WebGL context object.
                Module.ctx = GLctx = GL.currentContext?.GLctx;
                return !(contextHandle && !GLctx);
            },
            getContext: (contextHandle) => {
                return GL.contexts[contextHandle];
            },
            deleteContext: (contextHandle) => {
                if (GL.currentContext === GL.contexts[contextHandle]) {
                    GL.currentContext = null;
                }
                if (typeof JSEvents == 'object') {
                    // Release all JS event handlers on the DOM element that the GL context is
                    // associated with since the context is now deleted.
                    JSEvents.removeAllHandlersOnTarget(GL.contexts[contextHandle].GLctx.canvas);
                }
                // Make sure the canvas object no longer refers to the context object so
                // there are no GC surprises.
                if (GL.contexts[contextHandle] && GL.contexts[contextHandle].GLctx.canvas) {
                    GL.contexts[contextHandle].GLctx.canvas.GLctxObject = undefined;
                }
                _free(GL.contexts[contextHandle].handle);
                GL.contexts[contextHandle] = null;
            },
            initExtensions: (context) => {
                // If this function is called without a specific context object, init the
                // extensions of the currently active context.
                context ||= GL.currentContext;
                if (context.initExtensionsDone)
                    return;
                context.initExtensionsDone = true;
                var GLctx = context.GLctx;
                // Detect the presence of a few extensions manually, ction GL interop
                // layer itself will need to know if they exist.
                // Extensions that are only available in WebGL 1 (the calls will be no-ops
                // if called on a WebGL 2 context active)
                webgl_enable_ANGLE_instanced_arrays(GLctx);
                webgl_enable_OES_vertex_array_object(GLctx);
                webgl_enable_WEBGL_draw_buffers(GLctx);
                // Extensions that are available from WebGL >= 2 (no-op if called on a WebGL 1 context active)
                webgl_enable_WEBGL_draw_instanced_base_vertex_base_instance(GLctx);
                webgl_enable_WEBGL_multi_draw_instanced_base_vertex_base_instance(GLctx);
                // On WebGL 2, EXT_disjoint_timer_query is replaced with an alternative
                // that's based on core APIs, and exposes only the queryCounterEXT()
                // entrypoint.
                if (context.version >= 2) {
                    GLctx.disjointTimerQueryExt = GLctx.getExtension("EXT_disjoint_timer_query_webgl2");
                }
                // However, Firefox exposes the WebGL 1 version on WebGL 2 as well and
                // thus we look for the WebGL 1 version again if the WebGL 2 version
                // isn't present. https://bugzilla.mozilla.org/show_bug.cgi?id=1328882
                if (context.version < 2 || !GLctx.disjointTimerQueryExt) {
                    GLctx.disjointTimerQueryExt = GLctx.getExtension("EXT_disjoint_timer_query");
                }
                webgl_enable_WEBGL_multi_draw(GLctx);
                getEmscriptenSupportedExtensions(GLctx).forEach((ext) => {
                    // WEBGL_lose_context, WEBGL_debug_renderer_info and WEBGL_debug_shaders
                    // are not enabled by default.
                    if (!ext.includes('lose_context') && !ext.includes('debug')) {
                        // Call .getExtension() to enable that extension permanently.
                        GLctx.getExtension(ext);
                    }
                });
            },
        };
        var maybeCStringToJsString = (cString) => {
            // "cString > 2" checks if the input is a number, and isn't of the special
            // values we accept here, EMSCRIPTEN_EVENT_TARGET_* (which map to 0, 1, 2).
            // In other words, if cString > 2 then it's a pointer to a valid place in
            // memory, and points to a C string.
            return cString > 2 ? UTF8ToString(cString) : cString;
        };
        var findCanvasEventTarget = (target) => {
            target = maybeCStringToJsString(target);
            // When compiling with OffscreenCanvas support and looking up a canvas to target,
            // we first look up if the target Canvas has been transferred to OffscreenCanvas use.
            // These transfers are represented/tracked by GL.offscreenCanvases object, which contain
            // the OffscreenCanvas element for each regular Canvas element that has been transferred.
            // Note that each pthread/worker have their own set of GL.offscreenCanvases. That is,
            // when an OffscreenCanvas is transferred from a pthread/main thread to another pthread,
            // it will move in the GL.offscreenCanvases array between threads. Hence GL.offscreenCanvases
            // represents the set of OffscreenCanvases owned by the current calling thread.
            // First check out the list of OffscreenCanvases by CSS selector ID ('#myCanvasID')
            return GL.offscreenCanvases[target.substr(1)] // Remove '#' prefix
                // If not found, if one is querying by using DOM tag name selector 'canvas', grab the first
                // OffscreenCanvas that we can find.
                || (target == 'canvas' && Object.keys(GL.offscreenCanvases)[0])
                // If that is not found either, query via the regular DOM selector.
                || (typeof document != 'undefined' && document.querySelector(target));
        };
        var setCanvasElementSizeCallingThread = (target, width, height) => {
            var canvas = findCanvasEventTarget(target);
            if (!canvas)
                return -4;
            if (canvas.canvasSharedPtr) {
                // N.B. We hold the canvasSharedPtr info structure as the authoritative source for specifying the size of a canvas
                // since the actual canvas size changes are asynchronous if the canvas is owned by an OffscreenCanvas on another thread.
                // Therefore when setting the size, eagerly set the size of the canvas on the calling thread here, though this thread
                // might not be the one that actually ends up specifying the size, but the actual size change may be dispatched
                // as an asynchronous event below.
                HEAP32[((canvas.canvasSharedPtr) >> 2)] = width;
                HEAP32[(((canvas.canvasSharedPtr) + (4)) >> 2)] = height;
            }
            if (canvas.offscreenCanvas || !canvas.controlTransferredOffscreen) {
                if (canvas.offscreenCanvas)
                    canvas = canvas.offscreenCanvas;
                var autoResizeViewport = false;
                if (canvas.GLctxObject?.GLctx) {
                    var prevViewport = canvas.GLctxObject.GLctx.getParameter(0xBA2 /* GL_VIEWPORT */);
                    // TODO: Perhaps autoResizeViewport should only be true if FBO 0 is currently active?
                    autoResizeViewport = (prevViewport[0] === 0 && prevViewport[1] === 0 && prevViewport[2] === canvas.width && prevViewport[3] === canvas.height);
                }
                canvas.width = width;
                canvas.height = height;
                if (autoResizeViewport) {
                    // TODO: Add -sCANVAS_RESIZE_SETS_GL_VIEWPORT=0/1 option (default=1). This is commonly done and several graphics engines depend on this,
                    // but this can be quite disruptive.
                    canvas.GLctxObject.GLctx.viewport(0, 0, width, height);
                }
            }
            else if (canvas.canvasSharedPtr) {
                var targetThread = HEAPU32[(((canvas.canvasSharedPtr) + (8)) >> 2)];
                setOffscreenCanvasSizeOnTargetThread(targetThread, target, width, height);
                return 1; // This will have to be done asynchronously
            }
            else {
                return -4;
            }
            return 0;
        };
        function setCanvasElementSizeMainThread(target, width, height) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(4, 0, 1, target, width, height);
            return setCanvasElementSizeCallingThread(target, width, height);
        }
        /** @suppress {duplicate } */
        var _emscripten_set_canvas_element_size = (target, width, height) => {
            var canvas = findCanvasEventTarget(target);
            if (canvas) {
                return setCanvasElementSizeCallingThread(target, width, height);
            }
            return setCanvasElementSizeMainThread(target, width, height);
        };
        var __emscripten_set_offscreencanvas_size = _emscripten_set_canvas_element_size;
        var __emscripten_thread_cleanup = (thread) => {
            // Called when a thread needs to be cleaned up so it can be reused.
            // A thread is considered reusable when it either returns from its
            // entry point, calls pthread_exit, or acts upon a cancellation.
            // Detached threads are responsible for calling this themselves,
            // otherwise pthread_join is responsible for calling this.
            if (!ENVIRONMENT_IS_PTHREAD)
                cleanupThread(thread);
            else
                postMessage({ 'cmd': 'cleanupThread', 'thread': thread });
        };
        var __emscripten_thread_set_strongref = (thread) => {
            // Called when a thread needs to be strongly referenced.
            // Currently only used for:
            // - keeping the "main" thread alive in PROXY_TO_PTHREAD mode;
            // - crashed threads that needs to propagate the uncaught exception
            //   back to the main thread.
        };
        var __emscripten_throw_longjmp = () => {
            throw Infinity;
        };
        var requireRegisteredType = (rawType, humanName) => {
            var impl = registeredTypes[rawType];
            if (undefined === impl) {
                throwBindingError(`${humanName} has unknown type ${getTypeName(rawType)}`);
            }
            return impl;
        };
        var __emval_take_value = (type, arg) => {
            type = requireRegisteredType(type, '_emval_take_value');
            var v = type['readValueFromPointer'](arg);
            return Emval.toHandle(v);
        };
        function __gmtime_js(time, tmPtr) {
            time = bigintToI53Checked(time);
            var date = new Date(time * 1000);
            HEAP32[((tmPtr) >> 2)] = date.getUTCSeconds();
            HEAP32[(((tmPtr) + (4)) >> 2)] = date.getUTCMinutes();
            HEAP32[(((tmPtr) + (8)) >> 2)] = date.getUTCHours();
            HEAP32[(((tmPtr) + (12)) >> 2)] = date.getUTCDate();
            HEAP32[(((tmPtr) + (16)) >> 2)] = date.getUTCMonth();
            HEAP32[(((tmPtr) + (20)) >> 2)] = date.getUTCFullYear() - 1900;
            HEAP32[(((tmPtr) + (24)) >> 2)] = date.getUTCDay();
            var start = Date.UTC(date.getUTCFullYear(), 0, 1, 0, 0, 0, 0);
            var yday = ((date.getTime() - start) / (1000 * 60 * 60 * 24)) | 0;
            HEAP32[(((tmPtr) + (28)) >> 2)] = yday;
            ;
        }
        var isLeapYear = (year) => year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
        var MONTH_DAYS_LEAP_CUMULATIVE = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];
        var MONTH_DAYS_REGULAR_CUMULATIVE = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
        var ydayFromDate = (date) => {
            var leap = isLeapYear(date.getFullYear());
            var monthDaysCumulative = (leap ? MONTH_DAYS_LEAP_CUMULATIVE : MONTH_DAYS_REGULAR_CUMULATIVE);
            var yday = monthDaysCumulative[date.getMonth()] + date.getDate() - 1; // -1 since it's days since Jan 1
            return yday;
        };
        function __localtime_js(time, tmPtr) {
            time = bigintToI53Checked(time);
            var date = new Date(time * 1000);
            HEAP32[((tmPtr) >> 2)] = date.getSeconds();
            HEAP32[(((tmPtr) + (4)) >> 2)] = date.getMinutes();
            HEAP32[(((tmPtr) + (8)) >> 2)] = date.getHours();
            HEAP32[(((tmPtr) + (12)) >> 2)] = date.getDate();
            HEAP32[(((tmPtr) + (16)) >> 2)] = date.getMonth();
            HEAP32[(((tmPtr) + (20)) >> 2)] = date.getFullYear() - 1900;
            HEAP32[(((tmPtr) + (24)) >> 2)] = date.getDay();
            var yday = ydayFromDate(date) | 0;
            HEAP32[(((tmPtr) + (28)) >> 2)] = yday;
            HEAP32[(((tmPtr) + (36)) >> 2)] = -(date.getTimezoneOffset() * 60);
            // Attention: DST is in December in South, and some regions don't have DST at all.
            var start = new Date(date.getFullYear(), 0, 1);
            var summerOffset = new Date(date.getFullYear(), 6, 1).getTimezoneOffset();
            var winterOffset = start.getTimezoneOffset();
            var dst = (summerOffset != winterOffset && date.getTimezoneOffset() == Math.min(winterOffset, summerOffset)) | 0;
            HEAP32[(((tmPtr) + (32)) >> 2)] = dst;
            ;
        }
        var __mktime_js = function (tmPtr) {
            var ret = (() => {
                var date = new Date(HEAP32[(((tmPtr) + (20)) >> 2)] + 1900, HEAP32[(((tmPtr) + (16)) >> 2)], HEAP32[(((tmPtr) + (12)) >> 2)], HEAP32[(((tmPtr) + (8)) >> 2)], HEAP32[(((tmPtr) + (4)) >> 2)], HEAP32[((tmPtr) >> 2)], 0);
                // There's an ambiguous hour when the time goes back; the tm_isdst field is
                // used to disambiguate it.  Date() basically guesses, so we fix it up if it
                // guessed wrong, or fill in tm_isdst with the guess if it's -1.
                var dst = HEAP32[(((tmPtr) + (32)) >> 2)];
                var guessedOffset = date.getTimezoneOffset();
                var start = new Date(date.getFullYear(), 0, 1);
                var summerOffset = new Date(date.getFullYear(), 6, 1).getTimezoneOffset();
                var winterOffset = start.getTimezoneOffset();
                var dstOffset = Math.min(winterOffset, summerOffset); // DST is in December in South
                if (dst < 0) {
                    // Attention: some regions don't have DST at all.
                    HEAP32[(((tmPtr) + (32)) >> 2)] = Number(summerOffset != winterOffset && dstOffset == guessedOffset);
                }
                else if ((dst > 0) != (dstOffset == guessedOffset)) {
                    var nonDstOffset = Math.max(winterOffset, summerOffset);
                    var trueOffset = dst > 0 ? dstOffset : nonDstOffset;
                    // Don't try setMinutes(date.getMinutes() + ...) -- it's messed up.
                    date.setTime(date.getTime() + (trueOffset - guessedOffset) * 60000);
                }
                HEAP32[(((tmPtr) + (24)) >> 2)] = date.getDay();
                var yday = ydayFromDate(date) | 0;
                HEAP32[(((tmPtr) + (28)) >> 2)] = yday;
                // To match expected behavior, update fields from date
                HEAP32[((tmPtr) >> 2)] = date.getSeconds();
                HEAP32[(((tmPtr) + (4)) >> 2)] = date.getMinutes();
                HEAP32[(((tmPtr) + (8)) >> 2)] = date.getHours();
                HEAP32[(((tmPtr) + (12)) >> 2)] = date.getDate();
                HEAP32[(((tmPtr) + (16)) >> 2)] = date.getMonth();
                HEAP32[(((tmPtr) + (20)) >> 2)] = date.getYear();
                var timeMs = date.getTime();
                if (isNaN(timeMs)) {
                    return -1;
                }
                // Return time in microseconds
                return timeMs / 1000;
            })();
            return BigInt(ret);
        };
        var __tzset_js = (timezone, daylight, std_name, dst_name) => {
            // TODO: Use (malleable) environment variables instead of system settings.
            var currentYear = new Date().getFullYear();
            var winter = new Date(currentYear, 0, 1);
            var summer = new Date(currentYear, 6, 1);
            var winterOffset = winter.getTimezoneOffset();
            var summerOffset = summer.getTimezoneOffset();
            // Local standard timezone offset. Local standard time is not adjusted for
            // daylight savings.  This code uses the fact that getTimezoneOffset returns
            // a greater value during Standard Time versus Daylight Saving Time (DST).
            // Thus it determines the expected output during Standard Time, and it
            // compares whether the output of the given date the same (Standard) or less
            // (DST).
            var stdTimezoneOffset = Math.max(winterOffset, summerOffset);
            // timezone is specified as seconds west of UTC ("The external variable
            // `timezone` shall be set to the difference, in seconds, between
            // Coordinated Universal Time (UTC) and local standard time."), the same
            // as returned by stdTimezoneOffset.
            // See http://pubs.opengroup.org/onlinepubs/009695399/functions/tzset.html
            HEAPU32[((timezone) >> 2)] = stdTimezoneOffset * 60;
            HEAP32[((daylight) >> 2)] = Number(winterOffset != summerOffset);
            var extractZone = (date) => date.toLocaleTimeString(undefined, { hour12: false, timeZoneName: 'short' }).split(' ')[1];
            var winterName = extractZone(winter);
            var summerName = extractZone(summer);
            assert(winterName);
            assert(summerName);
            assert(lengthBytesUTF8(winterName) <= 16, `timezone name truncated to fit in TZNAME_MAX (${winterName})`);
            assert(lengthBytesUTF8(summerName) <= 16, `timezone name truncated to fit in TZNAME_MAX (${summerName})`);
            if (summerOffset < winterOffset) {
                // Northern hemisphere
                stringToUTF8(winterName, std_name, 17);
                stringToUTF8(summerName, dst_name, 17);
            }
            else {
                stringToUTF8(winterName, dst_name, 17);
                stringToUTF8(summerName, std_name, 17);
            }
        };
        var __wasmfs_copy_preloaded_file_data = (index, buffer) => HEAPU8.set(wasmFSPreloadedFiles[index].fileData, buffer);
        class HandleAllocator {
            constructor() {
                // TODO(https://github.com/emscripten-core/emscripten/issues/21414):
                // Use inline field declarations.
                this.allocated = [undefined];
                this.freelist = [];
            }
            get(id) {
                assert(this.allocated[id] !== undefined, `invalid handle: ${id}`);
                return this.allocated[id];
            }
            has(id) {
                return this.allocated[id] !== undefined;
            }
            allocate(handle) {
                var id = this.freelist.pop() || this.allocated.length;
                this.allocated[id] = handle;
                return id;
            }
            free(id) {
                assert(this.allocated[id] !== undefined);
                // Set the slot to `undefined` rather than using `delete` here since
                // apparently arrays with holes in them can be less efficient.
                this.allocated[id] = undefined;
                this.freelist.push(id);
            }
        }
        var wasmfsExternalFSBlobs = new HandleAllocator();
        var __wasmfs_externalfs_close_blob = (blobID) => {
            wasmfsExternalFSBlobs.free(blobID);
        };
        var wasmfsExternalFSDirectoryHandles = new HandleAllocator();
        var __wasmfs_externalfs_free_directory = (dirID) => {
            wasmfsExternalFSDirectoryHandles.free(dirID);
        };
        var wasmfsExternalFSFileHandles = new HandleAllocator();
        var __wasmfs_externalfs_free_file = (fileID) => {
            wasmfsExternalFSFileHandles.free(fileID);
        };
        async function wasmfsExternalFSGetOrCreateFile(parent, name, create) {
            let parentHandle = wasmfsExternalFSDirectoryHandles.get(parent);
            let fileHandle;
            try {
                fileHandle = await parentHandle.getFileHandle(name, { create: create });
            }
            catch (e) {
                if (e.name === "NotFoundError") {
                    return -20;
                }
                if (e.name === "TypeMismatchError") {
                    return -31;
                }
                if (e.name === "NotAllowedError") {
                    return -2;
                }
                err('unexpected error:', e, e.stack);
                return -29;
            }
            return wasmfsExternalFSFileHandles.allocate(fileHandle);
        }
        async function wasmfsExternalFSGetOrCreateDir(parent, name, create) {
            let parentHandle = wasmfsExternalFSDirectoryHandles.get(parent);
            let childHandle;
            try {
                childHandle = await parentHandle.getDirectoryHandle(name, { create: create });
            }
            catch (e) {
                if (e.name === "NotFoundError")
                    return -20;
                if (e.name === "TypeMismatchError")
                    return -54;
                if (e.name === "NotAllowedError")
                    return -2;
                err('unexpected error:', e, e.stack);
                return -29;
            }
            return wasmfsExternalFSDirectoryHandles.allocate(childHandle);
        }
        var wasmfsExternalFSProxyFinish = (ctx) => {
            // When using pthreads the proxy needs to know when the work is finished.
            // When used with JSPI the work will be executed in an async block so there
            // is no need to notify when done.
            _emscripten_proxy_finish(ctx);
        };
        async function __wasmfs_externalfs_get_child(ctx, parent, namePtr, childTypePtr, childIDPtr) {
            if (!wasmfsExternalFSDirectoryHandles.allocated[parent]) {
                let childID = -1;
                HEAP32[((childIDPtr) >> 2)] = childID;
                return wasmfsExternalFSProxyFinish(ctx);
            }
            let name = UTF8ToString(namePtr);
            let childType = 1;
            let childID = await wasmfsExternalFSGetOrCreateFile(parent, name, false);
            if (childID == -31) {
                childType = 2;
                childID = await wasmfsExternalFSGetOrCreateDir(parent, name, false);
            }
            HEAP32[((childTypePtr) >> 2)] = childType;
            HEAP32[((childIDPtr) >> 2)] = childID;
            wasmfsExternalFSProxyFinish(ctx);
        }
        async function __wasmfs_externalfs_get_entries(ctx, dirID, entriesPtr, errPtr) {
            let dirHandle = wasmfsExternalFSDirectoryHandles.get(dirID);
            // TODO: Use 'for await' once Acorn supports that.
            try {
                let iter = dirHandle.entries();
                for (let entry; entry = await iter.next(), !entry.done;) {
                    let [name, child] = entry.value;
                    let sp = stackSave();
                    let namePtr = stringToUTF8OnStack(name);
                    let type = child.kind == "file" ?
                        1 :
                        2;
                    __wasmfs_externalfs_record_entry(entriesPtr, namePtr, type);
                    stackRestore(sp);
                }
            }
            catch (e) {
                let err = -29;
                if (e.name === 'NotAllowedError')
                    err = -2;
                HEAP32[((errPtr) >> 2)] = err;
            }
            wasmfsExternalFSProxyFinish(ctx);
        }
        var __wasmfs_externalfs_get_size_blob = (blobID) => {
            // This cannot fail.
            let size = wasmfsExternalFSBlobs.get(blobID).size;
            return BigInt(size);
        };
        async function __wasmfs_externalfs_get_size_file(ctx, fileID, sizePtr) {
            let fileHandle = wasmfsExternalFSFileHandles.get(fileID);
            let size;
            try {
                size = (await fileHandle.getFile()).size;
            }
            catch {
                size = -29;
            }
            HEAP64[((sizePtr) >> 3)] = BigInt(size);
            wasmfsExternalFSProxyFinish(ctx);
        }
        var __wasmfs_externalfs_get_object_store = async function () {
            const db = await new Promise((resolve, reject) => {
                const req = indexedDB.open('externalfs_db', 1);
                req.onerror = reject;
                req.onsuccess = (event) => resolve(event.target.result);
                req.onupgradeneeded = (event) => event.target.result.createObjectStore('store');
            });
            return db.transaction(['store'], 'readwrite').objectStore('store');
        };
        var __wasmfs_externalfs_key_exists = async function (store, key) {
            return new Promise((resolve, reject) => {
                const req = store.count(key);
                req.onerror = reject;
                req.onsuccess = event => resolve(Boolean(event.target.result));
            });
        };
        var __wasmfs_externalfs_get_key = async function (store, key) {
            return new Promise(async (resolve, reject) => {
                const writeReq = store.get(key);
                writeReq.onerror = reject;
                writeReq.onsuccess = (event) => resolve(event.target.result);
            });
        };
        async function __wasmfs_externalfs_init_root_directory(ctx, directoryNamePtr, successPtr) {
            // Closure compiler errors on this as it does not recognize the OPFS
            // API yet, it seems. Unfortunately an existing annotation for this is in
            // the closure compiler codebase, and cannot be overridden in user code
            // (it complains on a duplicate type annotation), so just suppress it.
            /** @suppress {checkTypes} */
            let success = 0;
            HEAP32[((successPtr) >> 2)] = success;
            // allocated.length starts off as 1 since 0 is a reserved handle
            if (wasmfsExternalFSDirectoryHandles.allocated.length !== 1)
                return wasmfsExternalFSProxyFinish(ctx);
            let directoryName = UTF8ToString(directoryNamePtr);
            const store = await __wasmfs_externalfs_get_object_store();
            const keyExists = await __wasmfs_externalfs_key_exists(store, directoryName);
            if (!keyExists)
                return wasmfsExternalFSProxyFinish(ctx);
            const handle = await __wasmfs_externalfs_get_key(store, directoryName);
            if (!handle)
                return wasmfsExternalFSProxyFinish(ctx);
            const permission = await handle.queryPermission({ mode: 'read' });
            if (permission !== 'granted')
                return wasmfsExternalFSProxyFinish(ctx);
            success = 1;
            wasmfsExternalFSDirectoryHandles.allocated.push(handle);
            HEAP32[((successPtr) >> 2)] = success;
            wasmfsExternalFSProxyFinish(ctx);
        }
        async function __wasmfs_externalfs_open_blob(ctx, fileID, blobIDPtr) {
            let fileHandle = wasmfsExternalFSFileHandles.get(fileID);
            let blobID;
            try {
                let blob = await fileHandle.getFile();
                blobID = wasmfsExternalFSBlobs.allocate(blob);
            }
            catch (e) {
                if (e.name === "NotAllowedError") {
                    blobID = -2;
                }
                else {
                    err('unexpected error:', e, e.stack);
                    blobID = -29;
                }
            }
            HEAP32[((blobIDPtr) >> 2)] = blobID;
            wasmfsExternalFSProxyFinish(ctx);
        }
        async function __wasmfs_externalfs_read_blob(ctx, blobID, bufPtr, len, pos, nreadPtr) {
            pos = bigintToI53Checked(pos);
            let blob = wasmfsExternalFSBlobs.get(blobID);
            let i53pos = Number(pos);
            let slice = blob.slice(i53pos, i53pos + len);
            let nread = 0;
            try {
                // TODO: Use ReadableStreamBYOBReader once
                // https://bugs.chromium.org/p/chromium/issues/detail?id=1189621 is
                // resolved.
                let buf = await slice.arrayBuffer();
                let data = new Uint8Array(buf);
                HEAPU8.set(data, bufPtr);
                nread += data.length;
            }
            catch (e) {
                if (e instanceof RangeError) {
                    nread = -21;
                }
                else {
                    err('unexpected error:', e, e.stack);
                    nread = -29;
                }
            }
            HEAP32[((nreadPtr) >> 2)] = nread;
            wasmfsExternalFSProxyFinish(ctx);
        }
        var wasmFSPreloadedDirs = [];
        var __wasmfs_get_num_preloaded_dirs = () => wasmFSPreloadedDirs.length;
        var wasmFSPreloadedFiles = [];
        var wasmFSPreloadingFlushed = false;
        var __wasmfs_get_num_preloaded_files = () => {
            // When this method is called from WasmFS it means that we are about to
            // flush all the preloaded data, so mark that. (There is no call that
            // occurs at the end of that flushing, which would be more natural, but it
            // is fine to mark the flushing here as during the flushing itself no user
            // code can run, so nothing will check whether we have flushed or not.)
            wasmFSPreloadingFlushed = true;
            return wasmFSPreloadedFiles.length;
        };
        var __wasmfs_get_preloaded_child_path = (index, childNameBuffer) => {
            var s = wasmFSPreloadedDirs[index].childName;
            var len = lengthBytesUTF8(s) + 1;
            stringToUTF8(s, childNameBuffer, len);
        };
        var __wasmfs_get_preloaded_file_mode = (index) => wasmFSPreloadedFiles[index].mode;
        var __wasmfs_get_preloaded_file_size = (index) => wasmFSPreloadedFiles[index].fileData.length;
        var __wasmfs_get_preloaded_parent_path = (index, parentPathBuffer) => {
            var s = wasmFSPreloadedDirs[index].parentPath;
            var len = lengthBytesUTF8(s) + 1;
            stringToUTF8(s, parentPathBuffer, len);
        };
        var __wasmfs_get_preloaded_path_name = (index, fileNameBuffer) => {
            var s = wasmFSPreloadedFiles[index].pathName;
            var len = lengthBytesUTF8(s) + 1;
            stringToUTF8(s, fileNameBuffer, len);
        };
        var __wasmfs_jsimpl_alloc_file = (backend, file) => {
            assert(wasmFS$backends[backend]);
            return wasmFS$backends[backend].allocFile(file);
        };
        var __wasmfs_jsimpl_free_file = (backend, file) => {
            assert(wasmFS$backends[backend]);
            return wasmFS$backends[backend].freeFile(file);
        };
        var __wasmfs_jsimpl_get_size = (backend, file) => {
            assert(wasmFS$backends[backend]);
            return wasmFS$backends[backend].getSize(file);
        };
        function __wasmfs_jsimpl_read(backend, file, buffer, length, offset) {
            offset = bigintToI53Checked(offset);
            assert(wasmFS$backends[backend]);
            if (!wasmFS$backends[backend].read) {
                return -28;
            }
            return wasmFS$backends[backend].read(file, buffer, length, offset);
            ;
        }
        function __wasmfs_jsimpl_write(backend, file, buffer, length, offset) {
            offset = bigintToI53Checked(offset);
            assert(wasmFS$backends[backend]);
            if (!wasmFS$backends[backend].write) {
                return -28;
            }
            return wasmFS$backends[backend].write(file, buffer, length, offset);
            ;
        }
        var FS_stdin_getChar_buffer = [];
        /** @type {function(string, boolean=, number=)} */
        function intArrayFromString(stringy, dontAddNull, length) {
            var len = length > 0 ? length : lengthBytesUTF8(stringy) + 1;
            var u8array = new Array(len);
            var numBytesWritten = stringToUTF8Array(stringy, u8array, 0, u8array.length);
            if (dontAddNull)
                u8array.length = numBytesWritten;
            return u8array;
        }
        var FS_stdin_getChar = () => {
            if (!FS_stdin_getChar_buffer.length) {
                var result = null;
                if (typeof window != 'undefined' &&
                    typeof window.prompt == 'function') {
                    // Browser.
                    result = window.prompt('Input: '); // returns null on cancel
                    if (result !== null) {
                        result += '\n';
                    }
                }
                else { }
                if (!result) {
                    return null;
                }
                FS_stdin_getChar_buffer = intArrayFromString(result, true);
            }
            return FS_stdin_getChar_buffer.shift();
        };
        var __wasmfs_stdin_get_char = () => {
            // Return the read character, or -1 to indicate EOF.
            var c = FS_stdin_getChar();
            if (typeof c === 'number') {
                return c;
            }
            return -1;
        };
        var __wasmfs_thread_utils_heartbeat = (queue) => {
            var intervalID = setInterval(() => {
                if (ABORT) {
                    clearInterval(intervalID);
                }
                else {
                    _emscripten_proxy_execute_queue(queue);
                }
            }, 50);
        };
        var _emscripten_set_main_loop_timing = (mode, value) => {
            Browser.mainLoop.timingMode = mode;
            Browser.mainLoop.timingValue = value;
            if (!Browser.mainLoop.func) {
                err('emscripten_set_main_loop_timing: Cannot set timing mode for main loop since a main loop does not exist! Call emscripten_set_main_loop first to set one up.');
                return 1; // Return non-zero on failure, can't set timing mode when there is no main loop.
            }
            if (!Browser.mainLoop.running) {
                runtimeKeepalivePush();
                Browser.mainLoop.running = true;
            }
            if (mode == 0) {
                Browser.mainLoop.scheduler = function Browser_mainLoop_scheduler_setTimeout() {
                    var timeUntilNextTick = Math.max(0, Browser.mainLoop.tickStartTime + value - _emscripten_get_now()) | 0;
                    setTimeout(Browser.mainLoop.runner, timeUntilNextTick); // doing this each time means that on exception, we stop
                };
                Browser.mainLoop.method = 'timeout';
            }
            else if (mode == 1) {
                Browser.mainLoop.scheduler = function Browser_mainLoop_scheduler_rAF() {
                    Browser.requestAnimationFrame(Browser.mainLoop.runner);
                };
                Browser.mainLoop.method = 'rAF';
            }
            else if (mode == 2) {
                if (typeof Browser.setImmediate == 'undefined') {
                    if (typeof setImmediate == 'undefined') {
                        // Emulate setImmediate. (note: not a complete polyfill, we don't emulate clearImmediate() to keep code size to minimum, since not needed)
                        var setImmediates = [];
                        var emscriptenMainLoopMessageId = 'setimmediate';
                        /** @param {Event} event */
                        var Browser_setImmediate_messageHandler = (event) => {
                            // When called in current thread or Worker, the main loop ID is structured slightly different to accommodate for --proxy-to-worker runtime listening to Worker events,
                            // so check for both cases.
                            if (event.data === emscriptenMainLoopMessageId || event.data.target === emscriptenMainLoopMessageId) {
                                event.stopPropagation();
                                setImmediates.shift()();
                            }
                        };
                        addEventListener("message", Browser_setImmediate_messageHandler, true);
                        Browser.setImmediate = /** @type{function(function(): ?, ...?): number} */ (function Browser_emulated_setImmediate(func) {
                            setImmediates.push(func);
                            if (ENVIRONMENT_IS_WORKER) {
                                Module['setImmediates'] ??= [];
                                Module['setImmediates'].push(func);
                                postMessage({ target: emscriptenMainLoopMessageId }); // In --proxy-to-worker, route the message via proxyClient.js
                            }
                            else
                                postMessage(emscriptenMainLoopMessageId, "*"); // On the main thread, can just send the message to itself.
                        });
                    }
                    else {
                        Browser.setImmediate = setImmediate;
                    }
                }
                Browser.mainLoop.scheduler = function Browser_mainLoop_scheduler_setImmediate() {
                    Browser.setImmediate(Browser.mainLoop.runner);
                };
                Browser.mainLoop.method = 'immediate';
            }
            return 0;
        };
        var _emscripten_get_now;
        // Pthreads need their clocks synchronized to the execution of the main
        // thread, so, when using them, make sure to adjust all timings to the
        // respective time origins.
        _emscripten_get_now = () => performance.timeOrigin + performance.now();
        ;
        /**
         * @param {number=} arg
         * @param {boolean=} noSetTiming
         */
        var setMainLoop = (browserIterationFunc, fps, simulateInfiniteLoop, arg, noSetTiming) => {
            assert(!Browser.mainLoop.func, 'emscripten_set_main_loop: there can only be one main loop function at once: call emscripten_cancel_main_loop to cancel the previous one before setting a new one with different parameters.');
            Browser.mainLoop.func = browserIterationFunc;
            Browser.mainLoop.arg = arg;
            // Closure compiler bug(?): Closure does not see that the assignment
            //   var thisMainLoopId = Browser.mainLoop.currentlyRunningMainloop
            // is a value copy of a number (even with the JSDoc @type annotation)
            // but optimizeis the code as if the assignment was a reference assignment,
            // which results in Browser.mainLoop.pause() not working. Hence use a
            // workaround to make Closure believe this is a value copy that should occur:
            // (TODO: Minimize this down to a small test case and report - was unable
            // to reproduce in a small written test case)
            /** @type{number} */
            var thisMainLoopId = (() => Browser.mainLoop.currentlyRunningMainloop)();
            function checkIsRunning() {
                if (thisMainLoopId < Browser.mainLoop.currentlyRunningMainloop) {
                    runtimeKeepalivePop();
                    return false;
                }
                return true;
            }
            // We create the loop runner here but it is not actually running until
            // _emscripten_set_main_loop_timing is called (which might happen a
            // later time).  This member signifies that the current runner has not
            // yet been started so that we can call runtimeKeepalivePush when it
            // gets it timing set for the first time.
            Browser.mainLoop.running = false;
            Browser.mainLoop.runner = function Browser_mainLoop_runner() {
                if (ABORT)
                    return;
                if (Browser.mainLoop.queue.length > 0) {
                    var start = Date.now();
                    var blocker = Browser.mainLoop.queue.shift();
                    blocker.func(blocker.arg);
                    if (Browser.mainLoop.remainingBlockers) {
                        var remaining = Browser.mainLoop.remainingBlockers;
                        var next = remaining % 1 == 0 ? remaining - 1 : Math.floor(remaining);
                        if (blocker.counted) {
                            Browser.mainLoop.remainingBlockers = next;
                        }
                        else {
                            // not counted, but move the progress along a tiny bit
                            next = next + 0.5; // do not steal all the next one's progress
                            Browser.mainLoop.remainingBlockers = (8 * remaining + next) / 9;
                        }
                    }
                    Browser.mainLoop.updateStatus();
                    // catches pause/resume main loop from blocker execution
                    if (!checkIsRunning())
                        return;
                    setTimeout(Browser.mainLoop.runner, 0);
                    return;
                }
                // catch pauses from non-main loop sources
                if (!checkIsRunning())
                    return;
                // Implement very basic swap interval control
                Browser.mainLoop.currentFrameNumber = Browser.mainLoop.currentFrameNumber + 1 | 0;
                if (Browser.mainLoop.timingMode == 1 && Browser.mainLoop.timingValue > 1 && Browser.mainLoop.currentFrameNumber % Browser.mainLoop.timingValue != 0) {
                    // Not the scheduled time to render this frame - skip.
                    Browser.mainLoop.scheduler();
                    return;
                }
                else if (Browser.mainLoop.timingMode == 0) {
                    Browser.mainLoop.tickStartTime = _emscripten_get_now();
                }
                // Signal GL rendering layer that processing of a new frame is about to start. This helps it optimize
                // VBO double-buffering and reduce GPU stalls.
                GL.newRenderingFrameStarted();
                // If the current GL context is an OffscreenCanvas, but it was initialized with implicit swap mode, perform the swap on behalf of the user.
                if (typeof GL != 'undefined' && GL.currentContext && !GL.currentContextIsProxied && !GL.currentContext.attributes.explicitSwapControl && GL.currentContext.GLctx.commit) {
                    GL.currentContext.GLctx.commit();
                }
                if (Browser.mainLoop.method === 'timeout' && Module.ctx) {
                    warnOnce('Looks like you are rendering without using requestAnimationFrame for the main loop. You should use 0 for the frame rate in emscripten_set_main_loop in order to use requestAnimationFrame, as that can greatly improve your frame rates!');
                    Browser.mainLoop.method = ''; // just warn once per call to set main loop
                }
                Browser.mainLoop.runIter(browserIterationFunc);
                checkStackCookie();
                // catch pauses from the main loop itself
                if (!checkIsRunning())
                    return;
                // Queue new audio data. This is important to be right after the main loop invocation, so that we will immediately be able
                // to queue the newest produced audio samples.
                // TODO: Consider adding pre- and post- rAF callbacks so that GL.newRenderingFrameStarted() and SDL.audio.queueNewAudioData()
                //       do not need to be hardcoded into this function, but can be more generic.
                if (typeof SDL == 'object')
                    SDL.audio?.queueNewAudioData?.();
                Browser.mainLoop.scheduler();
            };
            if (!noSetTiming) {
                if (fps && fps > 0) {
                    _emscripten_set_main_loop_timing(0, 1000.0 / fps);
                }
                else {
                    // Do rAF by rendering each frame (no decimating)
                    _emscripten_set_main_loop_timing(1, 1);
                }
                Browser.mainLoop.scheduler();
            }
            if (simulateInfiniteLoop) {
                throw 'unwind';
            }
        };
        /** @param {number=} timeout */
        var safeSetTimeout = (func, timeout) => {
            runtimeKeepalivePush();
            return setTimeout(() => {
                runtimeKeepalivePop();
                callUserCallback(func);
            }, timeout);
        };
        var preloadPlugins = Module['preloadPlugins'] || [];
        var Browser = {
            mainLoop: {
                running: false,
                scheduler: null,
                method: "",
                currentlyRunningMainloop: 0,
                func: null,
                arg: 0,
                timingMode: 0,
                timingValue: 0,
                currentFrameNumber: 0,
                queue: [],
                pause() {
                    Browser.mainLoop.scheduler = null;
                    // Incrementing this signals the previous main loop that it's now become old, and it must return.
                    Browser.mainLoop.currentlyRunningMainloop++;
                },
                resume() {
                    Browser.mainLoop.currentlyRunningMainloop++;
                    var timingMode = Browser.mainLoop.timingMode;
                    var timingValue = Browser.mainLoop.timingValue;
                    var func = Browser.mainLoop.func;
                    Browser.mainLoop.func = null;
                    // do not set timing and call scheduler, we will do it on the next lines
                    setMainLoop(func, 0, false, Browser.mainLoop.arg, true);
                    _emscripten_set_main_loop_timing(timingMode, timingValue);
                    Browser.mainLoop.scheduler();
                },
                updateStatus() {
                    if (Module['setStatus']) {
                        var message = Module['statusMessage'] || 'Please wait...';
                        var remaining = Browser.mainLoop.remainingBlockers;
                        var expected = Browser.mainLoop.expectedBlockers;
                        if (remaining) {
                            if (remaining < expected) {
                                Module['setStatus'](`{message} ({expected - remaining}/{expected})`);
                            }
                            else {
                                Module['setStatus'](message);
                            }
                        }
                        else {
                            Module['setStatus']('');
                        }
                    }
                },
                runIter(func) {
                    if (ABORT)
                        return;
                    if (Module['preMainLoop']) {
                        var preRet = Module['preMainLoop']();
                        if (preRet === false) {
                            return; // |return false| skips a frame
                        }
                    }
                    callUserCallback(func);
                    Module['postMainLoop']?.();
                },
            },
            isFullscreen: false,
            pointerLock: false,
            moduleContextCreatedCallbacks: [],
            workers: [],
            init() {
                if (Browser.initted)
                    return;
                Browser.initted = true;
                // Support for plugins that can process preloaded files. You can add more of these to
                // your app by creating and appending to preloadPlugins.
                //
                // Each plugin is asked if it can handle a file based on the file's name. If it can,
                // it is given the file's raw data. When it is done, it calls a callback with the file's
                // (possibly modified) data. For example, a plugin might decompress a file, or it
                // might create some side data structure for use later (like an Image element, etc.).
                var imagePlugin = {};
                imagePlugin['canHandle'] = function imagePlugin_canHandle(name) {
                    return !Module.noImageDecoding && /\.(jpg|jpeg|png|bmp)$/i.test(name);
                };
                imagePlugin['handle'] = function imagePlugin_handle(byteArray, name, onload, onerror) {
                    var b = new Blob([byteArray], { type: Browser.getMimetype(name) });
                    if (b.size !== byteArray.length) { // Safari bug #118630
                        // Safari's Blob can only take an ArrayBuffer
                        b = new Blob([(new Uint8Array(byteArray)).buffer], { type: Browser.getMimetype(name) });
                    }
                    var url = URL.createObjectURL(b);
                    assert(typeof url == 'string', 'createObjectURL must return a url as a string');
                    var img = new Image();
                    img.onload = () => {
                        assert(img.complete, `Image ${name} could not be decoded`);
                        var canvas = /** @type {!HTMLCanvasElement} */ (document.createElement('canvas'));
                        canvas.width = img.width;
                        canvas.height = img.height;
                        var ctx = canvas.getContext('2d');
                        ctx.drawImage(img, 0, 0);
                        preloadedImages[name] = canvas;
                        URL.revokeObjectURL(url);
                        onload?.(byteArray);
                    };
                    img.onerror = (event) => {
                        err(`Image ${url} could not be decoded`);
                        onerror?.();
                    };
                    img.src = url;
                };
                preloadPlugins.push(imagePlugin);
                var audioPlugin = {};
                audioPlugin['canHandle'] = function audioPlugin_canHandle(name) {
                    return !Module.noAudioDecoding && name.substr(-4) in { '.ogg': 1, '.wav': 1, '.mp3': 1 };
                };
                audioPlugin['handle'] = function audioPlugin_handle(byteArray, name, onload, onerror) {
                    var done = false;
                    function finish(audio) {
                        if (done)
                            return;
                        done = true;
                        preloadedAudios[name] = audio;
                        onload?.(byteArray);
                    }
                    function fail() {
                        if (done)
                            return;
                        done = true;
                        preloadedAudios[name] = new Audio(); // empty shim
                        onerror?.();
                    }
                    var b = new Blob([byteArray], { type: Browser.getMimetype(name) });
                    var url = URL.createObjectURL(b); // XXX we never revoke this!
                    assert(typeof url == 'string', 'createObjectURL must return a url as a string');
                    var audio = new Audio();
                    audio.addEventListener('canplaythrough', () => finish(audio), false); // use addEventListener due to chromium bug 124926
                    audio.onerror = function audio_onerror(event) {
                        if (done)
                            return;
                        err(`warning: browser could not fully decode audio ${name}, trying slower base64 approach`);
                        function encode64(data) {
                            var BASE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
                            var PAD = '=';
                            var ret = '';
                            var leftchar = 0;
                            var leftbits = 0;
                            for (var i = 0; i < data.length; i++) {
                                leftchar = (leftchar << 8) | data[i];
                                leftbits += 8;
                                while (leftbits >= 6) {
                                    var curr = (leftchar >> (leftbits - 6)) & 0x3f;
                                    leftbits -= 6;
                                    ret += BASE[curr];
                                }
                            }
                            if (leftbits == 2) {
                                ret += BASE[(leftchar & 3) << 4];
                                ret += PAD + PAD;
                            }
                            else if (leftbits == 4) {
                                ret += BASE[(leftchar & 0xf) << 2];
                                ret += PAD;
                            }
                            return ret;
                        }
                        audio.src = 'data:audio/x-' + name.substr(-3) + ';base64,' + encode64(byteArray);
                        finish(audio); // we don't wait for confirmation this worked - but it's worth trying
                    };
                    audio.src = url;
                    // workaround for chrome bug 124926 - we do not always get oncanplaythrough or onerror
                    safeSetTimeout(() => {
                        finish(audio); // try to use it even though it is not necessarily ready to play
                    }, 10000);
                };
                preloadPlugins.push(audioPlugin);
                // Canvas event setup
                function pointerLockChange() {
                    Browser.pointerLock = document['pointerLockElement'] === Module['canvas'] ||
                        document['mozPointerLockElement'] === Module['canvas'] ||
                        document['webkitPointerLockElement'] === Module['canvas'] ||
                        document['msPointerLockElement'] === Module['canvas'];
                }
                var canvas = Module['canvas'];
                if (canvas) {
                    // forced aspect ratio can be enabled by defining 'forcedAspectRatio' on Module
                    // Module['forcedAspectRatio'] = 4 / 3;
                    canvas.requestPointerLock = canvas['requestPointerLock'] ||
                        canvas['mozRequestPointerLock'] ||
                        canvas['webkitRequestPointerLock'] ||
                        canvas['msRequestPointerLock'] ||
                        (() => { });
                    canvas.exitPointerLock = document['exitPointerLock'] ||
                        document['mozExitPointerLock'] ||
                        document['webkitExitPointerLock'] ||
                        document['msExitPointerLock'] ||
                        (() => { }); // no-op if function does not exist
                    canvas.exitPointerLock = canvas.exitPointerLock.bind(document);
                    document.addEventListener('pointerlockchange', pointerLockChange, false);
                    document.addEventListener('mozpointerlockchange', pointerLockChange, false);
                    document.addEventListener('webkitpointerlockchange', pointerLockChange, false);
                    document.addEventListener('mspointerlockchange', pointerLockChange, false);
                    if (Module['elementPointerLock']) {
                        canvas.addEventListener("click", (ev) => {
                            if (!Browser.pointerLock && Module['canvas'].requestPointerLock) {
                                Module['canvas'].requestPointerLock();
                                ev.preventDefault();
                            }
                        }, false);
                    }
                }
            },
            createContext(/** @type {HTMLCanvasElement} */ canvas, useWebGL, setInModule, webGLContextAttributes) {
                if (useWebGL && Module.ctx && canvas == Module.canvas)
                    return Module.ctx; // no need to recreate GL context if it's already been created for this canvas.
                var ctx;
                var contextHandle;
                if (useWebGL) {
                    // For GLES2/desktop GL compatibility, adjust a few defaults to be different to WebGL defaults, so that they align better with the desktop defaults.
                    var contextAttributes = {
                        antialias: false,
                        alpha: false,
                        majorVersion: (typeof WebGL2RenderingContext != 'undefined') ? 2 : 1,
                    };
                    if (webGLContextAttributes) {
                        for (var attribute in webGLContextAttributes) {
                            contextAttributes[attribute] = webGLContextAttributes[attribute];
                        }
                    }
                    // This check of existence of GL is here to satisfy Closure compiler, which yells if variable GL is referenced below but GL object is not
                    // actually compiled in because application is not doing any GL operations. TODO: Ideally if GL is not being used, this function
                    // Browser.createContext() should not even be emitted.
                    if (typeof GL != 'undefined') {
                        contextHandle = GL.createContext(canvas, contextAttributes);
                        if (contextHandle) {
                            ctx = GL.getContext(contextHandle).GLctx;
                        }
                    }
                }
                else {
                    ctx = canvas.getContext('2d');
                }
                if (!ctx)
                    return null;
                if (setInModule) {
                    if (!useWebGL)
                        assert(typeof GLctx == 'undefined', 'cannot set in module if GLctx is used, but we are a non-GL context that would replace it');
                    Module.ctx = ctx;
                    if (useWebGL)
                        GL.makeContextCurrent(contextHandle);
                    Module.useWebGL = useWebGL;
                    Browser.moduleContextCreatedCallbacks.forEach((callback) => callback());
                    Browser.init();
                }
                return ctx;
            },
            destroyContext(canvas, useWebGL, setInModule) { },
            fullscreenHandlersInstalled: false,
            lockPointer: undefined,
            resizeCanvas: undefined,
            requestFullscreen(lockPointer, resizeCanvas) {
                Browser.lockPointer = lockPointer;
                Browser.resizeCanvas = resizeCanvas;
                if (typeof Browser.lockPointer == 'undefined')
                    Browser.lockPointer = true;
                if (typeof Browser.resizeCanvas == 'undefined')
                    Browser.resizeCanvas = false;
                var canvas = Module['canvas'];
                function fullscreenChange() {
                    Browser.isFullscreen = false;
                    var canvasContainer = canvas.parentNode;
                    if ((document['fullscreenElement'] || document['mozFullScreenElement'] ||
                        document['msFullscreenElement'] || document['webkitFullscreenElement'] ||
                        document['webkitCurrentFullScreenElement']) === canvasContainer) {
                        canvas.exitFullscreen = Browser.exitFullscreen;
                        if (Browser.lockPointer)
                            canvas.requestPointerLock();
                        Browser.isFullscreen = true;
                        if (Browser.resizeCanvas) {
                            Browser.setFullscreenCanvasSize();
                        }
                        else {
                            Browser.updateCanvasDimensions(canvas);
                        }
                    }
                    else {
                        // remove the full screen specific parent of the canvas again to restore the HTML structure from before going full screen
                        canvasContainer.parentNode.insertBefore(canvas, canvasContainer);
                        canvasContainer.parentNode.removeChild(canvasContainer);
                        if (Browser.resizeCanvas) {
                            Browser.setWindowedCanvasSize();
                        }
                        else {
                            Browser.updateCanvasDimensions(canvas);
                        }
                    }
                    Module['onFullScreen']?.(Browser.isFullscreen);
                    Module['onFullscreen']?.(Browser.isFullscreen);
                }
                if (!Browser.fullscreenHandlersInstalled) {
                    Browser.fullscreenHandlersInstalled = true;
                    document.addEventListener('fullscreenchange', fullscreenChange, false);
                    document.addEventListener('mozfullscreenchange', fullscreenChange, false);
                    document.addEventListener('webkitfullscreenchange', fullscreenChange, false);
                    document.addEventListener('MSFullscreenChange', fullscreenChange, false);
                }
                // create a new parent to ensure the canvas has no siblings. this allows browsers to optimize full screen performance when its parent is the full screen root
                var canvasContainer = document.createElement("div");
                canvas.parentNode.insertBefore(canvasContainer, canvas);
                canvasContainer.appendChild(canvas);
                // use parent of canvas as full screen root to allow aspect ratio correction (Firefox stretches the root to screen size)
                canvasContainer.requestFullscreen = canvasContainer['requestFullscreen'] ||
                    canvasContainer['mozRequestFullScreen'] ||
                    canvasContainer['msRequestFullscreen'] ||
                    (canvasContainer['webkitRequestFullscreen'] ? () => canvasContainer['webkitRequestFullscreen'](Element['ALLOW_KEYBOARD_INPUT']) : null) ||
                    (canvasContainer['webkitRequestFullScreen'] ? () => canvasContainer['webkitRequestFullScreen'](Element['ALLOW_KEYBOARD_INPUT']) : null);
                canvasContainer.requestFullscreen();
            },
            requestFullScreen() {
                abort('Module.requestFullScreen has been replaced by Module.requestFullscreen (without a capital S)');
            },
            exitFullscreen() {
                // This is workaround for chrome. Trying to exit from fullscreen
                // not in fullscreen state will cause "TypeError: Document not active"
                // in chrome. See https://github.com/emscripten-core/emscripten/pull/8236
                if (!Browser.isFullscreen) {
                    return false;
                }
                var CFS = document['exitFullscreen'] ||
                    document['cancelFullScreen'] ||
                    document['mozCancelFullScreen'] ||
                    document['msExitFullscreen'] ||
                    document['webkitCancelFullScreen'] ||
                    (() => { });
                CFS.apply(document, []);
                return true;
            },
            nextRAF: 0,
            fakeRequestAnimationFrame(func) {
                // try to keep 60fps between calls to here
                var now = Date.now();
                if (Browser.nextRAF === 0) {
                    Browser.nextRAF = now + 1000 / 60;
                }
                else {
                    while (now + 2 >= Browser.nextRAF) { // fudge a little, to avoid timer jitter causing us to do lots of delay:0
                        Browser.nextRAF += 1000 / 60;
                    }
                }
                var delay = Math.max(Browser.nextRAF - now, 0);
                setTimeout(func, delay);
            },
            requestAnimationFrame(func) {
                if (typeof requestAnimationFrame == 'function') {
                    requestAnimationFrame(func);
                    return;
                }
                var RAF = Browser.fakeRequestAnimationFrame;
                RAF(func);
            },
            safeSetTimeout(func, timeout) {
                // Legacy function, this is used by the SDL2 port so we need to keep it
                // around at least until that is updated.
                // See https://github.com/libsdl-org/SDL/pull/6304
                return safeSetTimeout(func, timeout);
            },
            safeRequestAnimationFrame(func) {
                runtimeKeepalivePush();
                return Browser.requestAnimationFrame(() => {
                    runtimeKeepalivePop();
                    callUserCallback(func);
                });
            },
            getMimetype(name) {
                return {
                    'jpg': 'image/jpeg',
                    'jpeg': 'image/jpeg',
                    'png': 'image/png',
                    'bmp': 'image/bmp',
                    'ogg': 'audio/ogg',
                    'wav': 'audio/wav',
                    'mp3': 'audio/mpeg'
                }[name.substr(name.lastIndexOf('.') + 1)];
            },
            getUserMedia(func) {
                window.getUserMedia ||= navigator['getUserMedia'] ||
                    navigator['mozGetUserMedia'];
                window.getUserMedia(func);
            },
            getMovementX(event) {
                return event['movementX'] ||
                    event['mozMovementX'] ||
                    event['webkitMovementX'] ||
                    0;
            },
            getMovementY(event) {
                return event['movementY'] ||
                    event['mozMovementY'] ||
                    event['webkitMovementY'] ||
                    0;
            },
            getMouseWheelDelta(event) {
                var delta = 0;
                switch (event.type) {
                    case 'DOMMouseScroll':
                        // 3 lines make up a step
                        delta = event.detail / 3;
                        break;
                    case 'mousewheel':
                        // 120 units make up a step
                        delta = event.wheelDelta / 120;
                        break;
                    case 'wheel':
                        delta = event.deltaY;
                        switch (event.deltaMode) {
                            case 0:
                                // DOM_DELTA_PIXEL: 100 pixels make up a step
                                delta /= 100;
                                break;
                            case 1:
                                // DOM_DELTA_LINE: 3 lines make up a step
                                delta /= 3;
                                break;
                            case 2:
                                // DOM_DELTA_PAGE: A page makes up 80 steps
                                delta *= 80;
                                break;
                            default:
                                throw 'unrecognized mouse wheel delta mode: ' + event.deltaMode;
                        }
                        break;
                    default:
                        throw 'unrecognized mouse wheel event: ' + event.type;
                }
                return delta;
            },
            mouseX: 0,
            mouseY: 0,
            mouseMovementX: 0,
            mouseMovementY: 0,
            touches: {},
            lastTouches: {},
            calculateMouseCoords(pageX, pageY) {
                // Calculate the movement based on the changes
                // in the coordinates.
                var rect = Module["canvas"].getBoundingClientRect();
                var cw = Module["canvas"].width;
                var ch = Module["canvas"].height;
                // Neither .scrollX or .pageXOffset are defined in a spec, but
                // we prefer .scrollX because it is currently in a spec draft.
                // (see: http://www.w3.org/TR/2013/WD-cssom-view-20131217/)
                var scrollX = ((typeof window.scrollX != 'undefined') ? window.scrollX : window.pageXOffset);
                var scrollY = ((typeof window.scrollY != 'undefined') ? window.scrollY : window.pageYOffset);
                // If this assert lands, it's likely because the browser doesn't support scrollX or pageXOffset
                // and we have no viable fallback.
                assert((typeof scrollX != 'undefined') && (typeof scrollY != 'undefined'), 'Unable to retrieve scroll position, mouse positions likely broken.');
                var adjustedX = pageX - (scrollX + rect.left);
                var adjustedY = pageY - (scrollY + rect.top);
                // the canvas might be CSS-scaled compared to its backbuffer;
                // SDL-using content will want mouse coordinates in terms
                // of backbuffer units.
                adjustedX = adjustedX * (cw / rect.width);
                adjustedY = adjustedY * (ch / rect.height);
                return { x: adjustedX, y: adjustedY };
            },
            setMouseCoords(pageX, pageY) {
                const { x, y } = Browser.calculateMouseCoords(pageX, pageY);
                Browser.mouseMovementX = x - Browser.mouseX;
                Browser.mouseMovementY = y - Browser.mouseY;
                Browser.mouseX = x;
                Browser.mouseY = y;
            },
            calculateMouseEvent(event) {
                if (Browser.pointerLock) {
                    // When the pointer is locked, calculate the coordinates
                    // based on the movement of the mouse.
                    // Workaround for Firefox bug 764498
                    if (event.type != 'mousemove' &&
                        ('mozMovementX' in event)) {
                        Browser.mouseMovementX = Browser.mouseMovementY = 0;
                    }
                    else {
                        Browser.mouseMovementX = Browser.getMovementX(event);
                        Browser.mouseMovementY = Browser.getMovementY(event);
                    }
                    // add the mouse delta to the current absolute mouse position
                    Browser.mouseX += Browser.mouseMovementX;
                    Browser.mouseY += Browser.mouseMovementY;
                }
                else {
                    if (event.type === 'touchstart' || event.type === 'touchend' || event.type === 'touchmove') {
                        var touch = event.touch;
                        if (touch === undefined) {
                            return; // the "touch" property is only defined in SDL
                        }
                        var coords = Browser.calculateMouseCoords(touch.pageX, touch.pageY);
                        if (event.type === 'touchstart') {
                            Browser.lastTouches[touch.identifier] = coords;
                            Browser.touches[touch.identifier] = coords;
                        }
                        else if (event.type === 'touchend' || event.type === 'touchmove') {
                            var last = Browser.touches[touch.identifier];
                            last ||= coords;
                            Browser.lastTouches[touch.identifier] = last;
                            Browser.touches[touch.identifier] = coords;
                        }
                        return;
                    }
                    Browser.setMouseCoords(event.pageX, event.pageY);
                }
            },
            resizeListeners: [],
            updateResizeListeners() {
                var canvas = Module['canvas'];
                Browser.resizeListeners.forEach((listener) => listener(canvas.width, canvas.height));
            },
            setCanvasSize(width, height, noUpdates) {
                var canvas = Module['canvas'];
                Browser.updateCanvasDimensions(canvas, width, height);
                if (!noUpdates)
                    Browser.updateResizeListeners();
            },
            windowedWidth: 0,
            windowedHeight: 0,
            setFullscreenCanvasSize() {
                // check if SDL is available
                if (typeof SDL != "undefined") {
                    var flags = HEAPU32[((SDL.screen) >> 2)];
                    flags = flags | 0x00800000; // set SDL_FULLSCREEN flag
                    HEAP32[((SDL.screen) >> 2)] = flags;
                }
                Browser.updateCanvasDimensions(Module['canvas']);
                Browser.updateResizeListeners();
            },
            setWindowedCanvasSize() {
                // check if SDL is available
                if (typeof SDL != "undefined") {
                    var flags = HEAPU32[((SDL.screen) >> 2)];
                    flags = flags & ~0x00800000; // clear SDL_FULLSCREEN flag
                    HEAP32[((SDL.screen) >> 2)] = flags;
                }
                Browser.updateCanvasDimensions(Module['canvas']);
                Browser.updateResizeListeners();
            },
            updateCanvasDimensions(canvas, wNative, hNative) {
                if (wNative && hNative) {
                    canvas.widthNative = wNative;
                    canvas.heightNative = hNative;
                }
                else {
                    wNative = canvas.widthNative;
                    hNative = canvas.heightNative;
                }
                var w = wNative;
                var h = hNative;
                if (Module['forcedAspectRatio'] && Module['forcedAspectRatio'] > 0) {
                    if (w / h < Module['forcedAspectRatio']) {
                        w = Math.round(h * Module['forcedAspectRatio']);
                    }
                    else {
                        h = Math.round(w / Module['forcedAspectRatio']);
                    }
                }
                if (((document['fullscreenElement'] || document['mozFullScreenElement'] ||
                    document['msFullscreenElement'] || document['webkitFullscreenElement'] ||
                    document['webkitCurrentFullScreenElement']) === canvas.parentNode) && (typeof screen != 'undefined')) {
                    var factor = Math.min(screen.width / w, screen.height / h);
                    w = Math.round(w * factor);
                    h = Math.round(h * factor);
                }
                if (Browser.resizeCanvas) {
                    if (canvas.width != w)
                        canvas.width = w;
                    if (canvas.height != h)
                        canvas.height = h;
                    if (typeof canvas.style != 'undefined') {
                        canvas.style.removeProperty("width");
                        canvas.style.removeProperty("height");
                    }
                }
                else {
                    if (canvas.width != wNative)
                        canvas.width = wNative;
                    if (canvas.height != hNative)
                        canvas.height = hNative;
                    if (typeof canvas.style != 'undefined') {
                        if (w != wNative || h != hNative) {
                            canvas.style.setProperty("width", w + "px", "important");
                            canvas.style.setProperty("height", h + "px", "important");
                        }
                        else {
                            canvas.style.removeProperty("width");
                            canvas.style.removeProperty("height");
                        }
                    }
                }
            },
        };
        var AL = {
            QUEUE_INTERVAL: 25,
            QUEUE_LOOKAHEAD: 0.1,
            DEVICE_NAME: "Emscripten OpenAL",
            CAPTURE_DEVICE_NAME: "Emscripten OpenAL capture",
            ALC_EXTENSIONS: {
                ALC_SOFT_pause_device: true,
                ALC_SOFT_HRTF: true,
            },
            AL_EXTENSIONS: {
                AL_EXT_float32: true,
                AL_SOFT_loop_points: true,
                AL_SOFT_source_length: true,
                AL_EXT_source_distance_model: true,
                AL_SOFT_source_spatialize: true,
            },
            _alcErr: 0,
            alcErr: 0,
            deviceRefCounts: {},
            alcStringCache: {},
            paused: false,
            stringCache: {},
            contexts: {},
            currentCtx: null,
            buffers: {
                0: {
                    id: 0,
                    refCount: 0,
                    audioBuf: null,
                    frequency: 0,
                    bytesPerSample: 2,
                    channels: 1,
                    length: 0,
                },
            },
            paramArray: [],
            _nextId: 1,
            newId: () => AL.freeIds.length > 0 ? AL.freeIds.pop() : AL._nextId++,
            freeIds: [],
            scheduleContextAudio: (ctx) => {
                // If we are animating using the requestAnimationFrame method, then the main loop does not run when in the background.
                // To give a perfect glitch-free audio stop when switching from foreground to background, we need to avoid updating
                // audio altogether when in the background, so detect that case and kill audio buffer streaming if so.
                if (Browser.mainLoop.timingMode === 1 && document['visibilityState'] != 'visible') {
                    return;
                }
                for (var i in ctx.sources) {
                    AL.scheduleSourceAudio(ctx.sources[i]);
                }
            },
            scheduleSourceAudio: (src, lookahead) => {
                // See comment on scheduleContextAudio above.
                if (Browser.mainLoop.timingMode === 1 && document['visibilityState'] != 'visible') {
                    return;
                }
                if (src.state !== 4114) {
                    return;
                }
                var currentTime = AL.updateSourceTime(src);
                var startTime = src.bufStartTime;
                var startOffset = src.bufOffset;
                var bufCursor = src.bufsProcessed;
                // Advance past any audio that is already scheduled
                for (var i = 0; i < src.audioQueue.length; i++) {
                    var audioSrc = src.audioQueue[i];
                    startTime = audioSrc._startTime + audioSrc._duration;
                    startOffset = 0.0;
                    bufCursor += audioSrc._skipCount + 1;
                }
                if (!lookahead) {
                    lookahead = AL.QUEUE_LOOKAHEAD;
                }
                var lookaheadTime = currentTime + lookahead;
                var skipCount = 0;
                while (startTime < lookaheadTime) {
                    if (bufCursor >= src.bufQueue.length) {
                        if (src.looping) {
                            bufCursor %= src.bufQueue.length;
                        }
                        else {
                            break;
                        }
                    }
                    var buf = src.bufQueue[bufCursor % src.bufQueue.length];
                    // If the buffer contains no data, skip it
                    if (buf.length === 0) {
                        skipCount++;
                        // If we've gone through the whole queue and everything is 0 length, just give up
                        if (skipCount === src.bufQueue.length) {
                            break;
                        }
                    }
                    else {
                        var audioSrc = src.context.audioCtx.createBufferSource();
                        audioSrc.buffer = buf.audioBuf;
                        audioSrc.playbackRate.value = src.playbackRate;
                        if (buf.audioBuf._loopStart || buf.audioBuf._loopEnd) {
                            audioSrc.loopStart = buf.audioBuf._loopStart;
                            audioSrc.loopEnd = buf.audioBuf._loopEnd;
                        }
                        var duration = 0.0;
                        // If the source is a looping static buffer, use native looping for gapless playback
                        if (src.type === 4136 && src.looping) {
                            duration = Number.POSITIVE_INFINITY;
                            audioSrc.loop = true;
                            if (buf.audioBuf._loopStart) {
                                audioSrc.loopStart = buf.audioBuf._loopStart;
                            }
                            if (buf.audioBuf._loopEnd) {
                                audioSrc.loopEnd = buf.audioBuf._loopEnd;
                            }
                        }
                        else {
                            duration = (buf.audioBuf.duration - startOffset) / src.playbackRate;
                        }
                        audioSrc._startOffset = startOffset;
                        audioSrc._duration = duration;
                        audioSrc._skipCount = skipCount;
                        skipCount = 0;
                        audioSrc.connect(src.gain);
                        if (typeof audioSrc.start != 'undefined') {
                            // Sample the current time as late as possible to mitigate drift
                            startTime = Math.max(startTime, src.context.audioCtx.currentTime);
                            audioSrc.start(startTime, startOffset);
                        }
                        else if (typeof audioSrc.noteOn != 'undefined') {
                            startTime = Math.max(startTime, src.context.audioCtx.currentTime);
                            audioSrc.noteOn(startTime);
                        }
                        audioSrc._startTime = startTime;
                        src.audioQueue.push(audioSrc);
                        startTime += duration;
                    }
                    startOffset = 0.0;
                    bufCursor++;
                }
            },
            updateSourceTime: (src) => {
                var currentTime = src.context.audioCtx.currentTime;
                if (src.state !== 4114) {
                    return currentTime;
                }
                // if the start time is unset, determine it based on the current offset.
                // This will be the case when a source is resumed after being paused, and
                // allows us to pretend that the source actually started playing some time
                // in the past such that it would just now have reached the stored offset.
                if (!isFinite(src.bufStartTime)) {
                    src.bufStartTime = currentTime - src.bufOffset / src.playbackRate;
                    src.bufOffset = 0.0;
                }
                var nextStartTime = 0.0;
                while (src.audioQueue.length) {
                    var audioSrc = src.audioQueue[0];
                    src.bufsProcessed += audioSrc._skipCount;
                    nextStartTime = audioSrc._startTime + audioSrc._duration; // n.b. audioSrc._duration already factors in playbackRate, so no divide by src.playbackRate on it.
                    if (currentTime < nextStartTime) {
                        break;
                    }
                    src.audioQueue.shift();
                    src.bufStartTime = nextStartTime;
                    src.bufOffset = 0.0;
                    src.bufsProcessed++;
                }
                if (src.bufsProcessed >= src.bufQueue.length && !src.looping) {
                    // The source has played its entire queue and is non-looping, so just mark it as stopped.
                    AL.setSourceState(src, 4116);
                }
                else if (src.type === 4136 && src.looping) {
                    // If the source is a looping static buffer, determine the buffer offset based on the loop points
                    var buf = src.bufQueue[0];
                    if (buf.length === 0) {
                        src.bufOffset = 0.0;
                    }
                    else {
                        var delta = (currentTime - src.bufStartTime) * src.playbackRate;
                        var loopStart = buf.audioBuf._loopStart || 0.0;
                        var loopEnd = buf.audioBuf._loopEnd || buf.audioBuf.duration;
                        if (loopEnd <= loopStart) {
                            loopEnd = buf.audioBuf.duration;
                        }
                        if (delta < loopEnd) {
                            src.bufOffset = delta;
                        }
                        else {
                            src.bufOffset = loopStart + (delta - loopStart) % (loopEnd - loopStart);
                        }
                    }
                }
                else if (src.audioQueue[0]) {
                    // The source is still actively playing, so we just need to calculate where we are in the current buffer
                    // so it can be remembered if the source gets paused.
                    src.bufOffset = (currentTime - src.audioQueue[0]._startTime) * src.playbackRate;
                }
                else {
                    // The source hasn't finished yet, but there is no scheduled audio left for it. This can be because
                    // the source has just been started/resumed, or due to an underrun caused by a long blocking operation.
                    // We need to determine what state we would be in by this point in time so that when we next schedule
                    // audio playback, it will be just as if no underrun occurred.
                    if (src.type !== 4136 && src.looping) {
                        // if the source is a looping buffer queue, let's first calculate the queue duration, so we can
                        // quickly fast forward past any full loops of the queue and only worry about the remainder.
                        var srcDuration = AL.sourceDuration(src) / src.playbackRate;
                        if (srcDuration > 0.0) {
                            src.bufStartTime += Math.floor((currentTime - src.bufStartTime) / srcDuration) * srcDuration;
                        }
                    }
                    // Since we've already skipped any full-queue loops if there were any, we just need to find
                    // out where in the queue the remaining time puts us, which won't require stepping through the
                    // entire queue more than once.
                    for (var i = 0; i < src.bufQueue.length; i++) {
                        if (src.bufsProcessed >= src.bufQueue.length) {
                            if (src.looping) {
                                src.bufsProcessed %= src.bufQueue.length;
                            }
                            else {
                                AL.setSourceState(src, 4116);
                                break;
                            }
                        }
                        var buf = src.bufQueue[src.bufsProcessed];
                        if (buf.length > 0) {
                            nextStartTime = src.bufStartTime + buf.audioBuf.duration / src.playbackRate;
                            if (currentTime < nextStartTime) {
                                src.bufOffset = (currentTime - src.bufStartTime) * src.playbackRate;
                                break;
                            }
                            src.bufStartTime = nextStartTime;
                        }
                        src.bufOffset = 0.0;
                        src.bufsProcessed++;
                    }
                }
                return currentTime;
            },
            cancelPendingSourceAudio: (src) => {
                AL.updateSourceTime(src);
                for (var i = 1; i < src.audioQueue.length; i++) {
                    var audioSrc = src.audioQueue[i];
                    audioSrc.stop();
                }
                if (src.audioQueue.length > 1) {
                    src.audioQueue.length = 1;
                }
            },
            stopSourceAudio: (src) => {
                for (var i = 0; i < src.audioQueue.length; i++) {
                    src.audioQueue[i].stop();
                }
                src.audioQueue.length = 0;
            },
            setSourceState: (src, state) => {
                if (state === 4114) {
                    if (src.state === 4114 || src.state == 4116) {
                        src.bufsProcessed = 0;
                        src.bufOffset = 0.0;
                    }
                    else {
                    }
                    AL.stopSourceAudio(src);
                    src.state = 4114;
                    src.bufStartTime = Number.NEGATIVE_INFINITY;
                    AL.scheduleSourceAudio(src);
                }
                else if (state === 4115) {
                    if (src.state === 4114) {
                        // Store off the current offset to restore with on resume.
                        AL.updateSourceTime(src);
                        AL.stopSourceAudio(src);
                        src.state = 4115;
                    }
                }
                else if (state === 4116) {
                    if (src.state !== 4113) {
                        src.state = 4116;
                        src.bufsProcessed = src.bufQueue.length;
                        src.bufStartTime = Number.NEGATIVE_INFINITY;
                        src.bufOffset = 0.0;
                        AL.stopSourceAudio(src);
                    }
                }
                else if (state === 4113) {
                    if (src.state !== 4113) {
                        src.state = 4113;
                        src.bufsProcessed = 0;
                        src.bufStartTime = Number.NEGATIVE_INFINITY;
                        src.bufOffset = 0.0;
                        AL.stopSourceAudio(src);
                    }
                }
            },
            initSourcePanner: (src) => {
                if (src.type === 0x1030 /* AL_UNDETERMINED */) {
                    return;
                }
                // Find the first non-zero buffer in the queue to determine the proper format
                var templateBuf = AL.buffers[0];
                for (var i = 0; i < src.bufQueue.length; i++) {
                    if (src.bufQueue[i].id !== 0) {
                        templateBuf = src.bufQueue[i];
                        break;
                    }
                }
                // Create a panner if AL_SOURCE_SPATIALIZE_SOFT is set to true, or alternatively if it's set to auto and the source is mono
                if (src.spatialize === 1 || (src.spatialize === 2 /* AL_AUTO_SOFT */ && templateBuf.channels === 1)) {
                    if (src.panner) {
                        return;
                    }
                    src.panner = src.context.audioCtx.createPanner();
                    AL.updateSourceGlobal(src);
                    AL.updateSourceSpace(src);
                    src.panner.connect(src.context.gain);
                    src.gain.disconnect();
                    src.gain.connect(src.panner);
                }
                else {
                    if (!src.panner) {
                        return;
                    }
                    src.panner.disconnect();
                    src.gain.disconnect();
                    src.gain.connect(src.context.gain);
                    src.panner = null;
                }
            },
            updateContextGlobal: (ctx) => {
                for (var i in ctx.sources) {
                    AL.updateSourceGlobal(ctx.sources[i]);
                }
            },
            updateSourceGlobal: (src) => {
                var panner = src.panner;
                if (!panner) {
                    return;
                }
                panner.refDistance = src.refDistance;
                panner.maxDistance = src.maxDistance;
                panner.rolloffFactor = src.rolloffFactor;
                panner.panningModel = src.context.hrtf ? 'HRTF' : 'equalpower';
                // Use the source's distance model if AL_SOURCE_DISTANCE_MODEL is enabled
                var distanceModel = src.context.sourceDistanceModel ? src.distanceModel : src.context.distanceModel;
                switch (distanceModel) {
                    case 0:
                        panner.distanceModel = 'inverse';
                        panner.refDistance = 3.40282e38 /* FLT_MAX */;
                        break;
                    case 0xd001 /* AL_INVERSE_DISTANCE */:
                    case 0xd002 /* AL_INVERSE_DISTANCE_CLAMPED */:
                        panner.distanceModel = 'inverse';
                        break;
                    case 0xd003 /* AL_LINEAR_DISTANCE */:
                    case 0xd004 /* AL_LINEAR_DISTANCE_CLAMPED */:
                        panner.distanceModel = 'linear';
                        break;
                    case 0xd005 /* AL_EXPONENT_DISTANCE */:
                    case 0xd006 /* AL_EXPONENT_DISTANCE_CLAMPED */:
                        panner.distanceModel = 'exponential';
                        break;
                }
            },
            updateListenerSpace: (ctx) => {
                var listener = ctx.audioCtx.listener;
                if (listener.positionX) {
                    listener.positionX.value = ctx.listener.position[0];
                    listener.positionY.value = ctx.listener.position[1];
                    listener.positionZ.value = ctx.listener.position[2];
                }
                else {
                    listener.setPosition(ctx.listener.position[0], ctx.listener.position[1], ctx.listener.position[2]);
                }
                if (listener.forwardX) {
                    listener.forwardX.value = ctx.listener.direction[0];
                    listener.forwardY.value = ctx.listener.direction[1];
                    listener.forwardZ.value = ctx.listener.direction[2];
                    listener.upX.value = ctx.listener.up[0];
                    listener.upY.value = ctx.listener.up[1];
                    listener.upZ.value = ctx.listener.up[2];
                }
                else {
                    listener.setOrientation(ctx.listener.direction[0], ctx.listener.direction[1], ctx.listener.direction[2], ctx.listener.up[0], ctx.listener.up[1], ctx.listener.up[2]);
                }
                // Update sources that are relative to the listener
                for (var i in ctx.sources) {
                    AL.updateSourceSpace(ctx.sources[i]);
                }
            },
            updateSourceSpace: (src) => {
                if (!src.panner) {
                    return;
                }
                var panner = src.panner;
                var posX = src.position[0];
                var posY = src.position[1];
                var posZ = src.position[2];
                var dirX = src.direction[0];
                var dirY = src.direction[1];
                var dirZ = src.direction[2];
                var listener = src.context.listener;
                var lPosX = listener.position[0];
                var lPosY = listener.position[1];
                var lPosZ = listener.position[2];
                // WebAudio does spatialization in world-space coordinates, meaning both the buffer sources and
                // the listener position are in the same absolute coordinate system relative to a fixed origin.
                // By default, OpenAL works this way as well, but it also provides a "listener relative" mode, where
                // a buffer source's coordinate are interpreted not in absolute world space, but as being relative
                // to the listener object itself, so as the listener moves the source appears to move with it
                // with no update required. Since web audio does not support this mode, we must transform the source
                // coordinates from listener-relative space to absolute world space.
                //
                // We do this via affine transformation matrices applied to the source position and source direction.
                // A change-of-basis converts from listener-space displacements to world-space displacements,
                // which must be done for both the source position and direction. Lastly, the source position must be
                // added to the listener position to get the final source position, since the source position represents
                // a displacement from the listener.
                if (src.relative) {
                    // Negate the listener direction since forward is -Z.
                    var lBackX = -listener.direction[0];
                    var lBackY = -listener.direction[1];
                    var lBackZ = -listener.direction[2];
                    var lUpX = listener.up[0];
                    var lUpY = listener.up[1];
                    var lUpZ = listener.up[2];
                    var inverseMagnitude = (x, y, z) => {
                        var length = Math.sqrt(x * x + y * y + z * z);
                        if (length < Number.EPSILON) {
                            return 0.0;
                        }
                        return 1.0 / length;
                    };
                    // Normalize the Back vector
                    var invMag = inverseMagnitude(lBackX, lBackY, lBackZ);
                    lBackX *= invMag;
                    lBackY *= invMag;
                    lBackZ *= invMag;
                    // ...and the Up vector
                    invMag = inverseMagnitude(lUpX, lUpY, lUpZ);
                    lUpX *= invMag;
                    lUpY *= invMag;
                    lUpZ *= invMag;
                    // Calculate the Right vector as the cross product of the Up and Back vectors
                    var lRightX = (lUpY * lBackZ - lUpZ * lBackY);
                    var lRightY = (lUpZ * lBackX - lUpX * lBackZ);
                    var lRightZ = (lUpX * lBackY - lUpY * lBackX);
                    // Back and Up might not be exactly perpendicular, so the cross product also needs normalization
                    invMag = inverseMagnitude(lRightX, lRightY, lRightZ);
                    lRightX *= invMag;
                    lRightY *= invMag;
                    lRightZ *= invMag;
                    // Recompute Up from the now orthonormal Right and Back vectors so we have a fully orthonormal basis
                    lUpX = (lBackY * lRightZ - lBackZ * lRightY);
                    lUpY = (lBackZ * lRightX - lBackX * lRightZ);
                    lUpZ = (lBackX * lRightY - lBackY * lRightX);
                    var oldX = dirX;
                    var oldY = dirY;
                    var oldZ = dirZ;
                    // Use our 3 vectors to apply a change-of-basis matrix to the source direction
                    dirX = oldX * lRightX + oldY * lUpX + oldZ * lBackX;
                    dirY = oldX * lRightY + oldY * lUpY + oldZ * lBackY;
                    dirZ = oldX * lRightZ + oldY * lUpZ + oldZ * lBackZ;
                    oldX = posX;
                    oldY = posY;
                    oldZ = posZ;
                    // ...and to the source position
                    posX = oldX * lRightX + oldY * lUpX + oldZ * lBackX;
                    posY = oldX * lRightY + oldY * lUpY + oldZ * lBackY;
                    posZ = oldX * lRightZ + oldY * lUpZ + oldZ * lBackZ;
                    // The change-of-basis corrects the orientation, but the origin is still the listener.
                    // Translate the source position by the listener position to finish.
                    posX += lPosX;
                    posY += lPosY;
                    posZ += lPosZ;
                }
                if (panner.positionX) {
                    // Assigning to panner.positionX/Y/Z unnecessarily seems to cause performance issues
                    // See https://github.com/emscripten-core/emscripten/issues/15847
                    if (posX != panner.positionX.value)
                        panner.positionX.value = posX;
                    if (posY != panner.positionY.value)
                        panner.positionY.value = posY;
                    if (posZ != panner.positionZ.value)
                        panner.positionZ.value = posZ;
                }
                else {
                    panner.setPosition(posX, posY, posZ);
                }
                if (panner.orientationX) {
                    // Assigning to panner.orientation/Y/Z unnecessarily seems to cause performance issues
                    // See https://github.com/emscripten-core/emscripten/issues/15847
                    if (dirX != panner.orientationX.value)
                        panner.orientationX.value = dirX;
                    if (dirY != panner.orientationY.value)
                        panner.orientationY.value = dirY;
                    if (dirZ != panner.orientationZ.value)
                        panner.orientationZ.value = dirZ;
                }
                else {
                    panner.setOrientation(dirX, dirY, dirZ);
                }
                var oldShift = src.dopplerShift;
                var velX = src.velocity[0];
                var velY = src.velocity[1];
                var velZ = src.velocity[2];
                var lVelX = listener.velocity[0];
                var lVelY = listener.velocity[1];
                var lVelZ = listener.velocity[2];
                if (posX === lPosX && posY === lPosY && posZ === lPosZ
                    || velX === lVelX && velY === lVelY && velZ === lVelZ) {
                    src.dopplerShift = 1.0;
                }
                else {
                    // Doppler algorithm from 1.1 spec
                    var speedOfSound = src.context.speedOfSound;
                    var dopplerFactor = src.context.dopplerFactor;
                    var slX = lPosX - posX;
                    var slY = lPosY - posY;
                    var slZ = lPosZ - posZ;
                    var magSl = Math.sqrt(slX * slX + slY * slY + slZ * slZ);
                    var vls = (slX * lVelX + slY * lVelY + slZ * lVelZ) / magSl;
                    var vss = (slX * velX + slY * velY + slZ * velZ) / magSl;
                    vls = Math.min(vls, speedOfSound / dopplerFactor);
                    vss = Math.min(vss, speedOfSound / dopplerFactor);
                    src.dopplerShift = (speedOfSound - dopplerFactor * vls) / (speedOfSound - dopplerFactor * vss);
                }
                if (src.dopplerShift !== oldShift) {
                    AL.updateSourceRate(src);
                }
            },
            updateSourceRate: (src) => {
                if (src.state === 4114) {
                    // clear scheduled buffers
                    AL.cancelPendingSourceAudio(src);
                    var audioSrc = src.audioQueue[0];
                    if (!audioSrc) {
                        return; // It is possible that AL.scheduleContextAudio() has not yet fed the next buffer, if so, skip.
                    }
                    var duration;
                    if (src.type === 4136 && src.looping) {
                        duration = Number.POSITIVE_INFINITY;
                    }
                    else {
                        // audioSrc._duration is expressed after factoring in playbackRate, so when changing playback rate, need
                        // to recompute/rescale the rate to the new playback speed.
                        duration = (audioSrc.buffer.duration - audioSrc._startOffset) / src.playbackRate;
                    }
                    audioSrc._duration = duration;
                    audioSrc.playbackRate.value = src.playbackRate;
                    // reschedule buffers with the new playbackRate
                    AL.scheduleSourceAudio(src);
                }
            },
            sourceDuration: (src) => {
                var length = 0.0;
                for (var i = 0; i < src.bufQueue.length; i++) {
                    var audioBuf = src.bufQueue[i].audioBuf;
                    length += audioBuf ? audioBuf.duration : 0.0;
                }
                return length;
            },
            sourceTell: (src) => {
                AL.updateSourceTime(src);
                var offset = 0.0;
                for (var i = 0; i < src.bufsProcessed; i++) {
                    if (src.bufQueue[i].audioBuf) {
                        offset += src.bufQueue[i].audioBuf.duration;
                    }
                }
                offset += src.bufOffset;
                return offset;
            },
            sourceSeek: (src, offset) => {
                var playing = src.state == 4114;
                if (playing) {
                    AL.setSourceState(src, 4113);
                }
                if (src.bufQueue[src.bufsProcessed].audioBuf !== null) {
                    src.bufsProcessed = 0;
                    while (offset > src.bufQueue[src.bufsProcessed].audioBuf.duration) {
                        offset -= src.bufQueue[src.bufsProcessed].audioBuf.duration;
                        src.bufsProcessed++;
                    }
                    src.bufOffset = offset;
                }
                if (playing) {
                    AL.setSourceState(src, 4114);
                }
            },
            getGlobalParam: (funcname, param) => {
                if (!AL.currentCtx) {
                    return null;
                }
                switch (param) {
                    case 49152:
                        return AL.currentCtx.dopplerFactor;
                    case 49155:
                        return AL.currentCtx.speedOfSound;
                    case 53248:
                        return AL.currentCtx.distanceModel;
                    default:
                        AL.currentCtx.err = 40962;
                        return null;
                }
            },
            setGlobalParam: (funcname, param, value) => {
                if (!AL.currentCtx) {
                    return;
                }
                switch (param) {
                    case 49152:
                        if (!Number.isFinite(value) || value < 0.0) { // Strictly negative values are disallowed
                            AL.currentCtx.err = 40963;
                            return;
                        }
                        AL.currentCtx.dopplerFactor = value;
                        AL.updateListenerSpace(AL.currentCtx);
                        break;
                    case 49155:
                        if (!Number.isFinite(value) || value <= 0.0) { // Negative or zero values are disallowed
                            AL.currentCtx.err = 40963;
                            return;
                        }
                        AL.currentCtx.speedOfSound = value;
                        AL.updateListenerSpace(AL.currentCtx);
                        break;
                    case 53248:
                        switch (value) {
                            case 0:
                            case 0xd001 /* AL_INVERSE_DISTANCE */:
                            case 0xd002 /* AL_INVERSE_DISTANCE_CLAMPED */:
                            case 0xd003 /* AL_LINEAR_DISTANCE */:
                            case 0xd004 /* AL_LINEAR_DISTANCE_CLAMPED */:
                            case 0xd005 /* AL_EXPONENT_DISTANCE */:
                            case 0xd006 /* AL_EXPONENT_DISTANCE_CLAMPED */:
                                AL.currentCtx.distanceModel = value;
                                AL.updateContextGlobal(AL.currentCtx);
                                break;
                            default:
                                AL.currentCtx.err = 40963;
                                return;
                        }
                        break;
                    default:
                        AL.currentCtx.err = 40962;
                        return;
                }
            },
            getListenerParam: (funcname, param) => {
                if (!AL.currentCtx) {
                    return null;
                }
                switch (param) {
                    case 4100:
                        return AL.currentCtx.listener.position;
                    case 4102:
                        return AL.currentCtx.listener.velocity;
                    case 4111:
                        return AL.currentCtx.listener.direction.concat(AL.currentCtx.listener.up);
                    case 4106:
                        return AL.currentCtx.gain.gain.value;
                    default:
                        AL.currentCtx.err = 40962;
                        return null;
                }
            },
            setListenerParam: (funcname, param, value) => {
                if (!AL.currentCtx) {
                    return;
                }
                if (value === null) {
                    AL.currentCtx.err = 40962;
                    return;
                }
                var listener = AL.currentCtx.listener;
                switch (param) {
                    case 4100:
                        if (!Number.isFinite(value[0]) || !Number.isFinite(value[1]) || !Number.isFinite(value[2])) {
                            AL.currentCtx.err = 40963;
                            return;
                        }
                        listener.position[0] = value[0];
                        listener.position[1] = value[1];
                        listener.position[2] = value[2];
                        AL.updateListenerSpace(AL.currentCtx);
                        break;
                    case 4102:
                        if (!Number.isFinite(value[0]) || !Number.isFinite(value[1]) || !Number.isFinite(value[2])) {
                            AL.currentCtx.err = 40963;
                            return;
                        }
                        listener.velocity[0] = value[0];
                        listener.velocity[1] = value[1];
                        listener.velocity[2] = value[2];
                        AL.updateListenerSpace(AL.currentCtx);
                        break;
                    case 4106:
                        if (!Number.isFinite(value) || value < 0.0) {
                            AL.currentCtx.err = 40963;
                            return;
                        }
                        AL.currentCtx.gain.gain.value = value;
                        break;
                    case 4111:
                        if (!Number.isFinite(value[0]) || !Number.isFinite(value[1]) || !Number.isFinite(value[2])
                            || !Number.isFinite(value[3]) || !Number.isFinite(value[4]) || !Number.isFinite(value[5])) {
                            AL.currentCtx.err = 40963;
                            return;
                        }
                        listener.direction[0] = value[0];
                        listener.direction[1] = value[1];
                        listener.direction[2] = value[2];
                        listener.up[0] = value[3];
                        listener.up[1] = value[4];
                        listener.up[2] = value[5];
                        AL.updateListenerSpace(AL.currentCtx);
                        break;
                    default:
                        AL.currentCtx.err = 40962;
                        return;
                }
            },
            getBufferParam: (funcname, bufferId, param) => {
                if (!AL.currentCtx) {
                    return;
                }
                var buf = AL.buffers[bufferId];
                if (!buf || bufferId === 0) {
                    AL.currentCtx.err = 40961;
                    return;
                }
                switch (param) {
                    case 0x2001 /* AL_FREQUENCY */:
                        return buf.frequency;
                    case 0x2002 /* AL_BITS */:
                        return buf.bytesPerSample * 8;
                    case 0x2003 /* AL_CHANNELS */:
                        return buf.channels;
                    case 0x2004 /* AL_SIZE */:
                        return buf.length * buf.bytesPerSample * buf.channels;
                    case 0x2015 /* AL_LOOP_POINTS_SOFT */:
                        if (buf.length === 0) {
                            return [0, 0];
                        }
                        return [
                            (buf.audioBuf._loopStart || 0.0) * buf.frequency,
                            (buf.audioBuf._loopEnd || buf.length) * buf.frequency
                        ];
                    default:
                        AL.currentCtx.err = 40962;
                        return null;
                }
            },
            setBufferParam: (funcname, bufferId, param, value) => {
                if (!AL.currentCtx) {
                    return;
                }
                var buf = AL.buffers[bufferId];
                if (!buf || bufferId === 0) {
                    AL.currentCtx.err = 40961;
                    return;
                }
                if (value === null) {
                    AL.currentCtx.err = 40962;
                    return;
                }
                switch (param) {
                    case 0x2004 /* AL_SIZE */:
                        if (value !== 0) {
                            AL.currentCtx.err = 40963;
                            return;
                        }
                        // Per the spec, setting AL_SIZE to 0 is a legal NOP.
                        break;
                    case 0x2015 /* AL_LOOP_POINTS_SOFT */:
                        if (value[0] < 0 || value[0] > buf.length || value[1] < 0 || value[1] > buf.Length || value[0] >= value[1]) {
                            AL.currentCtx.err = 40963;
                            return;
                        }
                        if (buf.refCount > 0) {
                            AL.currentCtx.err = 40964;
                            return;
                        }
                        if (buf.audioBuf) {
                            buf.audioBuf._loopStart = value[0] / buf.frequency;
                            buf.audioBuf._loopEnd = value[1] / buf.frequency;
                        }
                        break;
                    default:
                        AL.currentCtx.err = 40962;
                        return;
                }
            },
            getSourceParam: (funcname, sourceId, param) => {
                if (!AL.currentCtx) {
                    return null;
                }
                var src = AL.currentCtx.sources[sourceId];
                if (!src) {
                    AL.currentCtx.err = 40961;
                    return null;
                }
                switch (param) {
                    case 0x202 /* AL_SOURCE_RELATIVE */:
                        return src.relative;
                    case 0x1001 /* AL_CONE_INNER_ANGLE */:
                        return src.coneInnerAngle;
                    case 0x1002 /* AL_CONE_OUTER_ANGLE */:
                        return src.coneOuterAngle;
                    case 0x1003 /* AL_PITCH */:
                        return src.pitch;
                    case 4100:
                        return src.position;
                    case 4101:
                        return src.direction;
                    case 4102:
                        return src.velocity;
                    case 0x1007 /* AL_LOOPING */:
                        return src.looping;
                    case 0x1009 /* AL_BUFFER */:
                        if (src.type === 4136) {
                            return src.bufQueue[0].id;
                        }
                        return 0;
                    case 4106:
                        return src.gain.gain.value;
                    case 0x100D /* AL_MIN_GAIN */:
                        return src.minGain;
                    case 0x100E /* AL_MAX_GAIN */:
                        return src.maxGain;
                    case 0x1010 /* AL_SOURCE_STATE */:
                        return src.state;
                    case 0x1015 /* AL_BUFFERS_QUEUED */:
                        if (src.bufQueue.length === 1 && src.bufQueue[0].id === 0) {
                            return 0;
                        }
                        return src.bufQueue.length;
                    case 0x1016 /* AL_BUFFERS_PROCESSED */:
                        if ((src.bufQueue.length === 1 && src.bufQueue[0].id === 0) || src.looping) {
                            return 0;
                        }
                        return src.bufsProcessed;
                    case 0x1020 /* AL_REFERENCE_DISTANCE */:
                        return src.refDistance;
                    case 0x1021 /* AL_ROLLOFF_FACTOR */:
                        return src.rolloffFactor;
                    case 0x1022 /* AL_CONE_OUTER_GAIN */:
                        return src.coneOuterGain;
                    case 0x1023 /* AL_MAX_DISTANCE */:
                        return src.maxDistance;
                    case 0x1024 /* AL_SEC_OFFSET */:
                        return AL.sourceTell(src);
                    case 0x1025 /* AL_SAMPLE_OFFSET */:
                        var offset = AL.sourceTell(src);
                        if (offset > 0.0) {
                            offset *= src.bufQueue[0].frequency;
                        }
                        return offset;
                    case 0x1026 /* AL_BYTE_OFFSET */:
                        var offset = AL.sourceTell(src);
                        if (offset > 0.0) {
                            offset *= src.bufQueue[0].frequency * src.bufQueue[0].bytesPerSample;
                        }
                        return offset;
                    case 0x1027 /* AL_SOURCE_TYPE */:
                        return src.type;
                    case 0x1214 /* AL_SOURCE_SPATIALIZE_SOFT */:
                        return src.spatialize;
                    case 0x2009 /* AL_BYTE_LENGTH_SOFT */:
                        var length = 0;
                        var bytesPerFrame = 0;
                        for (var i = 0; i < src.bufQueue.length; i++) {
                            length += src.bufQueue[i].length;
                            if (src.bufQueue[i].id !== 0) {
                                bytesPerFrame = src.bufQueue[i].bytesPerSample * src.bufQueue[i].channels;
                            }
                        }
                        return length * bytesPerFrame;
                    case 0x200A /* AL_SAMPLE_LENGTH_SOFT */:
                        var length = 0;
                        for (var i = 0; i < src.bufQueue.length; i++) {
                            length += src.bufQueue[i].length;
                        }
                        return length;
                    case 0x200B /* AL_SEC_LENGTH_SOFT */:
                        return AL.sourceDuration(src);
                    case 53248:
                        return src.distanceModel;
                    default:
                        AL.currentCtx.err = 40962;
                        return null;
                }
            },
            setSourceParam: (funcname, sourceId, param, value) => {
                if (!AL.currentCtx) {
                    return;
                }
                var src = AL.currentCtx.sources[sourceId];
                if (!src) {
                    AL.currentCtx.err = 40961;
                    return;
                }
                if (value === null) {
                    AL.currentCtx.err = 40962;
                    return;
                }
                switch (param) {
                    case 0x202 /* AL_SOURCE_RELATIVE */:
                        if (value === 1) {
                            src.relative = true;
                            AL.updateSourceSpace(src);
                        }
                        else if (value === 0) {
                            src.relative = false;
                            AL.updateSourceSpace(src);
                        }
                        else {
                            AL.currentCtx.err = 40963;
                            return;
                        }
                        break;
                    case 0x1001 /* AL_CONE_INNER_ANGLE */:
                        if (!Number.isFinite(value)) {
                            AL.currentCtx.err = 40963;
                            return;
                        }
                        src.coneInnerAngle = value;
                        if (src.panner) {
                            src.panner.coneInnerAngle = value % 360.0;
                        }
                        break;
                    case 0x1002 /* AL_CONE_OUTER_ANGLE */:
                        if (!Number.isFinite(value)) {
                            AL.currentCtx.err = 40963;
                            return;
                        }
                        src.coneOuterAngle = value;
                        if (src.panner) {
                            src.panner.coneOuterAngle = value % 360.0;
                        }
                        break;
                    case 0x1003 /* AL_PITCH */:
                        if (!Number.isFinite(value) || value <= 0.0) {
                            AL.currentCtx.err = 40963;
                            return;
                        }
                        if (src.pitch === value) {
                            break;
                        }
                        src.pitch = value;
                        AL.updateSourceRate(src);
                        break;
                    case 4100:
                        if (!Number.isFinite(value[0]) || !Number.isFinite(value[1]) || !Number.isFinite(value[2])) {
                            AL.currentCtx.err = 40963;
                            return;
                        }
                        src.position[0] = value[0];
                        src.position[1] = value[1];
                        src.position[2] = value[2];
                        AL.updateSourceSpace(src);
                        break;
                    case 4101:
                        if (!Number.isFinite(value[0]) || !Number.isFinite(value[1]) || !Number.isFinite(value[2])) {
                            AL.currentCtx.err = 40963;
                            return;
                        }
                        src.direction[0] = value[0];
                        src.direction[1] = value[1];
                        src.direction[2] = value[2];
                        AL.updateSourceSpace(src);
                        break;
                    case 4102:
                        if (!Number.isFinite(value[0]) || !Number.isFinite(value[1]) || !Number.isFinite(value[2])) {
                            AL.currentCtx.err = 40963;
                            return;
                        }
                        src.velocity[0] = value[0];
                        src.velocity[1] = value[1];
                        src.velocity[2] = value[2];
                        AL.updateSourceSpace(src);
                        break;
                    case 0x1007 /* AL_LOOPING */:
                        if (value === 1) {
                            src.looping = true;
                            AL.updateSourceTime(src);
                            if (src.type === 4136 && src.audioQueue.length > 0) {
                                var audioSrc = src.audioQueue[0];
                                audioSrc.loop = true;
                                audioSrc._duration = Number.POSITIVE_INFINITY;
                            }
                        }
                        else if (value === 0) {
                            src.looping = false;
                            var currentTime = AL.updateSourceTime(src);
                            if (src.type === 4136 && src.audioQueue.length > 0) {
                                var audioSrc = src.audioQueue[0];
                                audioSrc.loop = false;
                                audioSrc._duration = src.bufQueue[0].audioBuf.duration / src.playbackRate;
                                audioSrc._startTime = currentTime - src.bufOffset / src.playbackRate;
                            }
                        }
                        else {
                            AL.currentCtx.err = 40963;
                            return;
                        }
                        break;
                    case 0x1009 /* AL_BUFFER */:
                        if (src.state === 4114 || src.state === 4115) {
                            AL.currentCtx.err = 40964;
                            return;
                        }
                        if (value === 0) {
                            for (var i in src.bufQueue) {
                                src.bufQueue[i].refCount--;
                            }
                            src.bufQueue.length = 1;
                            src.bufQueue[0] = AL.buffers[0];
                            src.bufsProcessed = 0;
                            src.type = 0x1030 /* AL_UNDETERMINED */;
                        }
                        else {
                            var buf = AL.buffers[value];
                            if (!buf) {
                                AL.currentCtx.err = 40963;
                                return;
                            }
                            for (var i in src.bufQueue) {
                                src.bufQueue[i].refCount--;
                            }
                            src.bufQueue.length = 0;
                            buf.refCount++;
                            src.bufQueue = [buf];
                            src.bufsProcessed = 0;
                            src.type = 4136;
                        }
                        AL.initSourcePanner(src);
                        AL.scheduleSourceAudio(src);
                        break;
                    case 4106:
                        if (!Number.isFinite(value) || value < 0.0) {
                            AL.currentCtx.err = 40963;
                            return;
                        }
                        src.gain.gain.value = value;
                        break;
                    case 0x100D /* AL_MIN_GAIN */:
                        if (!Number.isFinite(value) || value < 0.0 || value > Math.min(src.maxGain, 1.0)) {
                            AL.currentCtx.err = 40963;
                            return;
                        }
                        src.minGain = value;
                        break;
                    case 0x100E /* AL_MAX_GAIN */:
                        if (!Number.isFinite(value) || value < Math.max(0.0, src.minGain) || value > 1.0) {
                            AL.currentCtx.err = 40963;
                            return;
                        }
                        src.maxGain = value;
                        break;
                    case 0x1020 /* AL_REFERENCE_DISTANCE */:
                        if (!Number.isFinite(value) || value < 0.0) {
                            AL.currentCtx.err = 40963;
                            return;
                        }
                        src.refDistance = value;
                        if (src.panner) {
                            src.panner.refDistance = value;
                        }
                        break;
                    case 0x1021 /* AL_ROLLOFF_FACTOR */:
                        if (!Number.isFinite(value) || value < 0.0) {
                            AL.currentCtx.err = 40963;
                            return;
                        }
                        src.rolloffFactor = value;
                        if (src.panner) {
                            src.panner.rolloffFactor = value;
                        }
                        break;
                    case 0x1022 /* AL_CONE_OUTER_GAIN */:
                        if (!Number.isFinite(value) || value < 0.0 || value > 1.0) {
                            AL.currentCtx.err = 40963;
                            return;
                        }
                        src.coneOuterGain = value;
                        if (src.panner) {
                            src.panner.coneOuterGain = value;
                        }
                        break;
                    case 0x1023 /* AL_MAX_DISTANCE */:
                        if (!Number.isFinite(value) || value < 0.0) {
                            AL.currentCtx.err = 40963;
                            return;
                        }
                        src.maxDistance = value;
                        if (src.panner) {
                            src.panner.maxDistance = value;
                        }
                        break;
                    case 0x1024 /* AL_SEC_OFFSET */:
                        if (value < 0.0 || value > AL.sourceDuration(src)) {
                            AL.currentCtx.err = 40963;
                            return;
                        }
                        AL.sourceSeek(src, value);
                        break;
                    case 0x1025 /* AL_SAMPLE_OFFSET */:
                        var srcLen = AL.sourceDuration(src);
                        if (srcLen > 0.0) {
                            var frequency;
                            for (var bufId in src.bufQueue) {
                                if (bufId) {
                                    frequency = src.bufQueue[bufId].frequency;
                                    break;
                                }
                            }
                            value /= frequency;
                        }
                        if (value < 0.0 || value > srcLen) {
                            AL.currentCtx.err = 40963;
                            return;
                        }
                        AL.sourceSeek(src, value);
                        break;
                    case 0x1026 /* AL_BYTE_OFFSET */:
                        var srcLen = AL.sourceDuration(src);
                        if (srcLen > 0.0) {
                            var bytesPerSec;
                            for (var bufId in src.bufQueue) {
                                if (bufId) {
                                    var buf = src.bufQueue[bufId];
                                    bytesPerSec = buf.frequency * buf.bytesPerSample * buf.channels;
                                    break;
                                }
                            }
                            value /= bytesPerSec;
                        }
                        if (value < 0.0 || value > srcLen) {
                            AL.currentCtx.err = 40963;
                            return;
                        }
                        AL.sourceSeek(src, value);
                        break;
                    case 0x1214 /* AL_SOURCE_SPATIALIZE_SOFT */:
                        if (value !== 0 && value !== 1 && value !== 2 /* AL_AUTO_SOFT */) {
                            AL.currentCtx.err = 40963;
                            return;
                        }
                        src.spatialize = value;
                        AL.initSourcePanner(src);
                        break;
                    case 0x2009 /* AL_BYTE_LENGTH_SOFT */:
                    case 0x200A /* AL_SAMPLE_LENGTH_SOFT */:
                    case 0x200B /* AL_SEC_LENGTH_SOFT */:
                        AL.currentCtx.err = 40964;
                        break;
                    case 53248:
                        switch (value) {
                            case 0:
                            case 0xd001 /* AL_INVERSE_DISTANCE */:
                            case 0xd002 /* AL_INVERSE_DISTANCE_CLAMPED */:
                            case 0xd003 /* AL_LINEAR_DISTANCE */:
                            case 0xd004 /* AL_LINEAR_DISTANCE_CLAMPED */:
                            case 0xd005 /* AL_EXPONENT_DISTANCE */:
                            case 0xd006 /* AL_EXPONENT_DISTANCE_CLAMPED */:
                                src.distanceModel = value;
                                if (AL.currentCtx.sourceDistanceModel) {
                                    AL.updateContextGlobal(AL.currentCtx);
                                }
                                break;
                            default:
                                AL.currentCtx.err = 40963;
                                return;
                        }
                        break;
                    default:
                        AL.currentCtx.err = 40962;
                        return;
                }
            },
            captures: {},
            sharedCaptureAudioCtx: null,
            requireValidCaptureDevice: (deviceId, funcname) => {
                if (deviceId === 0) {
                    AL.alcErr = 40961;
                    return null;
                }
                var c = AL.captures[deviceId];
                if (!c) {
                    AL.alcErr = 40961;
                    return null;
                }
                var err = c.mediaStreamError;
                if (err) {
                    AL.alcErr = 40961;
                    return null;
                }
                return c;
            },
        };
        function _alBuffer3f(bufferId, param, value0, value1, value2) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(5, 0, 1, bufferId, param, value0, value1, value2);
            AL.setBufferParam('alBuffer3f', bufferId, param, null);
        }
        function _alBuffer3i(bufferId, param, value0, value1, value2) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(6, 0, 1, bufferId, param, value0, value1, value2);
            AL.setBufferParam('alBuffer3i', bufferId, param, null);
        }
        function _alBufferData(bufferId, format, pData, size, freq) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(7, 0, 1, bufferId, format, pData, size, freq);
            if (!AL.currentCtx) {
                return;
            }
            var buf = AL.buffers[bufferId];
            if (!buf) {
                AL.currentCtx.err = 40963;
                return;
            }
            if (freq <= 0) {
                AL.currentCtx.err = 40963;
                return;
            }
            var audioBuf = null;
            try {
                switch (format) {
                    case 0x1100 /* AL_FORMAT_MONO8 */:
                        if (size > 0) {
                            audioBuf = AL.currentCtx.audioCtx.createBuffer(1, size, freq);
                            var channel0 = audioBuf.getChannelData(0);
                            for (var i = 0; i < size; ++i) {
                                channel0[i] = HEAPU8[pData++] * 0.0078125 /* 1/128 */ - 1.0;
                            }
                        }
                        buf.bytesPerSample = 1;
                        buf.channels = 1;
                        buf.length = size;
                        break;
                    case 0x1101 /* AL_FORMAT_MONO16 */:
                        if (size > 0) {
                            audioBuf = AL.currentCtx.audioCtx.createBuffer(1, size >> 1, freq);
                            var channel0 = audioBuf.getChannelData(0);
                            pData >>= 1;
                            for (var i = 0; i < size >> 1; ++i) {
                                channel0[i] = HEAP16[pData++] * 0.000030517578125 /* 1/32768 */;
                            }
                        }
                        buf.bytesPerSample = 2;
                        buf.channels = 1;
                        buf.length = size >> 1;
                        break;
                    case 0x1102 /* AL_FORMAT_STEREO8 */:
                        if (size > 0) {
                            audioBuf = AL.currentCtx.audioCtx.createBuffer(2, size >> 1, freq);
                            var channel0 = audioBuf.getChannelData(0);
                            var channel1 = audioBuf.getChannelData(1);
                            for (var i = 0; i < size >> 1; ++i) {
                                channel0[i] = HEAPU8[pData++] * 0.0078125 /* 1/128 */ - 1.0;
                                channel1[i] = HEAPU8[pData++] * 0.0078125 /* 1/128 */ - 1.0;
                            }
                        }
                        buf.bytesPerSample = 1;
                        buf.channels = 2;
                        buf.length = size >> 1;
                        break;
                    case 0x1103 /* AL_FORMAT_STEREO16 */:
                        if (size > 0) {
                            audioBuf = AL.currentCtx.audioCtx.createBuffer(2, size >> 2, freq);
                            var channel0 = audioBuf.getChannelData(0);
                            var channel1 = audioBuf.getChannelData(1);
                            pData >>= 1;
                            for (var i = 0; i < size >> 2; ++i) {
                                channel0[i] = HEAP16[pData++] * 0.000030517578125 /* 1/32768 */;
                                channel1[i] = HEAP16[pData++] * 0.000030517578125 /* 1/32768 */;
                            }
                        }
                        buf.bytesPerSample = 2;
                        buf.channels = 2;
                        buf.length = size >> 2;
                        break;
                    case 0x10010 /* AL_FORMAT_MONO_FLOAT32 */:
                        if (size > 0) {
                            audioBuf = AL.currentCtx.audioCtx.createBuffer(1, size >> 2, freq);
                            var channel0 = audioBuf.getChannelData(0);
                            pData >>= 2;
                            for (var i = 0; i < size >> 2; ++i) {
                                channel0[i] = HEAPF32[pData++];
                            }
                        }
                        buf.bytesPerSample = 4;
                        buf.channels = 1;
                        buf.length = size >> 2;
                        break;
                    case 0x10011 /* AL_FORMAT_STEREO_FLOAT32 */:
                        if (size > 0) {
                            audioBuf = AL.currentCtx.audioCtx.createBuffer(2, size >> 3, freq);
                            var channel0 = audioBuf.getChannelData(0);
                            var channel1 = audioBuf.getChannelData(1);
                            pData >>= 2;
                            for (var i = 0; i < size >> 3; ++i) {
                                channel0[i] = HEAPF32[pData++];
                                channel1[i] = HEAPF32[pData++];
                            }
                        }
                        buf.bytesPerSample = 4;
                        buf.channels = 2;
                        buf.length = size >> 3;
                        break;
                    default:
                        AL.currentCtx.err = 40963;
                        return;
                }
                buf.frequency = freq;
                buf.audioBuf = audioBuf;
            }
            catch (e) {
                AL.currentCtx.err = 40963;
                return;
            }
        }
        function _alBufferf(bufferId, param, value) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(8, 0, 1, bufferId, param, value);
            AL.setBufferParam('alBufferf', bufferId, param, null);
        }
        function _alBufferfv(bufferId, param, pValues) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(9, 0, 1, bufferId, param, pValues);
            if (!AL.currentCtx) {
                return;
            }
            if (!pValues) {
                AL.currentCtx.err = 40963;
                return;
            }
            AL.setBufferParam('alBufferfv', bufferId, param, null);
        }
        function _alBufferi(bufferId, param, value) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(10, 0, 1, bufferId, param, value);
            AL.setBufferParam('alBufferi', bufferId, param, null);
        }
        function _alBufferiv(bufferId, param, pValues) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(11, 0, 1, bufferId, param, pValues);
            if (!AL.currentCtx) {
                return;
            }
            if (!pValues) {
                AL.currentCtx.err = 40963;
                return;
            }
            switch (param) {
                case 0x2015 /* AL_LOOP_POINTS_SOFT */:
                    AL.paramArray[0] = HEAP32[((pValues) >> 2)];
                    AL.paramArray[1] = HEAP32[(((pValues) + (4)) >> 2)];
                    AL.setBufferParam('alBufferiv', bufferId, param, AL.paramArray);
                    break;
                default:
                    AL.setBufferParam('alBufferiv', bufferId, param, null);
                    break;
            }
        }
        function _alDeleteBuffers(count, pBufferIds) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(12, 0, 1, count, pBufferIds);
            if (!AL.currentCtx) {
                return;
            }
            for (var i = 0; i < count; ++i) {
                var bufId = HEAP32[(((pBufferIds) + (i * 4)) >> 2)];
                /// Deleting the zero buffer is a legal NOP, so ignore it
                if (bufId === 0) {
                    continue;
                }
                // Make sure the buffer index is valid.
                if (!AL.buffers[bufId]) {
                    AL.currentCtx.err = 40961;
                    return;
                }
                // Make sure the buffer is no longer in use.
                if (AL.buffers[bufId].refCount) {
                    AL.currentCtx.err = 40964;
                    return;
                }
            }
            for (var i = 0; i < count; ++i) {
                var bufId = HEAP32[(((pBufferIds) + (i * 4)) >> 2)];
                if (bufId === 0) {
                    continue;
                }
                AL.deviceRefCounts[AL.buffers[bufId].deviceId]--;
                delete AL.buffers[bufId];
                AL.freeIds.push(bufId);
            }
        }
        function _alSourcei(sourceId, param, value) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(14, 0, 1, sourceId, param, value);
            switch (param) {
                case 0x202 /* AL_SOURCE_RELATIVE */:
                case 0x1001 /* AL_CONE_INNER_ANGLE */:
                case 0x1002 /* AL_CONE_OUTER_ANGLE */:
                case 0x1007 /* AL_LOOPING */:
                case 0x1009 /* AL_BUFFER */:
                case 0x1020 /* AL_REFERENCE_DISTANCE */:
                case 0x1021 /* AL_ROLLOFF_FACTOR */:
                case 0x1023 /* AL_MAX_DISTANCE */:
                case 0x1024 /* AL_SEC_OFFSET */:
                case 0x1025 /* AL_SAMPLE_OFFSET */:
                case 0x1026 /* AL_BYTE_OFFSET */:
                case 0x1214 /* AL_SOURCE_SPATIALIZE_SOFT */:
                case 0x2009 /* AL_BYTE_LENGTH_SOFT */:
                case 0x200A /* AL_SAMPLE_LENGTH_SOFT */:
                case 53248:
                    AL.setSourceParam('alSourcei', sourceId, param, value);
                    break;
                default:
                    AL.setSourceParam('alSourcei', sourceId, param, null);
                    break;
            }
        }
        function _alDeleteSources(count, pSourceIds) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(13, 0, 1, count, pSourceIds);
            if (!AL.currentCtx) {
                return;
            }
            for (var i = 0; i < count; ++i) {
                var srcId = HEAP32[(((pSourceIds) + (i * 4)) >> 2)];
                if (!AL.currentCtx.sources[srcId]) {
                    AL.currentCtx.err = 40961;
                    return;
                }
            }
            for (var i = 0; i < count; ++i) {
                var srcId = HEAP32[(((pSourceIds) + (i * 4)) >> 2)];
                AL.setSourceState(AL.currentCtx.sources[srcId], 4116);
                _alSourcei(srcId, 0x1009 /* AL_BUFFER */, 0);
                delete AL.currentCtx.sources[srcId];
                AL.freeIds.push(srcId);
            }
        }
        function _alDisable(param) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(15, 0, 1, param);
            if (!AL.currentCtx) {
                return;
            }
            switch (param) {
                case 0x200 /* AL_SOURCE_DISTANCE_MODEL */:
                    AL.currentCtx.sourceDistanceModel = false;
                    AL.updateContextGlobal(AL.currentCtx);
                    break;
                default:
                    AL.currentCtx.err = 40962;
                    return;
            }
        }
        function _alDistanceModel(model) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(16, 0, 1, model);
            AL.setGlobalParam('alDistanceModel', 53248, model);
        }
        function _alDopplerFactor(value) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(17, 0, 1, value);
            AL.setGlobalParam('alDopplerFactor', 49152, value);
        }
        function _alDopplerVelocity(value) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(18, 0, 1, value);
            warnOnce('alDopplerVelocity() is deprecated, and only kept for compatibility with OpenAL 1.0. Use alSpeedOfSound() instead.');
            if (!AL.currentCtx) {
                return;
            }
            if (value <= 0) { // Negative or zero values are disallowed
                AL.currentCtx.err = 40963;
                return;
            }
        }
        function _alEnable(param) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(19, 0, 1, param);
            if (!AL.currentCtx) {
                return;
            }
            switch (param) {
                case 0x200 /* AL_SOURCE_DISTANCE_MODEL */:
                    AL.currentCtx.sourceDistanceModel = true;
                    AL.updateContextGlobal(AL.currentCtx);
                    break;
                default:
                    AL.currentCtx.err = 40962;
                    return;
            }
        }
        function _alGenBuffers(count, pBufferIds) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(20, 0, 1, count, pBufferIds);
            if (!AL.currentCtx) {
                return;
            }
            for (var i = 0; i < count; ++i) {
                var buf = {
                    deviceId: AL.currentCtx.deviceId,
                    id: AL.newId(),
                    refCount: 0,
                    audioBuf: null,
                    frequency: 0,
                    bytesPerSample: 2,
                    channels: 1,
                    length: 0,
                };
                AL.deviceRefCounts[buf.deviceId]++;
                AL.buffers[buf.id] = buf;
                HEAP32[(((pBufferIds) + (i * 4)) >> 2)] = buf.id;
            }
        }
        function _alGenSources(count, pSourceIds) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(21, 0, 1, count, pSourceIds);
            if (!AL.currentCtx) {
                return;
            }
            for (var i = 0; i < count; ++i) {
                var gain = AL.currentCtx.audioCtx.createGain();
                gain.connect(AL.currentCtx.gain);
                var src = {
                    context: AL.currentCtx,
                    id: AL.newId(),
                    type: 0x1030 /* AL_UNDETERMINED */,
                    state: 4113,
                    bufQueue: [AL.buffers[0]],
                    audioQueue: [],
                    looping: false,
                    pitch: 1.0,
                    dopplerShift: 1.0,
                    gain,
                    minGain: 0.0,
                    maxGain: 1.0,
                    panner: null,
                    bufsProcessed: 0,
                    bufStartTime: Number.NEGATIVE_INFINITY,
                    bufOffset: 0.0,
                    relative: false,
                    refDistance: 1.0,
                    maxDistance: 3.40282e38 /* FLT_MAX */,
                    rolloffFactor: 1.0,
                    position: [0.0, 0.0, 0.0],
                    velocity: [0.0, 0.0, 0.0],
                    direction: [0.0, 0.0, 0.0],
                    coneOuterGain: 0.0,
                    coneInnerAngle: 360.0,
                    coneOuterAngle: 360.0,
                    distanceModel: 0xd002 /* AL_INVERSE_DISTANCE_CLAMPED */,
                    spatialize: 2 /* AL_AUTO_SOFT */,
                    get playbackRate() {
                        return this.pitch * this.dopplerShift;
                    }
                };
                AL.currentCtx.sources[src.id] = src;
                HEAP32[(((pSourceIds) + (i * 4)) >> 2)] = src.id;
            }
        }
        function _alGetBoolean(param) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(22, 0, 1, param);
            var val = AL.getGlobalParam('alGetBoolean', param);
            if (val === null) {
                return 0;
            }
            switch (param) {
                case 49152:
                case 49155:
                case 53248:
                    return val !== 0 ? 1 : 0;
                default:
                    AL.currentCtx.err = 40962;
                    return 0;
            }
        }
        function _alGetBooleanv(param, pValues) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(23, 0, 1, param, pValues);
            var val = AL.getGlobalParam('alGetBooleanv', param);
            // Silently ignore null destinations, as per the spec for global state functions
            if (val === null || !pValues) {
                return;
            }
            switch (param) {
                case 49152:
                case 49155:
                case 53248:
                    HEAP8[pValues] = val;
                    break;
                default:
                    AL.currentCtx.err = 40962;
                    return;
            }
        }
        function _alGetBuffer3f(bufferId, param, pValue0, pValue1, pValue2) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(24, 0, 1, bufferId, param, pValue0, pValue1, pValue2);
            var val = AL.getBufferParam('alGetBuffer3f', bufferId, param);
            if (val === null) {
                return;
            }
            if (!pValue0 || !pValue1 || !pValue2) {
                AL.currentCtx.err = 40963;
                return;
            }
            AL.currentCtx.err = 40962;
        }
        function _alGetBuffer3i(bufferId, param, pValue0, pValue1, pValue2) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(25, 0, 1, bufferId, param, pValue0, pValue1, pValue2);
            var val = AL.getBufferParam('alGetBuffer3i', bufferId, param);
            if (val === null) {
                return;
            }
            if (!pValue0 || !pValue1 || !pValue2) {
                AL.currentCtx.err = 40963;
                return;
            }
            AL.currentCtx.err = 40962;
        }
        function _alGetBufferf(bufferId, param, pValue) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(26, 0, 1, bufferId, param, pValue);
            var val = AL.getBufferParam('alGetBufferf', bufferId, param);
            if (val === null) {
                return;
            }
            if (!pValue) {
                AL.currentCtx.err = 40963;
                return;
            }
            AL.currentCtx.err = 40962;
        }
        function _alGetBufferfv(bufferId, param, pValues) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(27, 0, 1, bufferId, param, pValues);
            var val = AL.getBufferParam('alGetBufferfv', bufferId, param);
            if (val === null) {
                return;
            }
            if (!pValues) {
                AL.currentCtx.err = 40963;
                return;
            }
            AL.currentCtx.err = 40962;
        }
        function _alGetBufferi(bufferId, param, pValue) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(28, 0, 1, bufferId, param, pValue);
            var val = AL.getBufferParam('alGetBufferi', bufferId, param);
            if (val === null) {
                return;
            }
            if (!pValue) {
                AL.currentCtx.err = 40963;
                return;
            }
            switch (param) {
                case 0x2001 /* AL_FREQUENCY */:
                case 0x2002 /* AL_BITS */:
                case 0x2003 /* AL_CHANNELS */:
                case 0x2004 /* AL_SIZE */:
                    HEAP32[((pValue) >> 2)] = val;
                    break;
                default:
                    AL.currentCtx.err = 40962;
                    return;
            }
        }
        function _alGetBufferiv(bufferId, param, pValues) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(29, 0, 1, bufferId, param, pValues);
            var val = AL.getBufferParam('alGetBufferiv', bufferId, param);
            if (val === null) {
                return;
            }
            if (!pValues) {
                AL.currentCtx.err = 40963;
                return;
            }
            switch (param) {
                case 0x2001 /* AL_FREQUENCY */:
                case 0x2002 /* AL_BITS */:
                case 0x2003 /* AL_CHANNELS */:
                case 0x2004 /* AL_SIZE */:
                    HEAP32[((pValues) >> 2)] = val;
                    break;
                case 0x2015 /* AL_LOOP_POINTS_SOFT */:
                    HEAP32[((pValues) >> 2)] = val[0];
                    HEAP32[(((pValues) + (4)) >> 2)] = val[1];
                    break;
                default:
                    AL.currentCtx.err = 40962;
                    return;
            }
        }
        function _alGetDouble(param) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(30, 0, 1, param);
            var val = AL.getGlobalParam('alGetDouble', param);
            if (val === null) {
                return 0.0;
            }
            switch (param) {
                case 49152:
                case 49155:
                case 53248:
                    return val;
                default:
                    AL.currentCtx.err = 40962;
                    return 0.0;
            }
        }
        function _alGetDoublev(param, pValues) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(31, 0, 1, param, pValues);
            var val = AL.getGlobalParam('alGetDoublev', param);
            // Silently ignore null destinations, as per the spec for global state functions
            if (val === null || !pValues) {
                return;
            }
            switch (param) {
                case 49152:
                case 49155:
                case 53248:
                    HEAPF64[((pValues) >> 3)] = val;
                    break;
                default:
                    AL.currentCtx.err = 40962;
                    return;
            }
        }
        function _alGetEnumValue(pEnumName) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(32, 0, 1, pEnumName);
            if (!AL.currentCtx) {
                return 0;
            }
            if (!pEnumName) {
                AL.currentCtx.err = 40963;
                return 0;
            }
            var name = UTF8ToString(pEnumName);
            switch (name) {
                // Spec doesn't clearly state that alGetEnumValue() is required to
                // support _only_ extension tokens.
                // We should probably follow OpenAL-Soft's example and support all
                // of the names we know.
                // See http://repo.or.cz/openal-soft.git/blob/HEAD:/Alc/ALc.c
                case 'AL_BITS': return 0x2002;
                case 'AL_BUFFER': return 0x1009;
                case 'AL_BUFFERS_PROCESSED': return 0x1016;
                case 'AL_BUFFERS_QUEUED': return 0x1015;
                case 'AL_BYTE_OFFSET': return 0x1026;
                case 'AL_CHANNELS': return 0x2003;
                case 'AL_CONE_INNER_ANGLE': return 0x1001;
                case 'AL_CONE_OUTER_ANGLE': return 0x1002;
                case 'AL_CONE_OUTER_GAIN': return 0x1022;
                case 'AL_DIRECTION': return 0x1005;
                case 'AL_DISTANCE_MODEL': return 0xD000;
                case 'AL_DOPPLER_FACTOR': return 0xC000;
                case 'AL_DOPPLER_VELOCITY': return 0xC001;
                case 'AL_EXPONENT_DISTANCE': return 0xD005;
                case 'AL_EXPONENT_DISTANCE_CLAMPED': return 0xD006;
                case 'AL_EXTENSIONS': return 0xB004;
                case 'AL_FORMAT_MONO16': return 0x1101;
                case 'AL_FORMAT_MONO8': return 0x1100;
                case 'AL_FORMAT_STEREO16': return 0x1103;
                case 'AL_FORMAT_STEREO8': return 0x1102;
                case 'AL_FREQUENCY': return 0x2001;
                case 'AL_GAIN': return 0x100A;
                case 'AL_INITIAL': return 0x1011;
                case 'AL_INVALID': return -1;
                case 'AL_ILLEGAL_ENUM': // fallthrough
                case 'AL_INVALID_ENUM': return 0xA002;
                case 'AL_INVALID_NAME': return 0xA001;
                case 'AL_ILLEGAL_COMMAND': // fallthrough
                case 'AL_INVALID_OPERATION': return 0xA004;
                case 'AL_INVALID_VALUE': return 0xA003;
                case 'AL_INVERSE_DISTANCE': return 0xD001;
                case 'AL_INVERSE_DISTANCE_CLAMPED': return 0xD002;
                case 'AL_LINEAR_DISTANCE': return 0xD003;
                case 'AL_LINEAR_DISTANCE_CLAMPED': return 0xD004;
                case 'AL_LOOPING': return 0x1007;
                case 'AL_MAX_DISTANCE': return 0x1023;
                case 'AL_MAX_GAIN': return 0x100E;
                case 'AL_MIN_GAIN': return 0x100D;
                case 'AL_NONE': return 0;
                case 'AL_NO_ERROR': return 0;
                case 'AL_ORIENTATION': return 0x100F;
                case 'AL_OUT_OF_MEMORY': return 0xA005;
                case 'AL_PAUSED': return 0x1013;
                case 'AL_PENDING': return 0x2011;
                case 'AL_PITCH': return 0x1003;
                case 'AL_PLAYING': return 0x1012;
                case 'AL_POSITION': return 0x1004;
                case 'AL_PROCESSED': return 0x2012;
                case 'AL_REFERENCE_DISTANCE': return 0x1020;
                case 'AL_RENDERER': return 0xB003;
                case 'AL_ROLLOFF_FACTOR': return 0x1021;
                case 'AL_SAMPLE_OFFSET': return 0x1025;
                case 'AL_SEC_OFFSET': return 0x1024;
                case 'AL_SIZE': return 0x2004;
                case 'AL_SOURCE_RELATIVE': return 0x202;
                case 'AL_SOURCE_STATE': return 0x1010;
                case 'AL_SOURCE_TYPE': return 0x1027;
                case 'AL_SPEED_OF_SOUND': return 0xC003;
                case 'AL_STATIC': return 0x1028;
                case 'AL_STOPPED': return 0x1014;
                case 'AL_STREAMING': return 0x1029;
                case 'AL_UNDETERMINED': return 0x1030;
                case 'AL_UNUSED': return 0x2010;
                case 'AL_VELOCITY': return 0x1006;
                case 'AL_VENDOR': return 0xB001;
                case 'AL_VERSION': return 0xB002;
                /* Extensions */
                case 'AL_AUTO_SOFT': return 0x0002;
                case 'AL_SOURCE_DISTANCE_MODEL': return 0x200;
                case 'AL_SOURCE_SPATIALIZE_SOFT': return 0x1214;
                case 'AL_LOOP_POINTS_SOFT': return 0x2015;
                case 'AL_BYTE_LENGTH_SOFT': return 0x2009;
                case 'AL_SAMPLE_LENGTH_SOFT': return 0x200A;
                case 'AL_SEC_LENGTH_SOFT': return 0x200B;
                case 'AL_FORMAT_MONO_FLOAT32': return 0x10010;
                case 'AL_FORMAT_STEREO_FLOAT32': return 0x10011;
                default:
                    AL.currentCtx.err = 40963;
                    return 0;
            }
        }
        function _alGetError() {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(33, 0, 1);
            if (!AL.currentCtx) {
                return 40964;
            }
            // Reset error on get.
            var err = AL.currentCtx.err;
            AL.currentCtx.err = 0;
            return err;
        }
        function _alGetFloat(param) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(34, 0, 1, param);
            var val = AL.getGlobalParam('alGetFloat', param);
            if (val === null) {
                return 0.0;
            }
            switch (param) {
                case 49152:
                case 49155:
                case 53248:
                    return val;
                default:
                    return 0.0;
            }
        }
        function _alGetFloatv(param, pValues) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(35, 0, 1, param, pValues);
            var val = AL.getGlobalParam('alGetFloatv', param);
            // Silently ignore null destinations, as per the spec for global state functions
            if (val === null || !pValues) {
                return;
            }
            switch (param) {
                case 49152:
                case 49155:
                case 53248:
                    HEAPF32[((pValues) >> 2)] = val;
                    break;
                default:
                    AL.currentCtx.err = 40962;
                    return;
            }
        }
        function _alGetInteger(param) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(36, 0, 1, param);
            var val = AL.getGlobalParam('alGetInteger', param);
            if (val === null) {
                return 0;
            }
            switch (param) {
                case 49152:
                case 49155:
                case 53248:
                    return val;
                default:
                    AL.currentCtx.err = 40962;
                    return 0;
            }
        }
        function _alGetIntegerv(param, pValues) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(37, 0, 1, param, pValues);
            var val = AL.getGlobalParam('alGetIntegerv', param);
            // Silently ignore null destinations, as per the spec for global state functions
            if (val === null || !pValues) {
                return;
            }
            switch (param) {
                case 49152:
                case 49155:
                case 53248:
                    HEAP32[((pValues) >> 2)] = val;
                    break;
                default:
                    AL.currentCtx.err = 40962;
                    return;
            }
        }
        function _alGetListener3f(param, pValue0, pValue1, pValue2) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(38, 0, 1, param, pValue0, pValue1, pValue2);
            var val = AL.getListenerParam('alGetListener3f', param);
            if (val === null) {
                return;
            }
            if (!pValue0 || !pValue1 || !pValue2) {
                AL.currentCtx.err = 40963;
                return;
            }
            switch (param) {
                case 4100:
                case 4102:
                    HEAPF32[((pValue0) >> 2)] = val[0];
                    HEAPF32[((pValue1) >> 2)] = val[1];
                    HEAPF32[((pValue2) >> 2)] = val[2];
                    break;
                default:
                    AL.currentCtx.err = 40962;
                    return;
            }
        }
        function _alGetListener3i(param, pValue0, pValue1, pValue2) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(39, 0, 1, param, pValue0, pValue1, pValue2);
            var val = AL.getListenerParam('alGetListener3i', param);
            if (val === null) {
                return;
            }
            if (!pValue0 || !pValue1 || !pValue2) {
                AL.currentCtx.err = 40963;
                return;
            }
            switch (param) {
                case 4100:
                case 4102:
                    HEAP32[((pValue0) >> 2)] = val[0];
                    HEAP32[((pValue1) >> 2)] = val[1];
                    HEAP32[((pValue2) >> 2)] = val[2];
                    break;
                default:
                    AL.currentCtx.err = 40962;
                    return;
            }
        }
        function _alGetListenerf(param, pValue) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(40, 0, 1, param, pValue);
            var val = AL.getListenerParam('alGetListenerf', param);
            if (val === null) {
                return;
            }
            if (!pValue) {
                AL.currentCtx.err = 40963;
                return;
            }
            switch (param) {
                case 4106:
                    HEAPF32[((pValue) >> 2)] = val;
                    break;
                default:
                    AL.currentCtx.err = 40962;
                    return;
            }
        }
        function _alGetListenerfv(param, pValues) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(41, 0, 1, param, pValues);
            var val = AL.getListenerParam('alGetListenerfv', param);
            if (val === null) {
                return;
            }
            if (!pValues) {
                AL.currentCtx.err = 40963;
                return;
            }
            switch (param) {
                case 4100:
                case 4102:
                    HEAPF32[((pValues) >> 2)] = val[0];
                    HEAPF32[(((pValues) + (4)) >> 2)] = val[1];
                    HEAPF32[(((pValues) + (8)) >> 2)] = val[2];
                    break;
                case 4111:
                    HEAPF32[((pValues) >> 2)] = val[0];
                    HEAPF32[(((pValues) + (4)) >> 2)] = val[1];
                    HEAPF32[(((pValues) + (8)) >> 2)] = val[2];
                    HEAPF32[(((pValues) + (12)) >> 2)] = val[3];
                    HEAPF32[(((pValues) + (16)) >> 2)] = val[4];
                    HEAPF32[(((pValues) + (20)) >> 2)] = val[5];
                    break;
                default:
                    AL.currentCtx.err = 40962;
                    return;
            }
        }
        function _alGetListeneri(param, pValue) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(42, 0, 1, param, pValue);
            var val = AL.getListenerParam('alGetListeneri', param);
            if (val === null) {
                return;
            }
            if (!pValue) {
                AL.currentCtx.err = 40963;
                return;
            }
            AL.currentCtx.err = 40962;
        }
        function _alGetListeneriv(param, pValues) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(43, 0, 1, param, pValues);
            var val = AL.getListenerParam('alGetListeneriv', param);
            if (val === null) {
                return;
            }
            if (!pValues) {
                AL.currentCtx.err = 40963;
                return;
            }
            switch (param) {
                case 4100:
                case 4102:
                    HEAP32[((pValues) >> 2)] = val[0];
                    HEAP32[(((pValues) + (4)) >> 2)] = val[1];
                    HEAP32[(((pValues) + (8)) >> 2)] = val[2];
                    break;
                case 4111:
                    HEAP32[((pValues) >> 2)] = val[0];
                    HEAP32[(((pValues) + (4)) >> 2)] = val[1];
                    HEAP32[(((pValues) + (8)) >> 2)] = val[2];
                    HEAP32[(((pValues) + (12)) >> 2)] = val[3];
                    HEAP32[(((pValues) + (16)) >> 2)] = val[4];
                    HEAP32[(((pValues) + (20)) >> 2)] = val[5];
                    break;
                default:
                    AL.currentCtx.err = 40962;
                    return;
            }
        }
        function _alGetSource3f(sourceId, param, pValue0, pValue1, pValue2) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(44, 0, 1, sourceId, param, pValue0, pValue1, pValue2);
            var val = AL.getSourceParam('alGetSource3f', sourceId, param);
            if (val === null) {
                return;
            }
            if (!pValue0 || !pValue1 || !pValue2) {
                AL.currentCtx.err = 40963;
                return;
            }
            switch (param) {
                case 4100:
                case 4101:
                case 4102:
                    HEAPF32[((pValue0) >> 2)] = val[0];
                    HEAPF32[((pValue1) >> 2)] = val[1];
                    HEAPF32[((pValue2) >> 2)] = val[2];
                    break;
                default:
                    AL.currentCtx.err = 40962;
                    return;
            }
        }
        function _alGetSource3i(sourceId, param, pValue0, pValue1, pValue2) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(45, 0, 1, sourceId, param, pValue0, pValue1, pValue2);
            var val = AL.getSourceParam('alGetSource3i', sourceId, param);
            if (val === null) {
                return;
            }
            if (!pValue0 || !pValue1 || !pValue2) {
                AL.currentCtx.err = 40963;
                return;
            }
            switch (param) {
                case 4100:
                case 4101:
                case 4102:
                    HEAP32[((pValue0) >> 2)] = val[0];
                    HEAP32[((pValue1) >> 2)] = val[1];
                    HEAP32[((pValue2) >> 2)] = val[2];
                    break;
                default:
                    AL.currentCtx.err = 40962;
                    return;
            }
        }
        function _alGetSourcef(sourceId, param, pValue) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(46, 0, 1, sourceId, param, pValue);
            var val = AL.getSourceParam('alGetSourcef', sourceId, param);
            if (val === null) {
                return;
            }
            if (!pValue) {
                AL.currentCtx.err = 40963;
                return;
            }
            switch (param) {
                case 0x1001 /* AL_CONE_INNER_ANGLE */:
                case 0x1002 /* AL_CONE_OUTER_ANGLE */:
                case 0x1003 /* AL_PITCH */:
                case 4106:
                case 0x100D /* AL_MIN_GAIN */:
                case 0x100E /* AL_MAX_GAIN */:
                case 0x1020 /* AL_REFERENCE_DISTANCE */:
                case 0x1021 /* AL_ROLLOFF_FACTOR */:
                case 0x1022 /* AL_CONE_OUTER_GAIN */:
                case 0x1023 /* AL_MAX_DISTANCE */:
                case 0x1024 /* AL_SEC_OFFSET */:
                case 0x1025 /* AL_SAMPLE_OFFSET */:
                case 0x1026 /* AL_BYTE_OFFSET */:
                case 0x200B /* AL_SEC_LENGTH_SOFT */:
                    HEAPF32[((pValue) >> 2)] = val;
                    break;
                default:
                    AL.currentCtx.err = 40962;
                    return;
            }
        }
        function _alGetSourcefv(sourceId, param, pValues) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(47, 0, 1, sourceId, param, pValues);
            var val = AL.getSourceParam('alGetSourcefv', sourceId, param);
            if (val === null) {
                return;
            }
            if (!pValues) {
                AL.currentCtx.err = 40963;
                return;
            }
            switch (param) {
                case 0x1001 /* AL_CONE_INNER_ANGLE */:
                case 0x1002 /* AL_CONE_OUTER_ANGLE */:
                case 0x1003 /* AL_PITCH */:
                case 4106:
                case 0x100D /* AL_MIN_GAIN */:
                case 0x100E /* AL_MAX_GAIN */:
                case 0x1020 /* AL_REFERENCE_DISTANCE */:
                case 0x1021 /* AL_ROLLOFF_FACTOR */:
                case 0x1022 /* AL_CONE_OUTER_GAIN */:
                case 0x1023 /* AL_MAX_DISTANCE */:
                case 0x1024 /* AL_SEC_OFFSET */:
                case 0x1025 /* AL_SAMPLE_OFFSET */:
                case 0x1026 /* AL_BYTE_OFFSET */:
                case 0x200B /* AL_SEC_LENGTH_SOFT */:
                    HEAPF32[((pValues) >> 2)] = val[0];
                    break;
                case 4100:
                case 4101:
                case 4102:
                    HEAPF32[((pValues) >> 2)] = val[0];
                    HEAPF32[(((pValues) + (4)) >> 2)] = val[1];
                    HEAPF32[(((pValues) + (8)) >> 2)] = val[2];
                    break;
                default:
                    AL.currentCtx.err = 40962;
                    return;
            }
        }
        function _alGetSourcei(sourceId, param, pValue) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(48, 0, 1, sourceId, param, pValue);
            var val = AL.getSourceParam('alGetSourcei', sourceId, param);
            if (val === null) {
                return;
            }
            if (!pValue) {
                AL.currentCtx.err = 40963;
                return;
            }
            switch (param) {
                case 0x202 /* AL_SOURCE_RELATIVE */:
                case 0x1001 /* AL_CONE_INNER_ANGLE */:
                case 0x1002 /* AL_CONE_OUTER_ANGLE */:
                case 0x1007 /* AL_LOOPING */:
                case 0x1009 /* AL_BUFFER */:
                case 0x1010 /* AL_SOURCE_STATE */:
                case 0x1015 /* AL_BUFFERS_QUEUED */:
                case 0x1016 /* AL_BUFFERS_PROCESSED */:
                case 0x1020 /* AL_REFERENCE_DISTANCE */:
                case 0x1021 /* AL_ROLLOFF_FACTOR */:
                case 0x1023 /* AL_MAX_DISTANCE */:
                case 0x1024 /* AL_SEC_OFFSET */:
                case 0x1025 /* AL_SAMPLE_OFFSET */:
                case 0x1026 /* AL_BYTE_OFFSET */:
                case 0x1027 /* AL_SOURCE_TYPE */:
                case 0x1214 /* AL_SOURCE_SPATIALIZE_SOFT */:
                case 0x2009 /* AL_BYTE_LENGTH_SOFT */:
                case 0x200A /* AL_SAMPLE_LENGTH_SOFT */:
                case 53248:
                    HEAP32[((pValue) >> 2)] = val;
                    break;
                default:
                    AL.currentCtx.err = 40962;
                    return;
            }
        }
        function _alGetSourceiv(sourceId, param, pValues) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(49, 0, 1, sourceId, param, pValues);
            var val = AL.getSourceParam('alGetSourceiv', sourceId, param);
            if (val === null) {
                return;
            }
            if (!pValues) {
                AL.currentCtx.err = 40963;
                return;
            }
            switch (param) {
                case 0x202 /* AL_SOURCE_RELATIVE */:
                case 0x1001 /* AL_CONE_INNER_ANGLE */:
                case 0x1002 /* AL_CONE_OUTER_ANGLE */:
                case 0x1007 /* AL_LOOPING */:
                case 0x1009 /* AL_BUFFER */:
                case 0x1010 /* AL_SOURCE_STATE */:
                case 0x1015 /* AL_BUFFERS_QUEUED */:
                case 0x1016 /* AL_BUFFERS_PROCESSED */:
                case 0x1020 /* AL_REFERENCE_DISTANCE */:
                case 0x1021 /* AL_ROLLOFF_FACTOR */:
                case 0x1023 /* AL_MAX_DISTANCE */:
                case 0x1024 /* AL_SEC_OFFSET */:
                case 0x1025 /* AL_SAMPLE_OFFSET */:
                case 0x1026 /* AL_BYTE_OFFSET */:
                case 0x1027 /* AL_SOURCE_TYPE */:
                case 0x1214 /* AL_SOURCE_SPATIALIZE_SOFT */:
                case 0x2009 /* AL_BYTE_LENGTH_SOFT */:
                case 0x200A /* AL_SAMPLE_LENGTH_SOFT */:
                case 53248:
                    HEAP32[((pValues) >> 2)] = val;
                    break;
                case 4100:
                case 4101:
                case 4102:
                    HEAP32[((pValues) >> 2)] = val[0];
                    HEAP32[(((pValues) + (4)) >> 2)] = val[1];
                    HEAP32[(((pValues) + (8)) >> 2)] = val[2];
                    break;
                default:
                    AL.currentCtx.err = 40962;
                    return;
            }
        }
        function _alGetString(param) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(50, 0, 1, param);
            if (AL.stringCache[param]) {
                return AL.stringCache[param];
            }
            var ret;
            switch (param) {
                case 0:
                    ret = 'No Error';
                    break;
                case 40961:
                    ret = 'Invalid Name';
                    break;
                case 40962:
                    ret = 'Invalid Enum';
                    break;
                case 40963:
                    ret = 'Invalid Value';
                    break;
                case 40964:
                    ret = 'Invalid Operation';
                    break;
                case 0xA005 /* AL_OUT_OF_MEMORY */:
                    ret = 'Out of Memory';
                    break;
                case 0xB001 /* AL_VENDOR */:
                    ret = 'Emscripten';
                    break;
                case 0xB002 /* AL_VERSION */:
                    ret = '1.1';
                    break;
                case 0xB003 /* AL_RENDERER */:
                    ret = 'WebAudio';
                    break;
                case 0xB004 /* AL_EXTENSIONS */:
                    ret = Object.keys(AL.AL_EXTENSIONS).join(' ');
                    break;
                default:
                    if (AL.currentCtx) {
                        AL.currentCtx.err = 40962;
                    }
                    else {
                    }
                    return 0;
            }
            ret = stringToNewUTF8(ret);
            AL.stringCache[param] = ret;
            return ret;
        }
        function _alIsBuffer(bufferId) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(51, 0, 1, bufferId);
            if (!AL.currentCtx) {
                return false;
            }
            if (bufferId > AL.buffers.length) {
                return false;
            }
            if (!AL.buffers[bufferId]) {
                return false;
            }
            return true;
        }
        function _alIsEnabled(param) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(52, 0, 1, param);
            if (!AL.currentCtx) {
                return 0;
            }
            switch (param) {
                case 0x200 /* AL_SOURCE_DISTANCE_MODEL */:
                    return AL.currentCtx.sourceDistanceModel ? 0 : 1;
                default:
                    AL.currentCtx.err = 40962;
                    return 0;
            }
        }
        function _alIsExtensionPresent(pExtName) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(53, 0, 1, pExtName);
            var name = UTF8ToString(pExtName);
            return AL.AL_EXTENSIONS[name] ? 1 : 0;
        }
        function _alIsSource(sourceId) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(54, 0, 1, sourceId);
            if (!AL.currentCtx) {
                return false;
            }
            if (!AL.currentCtx.sources[sourceId]) {
                return false;
            }
            return true;
        }
        function _alListener3f(param, value0, value1, value2) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(55, 0, 1, param, value0, value1, value2);
            switch (param) {
                case 4100:
                case 4102:
                    AL.paramArray[0] = value0;
                    AL.paramArray[1] = value1;
                    AL.paramArray[2] = value2;
                    AL.setListenerParam('alListener3f', param, AL.paramArray);
                    break;
                default:
                    AL.setListenerParam('alListener3f', param, null);
                    break;
            }
        }
        function _alListener3i(param, value0, value1, value2) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(56, 0, 1, param, value0, value1, value2);
            switch (param) {
                case 4100:
                case 4102:
                    AL.paramArray[0] = value0;
                    AL.paramArray[1] = value1;
                    AL.paramArray[2] = value2;
                    AL.setListenerParam('alListener3i', param, AL.paramArray);
                    break;
                default:
                    AL.setListenerParam('alListener3i', param, null);
                    break;
            }
        }
        function _alListenerf(param, value) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(57, 0, 1, param, value);
            switch (param) {
                case 4106:
                    AL.setListenerParam('alListenerf', param, value);
                    break;
                default:
                    AL.setListenerParam('alListenerf', param, null);
                    break;
            }
        }
        function _alListenerfv(param, pValues) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(58, 0, 1, param, pValues);
            if (!AL.currentCtx) {
                return;
            }
            if (!pValues) {
                AL.currentCtx.err = 40963;
                return;
            }
            switch (param) {
                case 4100:
                case 4102:
                    AL.paramArray[0] = HEAPF32[((pValues) >> 2)];
                    AL.paramArray[1] = HEAPF32[(((pValues) + (4)) >> 2)];
                    AL.paramArray[2] = HEAPF32[(((pValues) + (8)) >> 2)];
                    AL.setListenerParam('alListenerfv', param, AL.paramArray);
                    break;
                case 4111:
                    AL.paramArray[0] = HEAPF32[((pValues) >> 2)];
                    AL.paramArray[1] = HEAPF32[(((pValues) + (4)) >> 2)];
                    AL.paramArray[2] = HEAPF32[(((pValues) + (8)) >> 2)];
                    AL.paramArray[3] = HEAPF32[(((pValues) + (12)) >> 2)];
                    AL.paramArray[4] = HEAPF32[(((pValues) + (16)) >> 2)];
                    AL.paramArray[5] = HEAPF32[(((pValues) + (20)) >> 2)];
                    AL.setListenerParam('alListenerfv', param, AL.paramArray);
                    break;
                default:
                    AL.setListenerParam('alListenerfv', param, null);
                    break;
            }
        }
        function _alListeneri(param, value) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(59, 0, 1, param, value);
            AL.setListenerParam('alListeneri', param, null);
        }
        function _alListeneriv(param, pValues) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(60, 0, 1, param, pValues);
            if (!AL.currentCtx) {
                return;
            }
            if (!pValues) {
                AL.currentCtx.err = 40963;
                return;
            }
            switch (param) {
                case 4100:
                case 4102:
                    AL.paramArray[0] = HEAP32[((pValues) >> 2)];
                    AL.paramArray[1] = HEAP32[(((pValues) + (4)) >> 2)];
                    AL.paramArray[2] = HEAP32[(((pValues) + (8)) >> 2)];
                    AL.setListenerParam('alListeneriv', param, AL.paramArray);
                    break;
                case 4111:
                    AL.paramArray[0] = HEAP32[((pValues) >> 2)];
                    AL.paramArray[1] = HEAP32[(((pValues) + (4)) >> 2)];
                    AL.paramArray[2] = HEAP32[(((pValues) + (8)) >> 2)];
                    AL.paramArray[3] = HEAP32[(((pValues) + (12)) >> 2)];
                    AL.paramArray[4] = HEAP32[(((pValues) + (16)) >> 2)];
                    AL.paramArray[5] = HEAP32[(((pValues) + (20)) >> 2)];
                    AL.setListenerParam('alListeneriv', param, AL.paramArray);
                    break;
                default:
                    AL.setListenerParam('alListeneriv', param, null);
                    break;
            }
        }
        function _alSource3f(sourceId, param, value0, value1, value2) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(61, 0, 1, sourceId, param, value0, value1, value2);
            switch (param) {
                case 4100:
                case 4101:
                case 4102:
                    AL.paramArray[0] = value0;
                    AL.paramArray[1] = value1;
                    AL.paramArray[2] = value2;
                    AL.setSourceParam('alSource3f', sourceId, param, AL.paramArray);
                    break;
                default:
                    AL.setSourceParam('alSource3f', sourceId, param, null);
                    break;
            }
        }
        function _alSource3i(sourceId, param, value0, value1, value2) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(62, 0, 1, sourceId, param, value0, value1, value2);
            switch (param) {
                case 4100:
                case 4101:
                case 4102:
                    AL.paramArray[0] = value0;
                    AL.paramArray[1] = value1;
                    AL.paramArray[2] = value2;
                    AL.setSourceParam('alSource3i', sourceId, param, AL.paramArray);
                    break;
                default:
                    AL.setSourceParam('alSource3i', sourceId, param, null);
                    break;
            }
        }
        function _alSourcePause(sourceId) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(63, 0, 1, sourceId);
            if (!AL.currentCtx) {
                return;
            }
            var src = AL.currentCtx.sources[sourceId];
            if (!src) {
                AL.currentCtx.err = 40961;
                return;
            }
            AL.setSourceState(src, 4115);
        }
        function _alSourcePausev(count, pSourceIds) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(64, 0, 1, count, pSourceIds);
            if (!AL.currentCtx) {
                return;
            }
            if (!pSourceIds) {
                AL.currentCtx.err = 40963;
            }
            for (var i = 0; i < count; ++i) {
                if (!AL.currentCtx.sources[HEAP32[(((pSourceIds) + (i * 4)) >> 2)]]) {
                    AL.currentCtx.err = 40961;
                    return;
                }
            }
            for (var i = 0; i < count; ++i) {
                var srcId = HEAP32[(((pSourceIds) + (i * 4)) >> 2)];
                AL.setSourceState(AL.currentCtx.sources[srcId], 4115);
            }
        }
        function _alSourcePlay(sourceId) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(65, 0, 1, sourceId);
            if (!AL.currentCtx) {
                return;
            }
            var src = AL.currentCtx.sources[sourceId];
            if (!src) {
                AL.currentCtx.err = 40961;
                return;
            }
            AL.setSourceState(src, 4114);
        }
        function _alSourcePlayv(count, pSourceIds) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(66, 0, 1, count, pSourceIds);
            if (!AL.currentCtx) {
                return;
            }
            if (!pSourceIds) {
                AL.currentCtx.err = 40963;
            }
            for (var i = 0; i < count; ++i) {
                if (!AL.currentCtx.sources[HEAP32[(((pSourceIds) + (i * 4)) >> 2)]]) {
                    AL.currentCtx.err = 40961;
                    return;
                }
            }
            for (var i = 0; i < count; ++i) {
                var srcId = HEAP32[(((pSourceIds) + (i * 4)) >> 2)];
                AL.setSourceState(AL.currentCtx.sources[srcId], 4114);
            }
        }
        function _alSourceQueueBuffers(sourceId, count, pBufferIds) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(67, 0, 1, sourceId, count, pBufferIds);
            if (!AL.currentCtx) {
                return;
            }
            var src = AL.currentCtx.sources[sourceId];
            if (!src) {
                AL.currentCtx.err = 40961;
                return;
            }
            if (src.type === 4136) {
                AL.currentCtx.err = 40964;
                return;
            }
            if (count === 0) {
                return;
            }
            // Find the first non-zero buffer in the queue to determine the proper format
            var templateBuf = AL.buffers[0];
            for (var i = 0; i < src.bufQueue.length; i++) {
                if (src.bufQueue[i].id !== 0) {
                    templateBuf = src.bufQueue[i];
                    break;
                }
            }
            for (var i = 0; i < count; ++i) {
                var bufId = HEAP32[(((pBufferIds) + (i * 4)) >> 2)];
                var buf = AL.buffers[bufId];
                if (!buf) {
                    AL.currentCtx.err = 40961;
                    return;
                }
                // Check that the added buffer has the correct format. If the template is the zero buffer, any format is valid.
                if (templateBuf.id !== 0 && (buf.frequency !== templateBuf.frequency
                    || buf.bytesPerSample !== templateBuf.bytesPerSample
                    || buf.channels !== templateBuf.channels)) {
                    AL.currentCtx.err = 40964;
                }
            }
            // If the only buffer in the queue is the zero buffer, clear the queue before we add anything.
            if (src.bufQueue.length === 1 && src.bufQueue[0].id === 0) {
                src.bufQueue.length = 0;
            }
            src.type = 0x1029 /* AL_STREAMING */;
            for (var i = 0; i < count; ++i) {
                var bufId = HEAP32[(((pBufferIds) + (i * 4)) >> 2)];
                var buf = AL.buffers[bufId];
                buf.refCount++;
                src.bufQueue.push(buf);
            }
            // if the source is looping, cancel the schedule so we can reschedule the loop order
            if (src.looping) {
                AL.cancelPendingSourceAudio(src);
            }
            AL.initSourcePanner(src);
            AL.scheduleSourceAudio(src);
        }
        function _alSourceRewind(sourceId) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(68, 0, 1, sourceId);
            if (!AL.currentCtx) {
                return;
            }
            var src = AL.currentCtx.sources[sourceId];
            if (!src) {
                AL.currentCtx.err = 40961;
                return;
            }
            // Stop the source first to clear the source queue
            AL.setSourceState(src, 4116);
            // Now set the state of AL_INITIAL according to the specification
            AL.setSourceState(src, 4113);
        }
        function _alSourceRewindv(count, pSourceIds) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(69, 0, 1, count, pSourceIds);
            if (!AL.currentCtx) {
                return;
            }
            if (!pSourceIds) {
                AL.currentCtx.err = 40963;
            }
            for (var i = 0; i < count; ++i) {
                if (!AL.currentCtx.sources[HEAP32[(((pSourceIds) + (i * 4)) >> 2)]]) {
                    AL.currentCtx.err = 40961;
                    return;
                }
            }
            for (var i = 0; i < count; ++i) {
                var srcId = HEAP32[(((pSourceIds) + (i * 4)) >> 2)];
                AL.setSourceState(AL.currentCtx.sources[srcId], 4113);
            }
        }
        function _alSourceStop(sourceId) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(70, 0, 1, sourceId);
            if (!AL.currentCtx) {
                return;
            }
            var src = AL.currentCtx.sources[sourceId];
            if (!src) {
                AL.currentCtx.err = 40961;
                return;
            }
            AL.setSourceState(src, 4116);
        }
        function _alSourceStopv(count, pSourceIds) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(71, 0, 1, count, pSourceIds);
            if (!AL.currentCtx) {
                return;
            }
            if (!pSourceIds) {
                AL.currentCtx.err = 40963;
            }
            for (var i = 0; i < count; ++i) {
                if (!AL.currentCtx.sources[HEAP32[(((pSourceIds) + (i * 4)) >> 2)]]) {
                    AL.currentCtx.err = 40961;
                    return;
                }
            }
            for (var i = 0; i < count; ++i) {
                var srcId = HEAP32[(((pSourceIds) + (i * 4)) >> 2)];
                AL.setSourceState(AL.currentCtx.sources[srcId], 4116);
            }
        }
        function _alSourceUnqueueBuffers(sourceId, count, pBufferIds) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(72, 0, 1, sourceId, count, pBufferIds);
            if (!AL.currentCtx) {
                return;
            }
            var src = AL.currentCtx.sources[sourceId];
            if (!src) {
                AL.currentCtx.err = 40961;
                return;
            }
            if (count > (src.bufQueue.length === 1 && src.bufQueue[0].id === 0 ? 0 : src.bufsProcessed)) {
                AL.currentCtx.err = 40963;
                return;
            }
            if (count === 0) {
                return;
            }
            for (var i = 0; i < count; i++) {
                var buf = src.bufQueue.shift();
                buf.refCount--;
                // Write the buffers index out to the return list.
                HEAP32[(((pBufferIds) + (i * 4)) >> 2)] = buf.id;
                src.bufsProcessed--;
            }
            /// If the queue is empty, put the zero buffer back in
            if (src.bufQueue.length === 0) {
                src.bufQueue.push(AL.buffers[0]);
            }
            AL.initSourcePanner(src);
            AL.scheduleSourceAudio(src);
        }
        function _alSourcef(sourceId, param, value) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(73, 0, 1, sourceId, param, value);
            switch (param) {
                case 0x1001 /* AL_CONE_INNER_ANGLE */:
                case 0x1002 /* AL_CONE_OUTER_ANGLE */:
                case 0x1003 /* AL_PITCH */:
                case 4106:
                case 0x100D /* AL_MIN_GAIN */:
                case 0x100E /* AL_MAX_GAIN */:
                case 0x1020 /* AL_REFERENCE_DISTANCE */:
                case 0x1021 /* AL_ROLLOFF_FACTOR */:
                case 0x1022 /* AL_CONE_OUTER_GAIN */:
                case 0x1023 /* AL_MAX_DISTANCE */:
                case 0x1024 /* AL_SEC_OFFSET */:
                case 0x1025 /* AL_SAMPLE_OFFSET */:
                case 0x1026 /* AL_BYTE_OFFSET */:
                case 0x200B /* AL_SEC_LENGTH_SOFT */:
                    AL.setSourceParam('alSourcef', sourceId, param, value);
                    break;
                default:
                    AL.setSourceParam('alSourcef', sourceId, param, null);
                    break;
            }
        }
        function _alSourcefv(sourceId, param, pValues) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(74, 0, 1, sourceId, param, pValues);
            if (!AL.currentCtx) {
                return;
            }
            if (!pValues) {
                AL.currentCtx.err = 40963;
                return;
            }
            switch (param) {
                case 0x1001 /* AL_CONE_INNER_ANGLE */:
                case 0x1002 /* AL_CONE_OUTER_ANGLE */:
                case 0x1003 /* AL_PITCH */:
                case 4106:
                case 0x100D /* AL_MIN_GAIN */:
                case 0x100E /* AL_MAX_GAIN */:
                case 0x1020 /* AL_REFERENCE_DISTANCE */:
                case 0x1021 /* AL_ROLLOFF_FACTOR */:
                case 0x1022 /* AL_CONE_OUTER_GAIN */:
                case 0x1023 /* AL_MAX_DISTANCE */:
                case 0x1024 /* AL_SEC_OFFSET */:
                case 0x1025 /* AL_SAMPLE_OFFSET */:
                case 0x1026 /* AL_BYTE_OFFSET */:
                case 0x200B /* AL_SEC_LENGTH_SOFT */:
                    var val = HEAPF32[((pValues) >> 2)];
                    AL.setSourceParam('alSourcefv', sourceId, param, val);
                    break;
                case 4100:
                case 4101:
                case 4102:
                    AL.paramArray[0] = HEAPF32[((pValues) >> 2)];
                    AL.paramArray[1] = HEAPF32[(((pValues) + (4)) >> 2)];
                    AL.paramArray[2] = HEAPF32[(((pValues) + (8)) >> 2)];
                    AL.setSourceParam('alSourcefv', sourceId, param, AL.paramArray);
                    break;
                default:
                    AL.setSourceParam('alSourcefv', sourceId, param, null);
                    break;
            }
        }
        function _alSourceiv(sourceId, param, pValues) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(75, 0, 1, sourceId, param, pValues);
            if (!AL.currentCtx) {
                return;
            }
            if (!pValues) {
                AL.currentCtx.err = 40963;
                return;
            }
            switch (param) {
                case 0x202 /* AL_SOURCE_RELATIVE */:
                case 0x1001 /* AL_CONE_INNER_ANGLE */:
                case 0x1002 /* AL_CONE_OUTER_ANGLE */:
                case 0x1007 /* AL_LOOPING */:
                case 0x1009 /* AL_BUFFER */:
                case 0x1020 /* AL_REFERENCE_DISTANCE */:
                case 0x1021 /* AL_ROLLOFF_FACTOR */:
                case 0x1023 /* AL_MAX_DISTANCE */:
                case 0x1024 /* AL_SEC_OFFSET */:
                case 0x1025 /* AL_SAMPLE_OFFSET */:
                case 0x1026 /* AL_BYTE_OFFSET */:
                case 0x1214 /* AL_SOURCE_SPATIALIZE_SOFT */:
                case 0x2009 /* AL_BYTE_LENGTH_SOFT */:
                case 0x200A /* AL_SAMPLE_LENGTH_SOFT */:
                case 53248:
                    var val = HEAP32[((pValues) >> 2)];
                    AL.setSourceParam('alSourceiv', sourceId, param, val);
                    break;
                case 4100:
                case 4101:
                case 4102:
                    AL.paramArray[0] = HEAP32[((pValues) >> 2)];
                    AL.paramArray[1] = HEAP32[(((pValues) + (4)) >> 2)];
                    AL.paramArray[2] = HEAP32[(((pValues) + (8)) >> 2)];
                    AL.setSourceParam('alSourceiv', sourceId, param, AL.paramArray);
                    break;
                default:
                    AL.setSourceParam('alSourceiv', sourceId, param, null);
                    break;
            }
        }
        function _alSpeedOfSound(value) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(76, 0, 1, value);
            AL.setGlobalParam('alSpeedOfSound', 49155, value);
        }
        function _alcCloseDevice(deviceId) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(77, 0, 1, deviceId);
            if (!(deviceId in AL.deviceRefCounts) || AL.deviceRefCounts[deviceId] > 0) {
                return 0;
            }
            delete AL.deviceRefCounts[deviceId];
            AL.freeIds.push(deviceId);
            return 1;
        }
        var listenOnce = (object, event, func) => {
            object.addEventListener(event, func, { 'once': true });
        };
        /** @param {Object=} elements */
        var autoResumeAudioContext = (ctx, elements) => {
            if (!elements) {
                elements = [document, document.getElementById('canvas')];
            }
            ['keydown', 'mousedown', 'touchstart'].forEach((event) => {
                elements.forEach((element) => {
                    if (element) {
                        listenOnce(element, event, () => {
                            if (ctx.state === 'suspended')
                                ctx.resume();
                        });
                    }
                });
            });
        };
        function _alcCreateContext(deviceId, pAttrList) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(78, 0, 1, deviceId, pAttrList);
            if (!(deviceId in AL.deviceRefCounts)) {
                AL.alcErr = 0xA001; /* ALC_INVALID_DEVICE */
                return 0;
            }
            var options = null;
            var attrs = [];
            var hrtf = null;
            pAttrList >>= 2;
            if (pAttrList) {
                var attr = 0;
                var val = 0;
                while (true) {
                    attr = HEAP32[pAttrList++];
                    attrs.push(attr);
                    if (attr === 0) {
                        break;
                    }
                    val = HEAP32[pAttrList++];
                    attrs.push(val);
                    switch (attr) {
                        case 0x1007 /* ALC_FREQUENCY */:
                            if (!options) {
                                options = {};
                            }
                            options.sampleRate = val;
                            break;
                        case 0x1010 /* ALC_MONO_SOURCES */: // fallthrough
                        case 0x1011 /* ALC_STEREO_SOURCES */:
                            // Do nothing; these hints are satisfied by default
                            break;
                        case 0x1992 /* ALC_HRTF_SOFT */:
                            switch (val) {
                                case 0:
                                    hrtf = false;
                                    break;
                                case 1:
                                    hrtf = true;
                                    break;
                                case 2 /* ALC_DONT_CARE_SOFT */:
                                    break;
                                default:
                                    AL.alcErr = 40964;
                                    return 0;
                            }
                            break;
                        case 0x1996 /* ALC_HRTF_ID_SOFT */:
                            if (val !== 0) {
                                AL.alcErr = 40964;
                                return 0;
                            }
                            break;
                        default:
                            AL.alcErr = 0xA004; /* ALC_INVALID_VALUE */
                            return 0;
                    }
                }
            }
            var AudioContext = window.AudioContext || window.webkitAudioContext;
            var ac = null;
            try {
                // Only try to pass options if there are any, for compat with browsers that don't support this
                if (options) {
                    ac = new AudioContext(options);
                }
                else {
                    ac = new AudioContext();
                }
            }
            catch (e) {
                if (e.name === 'NotSupportedError') {
                    AL.alcErr = 0xA004; /* ALC_INVALID_VALUE */
                }
                else {
                    AL.alcErr = 0xA001; /* ALC_INVALID_DEVICE */
                }
                return 0;
            }
            autoResumeAudioContext(ac);
            // Old Web Audio API (e.g. Safari 6.0.5) had an inconsistently named createGainNode function.
            if (typeof ac.createGain == 'undefined') {
                ac.createGain = ac.createGainNode;
            }
            var gain = ac.createGain();
            gain.connect(ac.destination);
            var ctx = {
                deviceId,
                id: AL.newId(),
                attrs,
                audioCtx: ac,
                listener: {
                    position: [0.0, 0.0, 0.0],
                    velocity: [0.0, 0.0, 0.0],
                    direction: [0.0, 0.0, 0.0],
                    up: [0.0, 0.0, 0.0]
                },
                sources: [],
                interval: setInterval(() => AL.scheduleContextAudio(ctx), AL.QUEUE_INTERVAL),
                gain,
                distanceModel: 0xd002 /* AL_INVERSE_DISTANCE_CLAMPED */,
                speedOfSound: 343.3,
                dopplerFactor: 1.0,
                sourceDistanceModel: false,
                hrtf: hrtf || false,
                _err: 0,
                get err() {
                    return this._err;
                },
                set err(val) {
                    // Errors should not be overwritten by later errors until they are cleared by a query.
                    if (this._err === 0 || val === 0) {
                        this._err = val;
                    }
                }
            };
            AL.deviceRefCounts[deviceId]++;
            AL.contexts[ctx.id] = ctx;
            if (hrtf !== null) {
                // Apply hrtf attrib to all contexts for this device
                for (var ctxId in AL.contexts) {
                    var c = AL.contexts[ctxId];
                    if (c.deviceId === deviceId) {
                        c.hrtf = hrtf;
                        AL.updateContextGlobal(c);
                    }
                }
            }
            return ctx.id;
        }
        function _alcDestroyContext(contextId) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(79, 0, 1, contextId);
            var ctx = AL.contexts[contextId];
            if (AL.currentCtx === ctx) {
                AL.alcErr = 0xA002 /* ALC_INVALID_CONTEXT */;
                return;
            }
            // Stop playback, etc
            if (AL.contexts[contextId].interval) {
                clearInterval(AL.contexts[contextId].interval);
            }
            AL.deviceRefCounts[ctx.deviceId]--;
            delete AL.contexts[contextId];
            AL.freeIds.push(contextId);
        }
        function _alcGetContextsDevice(contextId) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(80, 0, 1, contextId);
            if (contextId in AL.contexts) {
                return AL.contexts[contextId].deviceId;
            }
            return 0;
        }
        function _alcGetCurrentContext() {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(81, 0, 1);
            if (AL.currentCtx !== null) {
                return AL.currentCtx.id;
            }
            return 0;
        }
        function _alcGetEnumValue(deviceId, pEnumName) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(82, 0, 1, deviceId, pEnumName);
            // Spec says :
            // Using a NULL handle is legal, but only the
            // tokens defined by the AL core are guaranteed.
            if (deviceId !== 0 && !(deviceId in AL.deviceRefCounts)) {
                // ALC_INVALID_DEVICE is not listed as a possible error state for
                // this function, sadly.
                return 0;
            }
            else if (!pEnumName) {
                AL.alcErr = 40964;
                return 0;
            }
            var name = UTF8ToString(pEnumName);
            // See alGetEnumValue(), but basically behave the same as OpenAL-Soft
            switch (name) {
                case 'ALC_NO_ERROR': return 0;
                case 'ALC_INVALID_DEVICE': return 0xA001;
                case 'ALC_INVALID_CONTEXT': return 0xA002;
                case 'ALC_INVALID_ENUM': return 0xA003;
                case 'ALC_INVALID_VALUE': return 0xA004;
                case 'ALC_OUT_OF_MEMORY': return 0xA005;
                case 'ALC_MAJOR_VERSION': return 0x1000;
                case 'ALC_MINOR_VERSION': return 0x1001;
                case 'ALC_ATTRIBUTES_SIZE': return 0x1002;
                case 'ALC_ALL_ATTRIBUTES': return 0x1003;
                case 'ALC_DEFAULT_DEVICE_SPECIFIER': return 0x1004;
                case 'ALC_DEVICE_SPECIFIER': return 0x1005;
                case 'ALC_EXTENSIONS': return 0x1006;
                case 'ALC_FREQUENCY': return 0x1007;
                case 'ALC_REFRESH': return 0x1008;
                case 'ALC_SYNC': return 0x1009;
                case 'ALC_MONO_SOURCES': return 0x1010;
                case 'ALC_STEREO_SOURCES': return 0x1011;
                case 'ALC_CAPTURE_DEVICE_SPECIFIER': return 0x310;
                case 'ALC_CAPTURE_DEFAULT_DEVICE_SPECIFIER': return 0x311;
                case 'ALC_CAPTURE_SAMPLES': return 0x312;
                /* Extensions */
                case 'ALC_HRTF_SOFT': return 0x1992;
                case 'ALC_HRTF_ID_SOFT': return 0x1996;
                case 'ALC_DONT_CARE_SOFT': return 0x0002;
                case 'ALC_HRTF_STATUS_SOFT': return 0x1993;
                case 'ALC_NUM_HRTF_SPECIFIERS_SOFT': return 0x1994;
                case 'ALC_HRTF_SPECIFIER_SOFT': return 0x1995;
                case 'ALC_HRTF_DISABLED_SOFT': return 0x0000;
                case 'ALC_HRTF_ENABLED_SOFT': return 0x0001;
                case 'ALC_HRTF_DENIED_SOFT': return 0x0002;
                case 'ALC_HRTF_REQUIRED_SOFT': return 0x0003;
                case 'ALC_HRTF_HEADPHONES_DETECTED_SOFT': return 0x0004;
                case 'ALC_HRTF_UNSUPPORTED_FORMAT_SOFT': return 0x0005;
                default:
                    AL.alcErr = 40964;
                    return 0;
            }
        }
        function _alcGetError(deviceId) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(83, 0, 1, deviceId);
            var err = AL.alcErr;
            AL.alcErr = 0;
            return err;
        }
        function _alcGetIntegerv(deviceId, param, size, pValues) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(84, 0, 1, deviceId, param, size, pValues);
            if (size === 0 || !pValues) {
                // Ignore the query, per the spec
                return;
            }
            switch (param) {
                case 0x1000 /* ALC_MAJOR_VERSION */:
                    HEAP32[((pValues) >> 2)] = 1;
                    break;
                case 0x1001 /* ALC_MINOR_VERSION */:
                    HEAP32[((pValues) >> 2)] = 1;
                    break;
                case 0x1002 /* ALC_ATTRIBUTES_SIZE */:
                    if (!(deviceId in AL.deviceRefCounts)) {
                        AL.alcErr = 40961;
                        return;
                    }
                    if (!AL.currentCtx) {
                        AL.alcErr = 0xA002 /* ALC_INVALID_CONTEXT */;
                        return;
                    }
                    HEAP32[((pValues) >> 2)] = AL.currentCtx.attrs.length;
                    break;
                case 0x1003 /* ALC_ALL_ATTRIBUTES */:
                    if (!(deviceId in AL.deviceRefCounts)) {
                        AL.alcErr = 40961;
                        return;
                    }
                    if (!AL.currentCtx) {
                        AL.alcErr = 0xA002 /* ALC_INVALID_CONTEXT */;
                        return;
                    }
                    for (var i = 0; i < AL.currentCtx.attrs.length; i++) {
                        HEAP32[(((pValues) + (i * 4)) >> 2)] = AL.currentCtx.attrs[i];
                    }
                    break;
                case 0x1007 /* ALC_FREQUENCY */:
                    if (!(deviceId in AL.deviceRefCounts)) {
                        AL.alcErr = 40961;
                        return;
                    }
                    if (!AL.currentCtx) {
                        AL.alcErr = 0xA002 /* ALC_INVALID_CONTEXT */;
                        return;
                    }
                    HEAP32[((pValues) >> 2)] = AL.currentCtx.audioCtx.sampleRate;
                    break;
                case 0x1010 /* ALC_MONO_SOURCES */:
                case 0x1011 /* ALC_STEREO_SOURCES */:
                    if (!(deviceId in AL.deviceRefCounts)) {
                        AL.alcErr = 40961;
                        return;
                    }
                    if (!AL.currentCtx) {
                        AL.alcErr = 0xA002 /* ALC_INVALID_CONTEXT */;
                        return;
                    }
                    HEAP32[((pValues) >> 2)] = 0x7FFFFFFF;
                    break;
                case 0x1992 /* ALC_HRTF_SOFT */:
                case 0x1993 /* ALC_HRTF_STATUS_SOFT */:
                    if (!(deviceId in AL.deviceRefCounts)) {
                        AL.alcErr = 40961;
                        return;
                    }
                    var hrtfStatus = 0 /* ALC_HRTF_DISABLED_SOFT */;
                    for (var ctxId in AL.contexts) {
                        var ctx = AL.contexts[ctxId];
                        if (ctx.deviceId === deviceId) {
                            hrtfStatus = ctx.hrtf ? 1 /* ALC_HRTF_ENABLED_SOFT */ : 0 /* ALC_HRTF_DISABLED_SOFT */;
                        }
                    }
                    HEAP32[((pValues) >> 2)] = hrtfStatus;
                    break;
                case 0x1994 /* ALC_NUM_HRTF_SPECIFIERS_SOFT */:
                    if (!(deviceId in AL.deviceRefCounts)) {
                        AL.alcErr = 40961;
                        return;
                    }
                    HEAP32[((pValues) >> 2)] = 1;
                    break;
                case 0x20003 /* ALC_MAX_AUXILIARY_SENDS */:
                    if (!(deviceId in AL.deviceRefCounts)) {
                        AL.alcErr = 40961;
                        return;
                    }
                    if (!AL.currentCtx) {
                        AL.alcErr = 0xA002 /* ALC_INVALID_CONTEXT */;
                        return;
                    }
                    HEAP32[((pValues) >> 2)] = 1;
                case 0x312 /* ALC_CAPTURE_SAMPLES */:
                    var c = AL.requireValidCaptureDevice(deviceId, 'alcGetIntegerv');
                    if (!c) {
                        return;
                    }
                    var n = c.capturedFrameCount;
                    var dstfreq = c.requestedSampleRate;
                    var srcfreq = c.audioCtx.sampleRate;
                    var nsamples = Math.floor(n * (dstfreq / srcfreq));
                    HEAP32[((pValues) >> 2)] = nsamples;
                    break;
                default:
                    AL.alcErr = 40963;
                    return;
            }
        }
        function _alcMakeContextCurrent(contextId) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(85, 0, 1, contextId);
            if (contextId === 0) {
                AL.currentCtx = null;
            }
            else {
                AL.currentCtx = AL.contexts[contextId];
            }
            return 1;
        }
        function _alcOpenDevice(pDeviceName) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(86, 0, 1, pDeviceName);
            if (pDeviceName) {
                var name = UTF8ToString(pDeviceName);
                if (name !== AL.DEVICE_NAME) {
                    return 0;
                }
            }
            if (typeof AudioContext != 'undefined' || typeof webkitAudioContext != 'undefined') {
                var deviceId = AL.newId();
                AL.deviceRefCounts[deviceId] = 0;
                return deviceId;
            }
            return 0;
        }
        var EGL = {
            errorCode: 12288,
            defaultDisplayInitialized: false,
            currentContext: 0,
            currentReadSurface: 0,
            currentDrawSurface: 0,
            contextAttributes: {
                alpha: false,
                depth: false,
                stencil: false,
                antialias: false,
            },
            stringCache: {},
            setErrorCode(code) {
                EGL.errorCode = code;
            },
            chooseConfig(display, attribList, config, config_size, numConfigs) {
                if (display != 62000) {
                    EGL.setErrorCode(0x3008 /* EGL_BAD_DISPLAY */);
                    return 0;
                }
                if (attribList) {
                    // read attribList if it is non-null
                    for (;;) {
                        var param = HEAP32[((attribList) >> 2)];
                        if (param == 0x3021 /*EGL_ALPHA_SIZE*/) {
                            var alphaSize = HEAP32[(((attribList) + (4)) >> 2)];
                            EGL.contextAttributes.alpha = (alphaSize > 0);
                        }
                        else if (param == 0x3025 /*EGL_DEPTH_SIZE*/) {
                            var depthSize = HEAP32[(((attribList) + (4)) >> 2)];
                            EGL.contextAttributes.depth = (depthSize > 0);
                        }
                        else if (param == 0x3026 /*EGL_STENCIL_SIZE*/) {
                            var stencilSize = HEAP32[(((attribList) + (4)) >> 2)];
                            EGL.contextAttributes.stencil = (stencilSize > 0);
                        }
                        else if (param == 0x3031 /*EGL_SAMPLES*/) {
                            var samples = HEAP32[(((attribList) + (4)) >> 2)];
                            EGL.contextAttributes.antialias = (samples > 0);
                        }
                        else if (param == 0x3032 /*EGL_SAMPLE_BUFFERS*/) {
                            var samples = HEAP32[(((attribList) + (4)) >> 2)];
                            EGL.contextAttributes.antialias = (samples == 1);
                        }
                        else if (param == 0x3100 /*EGL_CONTEXT_PRIORITY_LEVEL_IMG*/) {
                            var requestedPriority = HEAP32[(((attribList) + (4)) >> 2)];
                            EGL.contextAttributes.lowLatency = (requestedPriority != 0x3103 /*EGL_CONTEXT_PRIORITY_LOW_IMG*/);
                        }
                        else if (param == 0x3038 /*EGL_NONE*/) {
                            break;
                        }
                        attribList += 8;
                    }
                }
                if ((!config || !config_size) && !numConfigs) {
                    EGL.setErrorCode(0x300C /* EGL_BAD_PARAMETER */);
                    return 0;
                }
                if (numConfigs) {
                    HEAP32[((numConfigs) >> 2)] = 1; // Total number of supported configs: 1.
                }
                if (config && config_size > 0) {
                    HEAPU32[((config) >> 2)] = 62002;
                }
                EGL.setErrorCode(0x3000 /* EGL_SUCCESS */);
                return 1;
            },
        };
        function _eglBindAPI(api) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(87, 0, 1, api);
            if (api == 0x30A0 /* EGL_OPENGL_ES_API */) {
                EGL.setErrorCode(0x3000 /* EGL_SUCCESS */);
                return 1;
            }
            // if (api == 0x30A1 /* EGL_OPENVG_API */ || api == 0x30A2 /* EGL_OPENGL_API */) {
            EGL.setErrorCode(0x300C /* EGL_BAD_PARAMETER */);
            return 0;
        }
        function _eglChooseConfig(display, attrib_list, configs, config_size, numConfigs) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(88, 0, 1, display, attrib_list, configs, config_size, numConfigs);
            return EGL.chooseConfig(display, attrib_list, configs, config_size, numConfigs);
        }
        function _eglCreateContext(display, config, hmm, contextAttribs) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(89, 0, 1, display, config, hmm, contextAttribs);
            if (display != 62000) {
                EGL.setErrorCode(0x3008 /* EGL_BAD_DISPLAY */);
                return 0;
            }
            // EGL 1.4 spec says default EGL_CONTEXT_CLIENT_VERSION is GLES1, but this is not supported by Emscripten.
            // So user must pass EGL_CONTEXT_CLIENT_VERSION == 2 to initialize EGL.
            var glesContextVersion = 1;
            for (;;) {
                var param = HEAP32[((contextAttribs) >> 2)];
                if (param == 0x3098 /*EGL_CONTEXT_CLIENT_VERSION*/) {
                    glesContextVersion = HEAP32[(((contextAttribs) + (4)) >> 2)];
                }
                else if (param == 0x3038 /*EGL_NONE*/) {
                    break;
                }
                else {
                    /* EGL1.4 specifies only EGL_CONTEXT_CLIENT_VERSION as supported attribute */
                    EGL.setErrorCode(0x3004 /*EGL_BAD_ATTRIBUTE*/);
                    return 0;
                }
                contextAttribs += 8;
            }
            if (glesContextVersion < 2 || glesContextVersion > 3) {
                EGL.setErrorCode(0x3005 /* EGL_BAD_CONFIG */);
                return 0; /* EGL_NO_CONTEXT */
            }
            EGL.contextAttributes.majorVersion = glesContextVersion - 1; // WebGL 1 is GLES 2, WebGL2 is GLES3
            EGL.contextAttributes.minorVersion = 0;
            EGL.context = GL.createContext(Module['canvas'], EGL.contextAttributes);
            if (EGL.context != 0) {
                EGL.setErrorCode(0x3000 /* EGL_SUCCESS */);
                // Run callbacks so that GL emulation works
                GL.makeContextCurrent(EGL.context);
                Module.useWebGL = true;
                Browser.moduleContextCreatedCallbacks.forEach(function (callback) { callback(); });
                // Note: This function only creates a context, but it shall not make it active.
                GL.makeContextCurrent(null);
                return 62004;
            }
            else {
                EGL.setErrorCode(0x3009 /* EGL_BAD_MATCH */); // By the EGL 1.4 spec, an implementation that does not support GLES2 (WebGL in this case), this error code is set.
                return 0; /* EGL_NO_CONTEXT */
            }
        }
        function _eglDestroyContext(display, context) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(90, 0, 1, display, context);
            if (display != 62000) {
                EGL.setErrorCode(0x3008 /* EGL_BAD_DISPLAY */);
                return 0;
            }
            if (context != 62004) {
                EGL.setErrorCode(0x3006 /* EGL_BAD_CONTEXT */);
                return 0;
            }
            GL.deleteContext(EGL.context);
            EGL.setErrorCode(0x3000 /* EGL_SUCCESS */);
            if (EGL.currentContext == context) {
                EGL.currentContext = 0;
            }
            return 1 /* EGL_TRUE */;
        }
        function _eglGetConfigAttrib(display, config, attribute, value) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(91, 0, 1, display, config, attribute, value);
            if (display != 62000) {
                EGL.setErrorCode(0x3008 /* EGL_BAD_DISPLAY */);
                return 0;
            }
            if (config != 62002) {
                EGL.setErrorCode(0x3005 /* EGL_BAD_CONFIG */);
                return 0;
            }
            if (!value) {
                EGL.setErrorCode(0x300C /* EGL_BAD_PARAMETER */);
                return 0;
            }
            EGL.setErrorCode(0x3000 /* EGL_SUCCESS */);
            switch (attribute) {
                case 0x3020: // EGL_BUFFER_SIZE
                    HEAP32[((value) >> 2)] = EGL.contextAttributes.alpha ? 32 : 24;
                    return 1;
                case 0x3021: // EGL_ALPHA_SIZE
                    HEAP32[((value) >> 2)] = EGL.contextAttributes.alpha ? 8 : 0;
                    return 1;
                case 0x3022: // EGL_BLUE_SIZE
                    HEAP32[((value) >> 2)] = 8;
                    return 1;
                case 0x3023: // EGL_GREEN_SIZE
                    HEAP32[((value) >> 2)] = 8;
                    return 1;
                case 0x3024: // EGL_RED_SIZE
                    HEAP32[((value) >> 2)] = 8;
                    return 1;
                case 0x3025: // EGL_DEPTH_SIZE
                    HEAP32[((value) >> 2)] = EGL.contextAttributes.depth ? 24 : 0;
                    return 1;
                case 0x3026: // EGL_STENCIL_SIZE
                    HEAP32[((value) >> 2)] = EGL.contextAttributes.stencil ? 8 : 0;
                    return 1;
                case 0x3027: // EGL_CONFIG_CAVEAT
                    // We can return here one of EGL_NONE (0x3038), EGL_SLOW_CONFIG (0x3050) or EGL_NON_CONFORMANT_CONFIG (0x3051).
                    HEAP32[((value) >> 2)] = 0x3038;
                    return 1;
                case 0x3028: // EGL_CONFIG_ID
                    HEAP32[((value) >> 2)] = 62002;
                    return 1;
                case 0x3029: // EGL_LEVEL
                    HEAP32[((value) >> 2)] = 0;
                    return 1;
                case 0x302A: // EGL_MAX_PBUFFER_HEIGHT
                    HEAP32[((value) >> 2)] = 4096;
                    return 1;
                case 0x302B: // EGL_MAX_PBUFFER_PIXELS
                    HEAP32[((value) >> 2)] = 16777216;
                    return 1;
                case 0x302C: // EGL_MAX_PBUFFER_WIDTH
                    HEAP32[((value) >> 2)] = 4096;
                    return 1;
                case 0x302D: // EGL_NATIVE_RENDERABLE
                    HEAP32[((value) >> 2)] = 0;
                    return 1;
                case 0x302E: // EGL_NATIVE_VISUAL_ID
                    HEAP32[((value) >> 2)] = 0;
                    return 1;
                case 0x302F: // EGL_NATIVE_VISUAL_TYPE
                    HEAP32[((value) >> 2)] = 0x3038;
                    return 1;
                case 0x3031: // EGL_SAMPLES
                    HEAP32[((value) >> 2)] = EGL.contextAttributes.antialias ? 4 : 0;
                    return 1;
                case 0x3032: // EGL_SAMPLE_BUFFERS
                    HEAP32[((value) >> 2)] = EGL.contextAttributes.antialias ? 1 : 0;
                    return 1;
                case 0x3033: // EGL_SURFACE_TYPE
                    HEAP32[((value) >> 2)] = 0x4;
                    return 1;
                case 0x3034: // EGL_TRANSPARENT_TYPE
                    // If this returns EGL_TRANSPARENT_RGB (0x3052), transparency is used through color-keying. No such thing applies to Emscripten canvas.
                    HEAP32[((value) >> 2)] = 0x3038;
                    return 1;
                case 0x3035: // EGL_TRANSPARENT_BLUE_VALUE
                case 0x3036: // EGL_TRANSPARENT_GREEN_VALUE
                case 0x3037: // EGL_TRANSPARENT_RED_VALUE
                    // "If EGL_TRANSPARENT_TYPE is EGL_NONE, then the values for EGL_TRANSPARENT_RED_VALUE, EGL_TRANSPARENT_GREEN_VALUE, and EGL_TRANSPARENT_BLUE_VALUE are undefined."
                    HEAP32[((value) >> 2)] = -1;
                    return 1;
                case 0x3039: // EGL_BIND_TO_TEXTURE_RGB
                case 0x303A: // EGL_BIND_TO_TEXTURE_RGBA
                    HEAP32[((value) >> 2)] = 0;
                    return 1;
                case 0x303B: // EGL_MIN_SWAP_INTERVAL
                    HEAP32[((value) >> 2)] = 0;
                    return 1;
                case 0x303C: // EGL_MAX_SWAP_INTERVAL
                    HEAP32[((value) >> 2)] = 1;
                    return 1;
                case 0x303D: // EGL_LUMINANCE_SIZE
                case 0x303E: // EGL_ALPHA_MASK_SIZE
                    HEAP32[((value) >> 2)] = 0;
                    return 1;
                case 0x303F: // EGL_COLOR_BUFFER_TYPE
                    // EGL has two types of buffers: EGL_RGB_BUFFER and EGL_LUMINANCE_BUFFER.
                    HEAP32[((value) >> 2)] = 0x308E;
                    return 1;
                case 0x3040: // EGL_RENDERABLE_TYPE
                    // A bit combination of EGL_OPENGL_ES_BIT,EGL_OPENVG_BIT,EGL_OPENGL_ES2_BIT and EGL_OPENGL_BIT.
                    HEAP32[((value) >> 2)] = 0x4;
                    return 1;
                case 0x3042: // EGL_CONFORMANT
                    // "EGL_CONFORMANT is a mask indicating if a client API context created with respect to the corresponding EGLConfig will pass the required conformance tests for that API."
                    HEAP32[((value) >> 2)] = 0;
                    return 1;
                default:
                    EGL.setErrorCode(0x3004 /* EGL_BAD_ATTRIBUTE */);
                    return 0;
            }
        }
        function _eglGetCurrentContext() {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(92, 0, 1);
            return EGL.currentContext;
        }
        function _eglGetCurrentDisplay() {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(93, 0, 1);
            return EGL.currentContext ? 62000 : 0;
        }
        function _eglGetDisplay(nativeDisplayType) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(94, 0, 1, nativeDisplayType);
            EGL.setErrorCode(0x3000 /* EGL_SUCCESS */);
            // Emscripten EGL implementation "emulates" X11, and eglGetDisplay is
            // expected to accept/receive a pointer to an X11 Display object (or
            // EGL_DEFAULT_DISPLAY).
            if (nativeDisplayType != 0 /* EGL_DEFAULT_DISPLAY */ && nativeDisplayType != 1 /* see library_xlib.js */) {
                return 0; // EGL_NO_DISPLAY
            }
            return 62000;
        }
        function _eglGetError() {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(95, 0, 1);
            return EGL.errorCode;
        }
        function _eglInitialize(display, majorVersion, minorVersion) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(96, 0, 1, display, majorVersion, minorVersion);
            if (display != 62000) {
                EGL.setErrorCode(0x3008 /* EGL_BAD_DISPLAY */);
                return 0;
            }
            if (majorVersion) {
                HEAP32[((majorVersion) >> 2)] = 1; // Advertise EGL Major version: '1'
            }
            if (minorVersion) {
                HEAP32[((minorVersion) >> 2)] = 4; // Advertise EGL Minor version: '4'
            }
            EGL.defaultDisplayInitialized = true;
            EGL.setErrorCode(0x3000 /* EGL_SUCCESS */);
            return 1;
        }
        function _eglMakeCurrent(display, draw, read, context) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(97, 0, 1, display, draw, read, context);
            if (display != 62000) {
                EGL.setErrorCode(0x3008 /* EGL_BAD_DISPLAY */);
                return 0 /* EGL_FALSE */;
            }
            //\todo An EGL_NOT_INITIALIZED error is generated if EGL is not initialized for dpy.
            if (context != 0 && context != 62004) {
                EGL.setErrorCode(0x3006 /* EGL_BAD_CONTEXT */);
                return 0;
            }
            if ((read != 0 && read != 62006) || (draw != 0 && draw != 62006 /* Magic ID for Emscripten 'default surface' */)) {
                EGL.setErrorCode(0x300D /* EGL_BAD_SURFACE */);
                return 0;
            }
            GL.makeContextCurrent(context ? EGL.context : null);
            EGL.currentContext = context;
            EGL.currentDrawSurface = draw;
            EGL.currentReadSurface = read;
            EGL.setErrorCode(0x3000 /* EGL_SUCCESS */);
            return 1 /* EGL_TRUE */;
        }
        function _eglQueryString(display, name) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(98, 0, 1, display, name);
            if (display != 62000) {
                EGL.setErrorCode(0x3008 /* EGL_BAD_DISPLAY */);
                return 0;
            }
            //\todo An EGL_NOT_INITIALIZED error is generated if EGL is not initialized for dpy.
            EGL.setErrorCode(0x3000 /* EGL_SUCCESS */);
            if (EGL.stringCache[name])
                return EGL.stringCache[name];
            var ret;
            switch (name) {
                case 0x3053 /* EGL_VENDOR */:
                    ret = stringToNewUTF8("Emscripten");
                    break;
                case 0x3054 /* EGL_VERSION */:
                    ret = stringToNewUTF8("1.4 Emscripten EGL");
                    break;
                case 0x3055 /* EGL_EXTENSIONS */:
                    ret = stringToNewUTF8("");
                    break; // Currently not supporting any EGL extensions.
                case 0x308D /* EGL_CLIENT_APIS */:
                    ret = stringToNewUTF8("OpenGL_ES");
                    break;
                default:
                    EGL.setErrorCode(0x300C /* EGL_BAD_PARAMETER */);
                    return 0;
            }
            EGL.stringCache[name] = ret;
            return ret;
        }
        function _eglSwapInterval(display, interval) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(99, 0, 1, display, interval);
            if (display != 62000) {
                EGL.setErrorCode(0x3008 /* EGL_BAD_DISPLAY */);
                return 0;
            }
            if (interval == 0)
                _emscripten_set_main_loop_timing(0, 0);
            else
                _emscripten_set_main_loop_timing(1, interval);
            EGL.setErrorCode(0x3000 /* EGL_SUCCESS */);
            return 1;
        }
        var readEmAsmArgsArray = [];
        var readEmAsmArgs = (sigPtr, buf) => {
            // Nobody should have mutated _readEmAsmArgsArray underneath us to be something else than an array.
            assert(Array.isArray(readEmAsmArgsArray));
            // The input buffer is allocated on the stack, so it must be stack-aligned.
            assert(buf % 16 == 0);
            readEmAsmArgsArray.length = 0;
            var ch;
            // Most arguments are i32s, so shift the buffer pointer so it is a plain
            // index into HEAP32.
            while (ch = HEAPU8[sigPtr++]) {
                var chr = String.fromCharCode(ch);
                var validChars = ['d', 'f', 'i', 'p'];
                // In WASM_BIGINT mode we support passing i64 values as bigint.
                validChars.push('j');
                assert(validChars.includes(chr), `Invalid character ${ch}("${chr}") in readEmAsmArgs! Use only [${validChars}], and do not specify "v" for void return argument.`);
                // Floats are always passed as doubles, so all types except for 'i'
                // are 8 bytes and require alignment.
                var wide = (ch != 105);
                wide &= (ch != 112);
                buf += wide && (buf % 8) ? 4 : 0;
                readEmAsmArgsArray.push(
                // Special case for pointers under wasm64 or CAN_ADDRESS_2GB mode.
                ch == 112 ? HEAPU32[((buf) >> 2)] :
                    ch == 106 ? HEAP64[((buf) >> 3)] :
                        ch == 105 ?
                            HEAP32[((buf) >> 2)] :
                            HEAPF64[((buf) >> 3)]);
                buf += wide ? 8 : 4;
            }
            return readEmAsmArgsArray;
        };
        var runEmAsmFunction = (code, sigPtr, argbuf) => {
            var args = readEmAsmArgs(sigPtr, argbuf);
            assert(ASM_CONSTS.hasOwnProperty(code), `No EM_ASM constant found at address ${code}.  The loaded WebAssembly file is likely out of sync with the generated JavaScript.`);
            return ASM_CONSTS[code](...args);
        };
        var _emscripten_asm_const_int = (code, sigPtr, argbuf) => {
            return runEmAsmFunction(code, sigPtr, argbuf);
        };
        var runMainThreadEmAsm = (emAsmAddr, sigPtr, argbuf, sync) => {
            var args = readEmAsmArgs(sigPtr, argbuf);
            if (ENVIRONMENT_IS_PTHREAD) {
                // EM_ASM functions are variadic, receiving the actual arguments as a buffer
                // in memory. the last parameter (argBuf) points to that data. We need to
                // always un-variadify that, *before proxying*, as in the async case this
                // is a stack allocation that LLVM made, which may go away before the main
                // thread gets the message. For that reason we handle proxying *after* the
                // call to readEmAsmArgs, and therefore we do that manually here instead
                // of using __proxy. (And dor simplicity, do the same in the sync
                // case as well, even though it's not strictly necessary, to keep the two
                // code paths as similar as possible on both sides.)
                return proxyToMainThread(0, emAsmAddr, sync, ...args);
            }
            assert(ASM_CONSTS.hasOwnProperty(emAsmAddr), `No EM_ASM constant found at address ${emAsmAddr}.  The loaded WebAssembly file is likely out of sync with the generated JavaScript.`);
            return ASM_CONSTS[emAsmAddr](...args);
        };
        var _emscripten_asm_const_int_sync_on_main_thread = (emAsmAddr, sigPtr, argbuf) => runMainThreadEmAsm(emAsmAddr, sigPtr, argbuf, 1);
        var _emscripten_asm_const_ptr_sync_on_main_thread = (emAsmAddr, sigPtr, argbuf) => runMainThreadEmAsm(emAsmAddr, sigPtr, argbuf, 1);
        var _emscripten_cancel_main_loop = () => {
            Browser.mainLoop.pause();
            Browser.mainLoop.func = null;
        };
        var _emscripten_check_blocking_allowed = () => {
            if (ENVIRONMENT_IS_WORKER)
                return; // Blocking in a worker/pthread is fine.
            warnOnce('Blocking on the main thread is very dangerous, see https://emscripten.org/docs/porting/pthreads.html#blocking-on-the-main-browser-thread');
        };
        var _emscripten_date_now = () => Date.now();
        var _emscripten_err = (str) => err(UTF8ToString(str));
        var currentFullscreenStrategy = {};
        var getCanvasSizeCallingThread = (target, width, height) => {
            var canvas = findCanvasEventTarget(target);
            if (!canvas)
                return -4;
            if (canvas.canvasSharedPtr) {
                // N.B. Reading the size of the Canvas takes priority from our shared state structure, which is not the actual size.
                // However if is possible that there is a canvas size set event pending on an OffscreenCanvas owned by another thread,
                // so that the real sizes of the canvas have not updated yet. Therefore reading the real values would be racy.
                var w = HEAP32[((canvas.canvasSharedPtr) >> 2)];
                var h = HEAP32[(((canvas.canvasSharedPtr) + (4)) >> 2)];
                HEAP32[((width) >> 2)] = w;
                HEAP32[((height) >> 2)] = h;
            }
            else if (canvas.offscreenCanvas) {
                HEAP32[((width) >> 2)] = canvas.offscreenCanvas.width;
                HEAP32[((height) >> 2)] = canvas.offscreenCanvas.height;
            }
            else if (!canvas.controlTransferredOffscreen) {
                HEAP32[((width) >> 2)] = canvas.width;
                HEAP32[((height) >> 2)] = canvas.height;
            }
            else {
                return -4;
            }
            return 0;
        };
        function getCanvasSizeMainThread(target, width, height) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(101, 0, 1, target, width, height);
            return getCanvasSizeCallingThread(target, width, height);
        }
        var _emscripten_get_canvas_element_size = (target, width, height) => {
            var canvas = findCanvasEventTarget(target);
            if (canvas) {
                return getCanvasSizeCallingThread(target, width, height);
            }
            return getCanvasSizeMainThread(target, width, height);
        };
        var stringToUTF8OnStack = (str) => {
            var size = lengthBytesUTF8(str) + 1;
            var ret = stackAlloc(size);
            stringToUTF8(str, ret, size);
            return ret;
        };
        var getCanvasElementSize = (target) => {
            var sp = stackSave();
            var w = stackAlloc(8);
            var h = w + 4;
            var targetInt = stringToUTF8OnStack(target.id);
            var ret = _emscripten_get_canvas_element_size(targetInt, w, h);
            var size = [HEAP32[((w) >> 2)], HEAP32[((h) >> 2)]];
            stackRestore(sp);
            return size;
        };
        var setCanvasElementSize = (target, width, height) => {
            if (!target.controlTransferredOffscreen) {
                target.width = width;
                target.height = height;
            }
            else {
                // This function is being called from high-level JavaScript code instead of asm.js/Wasm,
                // and it needs to synchronously proxy over to another thread, so marshal the string onto the heap to do the call.
                var sp = stackSave();
                var targetInt = stringToUTF8OnStack(target.id);
                _emscripten_set_canvas_element_size(targetInt, width, height);
                stackRestore(sp);
            }
        };
        var registerRestoreOldStyle = (canvas) => {
            var canvasSize = getCanvasElementSize(canvas);
            var oldWidth = canvasSize[0];
            var oldHeight = canvasSize[1];
            var oldCssWidth = canvas.style.width;
            var oldCssHeight = canvas.style.height;
            var oldBackgroundColor = canvas.style.backgroundColor; // Chrome reads color from here.
            var oldDocumentBackgroundColor = document.body.style.backgroundColor; // IE11 reads color from here.
            // Firefox always has black background color.
            var oldPaddingLeft = canvas.style.paddingLeft; // Chrome, FF, Safari
            var oldPaddingRight = canvas.style.paddingRight;
            var oldPaddingTop = canvas.style.paddingTop;
            var oldPaddingBottom = canvas.style.paddingBottom;
            var oldMarginLeft = canvas.style.marginLeft; // IE11
            var oldMarginRight = canvas.style.marginRight;
            var oldMarginTop = canvas.style.marginTop;
            var oldMarginBottom = canvas.style.marginBottom;
            var oldDocumentBodyMargin = document.body.style.margin;
            var oldDocumentOverflow = document.documentElement.style.overflow; // Chrome, Firefox
            var oldDocumentScroll = document.body.scroll; // IE
            var oldImageRendering = canvas.style.imageRendering;
            function restoreOldStyle() {
                var fullscreenElement = document.fullscreenElement
                    || document.webkitFullscreenElement;
                if (!fullscreenElement) {
                    document.removeEventListener('fullscreenchange', restoreOldStyle);
                    // Unprefixed Fullscreen API shipped in Chromium 71 (https://bugs.chromium.org/p/chromium/issues/detail?id=383813)
                    // As of Safari 13.0.3 on macOS Catalina 10.15.1 still ships with prefixed webkitfullscreenchange. TODO: revisit this check once Safari ships unprefixed version.
                    document.removeEventListener('webkitfullscreenchange', restoreOldStyle);
                    setCanvasElementSize(canvas, oldWidth, oldHeight);
                    canvas.style.width = oldCssWidth;
                    canvas.style.height = oldCssHeight;
                    canvas.style.backgroundColor = oldBackgroundColor; // Chrome
                    // IE11 hack: assigning 'undefined' or an empty string to document.body.style.backgroundColor has no effect, so first assign back the default color
                    // before setting the undefined value. Setting undefined value is also important, or otherwise we would later treat that as something that the user
                    // had explicitly set so subsequent fullscreen transitions would not set background color properly.
                    if (!oldDocumentBackgroundColor)
                        document.body.style.backgroundColor = 'white';
                    document.body.style.backgroundColor = oldDocumentBackgroundColor; // IE11
                    canvas.style.paddingLeft = oldPaddingLeft; // Chrome, FF, Safari
                    canvas.style.paddingRight = oldPaddingRight;
                    canvas.style.paddingTop = oldPaddingTop;
                    canvas.style.paddingBottom = oldPaddingBottom;
                    canvas.style.marginLeft = oldMarginLeft; // IE11
                    canvas.style.marginRight = oldMarginRight;
                    canvas.style.marginTop = oldMarginTop;
                    canvas.style.marginBottom = oldMarginBottom;
                    document.body.style.margin = oldDocumentBodyMargin;
                    document.documentElement.style.overflow = oldDocumentOverflow; // Chrome, Firefox
                    document.body.scroll = oldDocumentScroll; // IE
                    canvas.style.imageRendering = oldImageRendering;
                    if (canvas.GLctxObject)
                        canvas.GLctxObject.GLctx.viewport(0, 0, oldWidth, oldHeight);
                    if (currentFullscreenStrategy.canvasResizedCallback) {
                        if (currentFullscreenStrategy.canvasResizedCallbackTargetThread)
                            __emscripten_run_callback_on_thread(currentFullscreenStrategy.canvasResizedCallbackTargetThread, currentFullscreenStrategy.canvasResizedCallback, 37, 0, currentFullscreenStrategy.canvasResizedCallbackUserData);
                        else
                            getWasmTableEntry(currentFullscreenStrategy.canvasResizedCallback)(37, 0, currentFullscreenStrategy.canvasResizedCallbackUserData);
                    }
                }
            }
            document.addEventListener('fullscreenchange', restoreOldStyle);
            // Unprefixed Fullscreen API shipped in Chromium 71 (https://bugs.chromium.org/p/chromium/issues/detail?id=383813)
            // As of Safari 13.0.3 on macOS Catalina 10.15.1 still ships with prefixed webkitfullscreenchange. TODO: revisit this check once Safari ships unprefixed version.
            document.addEventListener('webkitfullscreenchange', restoreOldStyle);
            return restoreOldStyle;
        };
        var setLetterbox = (element, topBottom, leftRight) => {
            // Cannot use margin to specify letterboxes in FF or Chrome, since those ignore margins in fullscreen mode.
            element.style.paddingLeft = element.style.paddingRight = leftRight + 'px';
            element.style.paddingTop = element.style.paddingBottom = topBottom + 'px';
        };
        /** @type {Object} */
        var specialHTMLTargets = [0, typeof document != 'undefined' ? document : 0, typeof window != 'undefined' ? window : 0];
        var getBoundingClientRect = (e) => specialHTMLTargets.indexOf(e) < 0 ? e.getBoundingClientRect() : { 'left': 0, 'top': 0 };
        var JSEvents_resizeCanvasForFullscreen = (target, strategy) => {
            var restoreOldStyle = registerRestoreOldStyle(target);
            var cssWidth = strategy.softFullscreen ? innerWidth : screen.width;
            var cssHeight = strategy.softFullscreen ? innerHeight : screen.height;
            var rect = getBoundingClientRect(target);
            var windowedCssWidth = rect.width;
            var windowedCssHeight = rect.height;
            var canvasSize = getCanvasElementSize(target);
            var windowedRttWidth = canvasSize[0];
            var windowedRttHeight = canvasSize[1];
            if (strategy.scaleMode == 3) {
                setLetterbox(target, (cssHeight - windowedCssHeight) / 2, (cssWidth - windowedCssWidth) / 2);
                cssWidth = windowedCssWidth;
                cssHeight = windowedCssHeight;
            }
            else if (strategy.scaleMode == 2) {
                if (cssWidth * windowedRttHeight < windowedRttWidth * cssHeight) {
                    var desiredCssHeight = windowedRttHeight * cssWidth / windowedRttWidth;
                    setLetterbox(target, (cssHeight - desiredCssHeight) / 2, 0);
                    cssHeight = desiredCssHeight;
                }
                else {
                    var desiredCssWidth = windowedRttWidth * cssHeight / windowedRttHeight;
                    setLetterbox(target, 0, (cssWidth - desiredCssWidth) / 2);
                    cssWidth = desiredCssWidth;
                }
            }
            // If we are adding padding, must choose a background color or otherwise Chrome will give the
            // padding a default white color. Do it only if user has not customized their own background color.
            if (!target.style.backgroundColor)
                target.style.backgroundColor = 'black';
            // IE11 does the same, but requires the color to be set in the document body.
            if (!document.body.style.backgroundColor)
                document.body.style.backgroundColor = 'black'; // IE11
            // Firefox always shows black letterboxes independent of style color.
            target.style.width = cssWidth + 'px';
            target.style.height = cssHeight + 'px';
            if (strategy.filteringMode == 1) {
                target.style.imageRendering = 'optimizeSpeed';
                target.style.imageRendering = '-moz-crisp-edges';
                target.style.imageRendering = '-o-crisp-edges';
                target.style.imageRendering = '-webkit-optimize-contrast';
                target.style.imageRendering = 'optimize-contrast';
                target.style.imageRendering = 'crisp-edges';
                target.style.imageRendering = 'pixelated';
            }
            var dpiScale = (strategy.canvasResolutionScaleMode == 2) ? devicePixelRatio : 1;
            if (strategy.canvasResolutionScaleMode != 0) {
                var newWidth = (cssWidth * dpiScale) | 0;
                var newHeight = (cssHeight * dpiScale) | 0;
                setCanvasElementSize(target, newWidth, newHeight);
                if (target.GLctxObject)
                    target.GLctxObject.GLctx.viewport(0, 0, newWidth, newHeight);
            }
            return restoreOldStyle;
        };
        var JSEvents_requestFullscreen = (target, strategy) => {
            // EMSCRIPTEN_FULLSCREEN_SCALE_DEFAULT + EMSCRIPTEN_FULLSCREEN_CANVAS_SCALE_NONE is a mode where no extra logic is performed to the DOM elements.
            if (strategy.scaleMode != 0 || strategy.canvasResolutionScaleMode != 0) {
                JSEvents_resizeCanvasForFullscreen(target, strategy);
            }
            if (target.requestFullscreen) {
                target.requestFullscreen();
            }
            else if (target.webkitRequestFullscreen) {
                target.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
            }
            else {
                return JSEvents.fullscreenEnabled() ? -3 : -1;
            }
            currentFullscreenStrategy = strategy;
            if (strategy.canvasResizedCallback) {
                if (strategy.canvasResizedCallbackTargetThread)
                    __emscripten_run_callback_on_thread(strategy.canvasResizedCallbackTargetThread, strategy.canvasResizedCallback, 37, 0, strategy.canvasResizedCallbackUserData);
                else
                    getWasmTableEntry(strategy.canvasResizedCallback)(37, 0, strategy.canvasResizedCallbackUserData);
            }
            return 0;
        };
        function _emscripten_exit_fullscreen() {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(100, 0, 1);
            if (!JSEvents.fullscreenEnabled())
                return -1;
            // Make sure no queued up calls will fire after this.
            JSEvents.removeDeferredCalls(JSEvents_requestFullscreen);
            var d = specialHTMLTargets[1];
            if (d.exitFullscreen) {
                d.fullscreenElement && d.exitFullscreen();
            }
            else if (d.webkitExitFullscreen) {
                d.webkitFullscreenElement && d.webkitExitFullscreen();
            }
            else {
                return -1;
            }
            return 0;
        }
        var requestPointerLock = (target) => {
            if (target.requestPointerLock) {
                target.requestPointerLock();
            }
            else {
                // document.body is known to accept pointer lock, so use that to differentiate if the user passed a bad element,
                // or if the whole browser just doesn't support the feature.
                if (document.body.requestPointerLock) {
                    return -3;
                }
                return -1;
            }
            return 0;
        };
        function _emscripten_exit_pointerlock() {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(102, 0, 1);
            // Make sure no queued up calls will fire after this.
            JSEvents.removeDeferredCalls(requestPointerLock);
            if (document.exitPointerLock) {
                document.exitPointerLock();
            }
            else {
                return -1;
            }
            return 0;
        }
        var _emscripten_exit_with_live_runtime = () => {
            runtimeKeepalivePush();
            throw 'unwind';
        };
        function _emscripten_force_exit(status) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(103, 0, 1, status);
            warnOnce('emscripten_force_exit cannot actually shut down the runtime, as the build does not have EXIT_RUNTIME set');
            __emscripten_runtime_keepalive_clear();
            _exit(status);
        }
        function _emscripten_get_device_pixel_ratio() {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(104, 0, 1);
            return devicePixelRatio;
        }
        var findEventTarget = (target) => {
            target = maybeCStringToJsString(target);
            var domElement = specialHTMLTargets[target] || (typeof document != 'undefined' ? document.querySelector(target) : undefined);
            return domElement;
        };
        function _emscripten_get_element_css_size(target, width, height) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(105, 0, 1, target, width, height);
            target = findEventTarget(target);
            if (!target)
                return -4;
            var rect = getBoundingClientRect(target);
            HEAPF64[((width) >> 3)] = rect.width;
            HEAPF64[((height) >> 3)] = rect.height;
            return 0;
        }
        var fillGamepadEventData = (eventStruct, e) => {
            HEAPF64[((eventStruct) >> 3)] = e.timestamp;
            for (var i = 0; i < e.axes.length; ++i) {
                HEAPF64[(((eventStruct + i * 8) + (16)) >> 3)] = e.axes[i];
            }
            for (var i = 0; i < e.buttons.length; ++i) {
                if (typeof e.buttons[i] == 'object') {
                    HEAPF64[(((eventStruct + i * 8) + (528)) >> 3)] = e.buttons[i].value;
                }
                else {
                    HEAPF64[(((eventStruct + i * 8) + (528)) >> 3)] = e.buttons[i];
                }
            }
            for (var i = 0; i < e.buttons.length; ++i) {
                if (typeof e.buttons[i] == 'object') {
                    HEAP32[(((eventStruct + i * 4) + (1040)) >> 2)] = e.buttons[i].pressed;
                }
                else {
                    // Assigning a boolean to HEAP32, that's ok, but Closure would like to warn about it:
                    /** @suppress {checkTypes} */
                    HEAP32[(((eventStruct + i * 4) + (1040)) >> 2)] = e.buttons[i] == 1;
                }
            }
            HEAP32[(((eventStruct) + (1296)) >> 2)] = e.connected;
            HEAP32[(((eventStruct) + (1300)) >> 2)] = e.index;
            HEAP32[(((eventStruct) + (8)) >> 2)] = e.axes.length;
            HEAP32[(((eventStruct) + (12)) >> 2)] = e.buttons.length;
            stringToUTF8(e.id, eventStruct + 1304, 64);
            stringToUTF8(e.mapping, eventStruct + 1368, 64);
        };
        function _emscripten_get_gamepad_status(index, gamepadState) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(106, 0, 1, index, gamepadState);
            if (!JSEvents.lastGamepadState)
                throw 'emscripten_get_gamepad_status() can only be called after having first called emscripten_sample_gamepad_data() and that function has returned EMSCRIPTEN_RESULT_SUCCESS!';
            // INVALID_PARAM is returned on a Gamepad index that never was there.
            if (index < 0 || index >= JSEvents.lastGamepadState.length)
                return -5;
            // NO_DATA is returned on a Gamepad index that was removed.
            // For previously disconnected gamepads there should be an empty slot (null/undefined/false) at the index.
            // This is because gamepads must keep their original position in the array.
            // For example, removing the first of two gamepads produces [null/undefined/false, gamepad].
            if (!JSEvents.lastGamepadState[index])
                return -7;
            fillGamepadEventData(gamepadState, JSEvents.lastGamepadState[index]);
            return 0;
        }
        var getHeapMax = () => HEAPU8.length;
        var _emscripten_get_heap_max = () => getHeapMax();
        var _emscripten_get_main_loop_timing = (mode, value) => {
            if (mode)
                HEAP32[((mode) >> 2)] = Browser.mainLoop.timingMode;
            if (value)
                HEAP32[((value) >> 2)] = Browser.mainLoop.timingValue;
        };
        function _emscripten_get_num_gamepads() {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(107, 0, 1);
            if (!JSEvents.lastGamepadState)
                throw 'emscripten_get_num_gamepads() can only be called after having first called emscripten_sample_gamepad_data() and that function has returned EMSCRIPTEN_RESULT_SUCCESS!';
            // N.B. Do not call emscripten_get_num_gamepads() unless having first called emscripten_sample_gamepad_data(), and that has returned EMSCRIPTEN_RESULT_SUCCESS.
            // Otherwise the following line will throw an exception.
            return JSEvents.lastGamepadState.length;
        }
        function _emscripten_get_screen_size(width, height) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(108, 0, 1, width, height);
            HEAP32[((width) >> 2)] = screen.width;
            HEAP32[((height) >> 2)] = screen.height;
        }
        /** @suppress {duplicate } */
        var _glActiveTexture = (x0) => GLctx.activeTexture(x0);
        var _emscripten_glActiveTexture = _glActiveTexture;
        /** @suppress {duplicate } */
        var _glAttachShader = (program, shader) => {
            GLctx.attachShader(GL.programs[program], GL.shaders[shader]);
        };
        var _emscripten_glAttachShader = _glAttachShader;
        /** @suppress {duplicate } */
        var _glBeginQuery = (target, id) => {
            GLctx.beginQuery(target, GL.queries[id]);
        };
        var _emscripten_glBeginQuery = _glBeginQuery;
        /** @suppress {duplicate } */
        var _glBeginQueryEXT = (target, id) => {
            GLctx.disjointTimerQueryExt['beginQueryEXT'](target, GL.queries[id]);
        };
        var _emscripten_glBeginQueryEXT = _glBeginQueryEXT;
        /** @suppress {duplicate } */
        var _glBeginTransformFeedback = (x0) => GLctx.beginTransformFeedback(x0);
        var _emscripten_glBeginTransformFeedback = _glBeginTransformFeedback;
        /** @suppress {duplicate } */
        var _glBindAttribLocation = (program, index, name) => {
            GLctx.bindAttribLocation(GL.programs[program], index, UTF8ToString(name));
        };
        var _emscripten_glBindAttribLocation = _glBindAttribLocation;
        /** @suppress {duplicate } */
        var _glBindBuffer = (target, buffer) => {
            if (target == 0x8892 /*GL_ARRAY_BUFFER*/) {
                GLctx.currentArrayBufferBinding = buffer;
            }
            else if (target == 0x8893 /*GL_ELEMENT_ARRAY_BUFFER*/) {
                GLctx.currentElementArrayBufferBinding = buffer;
            }
            if (target == 0x88EB /*GL_PIXEL_PACK_BUFFER*/) {
                // In WebGL 2 glReadPixels entry point, we need to use a different WebGL 2
                // API function call when a buffer is bound to
                // GL_PIXEL_PACK_BUFFER_BINDING point, so must keep track whether that
                // binding point is non-null to know what is the proper API function to
                // call.
                GLctx.currentPixelPackBufferBinding = buffer;
            }
            else if (target == 0x88EC /*GL_PIXEL_UNPACK_BUFFER*/) {
                // In WebGL 2 gl(Compressed)Tex(Sub)Image[23]D entry points, we need to
                // use a different WebGL 2 API function call when a buffer is bound to
                // GL_PIXEL_UNPACK_BUFFER_BINDING point, so must keep track whether that
                // binding point is non-null to know what is the proper API function to
                // call.
                GLctx.currentPixelUnpackBufferBinding = buffer;
            }
            GLctx.bindBuffer(target, GL.buffers[buffer]);
        };
        var _emscripten_glBindBuffer = _glBindBuffer;
        /** @suppress {duplicate } */
        var _glBindBufferBase = (target, index, buffer) => {
            GLctx.bindBufferBase(target, index, GL.buffers[buffer]);
        };
        var _emscripten_glBindBufferBase = _glBindBufferBase;
        /** @suppress {duplicate } */
        var _glBindBufferRange = (target, index, buffer, offset, ptrsize) => {
            GLctx.bindBufferRange(target, index, GL.buffers[buffer], offset, ptrsize);
        };
        var _emscripten_glBindBufferRange = _glBindBufferRange;
        /** @suppress {duplicate } */
        var _glBindFramebuffer = (target, framebuffer) => {
            GLctx.bindFramebuffer(target, GL.framebuffers[framebuffer]);
        };
        var _emscripten_glBindFramebuffer = _glBindFramebuffer;
        /** @suppress {duplicate } */
        var _glBindRenderbuffer = (target, renderbuffer) => {
            GLctx.bindRenderbuffer(target, GL.renderbuffers[renderbuffer]);
        };
        var _emscripten_glBindRenderbuffer = _glBindRenderbuffer;
        /** @suppress {duplicate } */
        var _glBindSampler = (unit, sampler) => {
            GLctx.bindSampler(unit, GL.samplers[sampler]);
        };
        var _emscripten_glBindSampler = _glBindSampler;
        /** @suppress {duplicate } */
        var _glBindTexture = (target, texture) => {
            GLctx.bindTexture(target, GL.textures[texture]);
        };
        var _emscripten_glBindTexture = _glBindTexture;
        /** @suppress {duplicate } */
        var _glBindTransformFeedback = (target, id) => {
            GLctx.bindTransformFeedback(target, GL.transformFeedbacks[id]);
        };
        var _emscripten_glBindTransformFeedback = _glBindTransformFeedback;
        /** @suppress {duplicate } */
        var _glBindVertexArray = (vao) => {
            GLctx.bindVertexArray(GL.vaos[vao]);
            var ibo = GLctx.getParameter(0x8895 /*ELEMENT_ARRAY_BUFFER_BINDING*/);
            GLctx.currentElementArrayBufferBinding = ibo ? (ibo.name | 0) : 0;
        };
        var _emscripten_glBindVertexArray = _glBindVertexArray;
        /** @suppress {duplicate } */
        var _glBindVertexArrayOES = _glBindVertexArray;
        var _emscripten_glBindVertexArrayOES = _glBindVertexArrayOES;
        /** @suppress {duplicate } */
        var _glBlendColor = (x0, x1, x2, x3) => GLctx.blendColor(x0, x1, x2, x3);
        var _emscripten_glBlendColor = _glBlendColor;
        /** @suppress {duplicate } */
        var _glBlendEquation = (x0) => GLctx.blendEquation(x0);
        var _emscripten_glBlendEquation = _glBlendEquation;
        /** @suppress {duplicate } */
        var _glBlendEquationSeparate = (x0, x1) => GLctx.blendEquationSeparate(x0, x1);
        var _emscripten_glBlendEquationSeparate = _glBlendEquationSeparate;
        /** @suppress {duplicate } */
        var _glBlendFunc = (x0, x1) => GLctx.blendFunc(x0, x1);
        var _emscripten_glBlendFunc = _glBlendFunc;
        /** @suppress {duplicate } */
        var _glBlendFuncSeparate = (x0, x1, x2, x3) => GLctx.blendFuncSeparate(x0, x1, x2, x3);
        var _emscripten_glBlendFuncSeparate = _glBlendFuncSeparate;
        /** @suppress {duplicate } */
        var _glBlitFramebuffer = (x0, x1, x2, x3, x4, x5, x6, x7, x8, x9) => GLctx.blitFramebuffer(x0, x1, x2, x3, x4, x5, x6, x7, x8, x9);
        var _emscripten_glBlitFramebuffer = _glBlitFramebuffer;
        /** @suppress {duplicate } */
        var _glBufferData = (target, size, data, usage) => {
            if (GL.currentContext.version >= 2) {
                // If size is zero, WebGL would interpret uploading the whole input
                // arraybuffer (starting from given offset), which would not make sense in
                // WebAssembly, so avoid uploading if size is zero. However we must still
                // call bufferData to establish a backing storage of zero bytes.
                if (data && size) {
                    GLctx.bufferData(target, HEAPU8, usage, data, size);
                }
                else {
                    GLctx.bufferData(target, size, usage);
                }
                return;
            }
            // N.b. here first form specifies a heap subarray, second form an integer
            // size, so the ?: code here is polymorphic. It is advised to avoid
            // randomly mixing both uses in calling code, to avoid any potential JS
            // engine JIT issues.
            GLctx.bufferData(target, data ? HEAPU8.subarray(data, data + size) : size, usage);
        };
        var _emscripten_glBufferData = _glBufferData;
        /** @suppress {duplicate } */
        var _glBufferSubData = (target, offset, size, data) => {
            if (GL.currentContext.version >= 2) {
                size && GLctx.bufferSubData(target, offset, HEAPU8, data, size);
                return;
            }
            GLctx.bufferSubData(target, offset, HEAPU8.subarray(data, data + size));
        };
        var _emscripten_glBufferSubData = _glBufferSubData;
        /** @suppress {duplicate } */
        var _glCheckFramebufferStatus = (x0) => GLctx.checkFramebufferStatus(x0);
        var _emscripten_glCheckFramebufferStatus = _glCheckFramebufferStatus;
        /** @suppress {duplicate } */
        var _glClear = (x0) => GLctx.clear(x0);
        var _emscripten_glClear = _glClear;
        /** @suppress {duplicate } */
        var _glClearBufferfi = (x0, x1, x2, x3) => GLctx.clearBufferfi(x0, x1, x2, x3);
        var _emscripten_glClearBufferfi = _glClearBufferfi;
        /** @suppress {duplicate } */
        var _glClearBufferfv = (buffer, drawbuffer, value) => {
            GLctx.clearBufferfv(buffer, drawbuffer, HEAPF32, ((value) >> 2));
        };
        var _emscripten_glClearBufferfv = _glClearBufferfv;
        /** @suppress {duplicate } */
        var _glClearBufferiv = (buffer, drawbuffer, value) => {
            GLctx.clearBufferiv(buffer, drawbuffer, HEAP32, ((value) >> 2));
        };
        var _emscripten_glClearBufferiv = _glClearBufferiv;
        /** @suppress {duplicate } */
        var _glClearBufferuiv = (buffer, drawbuffer, value) => {
            GLctx.clearBufferuiv(buffer, drawbuffer, HEAPU32, ((value) >> 2));
        };
        var _emscripten_glClearBufferuiv = _glClearBufferuiv;
        /** @suppress {duplicate } */
        var _glClearColor = (x0, x1, x2, x3) => GLctx.clearColor(x0, x1, x2, x3);
        var _emscripten_glClearColor = _glClearColor;
        /** @suppress {duplicate } */
        var _glClearDepthf = (x0) => GLctx.clearDepth(x0);
        var _emscripten_glClearDepthf = _glClearDepthf;
        /** @suppress {duplicate } */
        var _glClearStencil = (x0) => GLctx.clearStencil(x0);
        var _emscripten_glClearStencil = _glClearStencil;
        /** @suppress {duplicate } */
        var _glClientWaitSync = (sync, flags, timeout) => {
            // WebGL2 vs GLES3 differences: in GLES3, the timeout parameter is a uint64, where 0xFFFFFFFFFFFFFFFFULL means GL_TIMEOUT_IGNORED.
            // In JS, there's no 64-bit value types, so instead timeout is taken to be signed, and GL_TIMEOUT_IGNORED is given value -1.
            // Inherently the value accepted in the timeout is lossy, and can't take in arbitrary u64 bit pattern (but most likely doesn't matter)
            // See https://www.khronos.org/registry/webgl/specs/latest/2.0/#5.15
            timeout = Number(timeout);
            return GLctx.clientWaitSync(GL.syncs[sync], flags, timeout);
        };
        var _emscripten_glClientWaitSync = _glClientWaitSync;
        /** @suppress {duplicate } */
        var _glColorMask = (red, green, blue, alpha) => {
            GLctx.colorMask(!!red, !!green, !!blue, !!alpha);
        };
        var _emscripten_glColorMask = _glColorMask;
        /** @suppress {duplicate } */
        var _glCompileShader = (shader) => {
            GLctx.compileShader(GL.shaders[shader]);
        };
        var _emscripten_glCompileShader = _glCompileShader;
        /** @suppress {duplicate } */
        var _glCompressedTexImage2D = (target, level, internalFormat, width, height, border, imageSize, data) => {
            if (GL.currentContext.version >= 2) {
                if (GLctx.currentPixelUnpackBufferBinding || !imageSize) {
                    GLctx.compressedTexImage2D(target, level, internalFormat, width, height, border, imageSize, data);
                    return;
                }
                GLctx.compressedTexImage2D(target, level, internalFormat, width, height, border, HEAPU8, data, imageSize);
                return;
            }
            GLctx.compressedTexImage2D(target, level, internalFormat, width, height, border, data ? HEAPU8.subarray((data), data + imageSize) : null);
        };
        var _emscripten_glCompressedTexImage2D = _glCompressedTexImage2D;
        /** @suppress {duplicate } */
        var _glCompressedTexImage3D = (target, level, internalFormat, width, height, depth, border, imageSize, data) => {
            if (GLctx.currentPixelUnpackBufferBinding) {
                GLctx.compressedTexImage3D(target, level, internalFormat, width, height, depth, border, imageSize, data);
            }
            else {
                GLctx.compressedTexImage3D(target, level, internalFormat, width, height, depth, border, HEAPU8, data, imageSize);
            }
        };
        var _emscripten_glCompressedTexImage3D = _glCompressedTexImage3D;
        /** @suppress {duplicate } */
        var _glCompressedTexSubImage2D = (target, level, xoffset, yoffset, width, height, format, imageSize, data) => {
            if (GL.currentContext.version >= 2) {
                if (GLctx.currentPixelUnpackBufferBinding || !imageSize) {
                    GLctx.compressedTexSubImage2D(target, level, xoffset, yoffset, width, height, format, imageSize, data);
                    return;
                }
                GLctx.compressedTexSubImage2D(target, level, xoffset, yoffset, width, height, format, HEAPU8, data, imageSize);
                return;
            }
            GLctx.compressedTexSubImage2D(target, level, xoffset, yoffset, width, height, format, data ? HEAPU8.subarray((data), data + imageSize) : null);
        };
        var _emscripten_glCompressedTexSubImage2D = _glCompressedTexSubImage2D;
        /** @suppress {duplicate } */
        var _glCompressedTexSubImage3D = (target, level, xoffset, yoffset, zoffset, width, height, depth, format, imageSize, data) => {
            if (GLctx.currentPixelUnpackBufferBinding) {
                GLctx.compressedTexSubImage3D(target, level, xoffset, yoffset, zoffset, width, height, depth, format, imageSize, data);
            }
            else {
                GLctx.compressedTexSubImage3D(target, level, xoffset, yoffset, zoffset, width, height, depth, format, HEAPU8, data, imageSize);
            }
        };
        var _emscripten_glCompressedTexSubImage3D = _glCompressedTexSubImage3D;
        /** @suppress {duplicate } */
        var _glCopyBufferSubData = (x0, x1, x2, x3, x4) => GLctx.copyBufferSubData(x0, x1, x2, x3, x4);
        var _emscripten_glCopyBufferSubData = _glCopyBufferSubData;
        /** @suppress {duplicate } */
        var _glCopyTexImage2D = (x0, x1, x2, x3, x4, x5, x6, x7) => GLctx.copyTexImage2D(x0, x1, x2, x3, x4, x5, x6, x7);
        var _emscripten_glCopyTexImage2D = _glCopyTexImage2D;
        /** @suppress {duplicate } */
        var _glCopyTexSubImage2D = (x0, x1, x2, x3, x4, x5, x6, x7) => GLctx.copyTexSubImage2D(x0, x1, x2, x3, x4, x5, x6, x7);
        var _emscripten_glCopyTexSubImage2D = _glCopyTexSubImage2D;
        /** @suppress {duplicate } */
        var _glCopyTexSubImage3D = (x0, x1, x2, x3, x4, x5, x6, x7, x8) => GLctx.copyTexSubImage3D(x0, x1, x2, x3, x4, x5, x6, x7, x8);
        var _emscripten_glCopyTexSubImage3D = _glCopyTexSubImage3D;
        /** @suppress {duplicate } */
        var _glCreateProgram = () => {
            var id = GL.getNewId(GL.programs);
            var program = GLctx.createProgram();
            // Store additional information needed for each shader program:
            program.name = id;
            // Lazy cache results of
            // glGetProgramiv(GL_ACTIVE_UNIFORM_MAX_LENGTH/GL_ACTIVE_ATTRIBUTE_MAX_LENGTH/GL_ACTIVE_UNIFORM_BLOCK_MAX_NAME_LENGTH)
            program.maxUniformLength = program.maxAttributeLength = program.maxUniformBlockNameLength = 0;
            program.uniformIdCounter = 1;
            GL.programs[id] = program;
            return id;
        };
        var _emscripten_glCreateProgram = _glCreateProgram;
        /** @suppress {duplicate } */
        var _glCreateShader = (shaderType) => {
            var id = GL.getNewId(GL.shaders);
            GL.shaders[id] = GLctx.createShader(shaderType);
            return id;
        };
        var _emscripten_glCreateShader = _glCreateShader;
        /** @suppress {duplicate } */
        var _glCullFace = (x0) => GLctx.cullFace(x0);
        var _emscripten_glCullFace = _glCullFace;
        /** @suppress {duplicate } */
        var _glDeleteBuffers = (n, buffers) => {
            for (var i = 0; i < n; i++) {
                var id = HEAP32[(((buffers) + (i * 4)) >> 2)];
                var buffer = GL.buffers[id];
                // From spec: "glDeleteBuffers silently ignores 0's and names that do not
                // correspond to existing buffer objects."
                if (!buffer)
                    continue;
                GLctx.deleteBuffer(buffer);
                buffer.name = 0;
                GL.buffers[id] = null;
                if (id == GLctx.currentArrayBufferBinding)
                    GLctx.currentArrayBufferBinding = 0;
                if (id == GLctx.currentElementArrayBufferBinding)
                    GLctx.currentElementArrayBufferBinding = 0;
                if (id == GLctx.currentPixelPackBufferBinding)
                    GLctx.currentPixelPackBufferBinding = 0;
                if (id == GLctx.currentPixelUnpackBufferBinding)
                    GLctx.currentPixelUnpackBufferBinding = 0;
            }
        };
        var _emscripten_glDeleteBuffers = _glDeleteBuffers;
        /** @suppress {duplicate } */
        var _glDeleteFramebuffers = (n, framebuffers) => {
            for (var i = 0; i < n; ++i) {
                var id = HEAP32[(((framebuffers) + (i * 4)) >> 2)];
                var framebuffer = GL.framebuffers[id];
                if (!framebuffer)
                    continue; // GL spec: "glDeleteFramebuffers silently ignores 0s and names that do not correspond to existing framebuffer objects".
                GLctx.deleteFramebuffer(framebuffer);
                framebuffer.name = 0;
                GL.framebuffers[id] = null;
            }
        };
        var _emscripten_glDeleteFramebuffers = _glDeleteFramebuffers;
        /** @suppress {duplicate } */
        var _glDeleteProgram = (id) => {
            if (!id)
                return;
            var program = GL.programs[id];
            if (!program) {
                // glDeleteProgram actually signals an error when deleting a nonexisting
                // object, unlike some other GL delete functions.
                GL.recordError(0x501 /* GL_INVALID_VALUE */);
                return;
            }
            GLctx.deleteProgram(program);
            program.name = 0;
            GL.programs[id] = null;
        };
        var _emscripten_glDeleteProgram = _glDeleteProgram;
        /** @suppress {duplicate } */
        var _glDeleteQueries = (n, ids) => {
            for (var i = 0; i < n; i++) {
                var id = HEAP32[(((ids) + (i * 4)) >> 2)];
                var query = GL.queries[id];
                if (!query)
                    continue; // GL spec: "unused names in ids are ignored, as is the name zero."
                GLctx.deleteQuery(query);
                GL.queries[id] = null;
            }
        };
        var _emscripten_glDeleteQueries = _glDeleteQueries;
        /** @suppress {duplicate } */
        var _glDeleteQueriesEXT = (n, ids) => {
            for (var i = 0; i < n; i++) {
                var id = HEAP32[(((ids) + (i * 4)) >> 2)];
                var query = GL.queries[id];
                if (!query)
                    continue; // GL spec: "unused names in ids are ignored, as is the name zero."
                GLctx.disjointTimerQueryExt['deleteQueryEXT'](query);
                GL.queries[id] = null;
            }
        };
        var _emscripten_glDeleteQueriesEXT = _glDeleteQueriesEXT;
        /** @suppress {duplicate } */
        var _glDeleteRenderbuffers = (n, renderbuffers) => {
            for (var i = 0; i < n; i++) {
                var id = HEAP32[(((renderbuffers) + (i * 4)) >> 2)];
                var renderbuffer = GL.renderbuffers[id];
                if (!renderbuffer)
                    continue; // GL spec: "glDeleteRenderbuffers silently ignores 0s and names that do not correspond to existing renderbuffer objects".
                GLctx.deleteRenderbuffer(renderbuffer);
                renderbuffer.name = 0;
                GL.renderbuffers[id] = null;
            }
        };
        var _emscripten_glDeleteRenderbuffers = _glDeleteRenderbuffers;
        /** @suppress {duplicate } */
        var _glDeleteSamplers = (n, samplers) => {
            for (var i = 0; i < n; i++) {
                var id = HEAP32[(((samplers) + (i * 4)) >> 2)];
                var sampler = GL.samplers[id];
                if (!sampler)
                    continue;
                GLctx.deleteSampler(sampler);
                sampler.name = 0;
                GL.samplers[id] = null;
            }
        };
        var _emscripten_glDeleteSamplers = _glDeleteSamplers;
        /** @suppress {duplicate } */
        var _glDeleteShader = (id) => {
            if (!id)
                return;
            var shader = GL.shaders[id];
            if (!shader) {
                // glDeleteShader actually signals an error when deleting a nonexisting
                // object, unlike some other GL delete functions.
                GL.recordError(0x501 /* GL_INVALID_VALUE */);
                return;
            }
            GLctx.deleteShader(shader);
            GL.shaders[id] = null;
        };
        var _emscripten_glDeleteShader = _glDeleteShader;
        /** @suppress {duplicate } */
        var _glDeleteSync = (id) => {
            if (!id)
                return;
            var sync = GL.syncs[id];
            if (!sync) { // glDeleteSync signals an error when deleting a nonexisting object, unlike some other GL delete functions.
                GL.recordError(0x501 /* GL_INVALID_VALUE */);
                return;
            }
            GLctx.deleteSync(sync);
            sync.name = 0;
            GL.syncs[id] = null;
        };
        var _emscripten_glDeleteSync = _glDeleteSync;
        /** @suppress {duplicate } */
        var _glDeleteTextures = (n, textures) => {
            for (var i = 0; i < n; i++) {
                var id = HEAP32[(((textures) + (i * 4)) >> 2)];
                var texture = GL.textures[id];
                // GL spec: "glDeleteTextures silently ignores 0s and names that do not
                // correspond to existing textures".
                if (!texture)
                    continue;
                GLctx.deleteTexture(texture);
                texture.name = 0;
                GL.textures[id] = null;
            }
        };
        var _emscripten_glDeleteTextures = _glDeleteTextures;
        /** @suppress {duplicate } */
        var _glDeleteTransformFeedbacks = (n, ids) => {
            for (var i = 0; i < n; i++) {
                var id = HEAP32[(((ids) + (i * 4)) >> 2)];
                var transformFeedback = GL.transformFeedbacks[id];
                if (!transformFeedback)
                    continue; // GL spec: "unused names in ids are ignored, as is the name zero."
                GLctx.deleteTransformFeedback(transformFeedback);
                transformFeedback.name = 0;
                GL.transformFeedbacks[id] = null;
            }
        };
        var _emscripten_glDeleteTransformFeedbacks = _glDeleteTransformFeedbacks;
        /** @suppress {duplicate } */
        var _glDeleteVertexArrays = (n, vaos) => {
            for (var i = 0; i < n; i++) {
                var id = HEAP32[(((vaos) + (i * 4)) >> 2)];
                GLctx.deleteVertexArray(GL.vaos[id]);
                GL.vaos[id] = null;
            }
        };
        var _emscripten_glDeleteVertexArrays = _glDeleteVertexArrays;
        /** @suppress {duplicate } */
        var _glDeleteVertexArraysOES = _glDeleteVertexArrays;
        var _emscripten_glDeleteVertexArraysOES = _glDeleteVertexArraysOES;
        /** @suppress {duplicate } */
        var _glDepthFunc = (x0) => GLctx.depthFunc(x0);
        var _emscripten_glDepthFunc = _glDepthFunc;
        /** @suppress {duplicate } */
        var _glDepthMask = (flag) => {
            GLctx.depthMask(!!flag);
        };
        var _emscripten_glDepthMask = _glDepthMask;
        /** @suppress {duplicate } */
        var _glDepthRangef = (x0, x1) => GLctx.depthRange(x0, x1);
        var _emscripten_glDepthRangef = _glDepthRangef;
        /** @suppress {duplicate } */
        var _glDetachShader = (program, shader) => {
            GLctx.detachShader(GL.programs[program], GL.shaders[shader]);
        };
        var _emscripten_glDetachShader = _glDetachShader;
        /** @suppress {duplicate } */
        var _glDisable = (x0) => GLctx.disable(x0);
        var _emscripten_glDisable = _glDisable;
        /** @suppress {duplicate } */
        var _glDisableVertexAttribArray = (index) => {
            var cb = GL.currentContext.clientBuffers[index];
            cb.enabled = false;
            GLctx.disableVertexAttribArray(index);
        };
        var _emscripten_glDisableVertexAttribArray = _glDisableVertexAttribArray;
        /** @suppress {duplicate } */
        var _glDrawArrays = (mode, first, count) => {
            // bind any client-side buffers
            GL.preDrawHandleClientVertexAttribBindings(first + count);
            GLctx.drawArrays(mode, first, count);
            GL.postDrawHandleClientVertexAttribBindings();
        };
        var _emscripten_glDrawArrays = _glDrawArrays;
        /** @suppress {duplicate } */
        var _glDrawArraysInstanced = (mode, first, count, primcount) => {
            GLctx.drawArraysInstanced(mode, first, count, primcount);
        };
        var _emscripten_glDrawArraysInstanced = _glDrawArraysInstanced;
        /** @suppress {duplicate } */
        var _glDrawArraysInstancedANGLE = _glDrawArraysInstanced;
        var _emscripten_glDrawArraysInstancedANGLE = _glDrawArraysInstancedANGLE;
        /** @suppress {duplicate } */
        var _glDrawArraysInstancedARB = _glDrawArraysInstanced;
        var _emscripten_glDrawArraysInstancedARB = _glDrawArraysInstancedARB;
        /** @suppress {duplicate } */
        var _glDrawArraysInstancedEXT = _glDrawArraysInstanced;
        var _emscripten_glDrawArraysInstancedEXT = _glDrawArraysInstancedEXT;
        /** @suppress {duplicate } */
        var _glDrawArraysInstancedNV = _glDrawArraysInstanced;
        var _emscripten_glDrawArraysInstancedNV = _glDrawArraysInstancedNV;
        var tempFixedLengthArray = [];
        /** @suppress {duplicate } */
        var _glDrawBuffers = (n, bufs) => {
            var bufArray = tempFixedLengthArray[n];
            for (var i = 0; i < n; i++) {
                bufArray[i] = HEAP32[(((bufs) + (i * 4)) >> 2)];
            }
            GLctx.drawBuffers(bufArray);
        };
        var _emscripten_glDrawBuffers = _glDrawBuffers;
        /** @suppress {duplicate } */
        var _glDrawBuffersEXT = _glDrawBuffers;
        var _emscripten_glDrawBuffersEXT = _glDrawBuffersEXT;
        /** @suppress {duplicate } */
        var _glDrawBuffersWEBGL = _glDrawBuffers;
        var _emscripten_glDrawBuffersWEBGL = _glDrawBuffersWEBGL;
        /** @suppress {duplicate } */
        var _glDrawElements = (mode, count, type, indices) => {
            var buf;
            if (!GLctx.currentElementArrayBufferBinding) {
                var size = GL.calcBufLength(1, type, 0, count);
                buf = GL.getTempIndexBuffer(size);
                GLctx.bindBuffer(0x8893 /*GL_ELEMENT_ARRAY_BUFFER*/, buf);
                GLctx.bufferSubData(0x8893 /*GL_ELEMENT_ARRAY_BUFFER*/, 0, HEAPU8.subarray(indices, indices + size));
                // the index is now 0
                indices = 0;
            }
            // bind any client-side buffers
            GL.preDrawHandleClientVertexAttribBindings(count);
            GLctx.drawElements(mode, count, type, indices);
            GL.postDrawHandleClientVertexAttribBindings(count);
            if (!GLctx.currentElementArrayBufferBinding) {
                GLctx.bindBuffer(0x8893 /*GL_ELEMENT_ARRAY_BUFFER*/, null);
            }
        };
        var _emscripten_glDrawElements = _glDrawElements;
        /** @suppress {duplicate } */
        var _glDrawElementsInstanced = (mode, count, type, indices, primcount) => {
            GLctx.drawElementsInstanced(mode, count, type, indices, primcount);
        };
        var _emscripten_glDrawElementsInstanced = _glDrawElementsInstanced;
        /** @suppress {duplicate } */
        var _glDrawElementsInstancedANGLE = _glDrawElementsInstanced;
        var _emscripten_glDrawElementsInstancedANGLE = _glDrawElementsInstancedANGLE;
        /** @suppress {duplicate } */
        var _glDrawElementsInstancedARB = _glDrawElementsInstanced;
        var _emscripten_glDrawElementsInstancedARB = _glDrawElementsInstancedARB;
        /** @suppress {duplicate } */
        var _glDrawElementsInstancedEXT = _glDrawElementsInstanced;
        var _emscripten_glDrawElementsInstancedEXT = _glDrawElementsInstancedEXT;
        /** @suppress {duplicate } */
        var _glDrawElementsInstancedNV = _glDrawElementsInstanced;
        var _emscripten_glDrawElementsInstancedNV = _glDrawElementsInstancedNV;
        /** @suppress {duplicate } */
        var _glDrawRangeElements = (mode, start, end, count, type, indices) => {
            // TODO: This should be a trivial pass-though function registered at the bottom of this page as
            // glFuncs[6][1] += ' drawRangeElements';
            // but due to https://bugzilla.mozilla.org/show_bug.cgi?id=1202427,
            // we work around by ignoring the range.
            _glDrawElements(mode, count, type, indices);
        };
        var _emscripten_glDrawRangeElements = _glDrawRangeElements;
        /** @suppress {duplicate } */
        var _glEnable = (x0) => GLctx.enable(x0);
        var _emscripten_glEnable = _glEnable;
        /** @suppress {duplicate } */
        var _glEnableVertexAttribArray = (index) => {
            var cb = GL.currentContext.clientBuffers[index];
            cb.enabled = true;
            GLctx.enableVertexAttribArray(index);
        };
        var _emscripten_glEnableVertexAttribArray = _glEnableVertexAttribArray;
        /** @suppress {duplicate } */
        var _glEndQuery = (x0) => GLctx.endQuery(x0);
        var _emscripten_glEndQuery = _glEndQuery;
        /** @suppress {duplicate } */
        var _glEndQueryEXT = (target) => {
            GLctx.disjointTimerQueryExt['endQueryEXT'](target);
        };
        var _emscripten_glEndQueryEXT = _glEndQueryEXT;
        /** @suppress {duplicate } */
        var _glEndTransformFeedback = () => GLctx.endTransformFeedback();
        var _emscripten_glEndTransformFeedback = _glEndTransformFeedback;
        /** @suppress {duplicate } */
        var _glFenceSync = (condition, flags) => {
            var sync = GLctx.fenceSync(condition, flags);
            if (sync) {
                var id = GL.getNewId(GL.syncs);
                sync.name = id;
                GL.syncs[id] = sync;
                return id;
            }
            return 0; // Failed to create a sync object
        };
        var _emscripten_glFenceSync = _glFenceSync;
        /** @suppress {duplicate } */
        var _glFinish = () => GLctx.finish();
        var _emscripten_glFinish = _glFinish;
        /** @suppress {duplicate } */
        var _glFlush = () => GLctx.flush();
        var _emscripten_glFlush = _glFlush;
        var emscriptenWebGLGetBufferBinding = (target) => {
            switch (target) {
                case 0x8892 /*GL_ARRAY_BUFFER*/:
                    target = 0x8894 /*GL_ARRAY_BUFFER_BINDING*/;
                    break;
                case 0x8893 /*GL_ELEMENT_ARRAY_BUFFER*/:
                    target = 0x8895 /*GL_ELEMENT_ARRAY_BUFFER_BINDING*/;
                    break;
                case 0x88EB /*GL_PIXEL_PACK_BUFFER*/:
                    target = 0x88ED /*GL_PIXEL_PACK_BUFFER_BINDING*/;
                    break;
                case 0x88EC /*GL_PIXEL_UNPACK_BUFFER*/:
                    target = 0x88EF /*GL_PIXEL_UNPACK_BUFFER_BINDING*/;
                    break;
                case 0x8C8E /*GL_TRANSFORM_FEEDBACK_BUFFER*/:
                    target = 0x8C8F /*GL_TRANSFORM_FEEDBACK_BUFFER_BINDING*/;
                    break;
                case 0x8F36 /*GL_COPY_READ_BUFFER*/:
                    target = 0x8F36 /*GL_COPY_READ_BUFFER_BINDING*/;
                    break;
                case 0x8F37 /*GL_COPY_WRITE_BUFFER*/:
                    target = 0x8F37 /*GL_COPY_WRITE_BUFFER_BINDING*/;
                    break;
                case 0x8A11 /*GL_UNIFORM_BUFFER*/:
                    target = 0x8A28 /*GL_UNIFORM_BUFFER_BINDING*/;
                    break;
                // In default case, fall through and assume passed one of the _BINDING enums directly.
            }
            var buffer = GLctx.getParameter(target);
            if (buffer)
                return buffer.name | 0;
            else
                return 0;
        };
        var emscriptenWebGLValidateMapBufferTarget = (target) => {
            switch (target) {
                case 0x8892: // GL_ARRAY_BUFFER
                case 0x8893: // GL_ELEMENT_ARRAY_BUFFER
                case 0x8F36: // GL_COPY_READ_BUFFER
                case 0x8F37: // GL_COPY_WRITE_BUFFER
                case 0x88EB: // GL_PIXEL_PACK_BUFFER
                case 0x88EC: // GL_PIXEL_UNPACK_BUFFER
                case 0x8C2A: // GL_TEXTURE_BUFFER
                case 0x8C8E: // GL_TRANSFORM_FEEDBACK_BUFFER
                case 0x8A11: // GL_UNIFORM_BUFFER
                    return true;
                default:
                    return false;
            }
        };
        /** @suppress {duplicate } */
        var _glFlushMappedBufferRange = (target, offset, length) => {
            if (!emscriptenWebGLValidateMapBufferTarget(target)) {
                GL.recordError(0x500 /*GL_INVALID_ENUM*/);
                err('GL_INVALID_ENUM in glFlushMappedBufferRange');
                return;
            }
            var mapping = GL.mappedBuffers[emscriptenWebGLGetBufferBinding(target)];
            if (!mapping) {
                GL.recordError(0x502 /* GL_INVALID_OPERATION */);
                err('buffer was never mapped in glFlushMappedBufferRange');
                return;
            }
            if (!(mapping.access & 0x10)) {
                GL.recordError(0x502 /* GL_INVALID_OPERATION */);
                err('buffer was not mapped with GL_MAP_FLUSH_EXPLICIT_BIT in glFlushMappedBufferRange');
                return;
            }
            if (offset < 0 || length < 0 || offset + length > mapping.length) {
                GL.recordError(0x501 /* GL_INVALID_VALUE */);
                err('invalid range in glFlushMappedBufferRange');
                return;
            }
            GLctx.bufferSubData(target, mapping.offset, HEAPU8.subarray(mapping.mem + offset, mapping.mem + offset + length));
        };
        var _emscripten_glFlushMappedBufferRange = _glFlushMappedBufferRange;
        /** @suppress {duplicate } */
        var _glFramebufferRenderbuffer = (target, attachment, renderbuffertarget, renderbuffer) => {
            GLctx.framebufferRenderbuffer(target, attachment, renderbuffertarget, GL.renderbuffers[renderbuffer]);
        };
        var _emscripten_glFramebufferRenderbuffer = _glFramebufferRenderbuffer;
        /** @suppress {duplicate } */
        var _glFramebufferTexture2D = (target, attachment, textarget, texture, level) => {
            GLctx.framebufferTexture2D(target, attachment, textarget, GL.textures[texture], level);
        };
        var _emscripten_glFramebufferTexture2D = _glFramebufferTexture2D;
        /** @suppress {duplicate } */
        var _glFramebufferTextureLayer = (target, attachment, texture, level, layer) => {
            GLctx.framebufferTextureLayer(target, attachment, GL.textures[texture], level, layer);
        };
        var _emscripten_glFramebufferTextureLayer = _glFramebufferTextureLayer;
        /** @suppress {duplicate } */
        var _glFrontFace = (x0) => GLctx.frontFace(x0);
        var _emscripten_glFrontFace = _glFrontFace;
        /** @suppress {duplicate } */
        var _glGenBuffers = (n, buffers) => {
            GL.genObject(n, buffers, 'createBuffer', GL.buffers);
        };
        var _emscripten_glGenBuffers = _glGenBuffers;
        /** @suppress {duplicate } */
        var _glGenFramebuffers = (n, ids) => {
            GL.genObject(n, ids, 'createFramebuffer', GL.framebuffers);
        };
        var _emscripten_glGenFramebuffers = _glGenFramebuffers;
        /** @suppress {duplicate } */
        var _glGenQueries = (n, ids) => {
            GL.genObject(n, ids, 'createQuery', GL.queries);
        };
        var _emscripten_glGenQueries = _glGenQueries;
        /** @suppress {duplicate } */
        var _glGenQueriesEXT = (n, ids) => {
            for (var i = 0; i < n; i++) {
                var query = GLctx.disjointTimerQueryExt['createQueryEXT']();
                if (!query) {
                    GL.recordError(0x502 /* GL_INVALID_OPERATION */);
                    while (i < n)
                        HEAP32[(((ids) + (i++ * 4)) >> 2)] = 0;
                    return;
                }
                var id = GL.getNewId(GL.queries);
                query.name = id;
                GL.queries[id] = query;
                HEAP32[(((ids) + (i * 4)) >> 2)] = id;
            }
        };
        var _emscripten_glGenQueriesEXT = _glGenQueriesEXT;
        /** @suppress {duplicate } */
        var _glGenRenderbuffers = (n, renderbuffers) => {
            GL.genObject(n, renderbuffers, 'createRenderbuffer', GL.renderbuffers);
        };
        var _emscripten_glGenRenderbuffers = _glGenRenderbuffers;
        /** @suppress {duplicate } */
        var _glGenSamplers = (n, samplers) => {
            GL.genObject(n, samplers, 'createSampler', GL.samplers);
        };
        var _emscripten_glGenSamplers = _glGenSamplers;
        /** @suppress {duplicate } */
        var _glGenTextures = (n, textures) => {
            GL.genObject(n, textures, 'createTexture', GL.textures);
        };
        var _emscripten_glGenTextures = _glGenTextures;
        /** @suppress {duplicate } */
        var _glGenTransformFeedbacks = (n, ids) => {
            GL.genObject(n, ids, 'createTransformFeedback', GL.transformFeedbacks);
        };
        var _emscripten_glGenTransformFeedbacks = _glGenTransformFeedbacks;
        /** @suppress {duplicate } */
        var _glGenVertexArrays = (n, arrays) => {
            GL.genObject(n, arrays, 'createVertexArray', GL.vaos);
        };
        var _emscripten_glGenVertexArrays = _glGenVertexArrays;
        /** @suppress {duplicate } */
        var _glGenVertexArraysOES = _glGenVertexArrays;
        var _emscripten_glGenVertexArraysOES = _glGenVertexArraysOES;
        /** @suppress {duplicate } */
        var _glGenerateMipmap = (x0) => GLctx.generateMipmap(x0);
        var _emscripten_glGenerateMipmap = _glGenerateMipmap;
        var __glGetActiveAttribOrUniform = (funcName, program, index, bufSize, length, size, type, name) => {
            program = GL.programs[program];
            var info = GLctx[funcName](program, index);
            if (info) {
                // If an error occurs, nothing will be written to length, size and type and name.
                var numBytesWrittenExclNull = name && stringToUTF8(info.name, name, bufSize);
                if (length)
                    HEAP32[((length) >> 2)] = numBytesWrittenExclNull;
                if (size)
                    HEAP32[((size) >> 2)] = info.size;
                if (type)
                    HEAP32[((type) >> 2)] = info.type;
            }
        };
        /** @suppress {duplicate } */
        var _glGetActiveAttrib = (program, index, bufSize, length, size, type, name) => {
            __glGetActiveAttribOrUniform('getActiveAttrib', program, index, bufSize, length, size, type, name);
        };
        var _emscripten_glGetActiveAttrib = _glGetActiveAttrib;
        /** @suppress {duplicate } */
        var _glGetActiveUniform = (program, index, bufSize, length, size, type, name) => {
            __glGetActiveAttribOrUniform('getActiveUniform', program, index, bufSize, length, size, type, name);
        };
        var _emscripten_glGetActiveUniform = _glGetActiveUniform;
        /** @suppress {duplicate } */
        var _glGetActiveUniformBlockName = (program, uniformBlockIndex, bufSize, length, uniformBlockName) => {
            program = GL.programs[program];
            var result = GLctx.getActiveUniformBlockName(program, uniformBlockIndex);
            if (!result)
                return; // If an error occurs, nothing will be written to uniformBlockName or length.
            if (uniformBlockName && bufSize > 0) {
                var numBytesWrittenExclNull = stringToUTF8(result, uniformBlockName, bufSize);
                if (length)
                    HEAP32[((length) >> 2)] = numBytesWrittenExclNull;
            }
            else {
                if (length)
                    HEAP32[((length) >> 2)] = 0;
            }
        };
        var _emscripten_glGetActiveUniformBlockName = _glGetActiveUniformBlockName;
        /** @suppress {duplicate } */
        var _glGetActiveUniformBlockiv = (program, uniformBlockIndex, pname, params) => {
            if (!params) {
                // GLES2 specification does not specify how to behave if params is a null pointer. Since calling this function does not make sense
                // if params == null, issue a GL error to notify user about it.
                GL.recordError(0x501 /* GL_INVALID_VALUE */);
                return;
            }
            program = GL.programs[program];
            if (pname == 0x8A41 /* GL_UNIFORM_BLOCK_NAME_LENGTH */) {
                var name = GLctx.getActiveUniformBlockName(program, uniformBlockIndex);
                HEAP32[((params) >> 2)] = name.length + 1;
                return;
            }
            var result = GLctx.getActiveUniformBlockParameter(program, uniformBlockIndex, pname);
            if (result === null)
                return; // If an error occurs, nothing should be written to params.
            if (pname == 0x8A43 /*GL_UNIFORM_BLOCK_ACTIVE_UNIFORM_INDICES*/) {
                for (var i = 0; i < result.length; i++) {
                    HEAP32[(((params) + (i * 4)) >> 2)] = result[i];
                }
            }
            else {
                HEAP32[((params) >> 2)] = result;
            }
        };
        var _emscripten_glGetActiveUniformBlockiv = _glGetActiveUniformBlockiv;
        /** @suppress {duplicate } */
        var _glGetActiveUniformsiv = (program, uniformCount, uniformIndices, pname, params) => {
            if (!params) {
                // GLES2 specification does not specify how to behave if params is a null pointer. Since calling this function does not make sense
                // if params == null, issue a GL error to notify user about it.
                GL.recordError(0x501 /* GL_INVALID_VALUE */);
                return;
            }
            if (uniformCount > 0 && uniformIndices == 0) {
                GL.recordError(0x501 /* GL_INVALID_VALUE */);
                return;
            }
            program = GL.programs[program];
            var ids = [];
            for (var i = 0; i < uniformCount; i++) {
                ids.push(HEAP32[(((uniformIndices) + (i * 4)) >> 2)]);
            }
            var result = GLctx.getActiveUniforms(program, ids, pname);
            if (!result)
                return; // GL spec: If an error is generated, nothing is written out to params.
            var len = result.length;
            for (var i = 0; i < len; i++) {
                HEAP32[(((params) + (i * 4)) >> 2)] = result[i];
            }
        };
        var _emscripten_glGetActiveUniformsiv = _glGetActiveUniformsiv;
        /** @suppress {duplicate } */
        var _glGetAttachedShaders = (program, maxCount, count, shaders) => {
            var result = GLctx.getAttachedShaders(GL.programs[program]);
            var len = result.length;
            if (len > maxCount) {
                len = maxCount;
            }
            HEAP32[((count) >> 2)] = len;
            for (var i = 0; i < len; ++i) {
                var id = GL.shaders.indexOf(result[i]);
                HEAP32[(((shaders) + (i * 4)) >> 2)] = id;
            }
        };
        var _emscripten_glGetAttachedShaders = _glGetAttachedShaders;
        /** @suppress {duplicate } */
        var _glGetAttribLocation = (program, name) => {
            return GLctx.getAttribLocation(GL.programs[program], UTF8ToString(name));
        };
        var _emscripten_glGetAttribLocation = _glGetAttribLocation;
        var readI53FromI64 = (ptr) => {
            return HEAPU32[((ptr) >> 2)] + HEAP32[(((ptr) + (4)) >> 2)] * 4294967296;
        };
        var readI53FromU64 = (ptr) => {
            return HEAPU32[((ptr) >> 2)] + HEAPU32[(((ptr) + (4)) >> 2)] * 4294967296;
        };
        var writeI53ToI64 = (ptr, num) => {
            HEAPU32[((ptr) >> 2)] = num;
            var lower = HEAPU32[((ptr) >> 2)];
            HEAPU32[(((ptr) + (4)) >> 2)] = (num - lower) / 4294967296;
            var deserialized = (num >= 0) ? readI53FromU64(ptr) : readI53FromI64(ptr);
            var offset = ((ptr) >> 2);
            if (deserialized != num)
                warnOnce(`writeI53ToI64() out of range: serialized JS Number ${num} to Wasm heap as bytes lo=${ptrToString(HEAPU32[offset])}, hi=${ptrToString(HEAPU32[offset + 1])}, which deserializes back to ${deserialized} instead!`);
        };
        var webglGetExtensions = function $webglGetExtensions() {
            var exts = getEmscriptenSupportedExtensions(GLctx);
            exts = exts.concat(exts.map((e) => "GL_" + e));
            return exts;
        };
        var emscriptenWebGLGet = (name_, p, type) => {
            // Guard against user passing a null pointer.
            // Note that GLES2 spec does not say anything about how passing a null
            // pointer should be treated.  Testing on desktop core GL 3, the application
            // crashes on glGetIntegerv to a null pointer, but better to report an error
            // instead of doing anything random.
            if (!p) {
                GL.recordError(0x501 /* GL_INVALID_VALUE */);
                return;
            }
            var ret = undefined;
            switch (name_) { // Handle a few trivial GLES values
                case 0x8DFA: // GL_SHADER_COMPILER
                    ret = 1;
                    break;
                case 0x8DF8: // GL_SHADER_BINARY_FORMATS
                    if (type != 0 && type != 1) {
                        GL.recordError(0x500); // GL_INVALID_ENUM
                    }
                    // Do not write anything to the out pointer, since no binary formats are
                    // supported.
                    return;
                case 0x87FE: // GL_NUM_PROGRAM_BINARY_FORMATS
                case 0x8DF9: // GL_NUM_SHADER_BINARY_FORMATS
                    ret = 0;
                    break;
                case 0x86A2: // GL_NUM_COMPRESSED_TEXTURE_FORMATS
                    // WebGL doesn't have GL_NUM_COMPRESSED_TEXTURE_FORMATS (it's obsolete
                    // since GL_COMPRESSED_TEXTURE_FORMATS returns a JS array that can be
                    // queried for length), so implement it ourselves to allow C++ GLES2
                    // code get the length.
                    var formats = GLctx.getParameter(0x86A3 /*GL_COMPRESSED_TEXTURE_FORMATS*/);
                    ret = formats ? formats.length : 0;
                    break;
                case 0x821D: // GL_NUM_EXTENSIONS
                    if (GL.currentContext.version < 2) {
                        // Calling GLES3/WebGL2 function with a GLES2/WebGL1 context
                        GL.recordError(0x502 /* GL_INVALID_OPERATION */);
                        return;
                    }
                    ret = webglGetExtensions().length;
                    break;
                case 0x821B: // GL_MAJOR_VERSION
                case 0x821C: // GL_MINOR_VERSION
                    if (GL.currentContext.version < 2) {
                        GL.recordError(0x500); // GL_INVALID_ENUM
                        return;
                    }
                    ret = name_ == 0x821B ? 3 : 0; // return version 3.0
                    break;
            }
            if (ret === undefined) {
                var result = GLctx.getParameter(name_);
                switch (typeof result) {
                    case "number":
                        ret = result;
                        break;
                    case "boolean":
                        ret = result ? 1 : 0;
                        break;
                    case "string":
                        GL.recordError(0x500); // GL_INVALID_ENUM
                        return;
                    case "object":
                        if (result === null) {
                            // null is a valid result for some (e.g., which buffer is bound -
                            // perhaps nothing is bound), but otherwise can mean an invalid
                            // name_, which we need to report as an error
                            switch (name_) {
                                case 0x8894: // ARRAY_BUFFER_BINDING
                                case 0x8B8D: // CURRENT_PROGRAM
                                case 0x8895: // ELEMENT_ARRAY_BUFFER_BINDING
                                case 0x8CA6: // FRAMEBUFFER_BINDING or DRAW_FRAMEBUFFER_BINDING
                                case 0x8CA7: // RENDERBUFFER_BINDING
                                case 0x8069: // TEXTURE_BINDING_2D
                                case 0x85B5: // WebGL 2 GL_VERTEX_ARRAY_BINDING, or WebGL 1 extension OES_vertex_array_object GL_VERTEX_ARRAY_BINDING_OES
                                case 0x8F36: // COPY_READ_BUFFER_BINDING or COPY_READ_BUFFER
                                case 0x8F37: // COPY_WRITE_BUFFER_BINDING or COPY_WRITE_BUFFER
                                case 0x88ED: // PIXEL_PACK_BUFFER_BINDING
                                case 0x88EF: // PIXEL_UNPACK_BUFFER_BINDING
                                case 0x8CAA: // READ_FRAMEBUFFER_BINDING
                                case 0x8919: // SAMPLER_BINDING
                                case 0x8C1D: // TEXTURE_BINDING_2D_ARRAY
                                case 0x806A: // TEXTURE_BINDING_3D
                                case 0x8E25: // TRANSFORM_FEEDBACK_BINDING
                                case 0x8C8F: // TRANSFORM_FEEDBACK_BUFFER_BINDING
                                case 0x8A28: // UNIFORM_BUFFER_BINDING
                                case 0x8514: { // TEXTURE_BINDING_CUBE_MAP
                                    ret = 0;
                                    break;
                                }
                                default: {
                                    GL.recordError(0x500); // GL_INVALID_ENUM
                                    return;
                                }
                            }
                        }
                        else if (result instanceof Float32Array ||
                            result instanceof Uint32Array ||
                            result instanceof Int32Array ||
                            result instanceof Array) {
                            for (var i = 0; i < result.length; ++i) {
                                switch (type) {
                                    case 0:
                                        HEAP32[(((p) + (i * 4)) >> 2)] = result[i];
                                        break;
                                    case 2:
                                        HEAPF32[(((p) + (i * 4)) >> 2)] = result[i];
                                        break;
                                    case 4:
                                        HEAP8[(p) + (i)] = result[i] ? 1 : 0;
                                        break;
                                }
                            }
                            return;
                        }
                        else {
                            try {
                                ret = result.name | 0;
                            }
                            catch (e) {
                                GL.recordError(0x500); // GL_INVALID_ENUM
                                err(`GL_INVALID_ENUM in glGet${type}v: Unknown object returned from WebGL getParameter(${name_})! (error: ${e})`);
                                return;
                            }
                        }
                        break;
                    default:
                        GL.recordError(0x500); // GL_INVALID_ENUM
                        err(`GL_INVALID_ENUM in glGet${type}v: Native code calling glGet${type}v(${name_}) and it returns ${result} of type ${typeof (result)}!`);
                        return;
                }
            }
            switch (type) {
                case 1:
                    writeI53ToI64(p, ret);
                    break;
                case 0:
                    HEAP32[((p) >> 2)] = ret;
                    break;
                case 2:
                    HEAPF32[((p) >> 2)] = ret;
                    break;
                case 4:
                    HEAP8[p] = ret ? 1 : 0;
                    break;
            }
        };
        /** @suppress {duplicate } */
        var _glGetBooleanv = (name_, p) => emscriptenWebGLGet(name_, p, 4);
        var _emscripten_glGetBooleanv = _glGetBooleanv;
        /** @suppress {duplicate } */
        var _glGetBufferParameteri64v = (target, value, data) => {
            if (!data) {
                // GLES2 specification does not specify how to behave if data is a null pointer. Since calling this function does not make sense
                // if data == null, issue a GL error to notify user about it.
                GL.recordError(0x501 /* GL_INVALID_VALUE */);
                return;
            }
            writeI53ToI64(data, GLctx.getBufferParameter(target, value));
        };
        var _emscripten_glGetBufferParameteri64v = _glGetBufferParameteri64v;
        /** @suppress {duplicate } */
        var _glGetBufferParameteriv = (target, value, data) => {
            if (!data) {
                // GLES2 specification does not specify how to behave if data is a null
                // pointer. Since calling this function does not make sense if data ==
                // null, issue a GL error to notify user about it.
                GL.recordError(0x501 /* GL_INVALID_VALUE */);
                return;
            }
            HEAP32[((data) >> 2)] = GLctx.getBufferParameter(target, value);
        };
        var _emscripten_glGetBufferParameteriv = _glGetBufferParameteriv;
        /** @suppress {duplicate } */
        var _glGetBufferPointerv = (target, pname, params) => {
            if (pname == 0x88BD /*GL_BUFFER_MAP_POINTER*/) {
                var ptr = 0;
                var mappedBuffer = GL.mappedBuffers[emscriptenWebGLGetBufferBinding(target)];
                if (mappedBuffer) {
                    ptr = mappedBuffer.mem;
                }
                HEAP32[((params) >> 2)] = ptr;
            }
            else {
                GL.recordError(0x500 /*GL_INVALID_ENUM*/);
                err('GL_INVALID_ENUM in glGetBufferPointerv');
            }
        };
        var _emscripten_glGetBufferPointerv = _glGetBufferPointerv;
        /** @suppress {duplicate } */
        var _glGetError = () => {
            var error = GLctx.getError() || GL.lastError;
            GL.lastError = 0 /*GL_NO_ERROR*/;
            return error;
        };
        var _emscripten_glGetError = _glGetError;
        /** @suppress {duplicate } */
        var _glGetFloatv = (name_, p) => emscriptenWebGLGet(name_, p, 2);
        var _emscripten_glGetFloatv = _glGetFloatv;
        /** @suppress {duplicate } */
        var _glGetFragDataLocation = (program, name) => {
            return GLctx.getFragDataLocation(GL.programs[program], UTF8ToString(name));
        };
        var _emscripten_glGetFragDataLocation = _glGetFragDataLocation;
        /** @suppress {duplicate } */
        var _glGetFramebufferAttachmentParameteriv = (target, attachment, pname, params) => {
            var result = GLctx.getFramebufferAttachmentParameter(target, attachment, pname);
            if (result instanceof WebGLRenderbuffer ||
                result instanceof WebGLTexture) {
                result = result.name | 0;
            }
            HEAP32[((params) >> 2)] = result;
        };
        var _emscripten_glGetFramebufferAttachmentParameteriv = _glGetFramebufferAttachmentParameteriv;
        var emscriptenWebGLGetIndexed = (target, index, data, type) => {
            if (!data) {
                // GLES2 specification does not specify how to behave if data is a null pointer. Since calling this function does not make sense
                // if data == null, issue a GL error to notify user about it.
                GL.recordError(0x501 /* GL_INVALID_VALUE */);
                return;
            }
            var result = GLctx.getIndexedParameter(target, index);
            var ret;
            switch (typeof result) {
                case 'boolean':
                    ret = result ? 1 : 0;
                    break;
                case 'number':
                    ret = result;
                    break;
                case 'object':
                    if (result === null) {
                        switch (target) {
                            case 0x8C8F: // TRANSFORM_FEEDBACK_BUFFER_BINDING
                            case 0x8A28: // UNIFORM_BUFFER_BINDING
                                ret = 0;
                                break;
                            default: {
                                GL.recordError(0x500); // GL_INVALID_ENUM
                                return;
                            }
                        }
                    }
                    else if (result instanceof WebGLBuffer) {
                        ret = result.name | 0;
                    }
                    else {
                        GL.recordError(0x500); // GL_INVALID_ENUM
                        return;
                    }
                    break;
                default:
                    GL.recordError(0x500); // GL_INVALID_ENUM
                    return;
            }
            switch (type) {
                case 1:
                    writeI53ToI64(data, ret);
                    break;
                case 0:
                    HEAP32[((data) >> 2)] = ret;
                    break;
                case 2:
                    HEAPF32[((data) >> 2)] = ret;
                    break;
                case 4:
                    HEAP8[data] = ret ? 1 : 0;
                    break;
                default: throw 'internal emscriptenWebGLGetIndexed() error, bad type: ' + type;
            }
        };
        /** @suppress {duplicate } */
        var _glGetInteger64i_v = (target, index, data) => emscriptenWebGLGetIndexed(target, index, data, 1);
        var _emscripten_glGetInteger64i_v = _glGetInteger64i_v;
        /** @suppress {duplicate } */
        var _glGetInteger64v = (name_, p) => {
            emscriptenWebGLGet(name_, p, 1);
        };
        var _emscripten_glGetInteger64v = _glGetInteger64v;
        /** @suppress {duplicate } */
        var _glGetIntegeri_v = (target, index, data) => emscriptenWebGLGetIndexed(target, index, data, 0);
        var _emscripten_glGetIntegeri_v = _glGetIntegeri_v;
        /** @suppress {duplicate } */
        var _glGetIntegerv = (name_, p) => emscriptenWebGLGet(name_, p, 0);
        var _emscripten_glGetIntegerv = _glGetIntegerv;
        /** @suppress {duplicate } */
        var _glGetInternalformativ = (target, internalformat, pname, bufSize, params) => {
            if (bufSize < 0) {
                GL.recordError(0x501 /* GL_INVALID_VALUE */);
                return;
            }
            if (!params) {
                // GLES3 specification does not specify how to behave if values is a null pointer. Since calling this function does not make sense
                // if values == null, issue a GL error to notify user about it.
                GL.recordError(0x501 /* GL_INVALID_VALUE */);
                return;
            }
            var ret = GLctx.getInternalformatParameter(target, internalformat, pname);
            if (ret === null)
                return;
            for (var i = 0; i < ret.length && i < bufSize; ++i) {
                HEAP32[(((params) + (i * 4)) >> 2)] = ret[i];
            }
        };
        var _emscripten_glGetInternalformativ = _glGetInternalformativ;
        /** @suppress {duplicate } */
        var _glGetProgramBinary = (program, bufSize, length, binaryFormat, binary) => {
            GL.recordError(0x502 /*GL_INVALID_OPERATION*/);
        };
        var _emscripten_glGetProgramBinary = _glGetProgramBinary;
        /** @suppress {duplicate } */
        var _glGetProgramInfoLog = (program, maxLength, length, infoLog) => {
            var log = GLctx.getProgramInfoLog(GL.programs[program]);
            if (log === null)
                log = '(unknown error)';
            var numBytesWrittenExclNull = (maxLength > 0 && infoLog) ? stringToUTF8(log, infoLog, maxLength) : 0;
            if (length)
                HEAP32[((length) >> 2)] = numBytesWrittenExclNull;
        };
        var _emscripten_glGetProgramInfoLog = _glGetProgramInfoLog;
        /** @suppress {duplicate } */
        var _glGetProgramiv = (program, pname, p) => {
            if (!p) {
                // GLES2 specification does not specify how to behave if p is a null
                // pointer. Since calling this function does not make sense if p == null,
                // issue a GL error to notify user about it.
                GL.recordError(0x501 /* GL_INVALID_VALUE */);
                return;
            }
            if (program >= GL.counter) {
                GL.recordError(0x501 /* GL_INVALID_VALUE */);
                return;
            }
            program = GL.programs[program];
            if (pname == 0x8B84) { // GL_INFO_LOG_LENGTH
                var log = GLctx.getProgramInfoLog(program);
                if (log === null)
                    log = '(unknown error)';
                HEAP32[((p) >> 2)] = log.length + 1;
            }
            else if (pname == 0x8B87 /* GL_ACTIVE_UNIFORM_MAX_LENGTH */) {
                if (!program.maxUniformLength) {
                    for (var i = 0; i < GLctx.getProgramParameter(program, 0x8B86 /*GL_ACTIVE_UNIFORMS*/); ++i) {
                        program.maxUniformLength = Math.max(program.maxUniformLength, GLctx.getActiveUniform(program, i).name.length + 1);
                    }
                }
                HEAP32[((p) >> 2)] = program.maxUniformLength;
            }
            else if (pname == 0x8B8A /* GL_ACTIVE_ATTRIBUTE_MAX_LENGTH */) {
                if (!program.maxAttributeLength) {
                    for (var i = 0; i < GLctx.getProgramParameter(program, 0x8B89 /*GL_ACTIVE_ATTRIBUTES*/); ++i) {
                        program.maxAttributeLength = Math.max(program.maxAttributeLength, GLctx.getActiveAttrib(program, i).name.length + 1);
                    }
                }
                HEAP32[((p) >> 2)] = program.maxAttributeLength;
            }
            else if (pname == 0x8A35 /* GL_ACTIVE_UNIFORM_BLOCK_MAX_NAME_LENGTH */) {
                if (!program.maxUniformBlockNameLength) {
                    for (var i = 0; i < GLctx.getProgramParameter(program, 0x8A36 /*GL_ACTIVE_UNIFORM_BLOCKS*/); ++i) {
                        program.maxUniformBlockNameLength = Math.max(program.maxUniformBlockNameLength, GLctx.getActiveUniformBlockName(program, i).length + 1);
                    }
                }
                HEAP32[((p) >> 2)] = program.maxUniformBlockNameLength;
            }
            else {
                HEAP32[((p) >> 2)] = GLctx.getProgramParameter(program, pname);
            }
        };
        var _emscripten_glGetProgramiv = _glGetProgramiv;
        /** @suppress {duplicate } */
        var _glGetQueryObjecti64vEXT = (id, pname, params) => {
            if (!params) {
                // GLES2 specification does not specify how to behave if params is a null pointer. Since calling this function does not make sense
                // if p == null, issue a GL error to notify user about it.
                GL.recordError(0x501 /* GL_INVALID_VALUE */);
                return;
            }
            var query = GL.queries[id];
            var param;
            if (GL.currentContext.version < 2) {
                param = GLctx.disjointTimerQueryExt['getQueryObjectEXT'](query, pname);
            }
            else {
                param = GLctx.getQueryParameter(query, pname);
            }
            var ret;
            if (typeof param == 'boolean') {
                ret = param ? 1 : 0;
            }
            else {
                ret = param;
            }
            writeI53ToI64(params, ret);
        };
        var _emscripten_glGetQueryObjecti64vEXT = _glGetQueryObjecti64vEXT;
        /** @suppress {duplicate } */
        var _glGetQueryObjectivEXT = (id, pname, params) => {
            if (!params) {
                // GLES2 specification does not specify how to behave if params is a null pointer. Since calling this function does not make sense
                // if p == null, issue a GL error to notify user about it.
                GL.recordError(0x501 /* GL_INVALID_VALUE */);
                return;
            }
            var query = GL.queries[id];
            var param = GLctx.disjointTimerQueryExt['getQueryObjectEXT'](query, pname);
            var ret;
            if (typeof param == 'boolean') {
                ret = param ? 1 : 0;
            }
            else {
                ret = param;
            }
            HEAP32[((params) >> 2)] = ret;
        };
        var _emscripten_glGetQueryObjectivEXT = _glGetQueryObjectivEXT;
        /** @suppress {duplicate } */
        var _glGetQueryObjectui64vEXT = _glGetQueryObjecti64vEXT;
        var _emscripten_glGetQueryObjectui64vEXT = _glGetQueryObjectui64vEXT;
        /** @suppress {duplicate } */
        var _glGetQueryObjectuiv = (id, pname, params) => {
            if (!params) {
                // GLES2 specification does not specify how to behave if params is a null pointer. Since calling this function does not make sense
                // if p == null, issue a GL error to notify user about it.
                GL.recordError(0x501 /* GL_INVALID_VALUE */);
                return;
            }
            var query = GL.queries[id];
            var param = GLctx.getQueryParameter(query, pname);
            var ret;
            if (typeof param == 'boolean') {
                ret = param ? 1 : 0;
            }
            else {
                ret = param;
            }
            HEAP32[((params) >> 2)] = ret;
        };
        var _emscripten_glGetQueryObjectuiv = _glGetQueryObjectuiv;
        /** @suppress {duplicate } */
        var _glGetQueryObjectuivEXT = _glGetQueryObjectivEXT;
        var _emscripten_glGetQueryObjectuivEXT = _glGetQueryObjectuivEXT;
        /** @suppress {duplicate } */
        var _glGetQueryiv = (target, pname, params) => {
            if (!params) {
                // GLES2 specification does not specify how to behave if params is a null pointer. Since calling this function does not make sense
                // if p == null, issue a GL error to notify user about it.
                GL.recordError(0x501 /* GL_INVALID_VALUE */);
                return;
            }
            HEAP32[((params) >> 2)] = GLctx.getQuery(target, pname);
        };
        var _emscripten_glGetQueryiv = _glGetQueryiv;
        /** @suppress {duplicate } */
        var _glGetQueryivEXT = (target, pname, params) => {
            if (!params) {
                // GLES2 specification does not specify how to behave if params is a null pointer. Since calling this function does not make sense
                // if p == null, issue a GL error to notify user about it.
                GL.recordError(0x501 /* GL_INVALID_VALUE */);
                return;
            }
            HEAP32[((params) >> 2)] = GLctx.disjointTimerQueryExt['getQueryEXT'](target, pname);
        };
        var _emscripten_glGetQueryivEXT = _glGetQueryivEXT;
        /** @suppress {duplicate } */
        var _glGetRenderbufferParameteriv = (target, pname, params) => {
            if (!params) {
                // GLES2 specification does not specify how to behave if params is a null pointer. Since calling this function does not make sense
                // if params == null, issue a GL error to notify user about it.
                GL.recordError(0x501 /* GL_INVALID_VALUE */);
                return;
            }
            HEAP32[((params) >> 2)] = GLctx.getRenderbufferParameter(target, pname);
        };
        var _emscripten_glGetRenderbufferParameteriv = _glGetRenderbufferParameteriv;
        /** @suppress {duplicate } */
        var _glGetSamplerParameterfv = (sampler, pname, params) => {
            if (!params) {
                // GLES3 specification does not specify how to behave if params is a null pointer. Since calling this function does not make sense
                // if p == null, issue a GL error to notify user about it.
                GL.recordError(0x501 /* GL_INVALID_VALUE */);
                return;
            }
            HEAPF32[((params) >> 2)] = GLctx.getSamplerParameter(GL.samplers[sampler], pname);
        };
        var _emscripten_glGetSamplerParameterfv = _glGetSamplerParameterfv;
        /** @suppress {duplicate } */
        var _glGetSamplerParameteriv = (sampler, pname, params) => {
            if (!params) {
                // GLES3 specification does not specify how to behave if params is a null pointer. Since calling this function does not make sense
                // if p == null, issue a GL error to notify user about it.
                GL.recordError(0x501 /* GL_INVALID_VALUE */);
                return;
            }
            HEAP32[((params) >> 2)] = GLctx.getSamplerParameter(GL.samplers[sampler], pname);
        };
        var _emscripten_glGetSamplerParameteriv = _glGetSamplerParameteriv;
        /** @suppress {duplicate } */
        var _glGetShaderInfoLog = (shader, maxLength, length, infoLog) => {
            var log = GLctx.getShaderInfoLog(GL.shaders[shader]);
            if (log === null)
                log = '(unknown error)';
            var numBytesWrittenExclNull = (maxLength > 0 && infoLog) ? stringToUTF8(log, infoLog, maxLength) : 0;
            if (length)
                HEAP32[((length) >> 2)] = numBytesWrittenExclNull;
        };
        var _emscripten_glGetShaderInfoLog = _glGetShaderInfoLog;
        /** @suppress {duplicate } */
        var _glGetShaderPrecisionFormat = (shaderType, precisionType, range, precision) => {
            var result = GLctx.getShaderPrecisionFormat(shaderType, precisionType);
            HEAP32[((range) >> 2)] = result.rangeMin;
            HEAP32[(((range) + (4)) >> 2)] = result.rangeMax;
            HEAP32[((precision) >> 2)] = result.precision;
        };
        var _emscripten_glGetShaderPrecisionFormat = _glGetShaderPrecisionFormat;
        /** @suppress {duplicate } */
        var _glGetShaderSource = (shader, bufSize, length, source) => {
            var result = GLctx.getShaderSource(GL.shaders[shader]);
            if (!result)
                return; // If an error occurs, nothing will be written to length or source.
            var numBytesWrittenExclNull = (bufSize > 0 && source) ? stringToUTF8(result, source, bufSize) : 0;
            if (length)
                HEAP32[((length) >> 2)] = numBytesWrittenExclNull;
        };
        var _emscripten_glGetShaderSource = _glGetShaderSource;
        /** @suppress {duplicate } */
        var _glGetShaderiv = (shader, pname, p) => {
            if (!p) {
                // GLES2 specification does not specify how to behave if p is a null
                // pointer. Since calling this function does not make sense if p == null,
                // issue a GL error to notify user about it.
                GL.recordError(0x501 /* GL_INVALID_VALUE */);
                return;
            }
            if (pname == 0x8B84) { // GL_INFO_LOG_LENGTH
                var log = GLctx.getShaderInfoLog(GL.shaders[shader]);
                if (log === null)
                    log = '(unknown error)';
                // The GLES2 specification says that if the shader has an empty info log,
                // a value of 0 is returned. Otherwise the log has a null char appended.
                // (An empty string is falsey, so we can just check that instead of
                // looking at log.length.)
                var logLength = log ? log.length + 1 : 0;
                HEAP32[((p) >> 2)] = logLength;
            }
            else if (pname == 0x8B88) { // GL_SHADER_SOURCE_LENGTH
                var source = GLctx.getShaderSource(GL.shaders[shader]);
                // source may be a null, or the empty string, both of which are falsey
                // values that we report a 0 length for.
                var sourceLength = source ? source.length + 1 : 0;
                HEAP32[((p) >> 2)] = sourceLength;
            }
            else {
                HEAP32[((p) >> 2)] = GLctx.getShaderParameter(GL.shaders[shader], pname);
            }
        };
        var _emscripten_glGetShaderiv = _glGetShaderiv;
        /** @suppress {duplicate } */
        var _glGetString = (name_) => {
            var ret = GL.stringCache[name_];
            if (!ret) {
                switch (name_) {
                    case 0x1F03 /* GL_EXTENSIONS */:
                        ret = stringToNewUTF8(webglGetExtensions().join(' '));
                        break;
                    case 0x1F00 /* GL_VENDOR */:
                    case 0x1F01 /* GL_RENDERER */:
                    case 0x9245 /* UNMASKED_VENDOR_WEBGL */:
                    case 0x9246 /* UNMASKED_RENDERER_WEBGL */:
                        var s = GLctx.getParameter(name_);
                        if (!s) {
                            GL.recordError(0x500 /*GL_INVALID_ENUM*/);
                        }
                        ret = s ? stringToNewUTF8(s) : 0;
                        break;
                    case 0x1F02 /* GL_VERSION */:
                        var glVersion = GLctx.getParameter(0x1F02 /*GL_VERSION*/);
                        // return GLES version string corresponding to the version of the WebGL context
                        if (GL.currentContext.version >= 2)
                            glVersion = `OpenGL ES 3.0 (${glVersion})`;
                        else {
                            glVersion = `OpenGL ES 2.0 (${glVersion})`;
                        }
                        ret = stringToNewUTF8(glVersion);
                        break;
                    case 0x8B8C /* GL_SHADING_LANGUAGE_VERSION */:
                        var glslVersion = GLctx.getParameter(0x8B8C /*GL_SHADING_LANGUAGE_VERSION*/);
                        // extract the version number 'N.M' from the string 'WebGL GLSL ES N.M ...'
                        var ver_re = /^WebGL GLSL ES ([0-9]\.[0-9][0-9]?)(?:$| .*)/;
                        var ver_num = glslVersion.match(ver_re);
                        if (ver_num !== null) {
                            if (ver_num[1].length == 3)
                                ver_num[1] = ver_num[1] + '0'; // ensure minor version has 2 digits
                            glslVersion = `OpenGL ES GLSL ES ${ver_num[1]} (${glslVersion})`;
                        }
                        ret = stringToNewUTF8(glslVersion);
                        break;
                    default:
                        GL.recordError(0x500 /*GL_INVALID_ENUM*/);
                    // fall through
                }
                GL.stringCache[name_] = ret;
            }
            return ret;
        };
        var _emscripten_glGetString = _glGetString;
        /** @suppress {duplicate } */
        var _glGetStringi = (name, index) => {
            if (GL.currentContext.version < 2) {
                GL.recordError(0x502 /* GL_INVALID_OPERATION */); // Calling GLES3/WebGL2 function with a GLES2/WebGL1 context
                return 0;
            }
            var stringiCache = GL.stringiCache[name];
            if (stringiCache) {
                if (index < 0 || index >= stringiCache.length) {
                    GL.recordError(0x501 /*GL_INVALID_VALUE*/);
                    return 0;
                }
                return stringiCache[index];
            }
            switch (name) {
                case 0x1F03 /* GL_EXTENSIONS */:
                    var exts = webglGetExtensions().map(stringToNewUTF8);
                    stringiCache = GL.stringiCache[name] = exts;
                    if (index < 0 || index >= stringiCache.length) {
                        GL.recordError(0x501 /*GL_INVALID_VALUE*/);
                        return 0;
                    }
                    return stringiCache[index];
                default:
                    GL.recordError(0x500 /*GL_INVALID_ENUM*/);
                    return 0;
            }
        };
        var _emscripten_glGetStringi = _glGetStringi;
        /** @suppress {duplicate } */
        var _glGetSynciv = (sync, pname, bufSize, length, values) => {
            if (bufSize < 0) {
                // GLES3 specification does not specify how to behave if bufSize < 0, however in the spec wording for glGetInternalformativ, it does say that GL_INVALID_VALUE should be raised,
                // so raise GL_INVALID_VALUE here as well.
                GL.recordError(0x501 /* GL_INVALID_VALUE */);
                return;
            }
            if (!values) {
                // GLES3 specification does not specify how to behave if values is a null pointer. Since calling this function does not make sense
                // if values == null, issue a GL error to notify user about it.
                GL.recordError(0x501 /* GL_INVALID_VALUE */);
                return;
            }
            var ret = GLctx.getSyncParameter(GL.syncs[sync], pname);
            if (ret !== null) {
                HEAP32[((values) >> 2)] = ret;
                if (length)
                    HEAP32[((length) >> 2)] = 1; // Report a single value outputted.
            }
        };
        var _emscripten_glGetSynciv = _glGetSynciv;
        /** @suppress {duplicate } */
        var _glGetTexParameterfv = (target, pname, params) => {
            if (!params) {
                // GLES2 specification does not specify how to behave if params is a null
                // pointer. Since calling this function does not make sense if p == null,
                // issue a GL error to notify user about it.
                GL.recordError(0x501 /* GL_INVALID_VALUE */);
                return;
            }
            HEAPF32[((params) >> 2)] = GLctx.getTexParameter(target, pname);
        };
        var _emscripten_glGetTexParameterfv = _glGetTexParameterfv;
        /** @suppress {duplicate } */
        var _glGetTexParameteriv = (target, pname, params) => {
            if (!params) {
                // GLES2 specification does not specify how to behave if params is a null
                // pointer. Since calling this function does not make sense if p == null,
                // issue a GL error to notify user about it.
                GL.recordError(0x501 /* GL_INVALID_VALUE */);
                return;
            }
            HEAP32[((params) >> 2)] = GLctx.getTexParameter(target, pname);
        };
        var _emscripten_glGetTexParameteriv = _glGetTexParameteriv;
        /** @suppress {duplicate } */
        var _glGetTransformFeedbackVarying = (program, index, bufSize, length, size, type, name) => {
            program = GL.programs[program];
            var info = GLctx.getTransformFeedbackVarying(program, index);
            if (!info)
                return; // If an error occurred, the return parameters length, size, type and name will be unmodified.
            if (name && bufSize > 0) {
                var numBytesWrittenExclNull = stringToUTF8(info.name, name, bufSize);
                if (length)
                    HEAP32[((length) >> 2)] = numBytesWrittenExclNull;
            }
            else {
                if (length)
                    HEAP32[((length) >> 2)] = 0;
            }
            if (size)
                HEAP32[((size) >> 2)] = info.size;
            if (type)
                HEAP32[((type) >> 2)] = info.type;
        };
        var _emscripten_glGetTransformFeedbackVarying = _glGetTransformFeedbackVarying;
        /** @suppress {duplicate } */
        var _glGetUniformBlockIndex = (program, uniformBlockName) => {
            return GLctx.getUniformBlockIndex(GL.programs[program], UTF8ToString(uniformBlockName));
        };
        var _emscripten_glGetUniformBlockIndex = _glGetUniformBlockIndex;
        /** @suppress {duplicate } */
        var _glGetUniformIndices = (program, uniformCount, uniformNames, uniformIndices) => {
            if (!uniformIndices) {
                // GLES2 specification does not specify how to behave if uniformIndices is a null pointer. Since calling this function does not make sense
                // if uniformIndices == null, issue a GL error to notify user about it.
                GL.recordError(0x501 /* GL_INVALID_VALUE */);
                return;
            }
            if (uniformCount > 0 && (uniformNames == 0 || uniformIndices == 0)) {
                GL.recordError(0x501 /* GL_INVALID_VALUE */);
                return;
            }
            program = GL.programs[program];
            var names = [];
            for (var i = 0; i < uniformCount; i++)
                names.push(UTF8ToString(HEAP32[(((uniformNames) + (i * 4)) >> 2)]));
            var result = GLctx.getUniformIndices(program, names);
            if (!result)
                return; // GL spec: If an error is generated, nothing is written out to uniformIndices.
            var len = result.length;
            for (var i = 0; i < len; i++) {
                HEAP32[(((uniformIndices) + (i * 4)) >> 2)] = result[i];
            }
        };
        var _emscripten_glGetUniformIndices = _glGetUniformIndices;
        /** @suppress {checkTypes} */
        var jstoi_q = (str) => parseInt(str);
        /** @noinline */
        var webglGetLeftBracePos = (name) => name.slice(-1) == ']' && name.lastIndexOf('[');
        var webglPrepareUniformLocationsBeforeFirstUse = (program) => {
            var uniformLocsById = program.uniformLocsById, // Maps GLuint -> WebGLUniformLocation
            uniformSizeAndIdsByName = program.uniformSizeAndIdsByName, // Maps name -> [uniform array length, GLuint]
            i, j;
            // On the first time invocation of glGetUniformLocation on this shader program:
            // initialize cache data structures and discover which uniforms are arrays.
            if (!uniformLocsById) {
                // maps GLint integer locations to WebGLUniformLocations
                program.uniformLocsById = uniformLocsById = {};
                // maps integer locations back to uniform name strings, so that we can lazily fetch uniform array locations
                program.uniformArrayNamesById = {};
                for (i = 0; i < GLctx.getProgramParameter(program, 0x8B86 /*GL_ACTIVE_UNIFORMS*/); ++i) {
                    var u = GLctx.getActiveUniform(program, i);
                    var nm = u.name;
                    var sz = u.size;
                    var lb = webglGetLeftBracePos(nm);
                    var arrayName = lb > 0 ? nm.slice(0, lb) : nm;
                    // Assign a new location.
                    var id = program.uniformIdCounter;
                    program.uniformIdCounter += sz;
                    // Eagerly get the location of the uniformArray[0] base element.
                    // The remaining indices >0 will be left for lazy evaluation to
                    // improve performance. Those may never be needed to fetch, if the
                    // application fills arrays always in full starting from the first
                    // element of the array.
                    uniformSizeAndIdsByName[arrayName] = [sz, id];
                    // Store placeholder integers in place that highlight that these
                    // >0 index locations are array indices pending population.
                    for (j = 0; j < sz; ++j) {
                        uniformLocsById[id] = j;
                        program.uniformArrayNamesById[id++] = arrayName;
                    }
                }
            }
        };
        /** @suppress {duplicate } */
        var _glGetUniformLocation = (program, name) => {
            name = UTF8ToString(name);
            if (program = GL.programs[program]) {
                webglPrepareUniformLocationsBeforeFirstUse(program);
                var uniformLocsById = program.uniformLocsById; // Maps GLuint -> WebGLUniformLocation
                var arrayIndex = 0;
                var uniformBaseName = name;
                // Invariant: when populating integer IDs for uniform locations, we must
                // maintain the precondition that arrays reside in contiguous addresses,
                // i.e. for a 'vec4 colors[10];', colors[4] must be at location
                // colors[0]+4.  However, user might call glGetUniformLocation(program,
                // "colors") for an array, so we cannot discover based on the user input
                // arguments whether the uniform we are dealing with is an array. The only
                // way to discover which uniforms are arrays is to enumerate over all the
                // active uniforms in the program.
                var leftBrace = webglGetLeftBracePos(name);
                // If user passed an array accessor "[index]", parse the array index off the accessor.
                if (leftBrace > 0) {
                    arrayIndex = jstoi_q(name.slice(leftBrace + 1)) >>> 0; // "index]", coerce parseInt(']') with >>>0 to treat "foo[]" as "foo[0]" and foo[-1] as unsigned out-of-bounds.
                    uniformBaseName = name.slice(0, leftBrace);
                }
                // Have we cached the location of this uniform before?
                // A pair [array length, GLint of the uniform location]
                var sizeAndId = program.uniformSizeAndIdsByName[uniformBaseName];
                // If an uniform with this name exists, and if its index is within the
                // array limits (if it's even an array), query the WebGLlocation, or
                // return an existing cached location.
                if (sizeAndId && arrayIndex < sizeAndId[0]) {
                    arrayIndex += sizeAndId[1]; // Add the base location of the uniform to the array index offset.
                    if ((uniformLocsById[arrayIndex] = uniformLocsById[arrayIndex] || GLctx.getUniformLocation(program, name))) {
                        return arrayIndex;
                    }
                }
            }
            else {
                // N.b. we are currently unable to distinguish between GL program IDs that
                // never existed vs GL program IDs that have been deleted, so report
                // GL_INVALID_VALUE in both cases.
                GL.recordError(0x501 /* GL_INVALID_VALUE */);
            }
            return -1;
        };
        var _emscripten_glGetUniformLocation = _glGetUniformLocation;
        var webglGetUniformLocation = (location) => {
            var p = GLctx.currentProgram;
            if (p) {
                var webglLoc = p.uniformLocsById[location];
                // p.uniformLocsById[location] stores either an integer, or a
                // WebGLUniformLocation.
                // If an integer, we have not yet bound the location, so do it now. The
                // integer value specifies the array index we should bind to.
                if (typeof webglLoc == 'number') {
                    p.uniformLocsById[location] = webglLoc = GLctx.getUniformLocation(p, p.uniformArrayNamesById[location] + (webglLoc > 0 ? `[${webglLoc}]` : ''));
                }
                // Else an already cached WebGLUniformLocation, return it.
                return webglLoc;
            }
            else {
                GL.recordError(0x502 /*GL_INVALID_OPERATION*/);
            }
        };
        /** @suppress{checkTypes} */
        var emscriptenWebGLGetUniform = (program, location, params, type) => {
            if (!params) {
                // GLES2 specification does not specify how to behave if params is a null
                // pointer. Since calling this function does not make sense if params ==
                // null, issue a GL error to notify user about it.
                GL.recordError(0x501 /* GL_INVALID_VALUE */);
                return;
            }
            program = GL.programs[program];
            webglPrepareUniformLocationsBeforeFirstUse(program);
            var data = GLctx.getUniform(program, webglGetUniformLocation(location));
            if (typeof data == 'number' || typeof data == 'boolean') {
                switch (type) {
                    case 0:
                        HEAP32[((params) >> 2)] = data;
                        break;
                    case 2:
                        HEAPF32[((params) >> 2)] = data;
                        break;
                }
            }
            else {
                for (var i = 0; i < data.length; i++) {
                    switch (type) {
                        case 0:
                            HEAP32[(((params) + (i * 4)) >> 2)] = data[i];
                            break;
                        case 2:
                            HEAPF32[(((params) + (i * 4)) >> 2)] = data[i];
                            break;
                    }
                }
            }
        };
        /** @suppress {duplicate } */
        var _glGetUniformfv = (program, location, params) => {
            emscriptenWebGLGetUniform(program, location, params, 2);
        };
        var _emscripten_glGetUniformfv = _glGetUniformfv;
        /** @suppress {duplicate } */
        var _glGetUniformiv = (program, location, params) => {
            emscriptenWebGLGetUniform(program, location, params, 0);
        };
        var _emscripten_glGetUniformiv = _glGetUniformiv;
        /** @suppress {duplicate } */
        var _glGetUniformuiv = (program, location, params) => emscriptenWebGLGetUniform(program, location, params, 0);
        var _emscripten_glGetUniformuiv = _glGetUniformuiv;
        /** @suppress{checkTypes} */
        var emscriptenWebGLGetVertexAttrib = (index, pname, params, type) => {
            if (!params) {
                // GLES2 specification does not specify how to behave if params is a null
                // pointer. Since calling this function does not make sense if params ==
                // null, issue a GL error to notify user about it.
                GL.recordError(0x501 /* GL_INVALID_VALUE */);
                return;
            }
            if (GL.currentContext.clientBuffers[index].enabled) {
                err("glGetVertexAttrib*v on client-side array: not supported, bad data returned");
            }
            var data = GLctx.getVertexAttrib(index, pname);
            if (pname == 0x889F /*VERTEX_ATTRIB_ARRAY_BUFFER_BINDING*/) {
                HEAP32[((params) >> 2)] = data && data["name"];
            }
            else if (typeof data == 'number' || typeof data == 'boolean') {
                switch (type) {
                    case 0:
                        HEAP32[((params) >> 2)] = data;
                        break;
                    case 2:
                        HEAPF32[((params) >> 2)] = data;
                        break;
                    case 5:
                        HEAP32[((params) >> 2)] = Math.fround(data);
                        break;
                }
            }
            else {
                for (var i = 0; i < data.length; i++) {
                    switch (type) {
                        case 0:
                            HEAP32[(((params) + (i * 4)) >> 2)] = data[i];
                            break;
                        case 2:
                            HEAPF32[(((params) + (i * 4)) >> 2)] = data[i];
                            break;
                        case 5:
                            HEAP32[(((params) + (i * 4)) >> 2)] = Math.fround(data[i]);
                            break;
                    }
                }
            }
        };
        /** @suppress {duplicate } */
        var _glGetVertexAttribIiv = (index, pname, params) => {
            // N.B. This function may only be called if the vertex attribute was specified using the function glVertexAttribI4iv(),
            // otherwise the results are undefined. (GLES3 spec 6.1.12)
            emscriptenWebGLGetVertexAttrib(index, pname, params, 0);
        };
        var _emscripten_glGetVertexAttribIiv = _glGetVertexAttribIiv;
        /** @suppress {duplicate } */
        var _glGetVertexAttribIuiv = _glGetVertexAttribIiv;
        var _emscripten_glGetVertexAttribIuiv = _glGetVertexAttribIuiv;
        /** @suppress {duplicate } */
        var _glGetVertexAttribPointerv = (index, pname, pointer) => {
            if (!pointer) {
                // GLES2 specification does not specify how to behave if pointer is a null
                // pointer. Since calling this function does not make sense if pointer ==
                // null, issue a GL error to notify user about it.
                GL.recordError(0x501 /* GL_INVALID_VALUE */);
                return;
            }
            if (GL.currentContext.clientBuffers[index].enabled) {
                err("glGetVertexAttribPointer on client-side array: not supported, bad data returned");
            }
            HEAP32[((pointer) >> 2)] = GLctx.getVertexAttribOffset(index, pname);
        };
        var _emscripten_glGetVertexAttribPointerv = _glGetVertexAttribPointerv;
        /** @suppress {duplicate } */
        var _glGetVertexAttribfv = (index, pname, params) => {
            // N.B. This function may only be called if the vertex attribute was
            // specified using the function glVertexAttrib*f(), otherwise the results
            // are undefined. (GLES3 spec 6.1.12)
            emscriptenWebGLGetVertexAttrib(index, pname, params, 2);
        };
        var _emscripten_glGetVertexAttribfv = _glGetVertexAttribfv;
        /** @suppress {duplicate } */
        var _glGetVertexAttribiv = (index, pname, params) => {
            // N.B. This function may only be called if the vertex attribute was
            // specified using the function glVertexAttrib*f(), otherwise the results
            // are undefined. (GLES3 spec 6.1.12)
            emscriptenWebGLGetVertexAttrib(index, pname, params, 5);
        };
        var _emscripten_glGetVertexAttribiv = _glGetVertexAttribiv;
        /** @suppress {duplicate } */
        var _glHint = (x0, x1) => GLctx.hint(x0, x1);
        var _emscripten_glHint = _glHint;
        /** @suppress {duplicate } */
        var _glInvalidateFramebuffer = (target, numAttachments, attachments) => {
            var list = tempFixedLengthArray[numAttachments];
            for (var i = 0; i < numAttachments; i++) {
                list[i] = HEAP32[(((attachments) + (i * 4)) >> 2)];
            }
            GLctx.invalidateFramebuffer(target, list);
        };
        var _emscripten_glInvalidateFramebuffer = _glInvalidateFramebuffer;
        /** @suppress {duplicate } */
        var _glInvalidateSubFramebuffer = (target, numAttachments, attachments, x, y, width, height) => {
            var list = tempFixedLengthArray[numAttachments];
            for (var i = 0; i < numAttachments; i++) {
                list[i] = HEAP32[(((attachments) + (i * 4)) >> 2)];
            }
            GLctx.invalidateSubFramebuffer(target, list, x, y, width, height);
        };
        var _emscripten_glInvalidateSubFramebuffer = _glInvalidateSubFramebuffer;
        /** @suppress {duplicate } */
        var _glIsBuffer = (buffer) => {
            var b = GL.buffers[buffer];
            if (!b)
                return 0;
            return GLctx.isBuffer(b);
        };
        var _emscripten_glIsBuffer = _glIsBuffer;
        /** @suppress {duplicate } */
        var _glIsEnabled = (x0) => GLctx.isEnabled(x0);
        var _emscripten_glIsEnabled = _glIsEnabled;
        /** @suppress {duplicate } */
        var _glIsFramebuffer = (framebuffer) => {
            var fb = GL.framebuffers[framebuffer];
            if (!fb)
                return 0;
            return GLctx.isFramebuffer(fb);
        };
        var _emscripten_glIsFramebuffer = _glIsFramebuffer;
        /** @suppress {duplicate } */
        var _glIsProgram = (program) => {
            program = GL.programs[program];
            if (!program)
                return 0;
            return GLctx.isProgram(program);
        };
        var _emscripten_glIsProgram = _glIsProgram;
        /** @suppress {duplicate } */
        var _glIsQuery = (id) => {
            var query = GL.queries[id];
            if (!query)
                return 0;
            return GLctx.isQuery(query);
        };
        var _emscripten_glIsQuery = _glIsQuery;
        /** @suppress {duplicate } */
        var _glIsQueryEXT = (id) => {
            var query = GL.queries[id];
            if (!query)
                return 0;
            return GLctx.disjointTimerQueryExt['isQueryEXT'](query);
        };
        var _emscripten_glIsQueryEXT = _glIsQueryEXT;
        /** @suppress {duplicate } */
        var _glIsRenderbuffer = (renderbuffer) => {
            var rb = GL.renderbuffers[renderbuffer];
            if (!rb)
                return 0;
            return GLctx.isRenderbuffer(rb);
        };
        var _emscripten_glIsRenderbuffer = _glIsRenderbuffer;
        /** @suppress {duplicate } */
        var _glIsSampler = (id) => {
            var sampler = GL.samplers[id];
            if (!sampler)
                return 0;
            return GLctx.isSampler(sampler);
        };
        var _emscripten_glIsSampler = _glIsSampler;
        /** @suppress {duplicate } */
        var _glIsShader = (shader) => {
            var s = GL.shaders[shader];
            if (!s)
                return 0;
            return GLctx.isShader(s);
        };
        var _emscripten_glIsShader = _glIsShader;
        /** @suppress {duplicate } */
        var _glIsSync = (sync) => GLctx.isSync(GL.syncs[sync]);
        var _emscripten_glIsSync = _glIsSync;
        /** @suppress {duplicate } */
        var _glIsTexture = (id) => {
            var texture = GL.textures[id];
            if (!texture)
                return 0;
            return GLctx.isTexture(texture);
        };
        var _emscripten_glIsTexture = _glIsTexture;
        /** @suppress {duplicate } */
        var _glIsTransformFeedback = (id) => GLctx.isTransformFeedback(GL.transformFeedbacks[id]);
        var _emscripten_glIsTransformFeedback = _glIsTransformFeedback;
        /** @suppress {duplicate } */
        var _glIsVertexArray = (array) => {
            var vao = GL.vaos[array];
            if (!vao)
                return 0;
            return GLctx.isVertexArray(vao);
        };
        var _emscripten_glIsVertexArray = _glIsVertexArray;
        /** @suppress {duplicate } */
        var _glIsVertexArrayOES = _glIsVertexArray;
        var _emscripten_glIsVertexArrayOES = _glIsVertexArrayOES;
        /** @suppress {duplicate } */
        var _glLineWidth = (x0) => GLctx.lineWidth(x0);
        var _emscripten_glLineWidth = _glLineWidth;
        /** @suppress {duplicate } */
        var _glLinkProgram = (program) => {
            program = GL.programs[program];
            GLctx.linkProgram(program);
            // Invalidate earlier computed uniform->ID mappings, those have now become stale
            program.uniformLocsById = 0; // Mark as null-like so that glGetUniformLocation() knows to populate this again.
            program.uniformSizeAndIdsByName = {};
        };
        var _emscripten_glLinkProgram = _glLinkProgram;
        /** @suppress {duplicate } */
        var _glMapBufferRange = (target, offset, length, access) => {
            if ((access & (0x1 /*GL_MAP_READ_BIT*/ | 0x20 /*GL_MAP_UNSYNCHRONIZED_BIT*/)) != 0) {
                err("glMapBufferRange access does not support MAP_READ or MAP_UNSYNCHRONIZED");
                return 0;
            }
            if ((access & 0x2 /*GL_MAP_WRITE_BIT*/) == 0) {
                err("glMapBufferRange access must include MAP_WRITE");
                return 0;
            }
            if ((access & (0x4 /*GL_MAP_INVALIDATE_BUFFER_BIT*/ | 0x8 /*GL_MAP_INVALIDATE_RANGE_BIT*/)) == 0) {
                err("glMapBufferRange access must include INVALIDATE_BUFFER or INVALIDATE_RANGE");
                return 0;
            }
            if (!emscriptenWebGLValidateMapBufferTarget(target)) {
                GL.recordError(0x500 /*GL_INVALID_ENUM*/);
                err('GL_INVALID_ENUM in glMapBufferRange');
                return 0;
            }
            var mem = _malloc(length), binding = emscriptenWebGLGetBufferBinding(target);
            if (!mem)
                return 0;
            if (!GL.mappedBuffers[binding])
                GL.mappedBuffers[binding] = {};
            binding = GL.mappedBuffers[binding];
            binding.offset = offset;
            binding.length = length;
            binding.mem = mem;
            binding.access = access;
            return mem;
        };
        var _emscripten_glMapBufferRange = _glMapBufferRange;
        /** @suppress {duplicate } */
        var _glPauseTransformFeedback = () => GLctx.pauseTransformFeedback();
        var _emscripten_glPauseTransformFeedback = _glPauseTransformFeedback;
        /** @suppress {duplicate } */
        var _glPixelStorei = (pname, param) => {
            if (pname == 3317) {
                GL.unpackAlignment = param;
            }
            else if (pname == 3314) {
                GL.unpackRowLength = param;
            }
            GLctx.pixelStorei(pname, param);
        };
        var _emscripten_glPixelStorei = _glPixelStorei;
        /** @suppress {duplicate } */
        var _glPolygonOffset = (x0, x1) => GLctx.polygonOffset(x0, x1);
        var _emscripten_glPolygonOffset = _glPolygonOffset;
        /** @suppress {duplicate } */
        var _glProgramBinary = (program, binaryFormat, binary, length) => {
            GL.recordError(0x500 /*GL_INVALID_ENUM*/);
        };
        var _emscripten_glProgramBinary = _glProgramBinary;
        /** @suppress {duplicate } */
        var _glProgramParameteri = (program, pname, value) => {
            GL.recordError(0x500 /*GL_INVALID_ENUM*/);
        };
        var _emscripten_glProgramParameteri = _glProgramParameteri;
        /** @suppress {duplicate } */
        var _glQueryCounterEXT = (id, target) => {
            GLctx.disjointTimerQueryExt['queryCounterEXT'](GL.queries[id], target);
        };
        var _emscripten_glQueryCounterEXT = _glQueryCounterEXT;
        /** @suppress {duplicate } */
        var _glReadBuffer = (x0) => GLctx.readBuffer(x0);
        var _emscripten_glReadBuffer = _glReadBuffer;
        var computeUnpackAlignedImageSize = (width, height, sizePerPixel) => {
            function roundedToNextMultipleOf(x, y) {
                return (x + y - 1) & -y;
            }
            var plainRowSize = (GL.unpackRowLength || width) * sizePerPixel;
            var alignedRowSize = roundedToNextMultipleOf(plainRowSize, GL.unpackAlignment);
            return height * alignedRowSize;
        };
        var colorChannelsInGlTextureFormat = (format) => {
            // Micro-optimizations for size: map format to size by subtracting smallest
            // enum value (0x1902) from all values first.  Also omit the most common
            // size value (1) from the list, which is assumed by formats not on the
            // list.
            var colorChannels = {
                // 0x1902 /* GL_DEPTH_COMPONENT */ - 0x1902: 1,
                // 0x1906 /* GL_ALPHA */ - 0x1902: 1,
                5: 3,
                6: 4,
                // 0x1909 /* GL_LUMINANCE */ - 0x1902: 1,
                8: 2,
                29502: 3,
                29504: 4,
                // 0x1903 /* GL_RED */ - 0x1902: 1,
                26917: 2,
                26918: 2,
                // 0x8D94 /* GL_RED_INTEGER */ - 0x1902: 1,
                29846: 3,
                29847: 4
            };
            return colorChannels[format - 0x1902] || 1;
        };
        var heapObjectForWebGLType = (type) => {
            // Micro-optimization for size: Subtract lowest GL enum number (0x1400/* GL_BYTE */) from type to compare
            // smaller values for the heap, for shorter generated code size.
            // Also the type HEAPU16 is not tested for explicitly, but any unrecognized type will return out HEAPU16.
            // (since most types are HEAPU16)
            type -= 0x1400;
            if (type == 0)
                return HEAP8;
            if (type == 1)
                return HEAPU8;
            if (type == 2)
                return HEAP16;
            if (type == 4)
                return HEAP32;
            if (type == 6)
                return HEAPF32;
            if (type == 5
                || type == 28922
                || type == 28520
                || type == 30779
                || type == 30782)
                return HEAPU32;
            return HEAPU16;
        };
        var toTypedArrayIndex = (pointer, heap) => pointer >>> (31 - Math.clz32(heap.BYTES_PER_ELEMENT));
        var emscriptenWebGLGetTexPixelData = (type, format, width, height, pixels, internalFormat) => {
            var heap = heapObjectForWebGLType(type);
            var sizePerPixel = colorChannelsInGlTextureFormat(format) * heap.BYTES_PER_ELEMENT;
            var bytes = computeUnpackAlignedImageSize(width, height, sizePerPixel);
            return heap.subarray(toTypedArrayIndex(pixels, heap), toTypedArrayIndex(pixels + bytes, heap));
        };
        /** @suppress {duplicate } */
        var _glReadPixels = (x, y, width, height, format, type, pixels) => {
            if (GL.currentContext.version >= 2) {
                if (GLctx.currentPixelPackBufferBinding) {
                    GLctx.readPixels(x, y, width, height, format, type, pixels);
                    return;
                }
                var heap = heapObjectForWebGLType(type);
                var target = toTypedArrayIndex(pixels, heap);
                GLctx.readPixels(x, y, width, height, format, type, heap, target);
                return;
            }
            var pixelData = emscriptenWebGLGetTexPixelData(type, format, width, height, pixels, format);
            if (!pixelData) {
                GL.recordError(0x500 /*GL_INVALID_ENUM*/);
                return;
            }
            GLctx.readPixels(x, y, width, height, format, type, pixelData);
        };
        var _emscripten_glReadPixels = _glReadPixels;
        /** @suppress {duplicate } */
        var _glReleaseShaderCompiler = () => {
            // NOP (as allowed by GLES 2.0 spec)
        };
        var _emscripten_glReleaseShaderCompiler = _glReleaseShaderCompiler;
        /** @suppress {duplicate } */
        var _glRenderbufferStorage = (x0, x1, x2, x3) => GLctx.renderbufferStorage(x0, x1, x2, x3);
        var _emscripten_glRenderbufferStorage = _glRenderbufferStorage;
        /** @suppress {duplicate } */
        var _glRenderbufferStorageMultisample = (x0, x1, x2, x3, x4) => GLctx.renderbufferStorageMultisample(x0, x1, x2, x3, x4);
        var _emscripten_glRenderbufferStorageMultisample = _glRenderbufferStorageMultisample;
        /** @suppress {duplicate } */
        var _glResumeTransformFeedback = () => GLctx.resumeTransformFeedback();
        var _emscripten_glResumeTransformFeedback = _glResumeTransformFeedback;
        /** @suppress {duplicate } */
        var _glSampleCoverage = (value, invert) => {
            GLctx.sampleCoverage(value, !!invert);
        };
        var _emscripten_glSampleCoverage = _glSampleCoverage;
        /** @suppress {duplicate } */
        var _glSamplerParameterf = (sampler, pname, param) => {
            GLctx.samplerParameterf(GL.samplers[sampler], pname, param);
        };
        var _emscripten_glSamplerParameterf = _glSamplerParameterf;
        /** @suppress {duplicate } */
        var _glSamplerParameterfv = (sampler, pname, params) => {
            var param = HEAPF32[((params) >> 2)];
            GLctx.samplerParameterf(GL.samplers[sampler], pname, param);
        };
        var _emscripten_glSamplerParameterfv = _glSamplerParameterfv;
        /** @suppress {duplicate } */
        var _glSamplerParameteri = (sampler, pname, param) => {
            GLctx.samplerParameteri(GL.samplers[sampler], pname, param);
        };
        var _emscripten_glSamplerParameteri = _glSamplerParameteri;
        /** @suppress {duplicate } */
        var _glSamplerParameteriv = (sampler, pname, params) => {
            var param = HEAP32[((params) >> 2)];
            GLctx.samplerParameteri(GL.samplers[sampler], pname, param);
        };
        var _emscripten_glSamplerParameteriv = _glSamplerParameteriv;
        /** @suppress {duplicate } */
        var _glScissor = (x0, x1, x2, x3) => GLctx.scissor(x0, x1, x2, x3);
        var _emscripten_glScissor = _glScissor;
        /** @suppress {duplicate } */
        var _glShaderBinary = (count, shaders, binaryformat, binary, length) => {
            GL.recordError(0x500 /*GL_INVALID_ENUM*/);
        };
        var _emscripten_glShaderBinary = _glShaderBinary;
        /** @suppress {duplicate } */
        var _glShaderSource = (shader, count, string, length) => {
            var source = GL.getSource(shader, count, string, length);
            GLctx.shaderSource(GL.shaders[shader], source);
        };
        var _emscripten_glShaderSource = _glShaderSource;
        /** @suppress {duplicate } */
        var _glStencilFunc = (x0, x1, x2) => GLctx.stencilFunc(x0, x1, x2);
        var _emscripten_glStencilFunc = _glStencilFunc;
        /** @suppress {duplicate } */
        var _glStencilFuncSeparate = (x0, x1, x2, x3) => GLctx.stencilFuncSeparate(x0, x1, x2, x3);
        var _emscripten_glStencilFuncSeparate = _glStencilFuncSeparate;
        /** @suppress {duplicate } */
        var _glStencilMask = (x0) => GLctx.stencilMask(x0);
        var _emscripten_glStencilMask = _glStencilMask;
        /** @suppress {duplicate } */
        var _glStencilMaskSeparate = (x0, x1) => GLctx.stencilMaskSeparate(x0, x1);
        var _emscripten_glStencilMaskSeparate = _glStencilMaskSeparate;
        /** @suppress {duplicate } */
        var _glStencilOp = (x0, x1, x2) => GLctx.stencilOp(x0, x1, x2);
        var _emscripten_glStencilOp = _glStencilOp;
        /** @suppress {duplicate } */
        var _glStencilOpSeparate = (x0, x1, x2, x3) => GLctx.stencilOpSeparate(x0, x1, x2, x3);
        var _emscripten_glStencilOpSeparate = _glStencilOpSeparate;
        /** @suppress {duplicate } */
        var _glTexImage2D = (target, level, internalFormat, width, height, border, format, type, pixels) => {
            if (GL.currentContext.version >= 2) {
                if (GLctx.currentPixelUnpackBufferBinding) {
                    GLctx.texImage2D(target, level, internalFormat, width, height, border, format, type, pixels);
                    return;
                }
                if (pixels) {
                    var heap = heapObjectForWebGLType(type);
                    var index = toTypedArrayIndex(pixels, heap);
                    GLctx.texImage2D(target, level, internalFormat, width, height, border, format, type, heap, index);
                    return;
                }
            }
            var pixelData = pixels ? emscriptenWebGLGetTexPixelData(type, format, width, height, pixels, internalFormat) : null;
            GLctx.texImage2D(target, level, internalFormat, width, height, border, format, type, pixelData);
        };
        var _emscripten_glTexImage2D = _glTexImage2D;
        /** @suppress {duplicate } */
        var _glTexImage3D = (target, level, internalFormat, width, height, depth, border, format, type, pixels) => {
            if (GLctx.currentPixelUnpackBufferBinding) {
                GLctx.texImage3D(target, level, internalFormat, width, height, depth, border, format, type, pixels);
            }
            else if (pixels) {
                var heap = heapObjectForWebGLType(type);
                GLctx.texImage3D(target, level, internalFormat, width, height, depth, border, format, type, heap, toTypedArrayIndex(pixels, heap));
            }
            else {
                GLctx.texImage3D(target, level, internalFormat, width, height, depth, border, format, type, null);
            }
        };
        var _emscripten_glTexImage3D = _glTexImage3D;
        /** @suppress {duplicate } */
        var _glTexParameterf = (x0, x1, x2) => GLctx.texParameterf(x0, x1, x2);
        var _emscripten_glTexParameterf = _glTexParameterf;
        /** @suppress {duplicate } */
        var _glTexParameterfv = (target, pname, params) => {
            var param = HEAPF32[((params) >> 2)];
            GLctx.texParameterf(target, pname, param);
        };
        var _emscripten_glTexParameterfv = _glTexParameterfv;
        /** @suppress {duplicate } */
        var _glTexParameteri = (x0, x1, x2) => GLctx.texParameteri(x0, x1, x2);
        var _emscripten_glTexParameteri = _glTexParameteri;
        /** @suppress {duplicate } */
        var _glTexParameteriv = (target, pname, params) => {
            var param = HEAP32[((params) >> 2)];
            GLctx.texParameteri(target, pname, param);
        };
        var _emscripten_glTexParameteriv = _glTexParameteriv;
        /** @suppress {duplicate } */
        var _glTexStorage2D = (x0, x1, x2, x3, x4) => GLctx.texStorage2D(x0, x1, x2, x3, x4);
        var _emscripten_glTexStorage2D = _glTexStorage2D;
        /** @suppress {duplicate } */
        var _glTexStorage3D = (x0, x1, x2, x3, x4, x5) => GLctx.texStorage3D(x0, x1, x2, x3, x4, x5);
        var _emscripten_glTexStorage3D = _glTexStorage3D;
        /** @suppress {duplicate } */
        var _glTexSubImage2D = (target, level, xoffset, yoffset, width, height, format, type, pixels) => {
            if (GL.currentContext.version >= 2) {
                if (GLctx.currentPixelUnpackBufferBinding) {
                    GLctx.texSubImage2D(target, level, xoffset, yoffset, width, height, format, type, pixels);
                    return;
                }
                if (pixels) {
                    var heap = heapObjectForWebGLType(type);
                    GLctx.texSubImage2D(target, level, xoffset, yoffset, width, height, format, type, heap, toTypedArrayIndex(pixels, heap));
                    return;
                }
            }
            var pixelData = pixels ? emscriptenWebGLGetTexPixelData(type, format, width, height, pixels, 0) : null;
            GLctx.texSubImage2D(target, level, xoffset, yoffset, width, height, format, type, pixelData);
        };
        var _emscripten_glTexSubImage2D = _glTexSubImage2D;
        /** @suppress {duplicate } */
        var _glTexSubImage3D = (target, level, xoffset, yoffset, zoffset, width, height, depth, format, type, pixels) => {
            if (GLctx.currentPixelUnpackBufferBinding) {
                GLctx.texSubImage3D(target, level, xoffset, yoffset, zoffset, width, height, depth, format, type, pixels);
            }
            else if (pixels) {
                var heap = heapObjectForWebGLType(type);
                GLctx.texSubImage3D(target, level, xoffset, yoffset, zoffset, width, height, depth, format, type, heap, toTypedArrayIndex(pixels, heap));
            }
            else {
                GLctx.texSubImage3D(target, level, xoffset, yoffset, zoffset, width, height, depth, format, type, null);
            }
        };
        var _emscripten_glTexSubImage3D = _glTexSubImage3D;
        /** @suppress {duplicate } */
        var _glTransformFeedbackVaryings = (program, count, varyings, bufferMode) => {
            program = GL.programs[program];
            var vars = [];
            for (var i = 0; i < count; i++)
                vars.push(UTF8ToString(HEAP32[(((varyings) + (i * 4)) >> 2)]));
            GLctx.transformFeedbackVaryings(program, vars, bufferMode);
        };
        var _emscripten_glTransformFeedbackVaryings = _glTransformFeedbackVaryings;
        /** @suppress {duplicate } */
        var _glUniform1f = (location, v0) => {
            GLctx.uniform1f(webglGetUniformLocation(location), v0);
        };
        var _emscripten_glUniform1f = _glUniform1f;
        var miniTempWebGLFloatBuffers = [];
        /** @suppress {duplicate } */
        var _glUniform1fv = (location, count, value) => {
            if (GL.currentContext.version >= 2) {
                count && GLctx.uniform1fv(webglGetUniformLocation(location), HEAPF32, ((value) >> 2), count);
                return;
            }
            if (count <= 288) {
                // avoid allocation when uploading few enough uniforms
                var view = miniTempWebGLFloatBuffers[count];
                for (var i = 0; i < count; ++i) {
                    view[i] = HEAPF32[(((value) + (4 * i)) >> 2)];
                }
            }
            else {
                var view = HEAPF32.subarray((((value) >> 2)), ((value + count * 4) >> 2));
            }
            GLctx.uniform1fv(webglGetUniformLocation(location), view);
        };
        var _emscripten_glUniform1fv = _glUniform1fv;
        /** @suppress {duplicate } */
        var _glUniform1i = (location, v0) => {
            GLctx.uniform1i(webglGetUniformLocation(location), v0);
        };
        var _emscripten_glUniform1i = _glUniform1i;
        var miniTempWebGLIntBuffers = [];
        /** @suppress {duplicate } */
        var _glUniform1iv = (location, count, value) => {
            if (GL.currentContext.version >= 2) {
                count && GLctx.uniform1iv(webglGetUniformLocation(location), HEAP32, ((value) >> 2), count);
                return;
            }
            if (count <= 288) {
                // avoid allocation when uploading few enough uniforms
                var view = miniTempWebGLIntBuffers[count];
                for (var i = 0; i < count; ++i) {
                    view[i] = HEAP32[(((value) + (4 * i)) >> 2)];
                }
            }
            else {
                var view = HEAP32.subarray((((value) >> 2)), ((value + count * 4) >> 2));
            }
            GLctx.uniform1iv(webglGetUniformLocation(location), view);
        };
        var _emscripten_glUniform1iv = _glUniform1iv;
        /** @suppress {duplicate } */
        var _glUniform1ui = (location, v0) => {
            GLctx.uniform1ui(webglGetUniformLocation(location), v0);
        };
        var _emscripten_glUniform1ui = _glUniform1ui;
        /** @suppress {duplicate } */
        var _glUniform1uiv = (location, count, value) => {
            count && GLctx.uniform1uiv(webglGetUniformLocation(location), HEAPU32, ((value) >> 2), count);
        };
        var _emscripten_glUniform1uiv = _glUniform1uiv;
        /** @suppress {duplicate } */
        var _glUniform2f = (location, v0, v1) => {
            GLctx.uniform2f(webglGetUniformLocation(location), v0, v1);
        };
        var _emscripten_glUniform2f = _glUniform2f;
        /** @suppress {duplicate } */
        var _glUniform2fv = (location, count, value) => {
            if (GL.currentContext.version >= 2) {
                count && GLctx.uniform2fv(webglGetUniformLocation(location), HEAPF32, ((value) >> 2), count * 2);
                return;
            }
            if (count <= 144) {
                // avoid allocation when uploading few enough uniforms
                var view = miniTempWebGLFloatBuffers[2 * count];
                for (var i = 0; i < 2 * count; i += 2) {
                    view[i] = HEAPF32[(((value) + (4 * i)) >> 2)];
                    view[i + 1] = HEAPF32[(((value) + (4 * i + 4)) >> 2)];
                }
            }
            else {
                var view = HEAPF32.subarray((((value) >> 2)), ((value + count * 8) >> 2));
            }
            GLctx.uniform2fv(webglGetUniformLocation(location), view);
        };
        var _emscripten_glUniform2fv = _glUniform2fv;
        /** @suppress {duplicate } */
        var _glUniform2i = (location, v0, v1) => {
            GLctx.uniform2i(webglGetUniformLocation(location), v0, v1);
        };
        var _emscripten_glUniform2i = _glUniform2i;
        /** @suppress {duplicate } */
        var _glUniform2iv = (location, count, value) => {
            if (GL.currentContext.version >= 2) {
                count && GLctx.uniform2iv(webglGetUniformLocation(location), HEAP32, ((value) >> 2), count * 2);
                return;
            }
            if (count <= 144) {
                // avoid allocation when uploading few enough uniforms
                var view = miniTempWebGLIntBuffers[2 * count];
                for (var i = 0; i < 2 * count; i += 2) {
                    view[i] = HEAP32[(((value) + (4 * i)) >> 2)];
                    view[i + 1] = HEAP32[(((value) + (4 * i + 4)) >> 2)];
                }
            }
            else {
                var view = HEAP32.subarray((((value) >> 2)), ((value + count * 8) >> 2));
            }
            GLctx.uniform2iv(webglGetUniformLocation(location), view);
        };
        var _emscripten_glUniform2iv = _glUniform2iv;
        /** @suppress {duplicate } */
        var _glUniform2ui = (location, v0, v1) => {
            GLctx.uniform2ui(webglGetUniformLocation(location), v0, v1);
        };
        var _emscripten_glUniform2ui = _glUniform2ui;
        /** @suppress {duplicate } */
        var _glUniform2uiv = (location, count, value) => {
            count && GLctx.uniform2uiv(webglGetUniformLocation(location), HEAPU32, ((value) >> 2), count * 2);
        };
        var _emscripten_glUniform2uiv = _glUniform2uiv;
        /** @suppress {duplicate } */
        var _glUniform3f = (location, v0, v1, v2) => {
            GLctx.uniform3f(webglGetUniformLocation(location), v0, v1, v2);
        };
        var _emscripten_glUniform3f = _glUniform3f;
        /** @suppress {duplicate } */
        var _glUniform3fv = (location, count, value) => {
            if (GL.currentContext.version >= 2) {
                count && GLctx.uniform3fv(webglGetUniformLocation(location), HEAPF32, ((value) >> 2), count * 3);
                return;
            }
            if (count <= 96) {
                // avoid allocation when uploading few enough uniforms
                var view = miniTempWebGLFloatBuffers[3 * count];
                for (var i = 0; i < 3 * count; i += 3) {
                    view[i] = HEAPF32[(((value) + (4 * i)) >> 2)];
                    view[i + 1] = HEAPF32[(((value) + (4 * i + 4)) >> 2)];
                    view[i + 2] = HEAPF32[(((value) + (4 * i + 8)) >> 2)];
                }
            }
            else {
                var view = HEAPF32.subarray((((value) >> 2)), ((value + count * 12) >> 2));
            }
            GLctx.uniform3fv(webglGetUniformLocation(location), view);
        };
        var _emscripten_glUniform3fv = _glUniform3fv;
        /** @suppress {duplicate } */
        var _glUniform3i = (location, v0, v1, v2) => {
            GLctx.uniform3i(webglGetUniformLocation(location), v0, v1, v2);
        };
        var _emscripten_glUniform3i = _glUniform3i;
        /** @suppress {duplicate } */
        var _glUniform3iv = (location, count, value) => {
            if (GL.currentContext.version >= 2) {
                count && GLctx.uniform3iv(webglGetUniformLocation(location), HEAP32, ((value) >> 2), count * 3);
                return;
            }
            if (count <= 96) {
                // avoid allocation when uploading few enough uniforms
                var view = miniTempWebGLIntBuffers[3 * count];
                for (var i = 0; i < 3 * count; i += 3) {
                    view[i] = HEAP32[(((value) + (4 * i)) >> 2)];
                    view[i + 1] = HEAP32[(((value) + (4 * i + 4)) >> 2)];
                    view[i + 2] = HEAP32[(((value) + (4 * i + 8)) >> 2)];
                }
            }
            else {
                var view = HEAP32.subarray((((value) >> 2)), ((value + count * 12) >> 2));
            }
            GLctx.uniform3iv(webglGetUniformLocation(location), view);
        };
        var _emscripten_glUniform3iv = _glUniform3iv;
        /** @suppress {duplicate } */
        var _glUniform3ui = (location, v0, v1, v2) => {
            GLctx.uniform3ui(webglGetUniformLocation(location), v0, v1, v2);
        };
        var _emscripten_glUniform3ui = _glUniform3ui;
        /** @suppress {duplicate } */
        var _glUniform3uiv = (location, count, value) => {
            count && GLctx.uniform3uiv(webglGetUniformLocation(location), HEAPU32, ((value) >> 2), count * 3);
        };
        var _emscripten_glUniform3uiv = _glUniform3uiv;
        /** @suppress {duplicate } */
        var _glUniform4f = (location, v0, v1, v2, v3) => {
            GLctx.uniform4f(webglGetUniformLocation(location), v0, v1, v2, v3);
        };
        var _emscripten_glUniform4f = _glUniform4f;
        /** @suppress {duplicate } */
        var _glUniform4fv = (location, count, value) => {
            if (GL.currentContext.version >= 2) {
                count && GLctx.uniform4fv(webglGetUniformLocation(location), HEAPF32, ((value) >> 2), count * 4);
                return;
            }
            if (count <= 72) {
                // avoid allocation when uploading few enough uniforms
                var view = miniTempWebGLFloatBuffers[4 * count];
                // hoist the heap out of the loop for size and for pthreads+growth.
                var heap = HEAPF32;
                value = ((value) >> 2);
                for (var i = 0; i < 4 * count; i += 4) {
                    var dst = value + i;
                    view[i] = heap[dst];
                    view[i + 1] = heap[dst + 1];
                    view[i + 2] = heap[dst + 2];
                    view[i + 3] = heap[dst + 3];
                }
            }
            else {
                var view = HEAPF32.subarray((((value) >> 2)), ((value + count * 16) >> 2));
            }
            GLctx.uniform4fv(webglGetUniformLocation(location), view);
        };
        var _emscripten_glUniform4fv = _glUniform4fv;
        /** @suppress {duplicate } */
        var _glUniform4i = (location, v0, v1, v2, v3) => {
            GLctx.uniform4i(webglGetUniformLocation(location), v0, v1, v2, v3);
        };
        var _emscripten_glUniform4i = _glUniform4i;
        /** @suppress {duplicate } */
        var _glUniform4iv = (location, count, value) => {
            if (GL.currentContext.version >= 2) {
                count && GLctx.uniform4iv(webglGetUniformLocation(location), HEAP32, ((value) >> 2), count * 4);
                return;
            }
            if (count <= 72) {
                // avoid allocation when uploading few enough uniforms
                var view = miniTempWebGLIntBuffers[4 * count];
                for (var i = 0; i < 4 * count; i += 4) {
                    view[i] = HEAP32[(((value) + (4 * i)) >> 2)];
                    view[i + 1] = HEAP32[(((value) + (4 * i + 4)) >> 2)];
                    view[i + 2] = HEAP32[(((value) + (4 * i + 8)) >> 2)];
                    view[i + 3] = HEAP32[(((value) + (4 * i + 12)) >> 2)];
                }
            }
            else {
                var view = HEAP32.subarray((((value) >> 2)), ((value + count * 16) >> 2));
            }
            GLctx.uniform4iv(webglGetUniformLocation(location), view);
        };
        var _emscripten_glUniform4iv = _glUniform4iv;
        /** @suppress {duplicate } */
        var _glUniform4ui = (location, v0, v1, v2, v3) => {
            GLctx.uniform4ui(webglGetUniformLocation(location), v0, v1, v2, v3);
        };
        var _emscripten_glUniform4ui = _glUniform4ui;
        /** @suppress {duplicate } */
        var _glUniform4uiv = (location, count, value) => {
            count && GLctx.uniform4uiv(webglGetUniformLocation(location), HEAPU32, ((value) >> 2), count * 4);
        };
        var _emscripten_glUniform4uiv = _glUniform4uiv;
        /** @suppress {duplicate } */
        var _glUniformBlockBinding = (program, uniformBlockIndex, uniformBlockBinding) => {
            program = GL.programs[program];
            GLctx.uniformBlockBinding(program, uniformBlockIndex, uniformBlockBinding);
        };
        var _emscripten_glUniformBlockBinding = _glUniformBlockBinding;
        /** @suppress {duplicate } */
        var _glUniformMatrix2fv = (location, count, transpose, value) => {
            if (GL.currentContext.version >= 2) {
                count && GLctx.uniformMatrix2fv(webglGetUniformLocation(location), !!transpose, HEAPF32, ((value) >> 2), count * 4);
                return;
            }
            if (count <= 72) {
                // avoid allocation when uploading few enough uniforms
                var view = miniTempWebGLFloatBuffers[4 * count];
                for (var i = 0; i < 4 * count; i += 4) {
                    view[i] = HEAPF32[(((value) + (4 * i)) >> 2)];
                    view[i + 1] = HEAPF32[(((value) + (4 * i + 4)) >> 2)];
                    view[i + 2] = HEAPF32[(((value) + (4 * i + 8)) >> 2)];
                    view[i + 3] = HEAPF32[(((value) + (4 * i + 12)) >> 2)];
                }
            }
            else {
                var view = HEAPF32.subarray((((value) >> 2)), ((value + count * 16) >> 2));
            }
            GLctx.uniformMatrix2fv(webglGetUniformLocation(location), !!transpose, view);
        };
        var _emscripten_glUniformMatrix2fv = _glUniformMatrix2fv;
        /** @suppress {duplicate } */
        var _glUniformMatrix2x3fv = (location, count, transpose, value) => {
            count && GLctx.uniformMatrix2x3fv(webglGetUniformLocation(location), !!transpose, HEAPF32, ((value) >> 2), count * 6);
        };
        var _emscripten_glUniformMatrix2x3fv = _glUniformMatrix2x3fv;
        /** @suppress {duplicate } */
        var _glUniformMatrix2x4fv = (location, count, transpose, value) => {
            count && GLctx.uniformMatrix2x4fv(webglGetUniformLocation(location), !!transpose, HEAPF32, ((value) >> 2), count * 8);
        };
        var _emscripten_glUniformMatrix2x4fv = _glUniformMatrix2x4fv;
        /** @suppress {duplicate } */
        var _glUniformMatrix3fv = (location, count, transpose, value) => {
            if (GL.currentContext.version >= 2) {
                count && GLctx.uniformMatrix3fv(webglGetUniformLocation(location), !!transpose, HEAPF32, ((value) >> 2), count * 9);
                return;
            }
            if (count <= 32) {
                // avoid allocation when uploading few enough uniforms
                var view = miniTempWebGLFloatBuffers[9 * count];
                for (var i = 0; i < 9 * count; i += 9) {
                    view[i] = HEAPF32[(((value) + (4 * i)) >> 2)];
                    view[i + 1] = HEAPF32[(((value) + (4 * i + 4)) >> 2)];
                    view[i + 2] = HEAPF32[(((value) + (4 * i + 8)) >> 2)];
                    view[i + 3] = HEAPF32[(((value) + (4 * i + 12)) >> 2)];
                    view[i + 4] = HEAPF32[(((value) + (4 * i + 16)) >> 2)];
                    view[i + 5] = HEAPF32[(((value) + (4 * i + 20)) >> 2)];
                    view[i + 6] = HEAPF32[(((value) + (4 * i + 24)) >> 2)];
                    view[i + 7] = HEAPF32[(((value) + (4 * i + 28)) >> 2)];
                    view[i + 8] = HEAPF32[(((value) + (4 * i + 32)) >> 2)];
                }
            }
            else {
                var view = HEAPF32.subarray((((value) >> 2)), ((value + count * 36) >> 2));
            }
            GLctx.uniformMatrix3fv(webglGetUniformLocation(location), !!transpose, view);
        };
        var _emscripten_glUniformMatrix3fv = _glUniformMatrix3fv;
        /** @suppress {duplicate } */
        var _glUniformMatrix3x2fv = (location, count, transpose, value) => {
            count && GLctx.uniformMatrix3x2fv(webglGetUniformLocation(location), !!transpose, HEAPF32, ((value) >> 2), count * 6);
        };
        var _emscripten_glUniformMatrix3x2fv = _glUniformMatrix3x2fv;
        /** @suppress {duplicate } */
        var _glUniformMatrix3x4fv = (location, count, transpose, value) => {
            count && GLctx.uniformMatrix3x4fv(webglGetUniformLocation(location), !!transpose, HEAPF32, ((value) >> 2), count * 12);
        };
        var _emscripten_glUniformMatrix3x4fv = _glUniformMatrix3x4fv;
        /** @suppress {duplicate } */
        var _glUniformMatrix4fv = (location, count, transpose, value) => {
            if (GL.currentContext.version >= 2) {
                count && GLctx.uniformMatrix4fv(webglGetUniformLocation(location), !!transpose, HEAPF32, ((value) >> 2), count * 16);
                return;
            }
            if (count <= 18) {
                // avoid allocation when uploading few enough uniforms
                var view = miniTempWebGLFloatBuffers[16 * count];
                // hoist the heap out of the loop for size and for pthreads+growth.
                var heap = HEAPF32;
                value = ((value) >> 2);
                for (var i = 0; i < 16 * count; i += 16) {
                    var dst = value + i;
                    view[i] = heap[dst];
                    view[i + 1] = heap[dst + 1];
                    view[i + 2] = heap[dst + 2];
                    view[i + 3] = heap[dst + 3];
                    view[i + 4] = heap[dst + 4];
                    view[i + 5] = heap[dst + 5];
                    view[i + 6] = heap[dst + 6];
                    view[i + 7] = heap[dst + 7];
                    view[i + 8] = heap[dst + 8];
                    view[i + 9] = heap[dst + 9];
                    view[i + 10] = heap[dst + 10];
                    view[i + 11] = heap[dst + 11];
                    view[i + 12] = heap[dst + 12];
                    view[i + 13] = heap[dst + 13];
                    view[i + 14] = heap[dst + 14];
                    view[i + 15] = heap[dst + 15];
                }
            }
            else {
                var view = HEAPF32.subarray((((value) >> 2)), ((value + count * 64) >> 2));
            }
            GLctx.uniformMatrix4fv(webglGetUniformLocation(location), !!transpose, view);
        };
        var _emscripten_glUniformMatrix4fv = _glUniformMatrix4fv;
        /** @suppress {duplicate } */
        var _glUniformMatrix4x2fv = (location, count, transpose, value) => {
            count && GLctx.uniformMatrix4x2fv(webglGetUniformLocation(location), !!transpose, HEAPF32, ((value) >> 2), count * 8);
        };
        var _emscripten_glUniformMatrix4x2fv = _glUniformMatrix4x2fv;
        /** @suppress {duplicate } */
        var _glUniformMatrix4x3fv = (location, count, transpose, value) => {
            count && GLctx.uniformMatrix4x3fv(webglGetUniformLocation(location), !!transpose, HEAPF32, ((value) >> 2), count * 12);
        };
        var _emscripten_glUniformMatrix4x3fv = _glUniformMatrix4x3fv;
        /** @suppress {duplicate } */
        var _glUnmapBuffer = (target) => {
            if (!emscriptenWebGLValidateMapBufferTarget(target)) {
                GL.recordError(0x500 /*GL_INVALID_ENUM*/);
                err('GL_INVALID_ENUM in glUnmapBuffer');
                return 0;
            }
            var buffer = emscriptenWebGLGetBufferBinding(target);
            var mapping = GL.mappedBuffers[buffer];
            if (!mapping || !mapping.mem) {
                GL.recordError(0x502 /* GL_INVALID_OPERATION */);
                err('buffer was never mapped in glUnmapBuffer');
                return 0;
            }
            if (!(mapping.access & 0x10)) { /* GL_MAP_FLUSH_EXPLICIT_BIT */
                if (GL.currentContext.version >= 2) {
                    GLctx.bufferSubData(target, mapping.offset, HEAPU8, mapping.mem, mapping.length);
                }
                else
                    GLctx.bufferSubData(target, mapping.offset, HEAPU8.subarray(mapping.mem, mapping.mem + mapping.length));
            }
            _free(mapping.mem);
            mapping.mem = 0;
            return 1;
        };
        var _emscripten_glUnmapBuffer = _glUnmapBuffer;
        /** @suppress {duplicate } */
        var _glUseProgram = (program) => {
            program = GL.programs[program];
            GLctx.useProgram(program);
            // Record the currently active program so that we can access the uniform
            // mapping table of that program.
            GLctx.currentProgram = program;
        };
        var _emscripten_glUseProgram = _glUseProgram;
        /** @suppress {duplicate } */
        var _glValidateProgram = (program) => {
            GLctx.validateProgram(GL.programs[program]);
        };
        var _emscripten_glValidateProgram = _glValidateProgram;
        /** @suppress {duplicate } */
        var _glVertexAttrib1f = (x0, x1) => GLctx.vertexAttrib1f(x0, x1);
        var _emscripten_glVertexAttrib1f = _glVertexAttrib1f;
        /** @suppress {duplicate } */
        var _glVertexAttrib1fv = (index, v) => {
            GLctx.vertexAttrib1f(index, HEAPF32[v >> 2]);
        };
        var _emscripten_glVertexAttrib1fv = _glVertexAttrib1fv;
        /** @suppress {duplicate } */
        var _glVertexAttrib2f = (x0, x1, x2) => GLctx.vertexAttrib2f(x0, x1, x2);
        var _emscripten_glVertexAttrib2f = _glVertexAttrib2f;
        /** @suppress {duplicate } */
        var _glVertexAttrib2fv = (index, v) => {
            GLctx.vertexAttrib2f(index, HEAPF32[v >> 2], HEAPF32[v + 4 >> 2]);
        };
        var _emscripten_glVertexAttrib2fv = _glVertexAttrib2fv;
        /** @suppress {duplicate } */
        var _glVertexAttrib3f = (x0, x1, x2, x3) => GLctx.vertexAttrib3f(x0, x1, x2, x3);
        var _emscripten_glVertexAttrib3f = _glVertexAttrib3f;
        /** @suppress {duplicate } */
        var _glVertexAttrib3fv = (index, v) => {
            GLctx.vertexAttrib3f(index, HEAPF32[v >> 2], HEAPF32[v + 4 >> 2], HEAPF32[v + 8 >> 2]);
        };
        var _emscripten_glVertexAttrib3fv = _glVertexAttrib3fv;
        /** @suppress {duplicate } */
        var _glVertexAttrib4f = (x0, x1, x2, x3, x4) => GLctx.vertexAttrib4f(x0, x1, x2, x3, x4);
        var _emscripten_glVertexAttrib4f = _glVertexAttrib4f;
        /** @suppress {duplicate } */
        var _glVertexAttrib4fv = (index, v) => {
            GLctx.vertexAttrib4f(index, HEAPF32[v >> 2], HEAPF32[v + 4 >> 2], HEAPF32[v + 8 >> 2], HEAPF32[v + 12 >> 2]);
        };
        var _emscripten_glVertexAttrib4fv = _glVertexAttrib4fv;
        /** @suppress {duplicate } */
        var _glVertexAttribDivisor = (index, divisor) => {
            GLctx.vertexAttribDivisor(index, divisor);
        };
        var _emscripten_glVertexAttribDivisor = _glVertexAttribDivisor;
        /** @suppress {duplicate } */
        var _glVertexAttribDivisorANGLE = _glVertexAttribDivisor;
        var _emscripten_glVertexAttribDivisorANGLE = _glVertexAttribDivisorANGLE;
        /** @suppress {duplicate } */
        var _glVertexAttribDivisorARB = _glVertexAttribDivisor;
        var _emscripten_glVertexAttribDivisorARB = _glVertexAttribDivisorARB;
        /** @suppress {duplicate } */
        var _glVertexAttribDivisorEXT = _glVertexAttribDivisor;
        var _emscripten_glVertexAttribDivisorEXT = _glVertexAttribDivisorEXT;
        /** @suppress {duplicate } */
        var _glVertexAttribDivisorNV = _glVertexAttribDivisor;
        var _emscripten_glVertexAttribDivisorNV = _glVertexAttribDivisorNV;
        /** @suppress {duplicate } */
        var _glVertexAttribI4i = (x0, x1, x2, x3, x4) => GLctx.vertexAttribI4i(x0, x1, x2, x3, x4);
        var _emscripten_glVertexAttribI4i = _glVertexAttribI4i;
        /** @suppress {duplicate } */
        var _glVertexAttribI4iv = (index, v) => {
            GLctx.vertexAttribI4i(index, HEAP32[v >> 2], HEAP32[v + 4 >> 2], HEAP32[v + 8 >> 2], HEAP32[v + 12 >> 2]);
        };
        var _emscripten_glVertexAttribI4iv = _glVertexAttribI4iv;
        /** @suppress {duplicate } */
        var _glVertexAttribI4ui = (x0, x1, x2, x3, x4) => GLctx.vertexAttribI4ui(x0, x1, x2, x3, x4);
        var _emscripten_glVertexAttribI4ui = _glVertexAttribI4ui;
        /** @suppress {duplicate } */
        var _glVertexAttribI4uiv = (index, v) => {
            GLctx.vertexAttribI4ui(index, HEAPU32[v >> 2], HEAPU32[v + 4 >> 2], HEAPU32[v + 8 >> 2], HEAPU32[v + 12 >> 2]);
        };
        var _emscripten_glVertexAttribI4uiv = _glVertexAttribI4uiv;
        /** @suppress {duplicate } */
        var _glVertexAttribIPointer = (index, size, type, stride, ptr) => {
            var cb = GL.currentContext.clientBuffers[index];
            if (!GLctx.currentArrayBufferBinding) {
                cb.size = size;
                cb.type = type;
                cb.normalized = false;
                cb.stride = stride;
                cb.ptr = ptr;
                cb.clientside = true;
                cb.vertexAttribPointerAdaptor = function (index, size, type, normalized, stride, ptr) {
                    this.vertexAttribIPointer(index, size, type, stride, ptr);
                };
                return;
            }
            cb.clientside = false;
            GLctx.vertexAttribIPointer(index, size, type, stride, ptr);
        };
        var _emscripten_glVertexAttribIPointer = _glVertexAttribIPointer;
        /** @suppress {duplicate } */
        var _glVertexAttribPointer = (index, size, type, normalized, stride, ptr) => {
            var cb = GL.currentContext.clientBuffers[index];
            if (!GLctx.currentArrayBufferBinding) {
                cb.size = size;
                cb.type = type;
                cb.normalized = normalized;
                cb.stride = stride;
                cb.ptr = ptr;
                cb.clientside = true;
                cb.vertexAttribPointerAdaptor = function (index, size, type, normalized, stride, ptr) {
                    this.vertexAttribPointer(index, size, type, normalized, stride, ptr);
                };
                return;
            }
            cb.clientside = false;
            GLctx.vertexAttribPointer(index, size, type, !!normalized, stride, ptr);
        };
        var _emscripten_glVertexAttribPointer = _glVertexAttribPointer;
        /** @suppress {duplicate } */
        var _glViewport = (x0, x1, x2, x3) => GLctx.viewport(x0, x1, x2, x3);
        var _emscripten_glViewport = _glViewport;
        /** @suppress {duplicate } */
        var _glWaitSync = (sync, flags, timeout) => {
            // See WebGL2 vs GLES3 difference on GL_TIMEOUT_IGNORED above (https://www.khronos.org/registry/webgl/specs/latest/2.0/#5.15)
            timeout = Number(timeout);
            GLctx.waitSync(GL.syncs[sync], flags, timeout);
        };
        var _emscripten_glWaitSync = _glWaitSync;
        var _emscripten_has_asyncify = () => 0;
        var _emscripten_num_logical_cores = () => navigator['hardwareConcurrency'];
        var _emscripten_out = (str) => out(UTF8ToString(str));
        var promiseMap = new HandleAllocator();
        ;
        var makePromise = () => {
            var promiseInfo = {};
            promiseInfo.promise = new Promise((resolve, reject) => {
                promiseInfo.reject = reject;
                promiseInfo.resolve = resolve;
            });
            promiseInfo.id = promiseMap.allocate(promiseInfo);
            return promiseInfo;
        };
        var _emscripten_promise_create = () => makePromise().id;
        var _emscripten_promise_destroy = (id) => {
            promiseMap.free(id);
        };
        var getPromise = (id) => promiseMap.get(id).promise;
        var _emscripten_promise_resolve = (id, result, value) => {
            var info = promiseMap.get(id);
            switch (result) {
                case 0:
                    info.resolve(value);
                    return;
                case 1:
                    info.resolve(getPromise(value));
                    return;
                case 2:
                    info.resolve(getPromise(value));
                    _emscripten_promise_destroy(value);
                    return;
                case 3:
                    info.reject(value);
                    return;
            }
            abort("unexpected promise callback result " + result);
        };
        var doRequestFullscreen = (target, strategy) => {
            if (!JSEvents.fullscreenEnabled())
                return -1;
            target = findEventTarget(target);
            if (!target)
                return -4;
            if (!target.requestFullscreen
                && !target.webkitRequestFullscreen) {
                return -3;
            }
            var canPerformRequests = JSEvents.canPerformEventHandlerRequests();
            // Queue this function call if we're not currently in an event handler and the user saw it appropriate to do so.
            if (!canPerformRequests) {
                if (strategy.deferUntilInEventHandler) {
                    JSEvents.deferCall(JSEvents_requestFullscreen, 1 /* priority over pointer lock */, [target, strategy]);
                    return 1;
                }
                return -2;
            }
            return JSEvents_requestFullscreen(target, strategy);
        };
        function _emscripten_request_fullscreen_strategy(target, deferUntilInEventHandler, fullscreenStrategy) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(109, 0, 1, target, deferUntilInEventHandler, fullscreenStrategy);
            var strategy = {
                scaleMode: HEAP32[((fullscreenStrategy) >> 2)],
                canvasResolutionScaleMode: HEAP32[(((fullscreenStrategy) + (4)) >> 2)],
                filteringMode: HEAP32[(((fullscreenStrategy) + (8)) >> 2)],
                deferUntilInEventHandler,
                canvasResizedCallbackTargetThread: HEAP32[(((fullscreenStrategy) + (20)) >> 2)],
                canvasResizedCallback: HEAP32[(((fullscreenStrategy) + (12)) >> 2)],
                canvasResizedCallbackUserData: HEAP32[(((fullscreenStrategy) + (16)) >> 2)]
            };
            return doRequestFullscreen(target, strategy);
        }
        function _emscripten_request_pointerlock(target, deferUntilInEventHandler) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(110, 0, 1, target, deferUntilInEventHandler);
            target = findEventTarget(target);
            if (!target)
                return -4;
            if (!target.requestPointerLock) {
                return -1;
            }
            var canPerformRequests = JSEvents.canPerformEventHandlerRequests();
            // Queue this function call if we're not currently in an event handler and the user saw it appropriate to do so.
            if (!canPerformRequests) {
                if (deferUntilInEventHandler) {
                    JSEvents.deferCall(requestPointerLock, 2 /* priority below fullscreen */, [target]);
                    return 1;
                }
                return -2;
            }
            return requestPointerLock(target);
        }
        var abortOnCannotGrowMemory = (requestedSize) => {
            abort(`Cannot enlarge memory arrays to size ${requestedSize} bytes (OOM). Either (1) compile with -sINITIAL_MEMORY=X with X higher than the current value ${HEAP8.length}, (2) compile with -sALLOW_MEMORY_GROWTH which allows increasing the size at runtime, or (3) if you want malloc to return NULL (0) instead of this abort, compile with -sABORTING_MALLOC=0`);
        };
        var _emscripten_resize_heap = (requestedSize) => {
            var oldSize = HEAPU8.length;
            // With CAN_ADDRESS_2GB or MEMORY64, pointers are already unsigned.
            requestedSize >>>= 0;
            abortOnCannotGrowMemory(requestedSize);
        };
        var _emscripten_runtime_keepalive_check = keepRuntimeAlive;
        /** @suppress {checkTypes} */
        function _emscripten_sample_gamepad_data() {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(111, 0, 1);
            try {
                if (navigator.getGamepads)
                    return (JSEvents.lastGamepadState = navigator.getGamepads())
                        ? 0 : -1;
            }
            catch (e) {
                err(`navigator.getGamepads() exists, but failed to execute with exception ${e}. Disabling Gamepad access.`);
                navigator.getGamepads = null; // Disable getGamepads() so that it won't be attempted to be used again.
            }
            return -1;
        }
        var registerBeforeUnloadEventCallback = (target, userData, useCapture, callbackfunc, eventTypeId, eventTypeString) => {
            var beforeUnloadEventHandlerFunc = (e = event) => {
                // Note: This is always called on the main browser thread, since it needs synchronously return a value!
                var confirmationMessage = getWasmTableEntry(callbackfunc)(eventTypeId, 0, userData);
                if (confirmationMessage) {
                    confirmationMessage = UTF8ToString(confirmationMessage);
                }
                if (confirmationMessage) {
                    e.preventDefault();
                    e.returnValue = confirmationMessage;
                    return confirmationMessage;
                }
            };
            var eventHandler = {
                target: findEventTarget(target),
                eventTypeString,
                callbackfunc,
                handlerFunc: beforeUnloadEventHandlerFunc,
                useCapture
            };
            return JSEvents.registerOrRemoveHandler(eventHandler);
        };
        function _emscripten_set_beforeunload_callback_on_thread(userData, callbackfunc, targetThread) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(112, 0, 1, userData, callbackfunc, targetThread);
            if (typeof onbeforeunload == 'undefined')
                return -1;
            // beforeunload callback can only be registered on the main browser thread, because the page will go away immediately after returning from the handler,
            // and there is no time to start proxying it anywhere.
            if (targetThread !== 1)
                return -5;
            return registerBeforeUnloadEventCallback(2, userData, true, callbackfunc, 28, "beforeunload");
        }
        var registerFocusEventCallback = (target, userData, useCapture, callbackfunc, eventTypeId, eventTypeString, targetThread) => {
            targetThread = JSEvents.getTargetThreadForEventCallback(targetThread);
            if (!JSEvents.focusEvent)
                JSEvents.focusEvent = _malloc(256);
            var focusEventHandlerFunc = (e = event) => {
                var nodeName = JSEvents.getNodeNameForTarget(e.target);
                var id = e.target.id ? e.target.id : '';
                var focusEvent = targetThread ? _malloc(256) : JSEvents.focusEvent;
                stringToUTF8(nodeName, focusEvent + 0, 128);
                stringToUTF8(id, focusEvent + 128, 128);
                if (targetThread)
                    __emscripten_run_callback_on_thread(targetThread, callbackfunc, eventTypeId, focusEvent, userData);
                else if (getWasmTableEntry(callbackfunc)(eventTypeId, focusEvent, userData))
                    e.preventDefault();
            };
            var eventHandler = {
                target: findEventTarget(target),
                eventTypeString,
                callbackfunc,
                handlerFunc: focusEventHandlerFunc,
                useCapture
            };
            return JSEvents.registerOrRemoveHandler(eventHandler);
        };
        function _emscripten_set_blur_callback_on_thread(target, userData, useCapture, callbackfunc, targetThread) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(113, 0, 1, target, userData, useCapture, callbackfunc, targetThread);
            return registerFocusEventCallback(target, userData, useCapture, callbackfunc, 12, "blur", targetThread);
        }
        function _emscripten_set_element_css_size(target, width, height) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(114, 0, 1, target, width, height);
            target = findEventTarget(target);
            if (!target)
                return -4;
            target.style.width = width + "px";
            target.style.height = height + "px";
            return 0;
        }
        function _emscripten_set_focus_callback_on_thread(target, userData, useCapture, callbackfunc, targetThread) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(115, 0, 1, target, userData, useCapture, callbackfunc, targetThread);
            return registerFocusEventCallback(target, userData, useCapture, callbackfunc, 13, "focus", targetThread);
        }
        var fillFullscreenChangeEventData = (eventStruct) => {
            var fullscreenElement = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement;
            var isFullscreen = !!fullscreenElement;
            // Assigning a boolean to HEAP32 with expected type coercion.
            /** @suppress{checkTypes} */
            HEAP32[((eventStruct) >> 2)] = isFullscreen;
            HEAP32[(((eventStruct) + (4)) >> 2)] = JSEvents.fullscreenEnabled();
            // If transitioning to fullscreen, report info about the element that is now fullscreen.
            // If transitioning to windowed mode, report info about the element that just was fullscreen.
            var reportedElement = isFullscreen ? fullscreenElement : JSEvents.previousFullscreenElement;
            var nodeName = JSEvents.getNodeNameForTarget(reportedElement);
            var id = reportedElement?.id || '';
            stringToUTF8(nodeName, eventStruct + 8, 128);
            stringToUTF8(id, eventStruct + 136, 128);
            HEAP32[(((eventStruct) + (264)) >> 2)] = reportedElement ? reportedElement.clientWidth : 0;
            HEAP32[(((eventStruct) + (268)) >> 2)] = reportedElement ? reportedElement.clientHeight : 0;
            HEAP32[(((eventStruct) + (272)) >> 2)] = screen.width;
            HEAP32[(((eventStruct) + (276)) >> 2)] = screen.height;
            if (isFullscreen) {
                JSEvents.previousFullscreenElement = fullscreenElement;
            }
        };
        var registerFullscreenChangeEventCallback = (target, userData, useCapture, callbackfunc, eventTypeId, eventTypeString, targetThread) => {
            targetThread = JSEvents.getTargetThreadForEventCallback(targetThread);
            if (!JSEvents.fullscreenChangeEvent)
                JSEvents.fullscreenChangeEvent = _malloc(280);
            var fullscreenChangeEventhandlerFunc = (e = event) => {
                var fullscreenChangeEvent = targetThread ? _malloc(280) : JSEvents.fullscreenChangeEvent;
                fillFullscreenChangeEventData(fullscreenChangeEvent);
                if (targetThread)
                    __emscripten_run_callback_on_thread(targetThread, callbackfunc, eventTypeId, fullscreenChangeEvent, userData);
                else if (getWasmTableEntry(callbackfunc)(eventTypeId, fullscreenChangeEvent, userData))
                    e.preventDefault();
            };
            var eventHandler = {
                target,
                eventTypeString,
                callbackfunc,
                handlerFunc: fullscreenChangeEventhandlerFunc,
                useCapture
            };
            return JSEvents.registerOrRemoveHandler(eventHandler);
        };
        function _emscripten_set_fullscreenchange_callback_on_thread(target, userData, useCapture, callbackfunc, targetThread) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(116, 0, 1, target, userData, useCapture, callbackfunc, targetThread);
            if (!JSEvents.fullscreenEnabled())
                return -1;
            target = findEventTarget(target);
            if (!target)
                return -4;
            // Unprefixed Fullscreen API shipped in Chromium 71 (https://bugs.chromium.org/p/chromium/issues/detail?id=383813)
            // As of Safari 13.0.3 on macOS Catalina 10.15.1 still ships with prefixed webkitfullscreenchange. TODO: revisit this check once Safari ships unprefixed version.
            registerFullscreenChangeEventCallback(target, userData, useCapture, callbackfunc, 19, "webkitfullscreenchange", targetThread);
            return registerFullscreenChangeEventCallback(target, userData, useCapture, callbackfunc, 19, "fullscreenchange", targetThread);
        }
        var registerGamepadEventCallback = (target, userData, useCapture, callbackfunc, eventTypeId, eventTypeString, targetThread) => {
            targetThread = JSEvents.getTargetThreadForEventCallback(targetThread);
            if (!JSEvents.gamepadEvent)
                JSEvents.gamepadEvent = _malloc(1432);
            var gamepadEventHandlerFunc = (e = event) => {
                var gamepadEvent = targetThread ? _malloc(1432) : JSEvents.gamepadEvent;
                fillGamepadEventData(gamepadEvent, e["gamepad"]);
                if (targetThread)
                    __emscripten_run_callback_on_thread(targetThread, callbackfunc, eventTypeId, gamepadEvent, userData);
                else if (getWasmTableEntry(callbackfunc)(eventTypeId, gamepadEvent, userData))
                    e.preventDefault();
            };
            var eventHandler = {
                target: findEventTarget(target),
                allowsDeferredCalls: true,
                eventTypeString,
                callbackfunc,
                handlerFunc: gamepadEventHandlerFunc,
                useCapture
            };
            return JSEvents.registerOrRemoveHandler(eventHandler);
        };
        function _emscripten_set_gamepadconnected_callback_on_thread(userData, useCapture, callbackfunc, targetThread) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(117, 0, 1, userData, useCapture, callbackfunc, targetThread);
            if (_emscripten_sample_gamepad_data())
                return -1;
            return registerGamepadEventCallback(2, userData, useCapture, callbackfunc, 26, "gamepadconnected", targetThread);
        }
        function _emscripten_set_gamepaddisconnected_callback_on_thread(userData, useCapture, callbackfunc, targetThread) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(118, 0, 1, userData, useCapture, callbackfunc, targetThread);
            if (_emscripten_sample_gamepad_data())
                return -1;
            return registerGamepadEventCallback(2, userData, useCapture, callbackfunc, 27, "gamepaddisconnected", targetThread);
        }
        var registerKeyEventCallback = (target, userData, useCapture, callbackfunc, eventTypeId, eventTypeString, targetThread) => {
            targetThread = JSEvents.getTargetThreadForEventCallback(targetThread);
            if (!JSEvents.keyEvent)
                JSEvents.keyEvent = _malloc(176);
            var keyEventHandlerFunc = (e) => {
                assert(e);
                var keyEventData = targetThread ? _malloc(176) : JSEvents.keyEvent; // This allocated block is passed as satellite data to the proxied function call, so the call frees up the data block when done.
                HEAPF64[((keyEventData) >> 3)] = e.timeStamp;
                var idx = ((keyEventData) >> 2);
                HEAP32[idx + 2] = e.location;
                HEAP32[idx + 3] = e.ctrlKey;
                HEAP32[idx + 4] = e.shiftKey;
                HEAP32[idx + 5] = e.altKey;
                HEAP32[idx + 6] = e.metaKey;
                HEAP32[idx + 7] = e.repeat;
                HEAP32[idx + 8] = e.charCode;
                HEAP32[idx + 9] = e.keyCode;
                HEAP32[idx + 10] = e.which;
                stringToUTF8(e.key || '', keyEventData + 44, 32);
                stringToUTF8(e.code || '', keyEventData + 76, 32);
                stringToUTF8(e.char || '', keyEventData + 108, 32);
                stringToUTF8(e.locale || '', keyEventData + 140, 32);
                if (targetThread)
                    __emscripten_run_callback_on_thread(targetThread, callbackfunc, eventTypeId, keyEventData, userData);
                else if (getWasmTableEntry(callbackfunc)(eventTypeId, keyEventData, userData))
                    e.preventDefault();
            };
            var eventHandler = {
                target: findEventTarget(target),
                eventTypeString,
                callbackfunc,
                handlerFunc: keyEventHandlerFunc,
                useCapture
            };
            return JSEvents.registerOrRemoveHandler(eventHandler);
        };
        function _emscripten_set_keydown_callback_on_thread(target, userData, useCapture, callbackfunc, targetThread) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(119, 0, 1, target, userData, useCapture, callbackfunc, targetThread);
            return registerKeyEventCallback(target, userData, useCapture, callbackfunc, 2, "keydown", targetThread);
        }
        function _emscripten_set_keypress_callback_on_thread(target, userData, useCapture, callbackfunc, targetThread) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(120, 0, 1, target, userData, useCapture, callbackfunc, targetThread);
            return registerKeyEventCallback(target, userData, useCapture, callbackfunc, 1, "keypress", targetThread);
        }
        function _emscripten_set_keyup_callback_on_thread(target, userData, useCapture, callbackfunc, targetThread) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(121, 0, 1, target, userData, useCapture, callbackfunc, targetThread);
            return registerKeyEventCallback(target, userData, useCapture, callbackfunc, 3, "keyup", targetThread);
        }
        var _emscripten_set_main_loop = (func, fps, simulateInfiniteLoop) => {
            var browserIterationFunc = getWasmTableEntry(func);
            setMainLoop(browserIterationFunc, fps, simulateInfiniteLoop);
        };
        var fillMouseEventData = (eventStruct, e, target) => {
            assert(eventStruct % 4 == 0);
            HEAPF64[((eventStruct) >> 3)] = e.timeStamp;
            var idx = ((eventStruct) >> 2);
            HEAP32[idx + 2] = e.screenX;
            HEAP32[idx + 3] = e.screenY;
            HEAP32[idx + 4] = e.clientX;
            HEAP32[idx + 5] = e.clientY;
            HEAP32[idx + 6] = e.ctrlKey;
            HEAP32[idx + 7] = e.shiftKey;
            HEAP32[idx + 8] = e.altKey;
            HEAP32[idx + 9] = e.metaKey;
            HEAP16[idx * 2 + 20] = e.button;
            HEAP16[idx * 2 + 21] = e.buttons;
            HEAP32[idx + 11] = e["movementX"];
            HEAP32[idx + 12] = e["movementY"];
            // Note: rect contains doubles (truncated to placate SAFE_HEAP, which is the same behaviour when writing to HEAP32 anyway)
            var rect = getBoundingClientRect(target);
            HEAP32[idx + 13] = e.clientX - (rect.left | 0);
            HEAP32[idx + 14] = e.clientY - (rect.top | 0);
        };
        var registerMouseEventCallback = (target, userData, useCapture, callbackfunc, eventTypeId, eventTypeString, targetThread) => {
            targetThread = JSEvents.getTargetThreadForEventCallback(targetThread);
            if (!JSEvents.mouseEvent)
                JSEvents.mouseEvent = _malloc(72);
            target = findEventTarget(target);
            var mouseEventHandlerFunc = (e = event) => {
                // TODO: Make this access thread safe, or this could update live while app is reading it.
                fillMouseEventData(JSEvents.mouseEvent, e, target);
                if (targetThread) {
                    var mouseEventData = _malloc(72); // This allocated block is passed as satellite data to the proxied function call, so the call frees up the data block when done.
                    fillMouseEventData(mouseEventData, e, target);
                    __emscripten_run_callback_on_thread(targetThread, callbackfunc, eventTypeId, mouseEventData, userData);
                }
                else if (getWasmTableEntry(callbackfunc)(eventTypeId, JSEvents.mouseEvent, userData))
                    e.preventDefault();
            };
            var eventHandler = {
                target,
                allowsDeferredCalls: eventTypeString != 'mousemove' && eventTypeString != 'mouseenter' && eventTypeString != 'mouseleave', // Mouse move events do not allow fullscreen/pointer lock requests to be handled in them!
                eventTypeString,
                callbackfunc,
                handlerFunc: mouseEventHandlerFunc,
                useCapture
            };
            return JSEvents.registerOrRemoveHandler(eventHandler);
        };
        function _emscripten_set_mousedown_callback_on_thread(target, userData, useCapture, callbackfunc, targetThread) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(122, 0, 1, target, userData, useCapture, callbackfunc, targetThread);
            return registerMouseEventCallback(target, userData, useCapture, callbackfunc, 5, "mousedown", targetThread);
        }
        function _emscripten_set_mouseenter_callback_on_thread(target, userData, useCapture, callbackfunc, targetThread) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(123, 0, 1, target, userData, useCapture, callbackfunc, targetThread);
            return registerMouseEventCallback(target, userData, useCapture, callbackfunc, 33, "mouseenter", targetThread);
        }
        function _emscripten_set_mouseleave_callback_on_thread(target, userData, useCapture, callbackfunc, targetThread) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(124, 0, 1, target, userData, useCapture, callbackfunc, targetThread);
            return registerMouseEventCallback(target, userData, useCapture, callbackfunc, 34, "mouseleave", targetThread);
        }
        function _emscripten_set_mousemove_callback_on_thread(target, userData, useCapture, callbackfunc, targetThread) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(125, 0, 1, target, userData, useCapture, callbackfunc, targetThread);
            return registerMouseEventCallback(target, userData, useCapture, callbackfunc, 8, "mousemove", targetThread);
        }
        function _emscripten_set_mouseup_callback_on_thread(target, userData, useCapture, callbackfunc, targetThread) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(126, 0, 1, target, userData, useCapture, callbackfunc, targetThread);
            return registerMouseEventCallback(target, userData, useCapture, callbackfunc, 6, "mouseup", targetThread);
        }
        var fillPointerlockChangeEventData = (eventStruct) => {
            var pointerLockElement = document.pointerLockElement || document.mozPointerLockElement || document.webkitPointerLockElement || document.msPointerLockElement;
            var isPointerlocked = !!pointerLockElement;
            // Assigning a boolean to HEAP32 with expected type coercion.
            /** @suppress{checkTypes} */
            HEAP32[((eventStruct) >> 2)] = isPointerlocked;
            var nodeName = JSEvents.getNodeNameForTarget(pointerLockElement);
            var id = pointerLockElement?.id || '';
            stringToUTF8(nodeName, eventStruct + 4, 128);
            stringToUTF8(id, eventStruct + 132, 128);
        };
        var registerPointerlockChangeEventCallback = (target, userData, useCapture, callbackfunc, eventTypeId, eventTypeString, targetThread) => {
            targetThread = JSEvents.getTargetThreadForEventCallback(targetThread);
            if (!JSEvents.pointerlockChangeEvent)
                JSEvents.pointerlockChangeEvent = _malloc(260);
            var pointerlockChangeEventHandlerFunc = (e = event) => {
                var pointerlockChangeEvent = targetThread ? _malloc(260) : JSEvents.pointerlockChangeEvent;
                fillPointerlockChangeEventData(pointerlockChangeEvent);
                if (targetThread)
                    __emscripten_run_callback_on_thread(targetThread, callbackfunc, eventTypeId, pointerlockChangeEvent, userData);
                else if (getWasmTableEntry(callbackfunc)(eventTypeId, pointerlockChangeEvent, userData))
                    e.preventDefault();
            };
            var eventHandler = {
                target,
                eventTypeString,
                callbackfunc,
                handlerFunc: pointerlockChangeEventHandlerFunc,
                useCapture
            };
            return JSEvents.registerOrRemoveHandler(eventHandler);
        };
        /** @suppress {missingProperties} */
        function _emscripten_set_pointerlockchange_callback_on_thread(target, userData, useCapture, callbackfunc, targetThread) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(127, 0, 1, target, userData, useCapture, callbackfunc, targetThread);
            // TODO: Currently not supported in pthreads or in --proxy-to-worker mode. (In pthreads mode, document object is not defined)
            if (!document || !document.body || (!document.body.requestPointerLock && !document.body.mozRequestPointerLock && !document.body.webkitRequestPointerLock && !document.body.msRequestPointerLock)) {
                return -1;
            }
            target = findEventTarget(target);
            if (!target)
                return -4;
            registerPointerlockChangeEventCallback(target, userData, useCapture, callbackfunc, 20, "mozpointerlockchange", targetThread);
            registerPointerlockChangeEventCallback(target, userData, useCapture, callbackfunc, 20, "webkitpointerlockchange", targetThread);
            registerPointerlockChangeEventCallback(target, userData, useCapture, callbackfunc, 20, "mspointerlockchange", targetThread);
            return registerPointerlockChangeEventCallback(target, userData, useCapture, callbackfunc, 20, "pointerlockchange", targetThread);
        }
        var registerUiEventCallback = (target, userData, useCapture, callbackfunc, eventTypeId, eventTypeString, targetThread) => {
            targetThread = JSEvents.getTargetThreadForEventCallback(targetThread);
            if (!JSEvents.uiEvent)
                JSEvents.uiEvent = _malloc(36);
            target = findEventTarget(target);
            var uiEventHandlerFunc = (e = event) => {
                if (e.target != target) {
                    // Never take ui events such as scroll via a 'bubbled' route, but always from the direct element that
                    // was targeted. Otherwise e.g. if app logs a message in response to a page scroll, the Emscripten log
                    // message box could cause to scroll, generating a new (bubbled) scroll message, causing a new log print,
                    // causing a new scroll, etc..
                    return;
                }
                var b = document.body; // Take document.body to a variable, Closure compiler does not outline access to it on its own.
                if (!b) {
                    // During a page unload 'body' can be null, with "Cannot read property 'clientWidth' of null" being thrown
                    return;
                }
                var uiEvent = targetThread ? _malloc(36) : JSEvents.uiEvent;
                HEAP32[((uiEvent) >> 2)] = 0; // always zero for resize and scroll
                HEAP32[(((uiEvent) + (4)) >> 2)] = b.clientWidth;
                HEAP32[(((uiEvent) + (8)) >> 2)] = b.clientHeight;
                HEAP32[(((uiEvent) + (12)) >> 2)] = innerWidth;
                HEAP32[(((uiEvent) + (16)) >> 2)] = innerHeight;
                HEAP32[(((uiEvent) + (20)) >> 2)] = outerWidth;
                HEAP32[(((uiEvent) + (24)) >> 2)] = outerHeight;
                HEAP32[(((uiEvent) + (28)) >> 2)] = pageXOffset | 0; // scroll offsets are float
                HEAP32[(((uiEvent) + (32)) >> 2)] = pageYOffset | 0;
                if (targetThread)
                    __emscripten_run_callback_on_thread(targetThread, callbackfunc, eventTypeId, uiEvent, userData);
                else if (getWasmTableEntry(callbackfunc)(eventTypeId, uiEvent, userData))
                    e.preventDefault();
            };
            var eventHandler = {
                target,
                eventTypeString,
                callbackfunc,
                handlerFunc: uiEventHandlerFunc,
                useCapture
            };
            return JSEvents.registerOrRemoveHandler(eventHandler);
        };
        function _emscripten_set_resize_callback_on_thread(target, userData, useCapture, callbackfunc, targetThread) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(128, 0, 1, target, userData, useCapture, callbackfunc, targetThread);
            return registerUiEventCallback(target, userData, useCapture, callbackfunc, 10, "resize", targetThread);
        }
        var registerTouchEventCallback = (target, userData, useCapture, callbackfunc, eventTypeId, eventTypeString, targetThread) => {
            targetThread = JSEvents.getTargetThreadForEventCallback(targetThread);
            if (!JSEvents.touchEvent)
                JSEvents.touchEvent = _malloc(1696);
            target = findEventTarget(target);
            var touchEventHandlerFunc = (e) => {
                assert(e);
                var t, touches = {}, et = e.touches;
                // To ease marshalling different kinds of touches that browser reports (all touches are listed in e.touches,
                // only changed touches in e.changedTouches, and touches on target at a.targetTouches), mark a boolean in
                // each Touch object so that we can later loop only once over all touches we see to marshall over to Wasm.
                for (var i = 0; i < et.length; ++i) {
                    t = et[i];
                    // Browser might recycle the generated Touch objects between each frame (Firefox on Android), so reset any
                    // changed/target states we may have set from previous frame.
                    t.isChanged = t.onTarget = 0;
                    touches[t.identifier] = t;
                }
                // Mark which touches are part of the changedTouches list.
                for (var i = 0; i < e.changedTouches.length; ++i) {
                    t = e.changedTouches[i];
                    t.isChanged = 1;
                    touches[t.identifier] = t;
                }
                // Mark which touches are part of the targetTouches list.
                for (var i = 0; i < e.targetTouches.length; ++i) {
                    touches[e.targetTouches[i].identifier].onTarget = 1;
                }
                var touchEvent = targetThread ? _malloc(1696) : JSEvents.touchEvent;
                HEAPF64[((touchEvent) >> 3)] = e.timeStamp;
                var idx = ((touchEvent) >> 2); // Pre-shift the ptr to index to HEAP32 to save code size
                HEAP32[idx + 3] = e.ctrlKey;
                HEAP32[idx + 4] = e.shiftKey;
                HEAP32[idx + 5] = e.altKey;
                HEAP32[idx + 6] = e.metaKey;
                idx += 7; // Advance to the start of the touch array.
                var targetRect = getBoundingClientRect(target);
                var numTouches = 0;
                for (var i in touches) {
                    t = touches[i];
                    HEAP32[idx + 0] = t.identifier;
                    HEAP32[idx + 1] = t.screenX;
                    HEAP32[idx + 2] = t.screenY;
                    HEAP32[idx + 3] = t.clientX;
                    HEAP32[idx + 4] = t.clientY;
                    HEAP32[idx + 5] = t.pageX;
                    HEAP32[idx + 6] = t.pageY;
                    HEAP32[idx + 7] = t.isChanged;
                    HEAP32[idx + 8] = t.onTarget;
                    HEAP32[idx + 9] = t.clientX - (targetRect.left | 0);
                    HEAP32[idx + 10] = t.clientY - (targetRect.top | 0);
                    idx += 13;
                    if (++numTouches > 31) {
                        break;
                    }
                }
                HEAP32[(((touchEvent) + (8)) >> 2)] = numTouches;
                if (targetThread)
                    __emscripten_run_callback_on_thread(targetThread, callbackfunc, eventTypeId, touchEvent, userData);
                else if (getWasmTableEntry(callbackfunc)(eventTypeId, touchEvent, userData))
                    e.preventDefault();
            };
            var eventHandler = {
                target,
                allowsDeferredCalls: eventTypeString == 'touchstart' || eventTypeString == 'touchend',
                eventTypeString,
                callbackfunc,
                handlerFunc: touchEventHandlerFunc,
                useCapture
            };
            return JSEvents.registerOrRemoveHandler(eventHandler);
        };
        function _emscripten_set_touchcancel_callback_on_thread(target, userData, useCapture, callbackfunc, targetThread) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(129, 0, 1, target, userData, useCapture, callbackfunc, targetThread);
            return registerTouchEventCallback(target, userData, useCapture, callbackfunc, 25, "touchcancel", targetThread);
        }
        function _emscripten_set_touchend_callback_on_thread(target, userData, useCapture, callbackfunc, targetThread) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(130, 0, 1, target, userData, useCapture, callbackfunc, targetThread);
            return registerTouchEventCallback(target, userData, useCapture, callbackfunc, 23, "touchend", targetThread);
        }
        function _emscripten_set_touchmove_callback_on_thread(target, userData, useCapture, callbackfunc, targetThread) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(131, 0, 1, target, userData, useCapture, callbackfunc, targetThread);
            return registerTouchEventCallback(target, userData, useCapture, callbackfunc, 24, "touchmove", targetThread);
        }
        function _emscripten_set_touchstart_callback_on_thread(target, userData, useCapture, callbackfunc, targetThread) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(132, 0, 1, target, userData, useCapture, callbackfunc, targetThread);
            return registerTouchEventCallback(target, userData, useCapture, callbackfunc, 22, "touchstart", targetThread);
        }
        var fillVisibilityChangeEventData = (eventStruct) => {
            var visibilityStates = ["hidden", "visible", "prerender", "unloaded"];
            var visibilityState = visibilityStates.indexOf(document.visibilityState);
            // Assigning a boolean to HEAP32 with expected type coercion.
            /** @suppress{checkTypes} */
            HEAP32[((eventStruct) >> 2)] = document.hidden;
            HEAP32[(((eventStruct) + (4)) >> 2)] = visibilityState;
        };
        var registerVisibilityChangeEventCallback = (target, userData, useCapture, callbackfunc, eventTypeId, eventTypeString, targetThread) => {
            targetThread = JSEvents.getTargetThreadForEventCallback(targetThread);
            if (!JSEvents.visibilityChangeEvent)
                JSEvents.visibilityChangeEvent = _malloc(8);
            var visibilityChangeEventHandlerFunc = (e = event) => {
                var visibilityChangeEvent = targetThread ? _malloc(8) : JSEvents.visibilityChangeEvent;
                fillVisibilityChangeEventData(visibilityChangeEvent);
                if (targetThread)
                    __emscripten_run_callback_on_thread(targetThread, callbackfunc, eventTypeId, visibilityChangeEvent, userData);
                else if (getWasmTableEntry(callbackfunc)(eventTypeId, visibilityChangeEvent, userData))
                    e.preventDefault();
            };
            var eventHandler = {
                target,
                eventTypeString,
                callbackfunc,
                handlerFunc: visibilityChangeEventHandlerFunc,
                useCapture
            };
            return JSEvents.registerOrRemoveHandler(eventHandler);
        };
        function _emscripten_set_visibilitychange_callback_on_thread(userData, useCapture, callbackfunc, targetThread) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(133, 0, 1, userData, useCapture, callbackfunc, targetThread);
            if (!specialHTMLTargets[1]) {
                return -4;
            }
            return registerVisibilityChangeEventCallback(specialHTMLTargets[1], userData, useCapture, callbackfunc, 21, "visibilitychange", targetThread);
        }
        var registerWheelEventCallback = (target, userData, useCapture, callbackfunc, eventTypeId, eventTypeString, targetThread) => {
            targetThread = JSEvents.getTargetThreadForEventCallback(targetThread);
            if (!JSEvents.wheelEvent)
                JSEvents.wheelEvent = _malloc(104);
            // The DOM Level 3 events spec event 'wheel'
            var wheelHandlerFunc = (e = event) => {
                var wheelEvent = targetThread ? _malloc(104) : JSEvents.wheelEvent; // This allocated block is passed as satellite data to the proxied function call, so the call frees up the data block when done.
                fillMouseEventData(wheelEvent, e, target);
                HEAPF64[(((wheelEvent) + (72)) >> 3)] = e["deltaX"];
                HEAPF64[(((wheelEvent) + (80)) >> 3)] = e["deltaY"];
                HEAPF64[(((wheelEvent) + (88)) >> 3)] = e["deltaZ"];
                HEAP32[(((wheelEvent) + (96)) >> 2)] = e["deltaMode"];
                if (targetThread)
                    __emscripten_run_callback_on_thread(targetThread, callbackfunc, eventTypeId, wheelEvent, userData);
                else if (getWasmTableEntry(callbackfunc)(eventTypeId, wheelEvent, userData))
                    e.preventDefault();
            };
            var eventHandler = {
                target,
                allowsDeferredCalls: true,
                eventTypeString,
                callbackfunc,
                handlerFunc: wheelHandlerFunc,
                useCapture
            };
            return JSEvents.registerOrRemoveHandler(eventHandler);
        };
        function _emscripten_set_wheel_callback_on_thread(target, userData, useCapture, callbackfunc, targetThread) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(134, 0, 1, target, userData, useCapture, callbackfunc, targetThread);
            target = findEventTarget(target);
            if (!target)
                return -4;
            if (typeof target.onwheel != 'undefined') {
                return registerWheelEventCallback(target, userData, useCapture, callbackfunc, 9, "wheel", targetThread);
            }
            else {
                return -1;
            }
        }
        function _emscripten_set_window_title(title) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(135, 0, 1, title);
            return document.title = UTF8ToString(title);
        }
        var _emscripten_sleep = () => {
            throw 'Please compile your program with async support in order to use asynchronous operations like emscripten_sleep';
        };
        var _emscripten_unwind_to_js_event_loop = () => {
            throw 'unwind';
        };
        var _emscripten_supports_offscreencanvas = () => 
        // TODO: Add a new build mode, e.g. OFFSCREENCANVAS_SUPPORT=2, which
        // necessitates OffscreenCanvas support at build time, and "return 1;" here in that build mode.
        typeof OffscreenCanvas != 'undefined';
        var webglPowerPreferences = ["default", "low-power", "high-performance"];
        /** @suppress {duplicate } */
        var _emscripten_webgl_do_create_context = (target, attributes) => {
            assert(attributes);
            var a = ((attributes) >> 2);
            var powerPreference = HEAP32[a + (24 >> 2)];
            var contextAttributes = {
                'alpha': !!HEAP32[a + (0 >> 2)],
                'depth': !!HEAP32[a + (4 >> 2)],
                'stencil': !!HEAP32[a + (8 >> 2)],
                'antialias': !!HEAP32[a + (12 >> 2)],
                'premultipliedAlpha': !!HEAP32[a + (16 >> 2)],
                'preserveDrawingBuffer': !!HEAP32[a + (20 >> 2)],
                'powerPreference': webglPowerPreferences[powerPreference],
                'failIfMajorPerformanceCaveat': !!HEAP32[a + (28 >> 2)],
                // The following are not predefined WebGL context attributes in the WebGL specification, so the property names can be minified by Closure.
                majorVersion: HEAP32[a + (32 >> 2)],
                minorVersion: HEAP32[a + (36 >> 2)],
                enableExtensionsByDefault: HEAP32[a + (40 >> 2)],
                explicitSwapControl: HEAP32[a + (44 >> 2)],
                proxyContextToMainThread: HEAP32[a + (48 >> 2)],
                renderViaOffscreenBackBuffer: HEAP32[a + (52 >> 2)]
            };
            var canvas = findCanvasEventTarget(target);
            if (!canvas) {
                return 0;
            }
            if (canvas.offscreenCanvas)
                canvas = canvas.offscreenCanvas;
            if (contextAttributes.explicitSwapControl) {
                var supportsOffscreenCanvas = canvas.transferControlToOffscreen || (_emscripten_supports_offscreencanvas() && canvas instanceof OffscreenCanvas);
                if (!supportsOffscreenCanvas) {
                    return 0;
                }
                if (canvas.transferControlToOffscreen) {
                    if (!canvas.controlTransferredOffscreen) {
                        GL.offscreenCanvases[canvas.id] = {
                            canvas: canvas.transferControlToOffscreen(),
                            canvasSharedPtr: _malloc(12),
                            id: canvas.id
                        };
                        canvas.controlTransferredOffscreen = true;
                    }
                    else if (!GL.offscreenCanvases[canvas.id]) {
                        return 0;
                    }
                    canvas = GL.offscreenCanvases[canvas.id];
                }
            }
            var contextHandle = GL.createContext(canvas, contextAttributes);
            return contextHandle;
        };
        var _emscripten_webgl_create_context = _emscripten_webgl_do_create_context;
        var _emscripten_webgl_destroy_context_calling_thread = (contextHandle) => {
            if (GL.currentContext == contextHandle)
                GL.currentContext = 0;
            GL.deleteContext(contextHandle);
        };
        var _emscripten_webgl_destroy_context_main_thread = _emscripten_webgl_destroy_context_calling_thread;
        function _emscripten_webgl_destroy_context(p0) {
            return GL.contexts[p0] ? _emscripten_webgl_destroy_context_calling_thread(p0) : _emscripten_webgl_destroy_context_main_thread(p0);
        }
        var _emscripten_webgl_make_context_current = (contextHandle) => {
            var success = GL.makeContextCurrent(contextHandle);
            return success ? 0 : -5;
        };
        var ENV = {};
        var getExecutableName = () => {
            return thisProgram || './this.program';
        };
        var getEnvStrings = () => {
            if (!getEnvStrings.strings) {
                // Default values.
                // Browser language detection #8751
                var lang = ((typeof navigator == 'object' && navigator.languages && navigator.languages[0]) || 'C').replace('-', '_') + '.UTF-8';
                var env = {
                    'USER': 'web_user',
                    'LOGNAME': 'web_user',
                    'PATH': '/',
                    'PWD': '/',
                    'HOME': '/home/web_user',
                    'LANG': lang,
                    '_': getExecutableName()
                };
                // Apply the user-provided values, if any.
                for (var x in ENV) {
                    // x is a key in ENV; if ENV[x] is undefined, that means it was
                    // explicitly set to be so. We allow user code to do that to
                    // force variables with default values to remain unset.
                    if (ENV[x] === undefined)
                        delete env[x];
                    else
                        env[x] = ENV[x];
                }
                var strings = [];
                for (var x in env) {
                    strings.push(`${x}=${env[x]}`);
                }
                getEnvStrings.strings = strings;
            }
            return getEnvStrings.strings;
        };
        var stringToAscii = (str, buffer) => {
            for (var i = 0; i < str.length; ++i) {
                assert(str.charCodeAt(i) === (str.charCodeAt(i) & 0xff));
                HEAP8[buffer++] = str.charCodeAt(i);
            }
            // Null-terminate the string
            HEAP8[buffer] = 0;
        };
        var _environ_get = function (__environ, environ_buf) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(136, 0, 1, __environ, environ_buf);
            var bufSize = 0;
            getEnvStrings().forEach((string, i) => {
                var ptr = environ_buf + bufSize;
                HEAPU32[(((__environ) + (i * 4)) >> 2)] = ptr;
                stringToAscii(string, ptr);
                bufSize += string.length + 1;
            });
            return 0;
        };
        var _environ_sizes_get = function (penviron_count, penviron_buf_size) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(137, 0, 1, penviron_count, penviron_buf_size);
            var strings = getEnvStrings();
            HEAPU32[((penviron_count) >> 2)] = strings.length;
            var bufSize = 0;
            strings.forEach((string) => bufSize += string.length + 1);
            HEAPU32[((penviron_buf_size) >> 2)] = bufSize;
            return 0;
        };
        var Sockets = {
            BUFFER_SIZE: 10240,
            MAX_BUFFER_SIZE: 10485760,
            nextFd: 1,
            fds: {},
            nextport: 1,
            maxport: 65535,
            peer: null,
            connections: {},
            portmap: {},
            localAddr: 4261412874,
            addrPool: [33554442, 50331658, 67108874, 83886090, 100663306, 117440522, 134217738, 150994954, 167772170, 184549386, 201326602, 218103818, 234881034],
        };
        var inetPton4 = (str) => {
            var b = str.split('.');
            for (var i = 0; i < 4; i++) {
                var tmp = Number(b[i]);
                if (isNaN(tmp))
                    return null;
                b[i] = tmp;
            }
            return (b[0] | (b[1] << 8) | (b[2] << 16) | (b[3] << 24)) >>> 0;
        };
        var inetPton6 = (str) => {
            var words;
            var w, offset, z, i;
            /* http://home.deds.nl/~aeron/regex/ */
            var valid6regx = /^((?=.*::)(?!.*::.+::)(::)?([\dA-F]{1,4}:(:|\b)|){5}|([\dA-F]{1,4}:){6})((([\dA-F]{1,4}((?!\3)::|:\b|$))|(?!\2\3)){2}|(((2[0-4]|1\d|[1-9])?\d|25[0-5])\.?\b){4})$/i;
            var parts = [];
            if (!valid6regx.test(str)) {
                return null;
            }
            if (str === "::") {
                return [0, 0, 0, 0, 0, 0, 0, 0];
            }
            // Z placeholder to keep track of zeros when splitting the string on ":"
            if (str.startsWith("::")) {
                str = str.replace("::", "Z:"); // leading zeros case
            }
            else {
                str = str.replace("::", ":Z:");
            }
            if (str.indexOf(".") > 0) {
                // parse IPv4 embedded stress
                str = str.replace(new RegExp('[.]', 'g'), ":");
                words = str.split(":");
                words[words.length - 4] = jstoi_q(words[words.length - 4]) + jstoi_q(words[words.length - 3]) * 256;
                words[words.length - 3] = jstoi_q(words[words.length - 2]) + jstoi_q(words[words.length - 1]) * 256;
                words = words.slice(0, words.length - 2);
            }
            else {
                words = str.split(":");
            }
            offset = 0;
            z = 0;
            for (w = 0; w < words.length; w++) {
                if (typeof words[w] == 'string') {
                    if (words[w] === 'Z') {
                        // compressed zeros - write appropriate number of zero words
                        for (z = 0; z < (8 - words.length + 1); z++) {
                            parts[w + z] = 0;
                        }
                        offset = z - 1;
                    }
                    else {
                        // parse hex to field to 16-bit value and write it in network byte-order
                        parts[w + offset] = _htons(parseInt(words[w], 16));
                    }
                }
                else {
                    // parsed IPv4 words
                    parts[w + offset] = words[w];
                }
            }
            return [
                (parts[1] << 16) | parts[0],
                (parts[3] << 16) | parts[2],
                (parts[5] << 16) | parts[4],
                (parts[7] << 16) | parts[6]
            ];
        };
        var DNS = {
            address_map: {
                id: 1,
                addrs: {},
                names: {},
            },
            lookup_name(name) {
                // If the name is already a valid ipv4 / ipv6 address, don't generate a fake one.
                var res = inetPton4(name);
                if (res !== null) {
                    return name;
                }
                res = inetPton6(name);
                if (res !== null) {
                    return name;
                }
                // See if this name is already mapped.
                var addr;
                if (DNS.address_map.addrs[name]) {
                    addr = DNS.address_map.addrs[name];
                }
                else {
                    var id = DNS.address_map.id++;
                    assert(id < 65535, 'exceeded max address mappings of 65535');
                    addr = '172.29.' + (id & 0xff) + '.' + (id & 0xff00);
                    DNS.address_map.names[addr] = name;
                    DNS.address_map.addrs[name] = addr;
                }
                return addr;
            },
            lookup_addr(addr) {
                if (DNS.address_map.names[addr]) {
                    return DNS.address_map.names[addr];
                }
                return null;
            },
        };
        var inetNtop4 = (addr) => {
            return (addr & 0xff) + '.' + ((addr >> 8) & 0xff) + '.' + ((addr >> 16) & 0xff) + '.' + ((addr >> 24) & 0xff);
        };
        var inetNtop6 = (ints) => {
            //  ref:  http://www.ietf.org/rfc/rfc2373.txt - section 2.5.4
            //  Format for IPv4 compatible and mapped  128-bit IPv6 Addresses
            //  128-bits are split into eight 16-bit words
            //  stored in network byte order (big-endian)
            //  |                80 bits               | 16 |      32 bits        |
            //  +-----------------------------------------------------------------+
            //  |               10 bytes               |  2 |      4 bytes        |
            //  +--------------------------------------+--------------------------+
            //  +               5 words                |  1 |      2 words        |
            //  +--------------------------------------+--------------------------+
            //  |0000..............................0000|0000|    IPv4 ADDRESS     | (compatible)
            //  +--------------------------------------+----+---------------------+
            //  |0000..............................0000|FFFF|    IPv4 ADDRESS     | (mapped)
            //  +--------------------------------------+----+---------------------+
            var str = "";
            var word = 0;
            var longest = 0;
            var lastzero = 0;
            var zstart = 0;
            var len = 0;
            var i = 0;
            var parts = [
                ints[0] & 0xffff,
                (ints[0] >> 16),
                ints[1] & 0xffff,
                (ints[1] >> 16),
                ints[2] & 0xffff,
                (ints[2] >> 16),
                ints[3] & 0xffff,
                (ints[3] >> 16)
            ];
            // Handle IPv4-compatible, IPv4-mapped, loopback and any/unspecified addresses
            var hasipv4 = true;
            var v4part = "";
            // check if the 10 high-order bytes are all zeros (first 5 words)
            for (i = 0; i < 5; i++) {
                if (parts[i] !== 0) {
                    hasipv4 = false;
                    break;
                }
            }
            if (hasipv4) {
                // low-order 32-bits store an IPv4 address (bytes 13 to 16) (last 2 words)
                v4part = inetNtop4(parts[6] | (parts[7] << 16));
                // IPv4-mapped IPv6 address if 16-bit value (bytes 11 and 12) == 0xFFFF (6th word)
                if (parts[5] === -1) {
                    str = "::ffff:";
                    str += v4part;
                    return str;
                }
                // IPv4-compatible IPv6 address if 16-bit value (bytes 11 and 12) == 0x0000 (6th word)
                if (parts[5] === 0) {
                    str = "::";
                    //special case IPv6 addresses
                    if (v4part === "0.0.0.0")
                        v4part = ""; // any/unspecified address
                    if (v4part === "0.0.0.1")
                        v4part = "1"; // loopback address
                    str += v4part;
                    return str;
                }
            }
            // Handle all other IPv6 addresses
            // first run to find the longest contiguous zero words
            for (word = 0; word < 8; word++) {
                if (parts[word] === 0) {
                    if (word - lastzero > 1) {
                        len = 0;
                    }
                    lastzero = word;
                    len++;
                }
                if (len > longest) {
                    longest = len;
                    zstart = word - longest + 1;
                }
            }
            for (word = 0; word < 8; word++) {
                if (longest > 1) {
                    // compress contiguous zeros - to produce "::"
                    if (parts[word] === 0 && word >= zstart && word < (zstart + longest)) {
                        if (word === zstart) {
                            str += ":";
                            if (zstart === 0)
                                str += ":"; //leading zeros case
                        }
                        continue;
                    }
                }
                // converts 16-bit words from big-endian to little-endian before converting to hex string
                str += Number(_ntohs(parts[word] & 0xffff)).toString(16);
                str += word < 7 ? ":" : "";
            }
            return str;
        };
        /** @param {number=} addrlen */
        var writeSockaddr = (sa, family, addr, port, addrlen) => {
            switch (family) {
                case 2:
                    addr = inetPton4(addr);
                    zeroMemory(sa, 16);
                    if (addrlen) {
                        HEAP32[((addrlen) >> 2)] = 16;
                    }
                    HEAP16[((sa) >> 1)] = family;
                    HEAP32[(((sa) + (4)) >> 2)] = addr;
                    HEAP16[(((sa) + (2)) >> 1)] = _htons(port);
                    break;
                case 10:
                    addr = inetPton6(addr);
                    zeroMemory(sa, 28);
                    if (addrlen) {
                        HEAP32[((addrlen) >> 2)] = 28;
                    }
                    HEAP32[((sa) >> 2)] = family;
                    HEAP32[(((sa) + (8)) >> 2)] = addr[0];
                    HEAP32[(((sa) + (12)) >> 2)] = addr[1];
                    HEAP32[(((sa) + (16)) >> 2)] = addr[2];
                    HEAP32[(((sa) + (20)) >> 2)] = addr[3];
                    HEAP16[(((sa) + (2)) >> 1)] = _htons(port);
                    break;
                default:
                    return 5;
            }
            return 0;
        };
        function _getaddrinfo(node, service, hint, out) {
            if (ENVIRONMENT_IS_PTHREAD)
                return proxyToMainThread(138, 0, 1, node, service, hint, out);
            // Note getaddrinfo currently only returns a single addrinfo with ai_next defaulting to NULL. When NULL
            // hints are specified or ai_family set to AF_UNSPEC or ai_socktype or ai_protocol set to 0 then we
            // really should provide a linked list of suitable addrinfo values.
            var addrs = [];
            var canon = null;
            var addr = 0;
            var port = 0;
            var flags = 0;
            var family = 0;
            var type = 0;
            var proto = 0;
            var ai, last;
            function allocaddrinfo(family, type, proto, canon, addr, port) {
                var sa, salen, ai;
                var errno;
                salen = family === 10 ?
                    28 :
                    16;
                addr = family === 10 ?
                    inetNtop6(addr) :
                    inetNtop4(addr);
                sa = _malloc(salen);
                errno = writeSockaddr(sa, family, addr, port);
                assert(!errno);
                ai = _malloc(32);
                HEAP32[(((ai) + (4)) >> 2)] = family;
                HEAP32[(((ai) + (8)) >> 2)] = type;
                HEAP32[(((ai) + (12)) >> 2)] = proto;
                HEAPU32[(((ai) + (24)) >> 2)] = canon;
                HEAPU32[(((ai) + (20)) >> 2)] = sa;
                if (family === 10) {
                    HEAP32[(((ai) + (16)) >> 2)] = 28;
                }
                else {
                    HEAP32[(((ai) + (16)) >> 2)] = 16;
                }
                HEAP32[(((ai) + (28)) >> 2)] = 0;
                return ai;
            }
            if (hint) {
                flags = HEAP32[((hint) >> 2)];
                family = HEAP32[(((hint) + (4)) >> 2)];
                type = HEAP32[(((hint) + (8)) >> 2)];
                proto = HEAP32[(((hint) + (12)) >> 2)];
            }
            if (type && !proto) {
                proto = type === 2 ? 17 : 6;
            }
            if (!type && proto) {
                type = proto === 17 ? 2 : 1;
            }
            // If type or proto are set to zero in hints we should really be returning multiple addrinfo values, but for
            // now default to a TCP STREAM socket so we can at least return a sensible addrinfo given NULL hints.
            if (proto === 0) {
                proto = 6;
            }
            if (type === 0) {
                type = 1;
            }
            if (!node && !service) {
                return -2;
            }
            if (flags & ~(1 | 2 | 4 |
                1024 | 8 | 16 | 32)) {
                return -1;
            }
            if (hint !== 0 && (HEAP32[((hint) >> 2)] & 2) && !node) {
                return -1;
            }
            if (flags & 32) {
                // TODO
                return -2;
            }
            if (type !== 0 && type !== 1 && type !== 2) {
                return -7;
            }
            if (family !== 0 && family !== 2 && family !== 10) {
                return -6;
            }
            if (service) {
                service = UTF8ToString(service);
                port = parseInt(service, 10);
                if (isNaN(port)) {
                    if (flags & 1024) {
                        return -2;
                    }
                    // TODO support resolving well-known service names from:
                    // http://www.iana.org/assignments/service-names-port-numbers/service-names-port-numbers.txt
                    return -8;
                }
            }
            if (!node) {
                if (family === 0) {
                    family = 2;
                }
                if ((flags & 1) === 0) {
                    if (family === 2) {
                        addr = _htonl(2130706433);
                    }
                    else {
                        addr = [0, 0, 0, 1];
                    }
                }
                ai = allocaddrinfo(family, type, proto, null, addr, port);
                HEAPU32[((out) >> 2)] = ai;
                return 0;
            }
            //
            // try as a numeric address
            //
            node = UTF8ToString(node);
            addr = inetPton4(node);
            if (addr !== null) {
                // incoming node is a valid ipv4 address
                if (family === 0 || family === 2) {
                    family = 2;
                }
                else if (family === 10 && (flags & 8)) {
                    addr = [0, 0, _htonl(0xffff), addr];
                    family = 10;
                }
                else {
                    return -2;
                }
            }
            else {
                addr = inetPton6(node);
                if (addr !== null) {
                    // incoming node is a valid ipv6 address
                    if (family === 0 || family === 10) {
                        family = 10;
                    }
                    else {
                        return -2;
                    }
                }
            }
            if (addr != null) {
                ai = allocaddrinfo(family, type, proto, node, addr, port);
                HEAPU32[((out) >> 2)] = ai;
                return 0;
            }
            if (flags & 4) {
                return -2;
            }
            //
            // try as a hostname
            //
            // resolve the hostname to a temporary fake address
            node = DNS.lookup_name(node);
            addr = inetPton4(node);
            if (family === 0) {
                family = 2;
            }
            else if (family === 10) {
                addr = [0, 0, _htonl(0xffff), addr];
            }
            ai = allocaddrinfo(family, type, proto, null, addr, port);
            HEAPU32[((out) >> 2)] = ai;
            return 0;
        }
        var initRandomFill = () => {
            if (typeof crypto == 'object' && typeof crypto['getRandomValues'] == 'function') {
                // for modern web browsers
                // like with most Web APIs, we can't use Web Crypto API directly on shared memory,
                // so we need to create an intermediate buffer and copy it to the destination
                return (view) => (view.set(crypto.getRandomValues(new Uint8Array(view.byteLength))),
                    // Return the original view to match modern native implementations.
                    view);
            }
            else
                // we couldn't find a proper implementation, as Math.random() is not suitable for /dev/random, see emscripten-core/emscripten/pull/7096
                abort('no cryptographic support found for randomDevice. consider polyfilling it if you want to use something insecure like Math.random(), e.g. put this in a --pre-js: var crypto = { getRandomValues: (array) => { for (var i = 0; i < array.length; i++) array[i] = (Math.random()*256)|0 } };');
        };
        var randomFill = (view) => {
            // Lazily init on the first invocation.
            return (randomFill = initRandomFill())(view);
        };
        var _getentropy = (buffer, size) => {
            randomFill(HEAPU8.subarray(buffer, buffer + size));
            return 0;
        };
        var readSockaddr = (sa, salen) => {
            // family / port offsets are common to both sockaddr_in and sockaddr_in6
            var family = HEAP16[((sa) >> 1)];
            var port = _ntohs(HEAPU16[(((sa) + (2)) >> 1)]);
            var addr;
            switch (family) {
                case 2:
                    if (salen !== 16) {
                        return { errno: 28 };
                    }
                    addr = HEAP32[(((sa) + (4)) >> 2)];
                    addr = inetNtop4(addr);
                    break;
                case 10:
                    if (salen !== 28) {
                        return { errno: 28 };
                    }
                    addr = [
                        HEAP32[(((sa) + (8)) >> 2)],
                        HEAP32[(((sa) + (12)) >> 2)],
                        HEAP32[(((sa) + (16)) >> 2)],
                        HEAP32[(((sa) + (20)) >> 2)]
                    ];
                    addr = inetNtop6(addr);
                    break;
                default:
                    return { errno: 5 };
            }
            return { family: family, addr: addr, port: port };
        };
        var _getnameinfo = (sa, salen, node, nodelen, serv, servlen, flags) => {
            var info = readSockaddr(sa, salen);
            if (info.errno) {
                return -6;
            }
            var port = info.port;
            var addr = info.addr;
            var overflowed = false;
            if (node && nodelen) {
                var lookup;
                if ((flags & 1) || !(lookup = DNS.lookup_addr(addr))) {
                    if (flags & 8) {
                        return -2;
                    }
                }
                else {
                    addr = lookup;
                }
                var numBytesWrittenExclNull = stringToUTF8(addr, node, nodelen);
                if (numBytesWrittenExclNull + 1 >= nodelen) {
                    overflowed = true;
                }
            }
            if (serv && servlen) {
                port = '' + port;
                var numBytesWrittenExclNull = stringToUTF8(port, serv, servlen);
                if (numBytesWrittenExclNull + 1 >= servlen) {
                    overflowed = true;
                }
            }
            if (overflowed) {
                // Note: even when we overflow, getnameinfo() is specced to write out the truncated results.
                return -12;
            }
            return 0;
        };
        var arraySum = (array, index) => {
            var sum = 0;
            for (var i = 0; i <= index; sum += array[i++]) {
                // no-op
            }
            return sum;
        };
        var MONTH_DAYS_LEAP = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        var MONTH_DAYS_REGULAR = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        var addDays = (date, days) => {
            var newDate = new Date(date.getTime());
            while (days > 0) {
                var leap = isLeapYear(newDate.getFullYear());
                var currentMonth = newDate.getMonth();
                var daysInCurrentMonth = (leap ? MONTH_DAYS_LEAP : MONTH_DAYS_REGULAR)[currentMonth];
                if (days > daysInCurrentMonth - newDate.getDate()) {
                    // we spill over to next month
                    days -= (daysInCurrentMonth - newDate.getDate() + 1);
                    newDate.setDate(1);
                    if (currentMonth < 11) {
                        newDate.setMonth(currentMonth + 1);
                    }
                    else {
                        newDate.setMonth(0);
                        newDate.setFullYear(newDate.getFullYear() + 1);
                    }
                }
                else {
                    // we stay in current month
                    newDate.setDate(newDate.getDate() + days);
                    return newDate;
                }
            }
            return newDate;
        };
        var writeArrayToMemory = (array, buffer) => {
            assert(array.length >= 0, 'writeArrayToMemory array must have a length (should be an array or typed array)');
            HEAP8.set(array, buffer);
        };
        var _strftime = (s, maxsize, format, tm) => {
            // size_t strftime(char *restrict s, size_t maxsize, const char *restrict format, const struct tm *restrict timeptr);
            // http://pubs.opengroup.org/onlinepubs/009695399/functions/strftime.html
            var tm_zone = HEAPU32[(((tm) + (40)) >> 2)];
            var date = {
                tm_sec: HEAP32[((tm) >> 2)],
                tm_min: HEAP32[(((tm) + (4)) >> 2)],
                tm_hour: HEAP32[(((tm) + (8)) >> 2)],
                tm_mday: HEAP32[(((tm) + (12)) >> 2)],
                tm_mon: HEAP32[(((tm) + (16)) >> 2)],
                tm_year: HEAP32[(((tm) + (20)) >> 2)],
                tm_wday: HEAP32[(((tm) + (24)) >> 2)],
                tm_yday: HEAP32[(((tm) + (28)) >> 2)],
                tm_isdst: HEAP32[(((tm) + (32)) >> 2)],
                tm_gmtoff: HEAP32[(((tm) + (36)) >> 2)],
                tm_zone: tm_zone ? UTF8ToString(tm_zone) : ''
            };
            var pattern = UTF8ToString(format);
            // expand format
            var EXPANSION_RULES_1 = {
                '%D': '%m/%d/%y', // Equivalent to %m / %d / %y
                '%F': '%Y-%m-%d', // Equivalent to %Y - %m - %d
                '%h': '%b', // Equivalent to %b
                '%r': '%I:%M:%S %p', // Replaced by the time in a.m. and p.m. notation
                '%R': '%H:%M', // Replaced by the time in 24-hour notation
                '%T': '%H:%M:%S', // Replaced by the time
                '%x': '%m/%d/%y', // Replaced by the locale's appropriate date representation
                '%X': '%H:%M:%S', // Replaced by the locale's appropriate time representation
                // Modified Conversion Specifiers
                '%Ec': '%c', // Replaced by the locale's alternative appropriate date and time representation.
                '%EC': '%C', // Replaced by the name of the base year (period) in the locale's alternative representation.
                '%Ex': '%m/%d/%y', // Replaced by the locale's alternative date representation.
                '%EX': '%H:%M:%S', // Replaced by the locale's alternative time representation.
                '%Ey': '%y', // Replaced by the offset from %EC (year only) in the locale's alternative representation.
                '%EY': '%Y', // Replaced by the full alternative year representation.
                '%Od': '%d', // Replaced by the day of the month, using the locale's alternative numeric symbols, filled as needed with leading zeros if there is any alternative symbol for zero; otherwise, with leading <space> characters.
                '%Oe': '%e', // Replaced by the day of the month, using the locale's alternative numeric symbols, filled as needed with leading <space> characters.
                '%OH': '%H', // Replaced by the hour (24-hour clock) using the locale's alternative numeric symbols.
                '%OI': '%I', // Replaced by the hour (12-hour clock) using the locale's alternative numeric symbols.
                '%Om': '%m', // Replaced by the month using the locale's alternative numeric symbols.
                '%OM': '%M', // Replaced by the minutes using the locale's alternative numeric symbols.
                '%OS': '%S', // Replaced by the seconds using the locale's alternative numeric symbols.
                '%Ou': '%u', // Replaced by the weekday as a number in the locale's alternative representation (Monday=1).
                '%OU': '%U', // Replaced by the week number of the year (Sunday as the first day of the week, rules corresponding to %U ) using the locale's alternative numeric symbols.
                '%OV': '%V', // Replaced by the week number of the year (Monday as the first day of the week, rules corresponding to %V ) using the locale's alternative numeric symbols.
                '%Ow': '%w', // Replaced by the number of the weekday (Sunday=0) using the locale's alternative numeric symbols.
                '%OW': '%W', // Replaced by the week number of the year (Monday as the first day of the week) using the locale's alternative numeric symbols.
                '%Oy': '%y', // Replaced by the year (offset from %C ) using the locale's alternative numeric symbols.
                '%c': '%a %b %d %H:%M:%S %Y', // Replaced by the locale's appropriate date and time representation - e.g., Mon Aug  3 14:02:01 2013
            };
            for (var rule in EXPANSION_RULES_1) {
                pattern = pattern.replace(new RegExp(rule, 'g'), EXPANSION_RULES_1[rule]);
            }
            var WEEKDAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
            var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
            function leadingSomething(value, digits, character) {
                var str = typeof value == 'number' ? value.toString() : (value || '');
                while (str.length < digits) {
                    str = character[0] + str;
                }
                return str;
            }
            function leadingNulls(value, digits) {
                return leadingSomething(value, digits, '0');
            }
            function compareByDay(date1, date2) {
                function sgn(value) {
                    return value < 0 ? -1 : (value > 0 ? 1 : 0);
                }
                var compare;
                if ((compare = sgn(date1.getFullYear() - date2.getFullYear())) === 0) {
                    if ((compare = sgn(date1.getMonth() - date2.getMonth())) === 0) {
                        compare = sgn(date1.getDate() - date2.getDate());
                    }
                }
                return compare;
            }
            function getFirstWeekStartDate(janFourth) {
                switch (janFourth.getDay()) {
                    case 0: // Sunday
                        return new Date(janFourth.getFullYear() - 1, 11, 29);
                    case 1: // Monday
                        return janFourth;
                    case 2: // Tuesday
                        return new Date(janFourth.getFullYear(), 0, 3);
                    case 3: // Wednesday
                        return new Date(janFourth.getFullYear(), 0, 2);
                    case 4: // Thursday
                        return new Date(janFourth.getFullYear(), 0, 1);
                    case 5: // Friday
                        return new Date(janFourth.getFullYear() - 1, 11, 31);
                    case 6: // Saturday
                        return new Date(janFourth.getFullYear() - 1, 11, 30);
                }
            }
            function getWeekBasedYear(date) {
                var thisDate = addDays(new Date(date.tm_year + 1900, 0, 1), date.tm_yday);
                var janFourthThisYear = new Date(thisDate.getFullYear(), 0, 4);
                var janFourthNextYear = new Date(thisDate.getFullYear() + 1, 0, 4);
                var firstWeekStartThisYear = getFirstWeekStartDate(janFourthThisYear);
                var firstWeekStartNextYear = getFirstWeekStartDate(janFourthNextYear);
                if (compareByDay(firstWeekStartThisYear, thisDate) <= 0) {
                    // this date is after the start of the first week of this year
                    if (compareByDay(firstWeekStartNextYear, thisDate) <= 0) {
                        return thisDate.getFullYear() + 1;
                    }
                    return thisDate.getFullYear();
                }
                return thisDate.getFullYear() - 1;
            }
            var EXPANSION_RULES_2 = {
                '%a': (date) => WEEKDAYS[date.tm_wday].substring(0, 3),
                '%A': (date) => WEEKDAYS[date.tm_wday],
                '%b': (date) => MONTHS[date.tm_mon].substring(0, 3),
                '%B': (date) => MONTHS[date.tm_mon],
                '%C': (date) => {
                    var year = date.tm_year + 1900;
                    return leadingNulls((year / 100) | 0, 2);
                },
                '%d': (date) => leadingNulls(date.tm_mday, 2),
                '%e': (date) => leadingSomething(date.tm_mday, 2, ' '),
                '%g': (date) => {
                    // %g, %G, and %V give values according to the ISO 8601:2000 standard week-based year.
                    // In this system, weeks begin on a Monday and week 1 of the year is the week that includes
                    // January 4th, which is also the week that includes the first Thursday of the year, and
                    // is also the first week that contains at least four days in the year.
                    // If the first Monday of January is the 2nd, 3rd, or 4th, the preceding days are part of
                    // the last week of the preceding year; thus, for Saturday 2nd January 1999,
                    // %G is replaced by 1998 and %V is replaced by 53. If December 29th, 30th,
                    // or 31st is a Monday, it and any following days are part of week 1 of the following year.
                    // Thus, for Tuesday 30th December 1997, %G is replaced by 1998 and %V is replaced by 01.
                    return getWeekBasedYear(date).toString().substring(2);
                },
                '%G': getWeekBasedYear,
                '%H': (date) => leadingNulls(date.tm_hour, 2),
                '%I': (date) => {
                    var twelveHour = date.tm_hour;
                    if (twelveHour == 0)
                        twelveHour = 12;
                    else if (twelveHour > 12)
                        twelveHour -= 12;
                    return leadingNulls(twelveHour, 2);
                },
                '%j': (date) => {
                    // Day of the year (001-366)
                    return leadingNulls(date.tm_mday + arraySum(isLeapYear(date.tm_year + 1900) ? MONTH_DAYS_LEAP : MONTH_DAYS_REGULAR, date.tm_mon - 1), 3);
                },
                '%m': (date) => leadingNulls(date.tm_mon + 1, 2),
                '%M': (date) => leadingNulls(date.tm_min, 2),
                '%n': () => '\n',
                '%p': (date) => {
                    if (date.tm_hour >= 0 && date.tm_hour < 12) {
                        return 'AM';
                    }
                    return 'PM';
                },
                '%S': (date) => leadingNulls(date.tm_sec, 2),
                '%t': () => '\t',
                '%u': (date) => date.tm_wday || 7,
                '%U': (date) => {
                    var days = date.tm_yday + 7 - date.tm_wday;
                    return leadingNulls(Math.floor(days / 7), 2);
                },
                '%V': (date) => {
                    // Replaced by the week number of the year (Monday as the first day of the week)
                    // as a decimal number [01,53]. If the week containing 1 January has four
                    // or more days in the new year, then it is considered week 1.
                    // Otherwise, it is the last week of the previous year, and the next week is week 1.
                    // Both January 4th and the first Thursday of January are always in week 1. [ tm_year, tm_wday, tm_yday]
                    var val = Math.floor((date.tm_yday + 7 - (date.tm_wday + 6) % 7) / 7);
                    // If 1 Jan is just 1-3 days past Monday, the previous week
                    // is also in this year.
                    if ((date.tm_wday + 371 - date.tm_yday - 2) % 7 <= 2) {
                        val++;
                    }
                    if (!val) {
                        val = 52;
                        // If 31 December of prev year a Thursday, or Friday of a
                        // leap year, then the prev year has 53 weeks.
                        var dec31 = (date.tm_wday + 7 - date.tm_yday - 1) % 7;
                        if (dec31 == 4 || (dec31 == 5 && isLeapYear(date.tm_year % 400 - 1))) {
                            val++;
                        }
                    }
                    else if (val == 53) {
                        // If 1 January is not a Thursday, and not a Wednesday of a
                        // leap year, then this year has only 52 weeks.
                        var jan1 = (date.tm_wday + 371 - date.tm_yday) % 7;
                        if (jan1 != 4 && (jan1 != 3 || !isLeapYear(date.tm_year)))
                            val = 1;
                    }
                    return leadingNulls(val, 2);
                },
                '%w': (date) => date.tm_wday,
                '%W': (date) => {
                    var days = date.tm_yday + 7 - ((date.tm_wday + 6) % 7);
                    return leadingNulls(Math.floor(days / 7), 2);
                },
                '%y': (date) => {
                    // Replaced by the last two digits of the year as a decimal number [00,99]. [ tm_year]
                    return (date.tm_year + 1900).toString().substring(2);
                },
                // Replaced by the year as a decimal number (for example, 1997). [ tm_year]
                '%Y': (date) => date.tm_year + 1900,
                '%z': (date) => {
                    // Replaced by the offset from UTC in the ISO 8601:2000 standard format ( +hhmm or -hhmm ).
                    // For example, "-0430" means 4 hours 30 minutes behind UTC (west of Greenwich).
                    var off = date.tm_gmtoff;
                    var ahead = off >= 0;
                    off = Math.abs(off) / 60;
                    // convert from minutes into hhmm format (which means 60 minutes = 100 units)
                    off = (off / 60) * 100 + (off % 60);
                    return (ahead ? '+' : '-') + String("0000" + off).slice(-4);
                },
                '%Z': (date) => date.tm_zone,
                '%%': () => '%'
            };
            // Replace %% with a pair of NULLs (which cannot occur in a C string), then
            // re-inject them after processing.
            pattern = pattern.replace(/%%/g, '\0\0');
            for (var rule in EXPANSION_RULES_2) {
                if (pattern.includes(rule)) {
                    pattern = pattern.replace(new RegExp(rule, 'g'), EXPANSION_RULES_2[rule](date));
                }
            }
            pattern = pattern.replace(/\0\0/g, '%');
            var bytes = intArrayFromString(pattern, false);
            if (bytes.length > maxsize) {
                return 0;
            }
            writeArrayToMemory(bytes, s);
            return bytes.length - 1;
        };
        var _strftime_l = (s, maxsize, format, tm, loc) => {
            return _strftime(s, maxsize, format, tm); // no locale support yet
        };
        var dynCall = (sig, ptr, args = []) => {
            assert(getWasmTableEntry(ptr), `missing table entry in dynCall: ${ptr}`);
            var rtn = getWasmTableEntry(ptr)(...args);
            return rtn;
        };
        var MEMFS = {
            createBackend(opts) {
                return _wasmfs_create_memory_backend();
            },
        };
        var PATH = {
            isAbs: (path) => path.charAt(0) === '/',
            splitPath: (filename) => {
                var splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
                return splitPathRe.exec(filename).slice(1);
            },
            normalizeArray: (parts, allowAboveRoot) => {
                // if the path tries to go above the root, `up` ends up > 0
                var up = 0;
                for (var i = parts.length - 1; i >= 0; i--) {
                    var last = parts[i];
                    if (last === '.') {
                        parts.splice(i, 1);
                    }
                    else if (last === '..') {
                        parts.splice(i, 1);
                        up++;
                    }
                    else if (up) {
                        parts.splice(i, 1);
                        up--;
                    }
                }
                // if the path is allowed to go above the root, restore leading ..s
                if (allowAboveRoot) {
                    for (; up; up--) {
                        parts.unshift('..');
                    }
                }
                return parts;
            },
            normalize: (path) => {
                var isAbsolute = PATH.isAbs(path), trailingSlash = path.substr(-1) === '/';
                // Normalize the path
                path = PATH.normalizeArray(path.split('/').filter((p) => !!p), !isAbsolute).join('/');
                if (!path && !isAbsolute) {
                    path = '.';
                }
                if (path && trailingSlash) {
                    path += '/';
                }
                return (isAbsolute ? '/' : '') + path;
            },
            dirname: (path) => {
                var result = PATH.splitPath(path), root = result[0], dir = result[1];
                if (!root && !dir) {
                    // No dirname whatsoever
                    return '.';
                }
                if (dir) {
                    // It has a dirname, strip trailing slash
                    dir = dir.substr(0, dir.length - 1);
                }
                return root + dir;
            },
            basename: (path) => {
                // EMSCRIPTEN return '/'' for '/', not an empty string
                if (path === '/')
                    return '/';
                path = PATH.normalize(path);
                path = path.replace(/\/$/, "");
                var lastSlash = path.lastIndexOf('/');
                if (lastSlash === -1)
                    return path;
                return path.substr(lastSlash + 1);
            },
            join: (...paths) => PATH.normalize(paths.join('/')),
            join2: (l, r) => PATH.normalize(l + '/' + r),
        };
        var withStackSave = (f) => {
            var stack = stackSave();
            var ret = f();
            stackRestore(stack);
            return ret;
        };
        var FS_mknod = (path, mode, dev) => FS.handleError(withStackSave(() => {
            var pathBuffer = stringToUTF8OnStack(path);
            return __wasmfs_mknod(pathBuffer, mode, dev);
        }));
        var FS_create = (path, mode = 438 /* 0666 */) => {
            mode &= 4095;
            mode |= 32768;
            return FS_mknod(path, mode, 0);
        };
        var FS_writeFile = (path, data) => {
            var sp = stackSave();
            var pathBuffer = stringToUTF8OnStack(path);
            if (typeof data == 'string') {
                var buf = new Uint8Array(lengthBytesUTF8(data) + 1);
                var actualNumBytes = stringToUTF8Array(data, buf, 0, buf.length);
                data = buf.slice(0, actualNumBytes);
            }
            var dataBuffer = _malloc(data.length);
            assert(dataBuffer);
            for (var i = 0; i < data.length; i++) {
                HEAP8[(dataBuffer) + (i)] = data[i];
            }
            var ret = __wasmfs_write_file(pathBuffer, dataBuffer, data.length);
            _free(dataBuffer);
            stackRestore(sp);
            return ret;
        };
        var FS_createDataFile = (parent, name, fileData, canRead, canWrite, canOwn) => {
            var pathName = name ? parent + '/' + name : parent;
            var mode = FS_getMode(canRead, canWrite);
            if (!wasmFSPreloadingFlushed) {
                // WasmFS code in the wasm is not ready to be called yet. Cache the
                // files we want to create here in JS, and WasmFS will read them
                // later.
                wasmFSPreloadedFiles.push({ pathName, fileData, mode });
            }
            else {
                // WasmFS is already running, so create the file normally.
                FS_create(pathName, mode);
                FS_writeFile(pathName, fileData);
            }
        };
        /** @param {boolean=} noRunDep */
        var asyncLoad = (url, onload, onerror, noRunDep) => {
            var dep = !noRunDep ? getUniqueRunDependency(`al ${url}`) : '';
            readAsync(url).then((arrayBuffer) => {
                assert(arrayBuffer, `Loading data file "${url}" failed (no arrayBuffer).`);
                onload(new Uint8Array(arrayBuffer));
                if (dep)
                    removeRunDependency(dep);
            }, (err) => {
                if (onerror) {
                    onerror();
                }
                else {
                    throw `Loading data file "${url}" failed.`;
                }
            });
            if (dep)
                addRunDependency(dep);
        };
        var PATH_FS = {
            resolve: (...args) => {
                var resolvedPath = '', resolvedAbsolute = false;
                for (var i = args.length - 1; i >= -1 && !resolvedAbsolute; i--) {
                    var path = (i >= 0) ? args[i] : FS.cwd();
                    // Skip empty and invalid entries
                    if (typeof path != 'string') {
                        throw new TypeError('Arguments to path.resolve must be strings');
                    }
                    else if (!path) {
                        return ''; // an invalid portion invalidates the whole thing
                    }
                    resolvedPath = path + '/' + resolvedPath;
                    resolvedAbsolute = PATH.isAbs(path);
                }
                // At this point the path should be resolved to a full absolute path, but
                // handle relative paths to be safe (might happen when process.cwd() fails)
                resolvedPath = PATH.normalizeArray(resolvedPath.split('/').filter((p) => !!p), !resolvedAbsolute).join('/');
                return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
            },
            relative: (from, to) => {
                from = PATH_FS.resolve(from).substr(1);
                to = PATH_FS.resolve(to).substr(1);
                function trim(arr) {
                    var start = 0;
                    for (; start < arr.length; start++) {
                        if (arr[start] !== '')
                            break;
                    }
                    var end = arr.length - 1;
                    for (; end >= 0; end--) {
                        if (arr[end] !== '')
                            break;
                    }
                    if (start > end)
                        return [];
                    return arr.slice(start, end - start + 1);
                }
                var fromParts = trim(from.split('/'));
                var toParts = trim(to.split('/'));
                var length = Math.min(fromParts.length, toParts.length);
                var samePartsLength = length;
                for (var i = 0; i < length; i++) {
                    if (fromParts[i] !== toParts[i]) {
                        samePartsLength = i;
                        break;
                    }
                }
                var outputParts = [];
                for (var i = samePartsLength; i < fromParts.length; i++) {
                    outputParts.push('..');
                }
                outputParts = outputParts.concat(toParts.slice(samePartsLength));
                return outputParts.join('/');
            },
        };
        var FS_handledByPreloadPlugin = (byteArray, fullname, finish, onerror) => {
            // Ensure plugins are ready.
            if (typeof Browser != 'undefined')
                Browser.init();
            var handled = false;
            preloadPlugins.forEach((plugin) => {
                if (handled)
                    return;
                if (plugin['canHandle'](fullname)) {
                    plugin['handle'](byteArray, fullname, finish, onerror);
                    handled = true;
                }
            });
            return handled;
        };
        var FS_createPreloadedFile = (parent, name, url, canRead, canWrite, onload, onerror, dontCreateFile, canOwn, preFinish) => {
            // TODO we should allow people to just pass in a complete filename instead
            // of parent and name being that we just join them anyways
            var fullname = name ? PATH_FS.resolve(PATH.join2(parent, name)) : parent;
            var dep = getUniqueRunDependency(`cp ${fullname}`); // might have several active requests for the same fullname
            function processData(byteArray) {
                function finish(byteArray) {
                    preFinish?.();
                    if (!dontCreateFile) {
                        FS_createDataFile(parent, name, byteArray, canRead, canWrite, canOwn);
                    }
                    onload?.();
                    removeRunDependency(dep);
                }
                if (FS_handledByPreloadPlugin(byteArray, fullname, finish, () => {
                    onerror?.();
                    removeRunDependency(dep);
                })) {
                    return;
                }
                finish(byteArray);
            }
            addRunDependency(dep);
            if (typeof url == 'string') {
                asyncLoad(url, processData, onerror);
            }
            else {
                processData(url);
            }
        };
        var FS_getMode = (canRead, canWrite) => {
            var mode = 0;
            if (canRead)
                mode |= 292 | 73;
            if (canWrite)
                mode |= 146;
            return mode;
        };
        var FS_modeStringToFlags = (str) => {
            var flagModes = {
                'r': 0,
                'r+': 2,
                'w': 512 | 64 | 1,
                'w+': 512 | 64 | 2,
                'a': 1024 | 64 | 1,
                'a+': 1024 | 64 | 2,
            };
            var flags = flagModes[str];
            if (typeof flags == 'undefined') {
                throw new Error(`Unknown file open mode: ${str}`);
            }
            return flags;
        };
        var FS_mkdir = (path, mode = 511 /* 0777 */) => FS.handleError(withStackSave(() => {
            var buffer = stringToUTF8OnStack(path);
            return __wasmfs_mkdir(buffer, mode);
        }));
        /**
         * @param {number=} mode Optionally, the mode to create in. Uses mkdir's
         *                       default if not set.
         */
        var FS_mkdirTree = (path, mode) => {
            var dirs = path.split('/');
            var d = '';
            for (var i = 0; i < dirs.length; ++i) {
                if (!dirs[i])
                    continue;
                d += '/' + dirs[i];
                try {
                    FS_mkdir(d, mode);
                }
                catch (e) {
                    if (e.errno != 20)
                        throw e;
                }
            }
        };
        var FS_unlink = (path) => withStackSave(() => {
            var buffer = stringToUTF8OnStack(path);
            return __wasmfs_unlink(buffer);
        });
        var __wasmfs_externalfs_delete_key = async function (store, key) {
            return new Promise((resolve, reject) => {
                const deleteReq = store.delete(key);
                deleteReq.onerror = reject;
                deleteReq.onsuccess = event => resolve(event.target.result);
            });
        };
        var ExternalFS = {
            createBackend(opts) {
                return _wasmfs_create_externalfs_backend();
            },
            addDirectory: async function (handle) {
                if (!(handle instanceof FileSystemDirectoryHandle))
                    return null;
                const store = await __wasmfs_externalfs_get_object_store();
                if (await __wasmfs_externalfs_key_exists(store, handle.name))
                    await __wasmfs_externalfs_delete_key(store, handle.name);
                return new Promise(async (resolve, reject) => {
                    const writeReq = store.add(handle, handle.name);
                    writeReq.onerror = reject;
                    writeReq.onsuccess = (event) => resolve(event.target.result);
                });
            },
            getAllStoredHandles: async function () {
                const store = await __wasmfs_externalfs_get_object_store();
                return new Promise(async (resolve, reject) => {
                    const getAllReq = store.getAll();
                    getAllReq.onerror = reject;
                    getAllReq.onsuccess = (event) => resolve(event.target.result);
                });
            },
            permitHandle: async function (handle) {
                const permission = await handle.queryPermission({ mode: 'read' });
                if (permission !== 'granted') {
                    const newPermission = await handle.requestPermission({ mode: 'read' });
                    if (newPermission !== 'granted')
                        return false;
                }
                return true;
            },
            getHandle: async function (directoryName) {
                const store = await __wasmfs_externalfs_get_object_store();
                const handle = await __wasmfs_externalfs_get_key(store, directoryName);
                if (!handle)
                    return null;
                const permission = await this.permitHandle(handle);
                return permission ? handle : null;
            },
            removeHandle: async function (directoryName) {
                const store = await __wasmfs_externalfs_get_object_store();
                return __wasmfs_externalfs_delete_key(store, directoryName);
            },
        };
        var wasmFS$backends = {};
        var wasmFSDevices = {};
        var wasmFSDeviceStreams = {};
        var FS = {
            init() {
                FS.ensureErrnoError();
            },
            ErrnoError: null,
            handleError(returnValue) {
                // Assume errors correspond to negative returnValues
                // since some functions like _wasmfs_open() return positive
                // numbers on success (some callers of this function may need to negate the parameter).
                if (returnValue < 0) {
                    throw new FS.ErrnoError(-returnValue);
                }
                return returnValue;
            },
            ensureErrnoError() {
                if (FS.ErrnoError)
                    return;
                FS.ErrnoError = /** @this{Object} */ function ErrnoError(code) {
                    this.errno = code;
                    this.message = 'FS error';
                    this.name = "ErrnoError";
                };
                FS.ErrnoError.prototype = new Error();
                FS.ErrnoError.prototype.constructor = FS.ErrnoError;
            },
            createDataFile(parent, name, fileData, canRead, canWrite, canOwn) {
                FS_createDataFile(parent, name, fileData, canRead, canWrite, canOwn);
            },
            createPath(parent, path, canRead, canWrite) {
                // Cache file path directory names.
                var parts = path.split('/').reverse();
                while (parts.length) {
                    var part = parts.pop();
                    if (!part)
                        continue;
                    var current = PATH.join2(parent, part);
                    if (!wasmFSPreloadingFlushed) {
                        wasmFSPreloadedDirs.push({ parentPath: parent, childName: part });
                    }
                    else {
                        FS.mkdir(current);
                    }
                    parent = current;
                }
                return current;
            },
            createPreloadedFile(parent, name, url, canRead, canWrite, onload, onerror, dontCreateFile, canOwn, preFinish) {
                return FS_createPreloadedFile(parent, name, url, canRead, canWrite, onload, onerror, dontCreateFile, canOwn, preFinish);
            },
            readFile(path, opts = {}) {
                opts.encoding = opts.encoding || 'binary';
                if (opts.encoding !== 'utf8' && opts.encoding !== 'binary') {
                    throw new Error('Invalid encoding type "' + opts.encoding + '"');
                }
                // Copy the file into a JS buffer on the heap.
                var sp = stackSave();
                var buf = __wasmfs_read_file(stringToUTF8OnStack(path));
                stackRestore(sp);
                // The signed integer length resides in the first 8 bytes of the buffer.
                var length = readI53FromI64(buf);
                // Default return type is binary.
                // The buffer contents exist 8 bytes after the returned pointer.
                var ret = new Uint8Array(HEAPU8.subarray(buf + 8, buf + 8 + length));
                if (opts.encoding === 'utf8') {
                    ret = UTF8ArrayToString(ret, 0);
                }
                return ret;
            },
            cwd: () => UTF8ToString(__wasmfs_get_cwd()),
            analyzePath(path) {
                // TODO: Consider simplifying this API, which for now matches the JS FS.
                var exists = !!FS.findObject(path);
                return {
                    exists,
                    object: {
                        contents: exists ? FS.readFile(path) : null
                    }
                };
            },
            mkdir: (path, mode) => FS_mkdir(path, mode),
            mkdirTree: (path, mode) => FS_mkdirTree(path, mode),
            rmdir: (path) => FS.handleError(withStackSave(() => __wasmfs_rmdir(stringToUTF8OnStack(path)))),
            open: (path, flags, mode) => withStackSave(() => {
                flags = typeof flags == 'string' ? FS_modeStringToFlags(flags) : flags;
                mode = typeof mode == 'undefined' ? 438 /* 0666 */ : mode;
                var buffer = stringToUTF8OnStack(path);
                var fd = FS.handleError(__wasmfs_open(buffer, flags, mode));
                return { fd: fd };
            }),
            create: (path, mode) => FS_create(path, mode),
            close: (stream) => FS.handleError(-__wasmfs_close(stream.fd)),
            unlink: (path) => FS_unlink(path),
            chdir: (path) => withStackSave(() => {
                var buffer = stringToUTF8OnStack(path);
                return __wasmfs_chdir(buffer);
            }),
            read(stream, buffer, offset, length, position) {
                var seeking = typeof position != 'undefined';
                var dataBuffer = _malloc(length);
                var bytesRead;
                if (seeking) {
                    bytesRead = __wasmfs_pread(stream.fd, dataBuffer, length, position);
                }
                else {
                    bytesRead = __wasmfs_read(stream.fd, dataBuffer, length);
                }
                bytesRead = FS.handleError(bytesRead);
                for (var i = 0; i < length; i++) {
                    buffer[offset + i] = HEAP8[(dataBuffer) + (i)];
                }
                _free(dataBuffer);
                return bytesRead;
            },
            write(stream, buffer, offset, length, position, canOwn) {
                var seeking = typeof position != 'undefined';
                var dataBuffer = _malloc(length);
                for (var i = 0; i < length; i++) {
                    HEAP8[(dataBuffer) + (i)] = buffer[offset + i];
                }
                var bytesRead;
                if (seeking) {
                    bytesRead = __wasmfs_pwrite(stream.fd, dataBuffer, length, position);
                }
                else {
                    bytesRead = __wasmfs_write(stream.fd, dataBuffer, length);
                }
                bytesRead = FS.handleError(bytesRead);
                _free(dataBuffer);
                return bytesRead;
            },
            allocate(stream, offset, length) {
                return FS.handleError(__wasmfs_allocate(stream.fd, BigInt(offset), BigInt(length)));
            },
            writeFile: (path, data) => FS_writeFile(path, data),
            mmap: (stream, length, offset, prot, flags) => {
                var buf = FS.handleError(__wasmfs_mmap(length, prot, flags, stream.fd, BigInt(offset)));
                return { ptr: buf, allocated: true };
            },
            msync: (stream, bufferPtr, offset, length, mmapFlags) => {
                assert(offset === 0);
                // TODO: assert that stream has the fd corresponding to the mapped buffer (bufferPtr).
                return FS.handleError(__wasmfs_msync(bufferPtr, length, mmapFlags));
            },
            munmap: (addr, length) => (FS.handleError(__wasmfs_munmap(addr, length))),
            symlink: (target, linkpath) => withStackSave(() => (__wasmfs_symlink(stringToUTF8OnStack(target), stringToUTF8OnStack(linkpath)))),
            readlink(path) {
                var readBuffer = FS.handleError(withStackSave(() => __wasmfs_readlink(stringToUTF8OnStack(path))));
                return UTF8ToString(readBuffer);
            },
            statBufToObject(statBuf) {
                // i53/u53 are enough for times and ino in practice.
                return {
                    dev: HEAPU32[((statBuf) >> 2)],
                    mode: HEAPU32[(((statBuf) + (4)) >> 2)],
                    nlink: HEAPU32[(((statBuf) + (8)) >> 2)],
                    uid: HEAPU32[(((statBuf) + (12)) >> 2)],
                    gid: HEAPU32[(((statBuf) + (16)) >> 2)],
                    rdev: HEAPU32[(((statBuf) + (20)) >> 2)],
                    size: readI53FromI64((statBuf) + (24)),
                    blksize: HEAPU32[(((statBuf) + (32)) >> 2)],
                    blocks: HEAPU32[(((statBuf) + (36)) >> 2)],
                    atime: readI53FromI64((statBuf) + (40)),
                    mtime: readI53FromI64((statBuf) + (56)),
                    ctime: readI53FromI64((statBuf) + (72)),
                    ino: readI53FromU64((statBuf) + (88))
                };
            },
            stat(path) {
                var statBuf = _malloc(96);
                FS.handleError(withStackSave(() => __wasmfs_stat(stringToUTF8OnStack(path), statBuf)));
                var stats = FS.statBufToObject(statBuf);
                _free(statBuf);
                return stats;
            },
            lstat(path) {
                var statBuf = _malloc(96);
                FS.handleError(withStackSave(() => __wasmfs_lstat(stringToUTF8OnStack(path), statBuf)));
                var stats = FS.statBufToObject(statBuf);
                _free(statBuf);
                return stats;
            },
            chmod(path, mode) {
                return FS.handleError(withStackSave(() => {
                    var buffer = stringToUTF8OnStack(path);
                    return __wasmfs_chmod(buffer, mode);
                }));
            },
            lchmod(path, mode) {
                return FS.handleError(withStackSave(() => {
                    var buffer = stringToUTF8OnStack(path);
                    return __wasmfs_lchmod(buffer, mode);
                }));
            },
            fchmod(fd, mode) {
                return FS.handleError(__wasmfs_fchmod(fd, mode));
            },
            utime: (path, atime, mtime) => (FS.handleError(withStackSave(() => (__wasmfs_utime(stringToUTF8OnStack(path), atime, mtime))))),
            truncate(path, len) {
                return FS.handleError(withStackSave(() => (__wasmfs_truncate(stringToUTF8OnStack(path), BigInt(len)))));
            },
            ftruncate(fd, len) {
                return FS.handleError(__wasmfs_ftruncate(fd, BigInt(len)));
            },
            findObject(path) {
                var result = withStackSave(() => __wasmfs_identify(stringToUTF8OnStack(path)));
                if (result == 44) {
                    return null;
                }
                return {
                    isFolder: result == 31,
                    isDevice: false, // TODO: wasmfs support for devices
                };
            },
            readdir: (path) => withStackSave(() => {
                var pathBuffer = stringToUTF8OnStack(path);
                var entries = [];
                var state = __wasmfs_readdir_start(pathBuffer);
                if (!state) {
                    // TODO: The old FS threw an ErrnoError here.
                    throw new Error("No such directory");
                }
                var entry;
                while (entry = __wasmfs_readdir_get(state)) {
                    entries.push(UTF8ToString(entry));
                }
                __wasmfs_readdir_finish(state);
                return entries;
            }),
            mount: (type, opts, mountpoint) => {
                if (typeof type == 'string') {
                    // The filesystem was not included, and instead we have an error
                    // message stored in the variable.
                    throw type;
                }
                var backendPointer = type.createBackend(opts);
                return FS.handleError(withStackSave(() => __wasmfs_mount(stringToUTF8OnStack(mountpoint), backendPointer)));
            },
            unmount: (mountpoint) => (FS.handleError(withStackSave(() => __wasmfs_unmount(stringToUTF8OnStack(mountpoint))))),
            mknod: (path, mode, dev) => FS_mknod(path, mode, dev),
            makedev: (ma, mi) => ((ma) << 8 | (mi)),
            registerDevice(dev, ops) {
                var backendPointer = _wasmfs_create_jsimpl_backend();
                var definedOps = {
                    userRead: ops.read,
                    userWrite: ops.write,
                    allocFile: (file) => {
                        wasmFSDeviceStreams[file] = {};
                    },
                    freeFile: (file) => {
                        wasmFSDeviceStreams[file] = undefined;
                    },
                    getSize: (file) => { },
                    read: (file, buffer, length, offset) => {
                        var bufferArray = Module.HEAP8.subarray(buffer, buffer + length);
                        try {
                            var bytesRead = definedOps.userRead(wasmFSDeviceStreams[file], bufferArray, 0, length, offset);
                        }
                        catch (e) {
                            return -e.errno;
                        }
                        Module.HEAP8.set(bufferArray, buffer);
                        return bytesRead;
                    },
                    write: (file, buffer, length, offset) => {
                        var bufferArray = Module.HEAP8.subarray(buffer, buffer + length);
                        try {
                            var bytesWritten = definedOps.userWrite(wasmFSDeviceStreams[file], bufferArray, 0, length, offset);
                        }
                        catch (e) {
                            return -e.errno;
                        }
                        Module.HEAP8.set(bufferArray, buffer);
                        return bytesWritten;
                    },
                };
                wasmFS$backends[backendPointer] = definedOps;
                wasmFSDevices[dev] = backendPointer;
            },
            createDevice(parent, name, input, output) {
                if (typeof parent != 'string') {
                    // The old API allowed parents to be objects, which do not exist in WasmFS.
                    throw new Error("Only string paths are accepted");
                }
                var path = PATH.join2(parent, name);
                var mode = FS_getMode(!!input, !!output);
                if (!FS.createDevice.major)
                    FS.createDevice.major = 64;
                var dev = FS.makedev(FS.createDevice.major++, 0);
                // Create a fake device with a set of stream ops to emulate
                // the old API's createDevice().
                FS.registerDevice(dev, {
                    read(stream, buffer, offset, length, pos /* ignored */) {
                        var bytesRead = 0;
                        for (var i = 0; i < length; i++) {
                            var result;
                            try {
                                result = input();
                            }
                            catch (e) {
                                throw new FS.ErrnoError(29);
                            }
                            if (result === undefined && bytesRead === 0) {
                                throw new FS.ErrnoError(6);
                            }
                            if (result === null || result === undefined)
                                break;
                            bytesRead++;
                            buffer[offset + i] = result;
                        }
                        return bytesRead;
                    },
                    write(stream, buffer, offset, length, pos) {
                        for (var i = 0; i < length; i++) {
                            try {
                                output(buffer[offset + i]);
                            }
                            catch (e) {
                                throw new FS.ErrnoError(29);
                            }
                        }
                        return i;
                    }
                });
                return FS.mkdev(path, mode, dev);
            },
            mkdev(path, mode, dev) {
                if (typeof dev === 'undefined') {
                    dev = mode;
                    mode = 438 /* 0666 */;
                }
                var deviceBackend = wasmFSDevices[dev];
                if (!deviceBackend) {
                    throw new Error("Invalid device ID.");
                }
                return FS.handleError(withStackSave(() => (_wasmfs_create_file(stringToUTF8OnStack(path), mode, deviceBackend))));
            },
            rename(oldPath, newPath) {
                return FS.handleError(withStackSave(() => {
                    var oldPathBuffer = stringToUTF8OnStack(oldPath);
                    var newPathBuffer = stringToUTF8OnStack(newPath);
                    return __wasmfs_rename(oldPathBuffer, newPathBuffer);
                }));
            },
            llseek(stream, offset, whence) {
                return FS.handleError(__wasmfs_llseek(stream.fd, BigInt(offset), whence));
            },
        };
        var FS_createPath = FS.createPath;
        PThread.init();
        ;
        InternalError = Module['InternalError'] = class InternalError extends Error {
            constructor(message) { super(message); this.name = 'InternalError'; }
        };
        embind_init_charCodes();
        BindingError = Module['BindingError'] = class BindingError extends Error {
            constructor(message) { super(message); this.name = 'BindingError'; }
        };
        init_ClassHandle();
        init_embind();
        ;
        init_RegisteredPointer();
        UnboundTypeError = Module['UnboundTypeError'] = extendError(Error, 'UnboundTypeError');
        ;
        init_emval();
        ;
        var GLctx;
        ;
        // exports
        Module["requestFullscreen"] = Browser.requestFullscreen;
        Module["requestFullScreen"] = Browser.requestFullScreen;
        Module["requestAnimationFrame"] = Browser.requestAnimationFrame;
        Module["setCanvasSize"] = Browser.setCanvasSize;
        Module["pauseMainLoop"] = Browser.mainLoop.pause;
        Module["resumeMainLoop"] = Browser.mainLoop.resume;
        Module["getUserMedia"] = Browser.getUserMedia;
        Module["createContext"] = Browser.createContext;
        var preloadedImages = {};
        var preloadedAudios = {};
        ;
        for (var i = 0; i < 32; ++i)
            tempFixedLengthArray.push(new Array(i));
        ;
        var miniTempWebGLFloatBuffersStorage = new Float32Array(288);
        for ( /**@suppress{duplicate}*/var i = 0; i < 288; ++i) {
            miniTempWebGLFloatBuffers[i] = miniTempWebGLFloatBuffersStorage.subarray(0, i);
        }
        ;
        var miniTempWebGLIntBuffersStorage = new Int32Array(288);
        for ( /**@suppress{duplicate}*/var i = 0; i < 288; ++i) {
            miniTempWebGLIntBuffers[i] = miniTempWebGLIntBuffersStorage.subarray(0, i);
        }
        ;
        FS.init();
        ;
        // proxiedFunctionTable specifies the list of functions that can be called
        // either synchronously or asynchronously from other threads in postMessage()d
        // or internally queued events. This way a pthread in a Worker can synchronously
        // access e.g. the DOM on the main thread.
        var proxiedFunctionTable = [
            _proc_exit,
            exitOnMainThread,
            pthreadCreateProxied,
            __emscripten_runtime_keepalive_clear,
            setCanvasElementSizeMainThread,
            _alBuffer3f,
            _alBuffer3i,
            _alBufferData,
            _alBufferf,
            _alBufferfv,
            _alBufferi,
            _alBufferiv,
            _alDeleteBuffers,
            _alDeleteSources,
            _alSourcei,
            _alDisable,
            _alDistanceModel,
            _alDopplerFactor,
            _alDopplerVelocity,
            _alEnable,
            _alGenBuffers,
            _alGenSources,
            _alGetBoolean,
            _alGetBooleanv,
            _alGetBuffer3f,
            _alGetBuffer3i,
            _alGetBufferf,
            _alGetBufferfv,
            _alGetBufferi,
            _alGetBufferiv,
            _alGetDouble,
            _alGetDoublev,
            _alGetEnumValue,
            _alGetError,
            _alGetFloat,
            _alGetFloatv,
            _alGetInteger,
            _alGetIntegerv,
            _alGetListener3f,
            _alGetListener3i,
            _alGetListenerf,
            _alGetListenerfv,
            _alGetListeneri,
            _alGetListeneriv,
            _alGetSource3f,
            _alGetSource3i,
            _alGetSourcef,
            _alGetSourcefv,
            _alGetSourcei,
            _alGetSourceiv,
            _alGetString,
            _alIsBuffer,
            _alIsEnabled,
            _alIsExtensionPresent,
            _alIsSource,
            _alListener3f,
            _alListener3i,
            _alListenerf,
            _alListenerfv,
            _alListeneri,
            _alListeneriv,
            _alSource3f,
            _alSource3i,
            _alSourcePause,
            _alSourcePausev,
            _alSourcePlay,
            _alSourcePlayv,
            _alSourceQueueBuffers,
            _alSourceRewind,
            _alSourceRewindv,
            _alSourceStop,
            _alSourceStopv,
            _alSourceUnqueueBuffers,
            _alSourcef,
            _alSourcefv,
            _alSourceiv,
            _alSpeedOfSound,
            _alcCloseDevice,
            _alcCreateContext,
            _alcDestroyContext,
            _alcGetContextsDevice,
            _alcGetCurrentContext,
            _alcGetEnumValue,
            _alcGetError,
            _alcGetIntegerv,
            _alcMakeContextCurrent,
            _alcOpenDevice,
            _eglBindAPI,
            _eglChooseConfig,
            _eglCreateContext,
            _eglDestroyContext,
            _eglGetConfigAttrib,
            _eglGetCurrentContext,
            _eglGetCurrentDisplay,
            _eglGetDisplay,
            _eglGetError,
            _eglInitialize,
            _eglMakeCurrent,
            _eglQueryString,
            _eglSwapInterval,
            _emscripten_exit_fullscreen,
            getCanvasSizeMainThread,
            _emscripten_exit_pointerlock,
            _emscripten_force_exit,
            _emscripten_get_device_pixel_ratio,
            _emscripten_get_element_css_size,
            _emscripten_get_gamepad_status,
            _emscripten_get_num_gamepads,
            _emscripten_get_screen_size,
            _emscripten_request_fullscreen_strategy,
            _emscripten_request_pointerlock,
            _emscripten_sample_gamepad_data,
            _emscripten_set_beforeunload_callback_on_thread,
            _emscripten_set_blur_callback_on_thread,
            _emscripten_set_element_css_size,
            _emscripten_set_focus_callback_on_thread,
            _emscripten_set_fullscreenchange_callback_on_thread,
            _emscripten_set_gamepadconnected_callback_on_thread,
            _emscripten_set_gamepaddisconnected_callback_on_thread,
            _emscripten_set_keydown_callback_on_thread,
            _emscripten_set_keypress_callback_on_thread,
            _emscripten_set_keyup_callback_on_thread,
            _emscripten_set_mousedown_callback_on_thread,
            _emscripten_set_mouseenter_callback_on_thread,
            _emscripten_set_mouseleave_callback_on_thread,
            _emscripten_set_mousemove_callback_on_thread,
            _emscripten_set_mouseup_callback_on_thread,
            _emscripten_set_pointerlockchange_callback_on_thread,
            _emscripten_set_resize_callback_on_thread,
            _emscripten_set_touchcancel_callback_on_thread,
            _emscripten_set_touchend_callback_on_thread,
            _emscripten_set_touchmove_callback_on_thread,
            _emscripten_set_touchstart_callback_on_thread,
            _emscripten_set_visibilitychange_callback_on_thread,
            _emscripten_set_wheel_callback_on_thread,
            _emscripten_set_window_title,
            _environ_get,
            _environ_sizes_get,
            _getaddrinfo
        ];
        function checkIncomingModuleAPI() {
            ignoredModuleProp('fetchSettings');
        }
        var wasmImports;
        function assignWasmImports() {
            wasmImports = {
                /** @export */
                __assert_fail: ___assert_fail,
                /** @export */
                __call_sighandler: ___call_sighandler,
                /** @export */
                __cxa_throw: ___cxa_throw,
                /** @export */
                __pthread_create_js: ___pthread_create_js,
                /** @export */
                __pthread_kill_js: ___pthread_kill_js,
                /** @export */
                _abort_js: __abort_js,
                /** @export */
                _embind_finalize_value_object: __embind_finalize_value_object,
                /** @export */
                _embind_register_bigint: __embind_register_bigint,
                /** @export */
                _embind_register_bool: __embind_register_bool,
                /** @export */
                _embind_register_class: __embind_register_class,
                /** @export */
                _embind_register_class_constructor: __embind_register_class_constructor,
                /** @export */
                _embind_register_class_function: __embind_register_class_function,
                /** @export */
                _embind_register_emval: __embind_register_emval,
                /** @export */
                _embind_register_float: __embind_register_float,
                /** @export */
                _embind_register_function: __embind_register_function,
                /** @export */
                _embind_register_integer: __embind_register_integer,
                /** @export */
                _embind_register_memory_view: __embind_register_memory_view,
                /** @export */
                _embind_register_optional: __embind_register_optional,
                /** @export */
                _embind_register_std_string: __embind_register_std_string,
                /** @export */
                _embind_register_std_wstring: __embind_register_std_wstring,
                /** @export */
                _embind_register_value_object: __embind_register_value_object,
                /** @export */
                _embind_register_value_object_field: __embind_register_value_object_field,
                /** @export */
                _embind_register_void: __embind_register_void,
                /** @export */
                _emscripten_get_now_is_monotonic: __emscripten_get_now_is_monotonic,
                /** @export */
                _emscripten_init_main_thread_js: __emscripten_init_main_thread_js,
                /** @export */
                _emscripten_notify_mailbox_postmessage: __emscripten_notify_mailbox_postmessage,
                /** @export */
                _emscripten_receive_on_main_thread_js: __emscripten_receive_on_main_thread_js,
                /** @export */
                _emscripten_runtime_keepalive_clear: __emscripten_runtime_keepalive_clear,
                /** @export */
                _emscripten_set_offscreencanvas_size: __emscripten_set_offscreencanvas_size,
                /** @export */
                _emscripten_thread_cleanup: __emscripten_thread_cleanup,
                /** @export */
                _emscripten_thread_mailbox_await: __emscripten_thread_mailbox_await,
                /** @export */
                _emscripten_thread_set_strongref: __emscripten_thread_set_strongref,
                /** @export */
                _emscripten_throw_longjmp: __emscripten_throw_longjmp,
                /** @export */
                _emval_decref: __emval_decref,
                /** @export */
                _emval_take_value: __emval_take_value,
                /** @export */
                _gmtime_js: __gmtime_js,
                /** @export */
                _localtime_js: __localtime_js,
                /** @export */
                _mktime_js: __mktime_js,
                /** @export */
                _tzset_js: __tzset_js,
                /** @export */
                _wasmfs_copy_preloaded_file_data: __wasmfs_copy_preloaded_file_data,
                /** @export */
                _wasmfs_externalfs_close_blob: __wasmfs_externalfs_close_blob,
                /** @export */
                _wasmfs_externalfs_free_directory: __wasmfs_externalfs_free_directory,
                /** @export */
                _wasmfs_externalfs_free_file: __wasmfs_externalfs_free_file,
                /** @export */
                _wasmfs_externalfs_get_child: __wasmfs_externalfs_get_child,
                /** @export */
                _wasmfs_externalfs_get_entries: __wasmfs_externalfs_get_entries,
                /** @export */
                _wasmfs_externalfs_get_size_blob: __wasmfs_externalfs_get_size_blob,
                /** @export */
                _wasmfs_externalfs_get_size_file: __wasmfs_externalfs_get_size_file,
                /** @export */
                _wasmfs_externalfs_init_root_directory: __wasmfs_externalfs_init_root_directory,
                /** @export */
                _wasmfs_externalfs_open_blob: __wasmfs_externalfs_open_blob,
                /** @export */
                _wasmfs_externalfs_read_blob: __wasmfs_externalfs_read_blob,
                /** @export */
                _wasmfs_get_num_preloaded_dirs: __wasmfs_get_num_preloaded_dirs,
                /** @export */
                _wasmfs_get_num_preloaded_files: __wasmfs_get_num_preloaded_files,
                /** @export */
                _wasmfs_get_preloaded_child_path: __wasmfs_get_preloaded_child_path,
                /** @export */
                _wasmfs_get_preloaded_file_mode: __wasmfs_get_preloaded_file_mode,
                /** @export */
                _wasmfs_get_preloaded_file_size: __wasmfs_get_preloaded_file_size,
                /** @export */
                _wasmfs_get_preloaded_parent_path: __wasmfs_get_preloaded_parent_path,
                /** @export */
                _wasmfs_get_preloaded_path_name: __wasmfs_get_preloaded_path_name,
                /** @export */
                _wasmfs_jsimpl_alloc_file: __wasmfs_jsimpl_alloc_file,
                /** @export */
                _wasmfs_jsimpl_free_file: __wasmfs_jsimpl_free_file,
                /** @export */
                _wasmfs_jsimpl_get_size: __wasmfs_jsimpl_get_size,
                /** @export */
                _wasmfs_jsimpl_read: __wasmfs_jsimpl_read,
                /** @export */
                _wasmfs_jsimpl_write: __wasmfs_jsimpl_write,
                /** @export */
                _wasmfs_stdin_get_char: __wasmfs_stdin_get_char,
                /** @export */
                _wasmfs_thread_utils_heartbeat: __wasmfs_thread_utils_heartbeat,
                /** @export */
                alBuffer3f: _alBuffer3f,
                /** @export */
                alBuffer3i: _alBuffer3i,
                /** @export */
                alBufferData: _alBufferData,
                /** @export */
                alBufferf: _alBufferf,
                /** @export */
                alBufferfv: _alBufferfv,
                /** @export */
                alBufferi: _alBufferi,
                /** @export */
                alBufferiv: _alBufferiv,
                /** @export */
                alDeleteBuffers: _alDeleteBuffers,
                /** @export */
                alDeleteSources: _alDeleteSources,
                /** @export */
                alDisable: _alDisable,
                /** @export */
                alDistanceModel: _alDistanceModel,
                /** @export */
                alDopplerFactor: _alDopplerFactor,
                /** @export */
                alDopplerVelocity: _alDopplerVelocity,
                /** @export */
                alEnable: _alEnable,
                /** @export */
                alGenBuffers: _alGenBuffers,
                /** @export */
                alGenSources: _alGenSources,
                /** @export */
                alGetBoolean: _alGetBoolean,
                /** @export */
                alGetBooleanv: _alGetBooleanv,
                /** @export */
                alGetBuffer3f: _alGetBuffer3f,
                /** @export */
                alGetBuffer3i: _alGetBuffer3i,
                /** @export */
                alGetBufferf: _alGetBufferf,
                /** @export */
                alGetBufferfv: _alGetBufferfv,
                /** @export */
                alGetBufferi: _alGetBufferi,
                /** @export */
                alGetBufferiv: _alGetBufferiv,
                /** @export */
                alGetDouble: _alGetDouble,
                /** @export */
                alGetDoublev: _alGetDoublev,
                /** @export */
                alGetEnumValue: _alGetEnumValue,
                /** @export */
                alGetError: _alGetError,
                /** @export */
                alGetFloat: _alGetFloat,
                /** @export */
                alGetFloatv: _alGetFloatv,
                /** @export */
                alGetInteger: _alGetInteger,
                /** @export */
                alGetIntegerv: _alGetIntegerv,
                /** @export */
                alGetListener3f: _alGetListener3f,
                /** @export */
                alGetListener3i: _alGetListener3i,
                /** @export */
                alGetListenerf: _alGetListenerf,
                /** @export */
                alGetListenerfv: _alGetListenerfv,
                /** @export */
                alGetListeneri: _alGetListeneri,
                /** @export */
                alGetListeneriv: _alGetListeneriv,
                /** @export */
                alGetSource3f: _alGetSource3f,
                /** @export */
                alGetSource3i: _alGetSource3i,
                /** @export */
                alGetSourcef: _alGetSourcef,
                /** @export */
                alGetSourcefv: _alGetSourcefv,
                /** @export */
                alGetSourcei: _alGetSourcei,
                /** @export */
                alGetSourceiv: _alGetSourceiv,
                /** @export */
                alGetString: _alGetString,
                /** @export */
                alIsBuffer: _alIsBuffer,
                /** @export */
                alIsEnabled: _alIsEnabled,
                /** @export */
                alIsExtensionPresent: _alIsExtensionPresent,
                /** @export */
                alIsSource: _alIsSource,
                /** @export */
                alListener3f: _alListener3f,
                /** @export */
                alListener3i: _alListener3i,
                /** @export */
                alListenerf: _alListenerf,
                /** @export */
                alListenerfv: _alListenerfv,
                /** @export */
                alListeneri: _alListeneri,
                /** @export */
                alListeneriv: _alListeneriv,
                /** @export */
                alSource3f: _alSource3f,
                /** @export */
                alSource3i: _alSource3i,
                /** @export */
                alSourcePause: _alSourcePause,
                /** @export */
                alSourcePausev: _alSourcePausev,
                /** @export */
                alSourcePlay: _alSourcePlay,
                /** @export */
                alSourcePlayv: _alSourcePlayv,
                /** @export */
                alSourceQueueBuffers: _alSourceQueueBuffers,
                /** @export */
                alSourceRewind: _alSourceRewind,
                /** @export */
                alSourceRewindv: _alSourceRewindv,
                /** @export */
                alSourceStop: _alSourceStop,
                /** @export */
                alSourceStopv: _alSourceStopv,
                /** @export */
                alSourceUnqueueBuffers: _alSourceUnqueueBuffers,
                /** @export */
                alSourcef: _alSourcef,
                /** @export */
                alSourcefv: _alSourcefv,
                /** @export */
                alSourcei: _alSourcei,
                /** @export */
                alSourceiv: _alSourceiv,
                /** @export */
                alSpeedOfSound: _alSpeedOfSound,
                /** @export */
                alcCloseDevice: _alcCloseDevice,
                /** @export */
                alcCreateContext: _alcCreateContext,
                /** @export */
                alcDestroyContext: _alcDestroyContext,
                /** @export */
                alcGetContextsDevice: _alcGetContextsDevice,
                /** @export */
                alcGetCurrentContext: _alcGetCurrentContext,
                /** @export */
                alcGetEnumValue: _alcGetEnumValue,
                /** @export */
                alcGetError: _alcGetError,
                /** @export */
                alcGetIntegerv: _alcGetIntegerv,
                /** @export */
                alcMakeContextCurrent: _alcMakeContextCurrent,
                /** @export */
                alcOpenDevice: _alcOpenDevice,
                /** @export */
                eglBindAPI: _eglBindAPI,
                /** @export */
                eglChooseConfig: _eglChooseConfig,
                /** @export */
                eglCreateContext: _eglCreateContext,
                /** @export */
                eglDestroyContext: _eglDestroyContext,
                /** @export */
                eglGetConfigAttrib: _eglGetConfigAttrib,
                /** @export */
                eglGetCurrentContext: _eglGetCurrentContext,
                /** @export */
                eglGetCurrentDisplay: _eglGetCurrentDisplay,
                /** @export */
                eglGetDisplay: _eglGetDisplay,
                /** @export */
                eglGetError: _eglGetError,
                /** @export */
                eglInitialize: _eglInitialize,
                /** @export */
                eglMakeCurrent: _eglMakeCurrent,
                /** @export */
                eglQueryString: _eglQueryString,
                /** @export */
                eglSwapInterval: _eglSwapInterval,
                /** @export */
                emscripten_asm_const_int: _emscripten_asm_const_int,
                /** @export */
                emscripten_asm_const_int_sync_on_main_thread: _emscripten_asm_const_int_sync_on_main_thread,
                /** @export */
                emscripten_asm_const_ptr_sync_on_main_thread: _emscripten_asm_const_ptr_sync_on_main_thread,
                /** @export */
                emscripten_cancel_main_loop: _emscripten_cancel_main_loop,
                /** @export */
                emscripten_check_blocking_allowed: _emscripten_check_blocking_allowed,
                /** @export */
                emscripten_date_now: _emscripten_date_now,
                /** @export */
                emscripten_err: _emscripten_err,
                /** @export */
                emscripten_exit_fullscreen: _emscripten_exit_fullscreen,
                /** @export */
                emscripten_exit_pointerlock: _emscripten_exit_pointerlock,
                /** @export */
                emscripten_exit_with_live_runtime: _emscripten_exit_with_live_runtime,
                /** @export */
                emscripten_force_exit: _emscripten_force_exit,
                /** @export */
                emscripten_get_device_pixel_ratio: _emscripten_get_device_pixel_ratio,
                /** @export */
                emscripten_get_element_css_size: _emscripten_get_element_css_size,
                /** @export */
                emscripten_get_gamepad_status: _emscripten_get_gamepad_status,
                /** @export */
                emscripten_get_heap_max: _emscripten_get_heap_max,
                /** @export */
                emscripten_get_main_loop_timing: _emscripten_get_main_loop_timing,
                /** @export */
                emscripten_get_now: _emscripten_get_now,
                /** @export */
                emscripten_get_num_gamepads: _emscripten_get_num_gamepads,
                /** @export */
                emscripten_get_screen_size: _emscripten_get_screen_size,
                /** @export */
                emscripten_glActiveTexture: _emscripten_glActiveTexture,
                /** @export */
                emscripten_glAttachShader: _emscripten_glAttachShader,
                /** @export */
                emscripten_glBeginQuery: _emscripten_glBeginQuery,
                /** @export */
                emscripten_glBeginQueryEXT: _emscripten_glBeginQueryEXT,
                /** @export */
                emscripten_glBeginTransformFeedback: _emscripten_glBeginTransformFeedback,
                /** @export */
                emscripten_glBindAttribLocation: _emscripten_glBindAttribLocation,
                /** @export */
                emscripten_glBindBuffer: _emscripten_glBindBuffer,
                /** @export */
                emscripten_glBindBufferBase: _emscripten_glBindBufferBase,
                /** @export */
                emscripten_glBindBufferRange: _emscripten_glBindBufferRange,
                /** @export */
                emscripten_glBindFramebuffer: _emscripten_glBindFramebuffer,
                /** @export */
                emscripten_glBindRenderbuffer: _emscripten_glBindRenderbuffer,
                /** @export */
                emscripten_glBindSampler: _emscripten_glBindSampler,
                /** @export */
                emscripten_glBindTexture: _emscripten_glBindTexture,
                /** @export */
                emscripten_glBindTransformFeedback: _emscripten_glBindTransformFeedback,
                /** @export */
                emscripten_glBindVertexArray: _emscripten_glBindVertexArray,
                /** @export */
                emscripten_glBindVertexArrayOES: _emscripten_glBindVertexArrayOES,
                /** @export */
                emscripten_glBlendColor: _emscripten_glBlendColor,
                /** @export */
                emscripten_glBlendEquation: _emscripten_glBlendEquation,
                /** @export */
                emscripten_glBlendEquationSeparate: _emscripten_glBlendEquationSeparate,
                /** @export */
                emscripten_glBlendFunc: _emscripten_glBlendFunc,
                /** @export */
                emscripten_glBlendFuncSeparate: _emscripten_glBlendFuncSeparate,
                /** @export */
                emscripten_glBlitFramebuffer: _emscripten_glBlitFramebuffer,
                /** @export */
                emscripten_glBufferData: _emscripten_glBufferData,
                /** @export */
                emscripten_glBufferSubData: _emscripten_glBufferSubData,
                /** @export */
                emscripten_glCheckFramebufferStatus: _emscripten_glCheckFramebufferStatus,
                /** @export */
                emscripten_glClear: _emscripten_glClear,
                /** @export */
                emscripten_glClearBufferfi: _emscripten_glClearBufferfi,
                /** @export */
                emscripten_glClearBufferfv: _emscripten_glClearBufferfv,
                /** @export */
                emscripten_glClearBufferiv: _emscripten_glClearBufferiv,
                /** @export */
                emscripten_glClearBufferuiv: _emscripten_glClearBufferuiv,
                /** @export */
                emscripten_glClearColor: _emscripten_glClearColor,
                /** @export */
                emscripten_glClearDepthf: _emscripten_glClearDepthf,
                /** @export */
                emscripten_glClearStencil: _emscripten_glClearStencil,
                /** @export */
                emscripten_glClientWaitSync: _emscripten_glClientWaitSync,
                /** @export */
                emscripten_glColorMask: _emscripten_glColorMask,
                /** @export */
                emscripten_glCompileShader: _emscripten_glCompileShader,
                /** @export */
                emscripten_glCompressedTexImage2D: _emscripten_glCompressedTexImage2D,
                /** @export */
                emscripten_glCompressedTexImage3D: _emscripten_glCompressedTexImage3D,
                /** @export */
                emscripten_glCompressedTexSubImage2D: _emscripten_glCompressedTexSubImage2D,
                /** @export */
                emscripten_glCompressedTexSubImage3D: _emscripten_glCompressedTexSubImage3D,
                /** @export */
                emscripten_glCopyBufferSubData: _emscripten_glCopyBufferSubData,
                /** @export */
                emscripten_glCopyTexImage2D: _emscripten_glCopyTexImage2D,
                /** @export */
                emscripten_glCopyTexSubImage2D: _emscripten_glCopyTexSubImage2D,
                /** @export */
                emscripten_glCopyTexSubImage3D: _emscripten_glCopyTexSubImage3D,
                /** @export */
                emscripten_glCreateProgram: _emscripten_glCreateProgram,
                /** @export */
                emscripten_glCreateShader: _emscripten_glCreateShader,
                /** @export */
                emscripten_glCullFace: _emscripten_glCullFace,
                /** @export */
                emscripten_glDeleteBuffers: _emscripten_glDeleteBuffers,
                /** @export */
                emscripten_glDeleteFramebuffers: _emscripten_glDeleteFramebuffers,
                /** @export */
                emscripten_glDeleteProgram: _emscripten_glDeleteProgram,
                /** @export */
                emscripten_glDeleteQueries: _emscripten_glDeleteQueries,
                /** @export */
                emscripten_glDeleteQueriesEXT: _emscripten_glDeleteQueriesEXT,
                /** @export */
                emscripten_glDeleteRenderbuffers: _emscripten_glDeleteRenderbuffers,
                /** @export */
                emscripten_glDeleteSamplers: _emscripten_glDeleteSamplers,
                /** @export */
                emscripten_glDeleteShader: _emscripten_glDeleteShader,
                /** @export */
                emscripten_glDeleteSync: _emscripten_glDeleteSync,
                /** @export */
                emscripten_glDeleteTextures: _emscripten_glDeleteTextures,
                /** @export */
                emscripten_glDeleteTransformFeedbacks: _emscripten_glDeleteTransformFeedbacks,
                /** @export */
                emscripten_glDeleteVertexArrays: _emscripten_glDeleteVertexArrays,
                /** @export */
                emscripten_glDeleteVertexArraysOES: _emscripten_glDeleteVertexArraysOES,
                /** @export */
                emscripten_glDepthFunc: _emscripten_glDepthFunc,
                /** @export */
                emscripten_glDepthMask: _emscripten_glDepthMask,
                /** @export */
                emscripten_glDepthRangef: _emscripten_glDepthRangef,
                /** @export */
                emscripten_glDetachShader: _emscripten_glDetachShader,
                /** @export */
                emscripten_glDisable: _emscripten_glDisable,
                /** @export */
                emscripten_glDisableVertexAttribArray: _emscripten_glDisableVertexAttribArray,
                /** @export */
                emscripten_glDrawArrays: _emscripten_glDrawArrays,
                /** @export */
                emscripten_glDrawArraysInstanced: _emscripten_glDrawArraysInstanced,
                /** @export */
                emscripten_glDrawArraysInstancedANGLE: _emscripten_glDrawArraysInstancedANGLE,
                /** @export */
                emscripten_glDrawArraysInstancedARB: _emscripten_glDrawArraysInstancedARB,
                /** @export */
                emscripten_glDrawArraysInstancedEXT: _emscripten_glDrawArraysInstancedEXT,
                /** @export */
                emscripten_glDrawArraysInstancedNV: _emscripten_glDrawArraysInstancedNV,
                /** @export */
                emscripten_glDrawBuffers: _emscripten_glDrawBuffers,
                /** @export */
                emscripten_glDrawBuffersEXT: _emscripten_glDrawBuffersEXT,
                /** @export */
                emscripten_glDrawBuffersWEBGL: _emscripten_glDrawBuffersWEBGL,
                /** @export */
                emscripten_glDrawElements: _emscripten_glDrawElements,
                /** @export */
                emscripten_glDrawElementsInstanced: _emscripten_glDrawElementsInstanced,
                /** @export */
                emscripten_glDrawElementsInstancedANGLE: _emscripten_glDrawElementsInstancedANGLE,
                /** @export */
                emscripten_glDrawElementsInstancedARB: _emscripten_glDrawElementsInstancedARB,
                /** @export */
                emscripten_glDrawElementsInstancedEXT: _emscripten_glDrawElementsInstancedEXT,
                /** @export */
                emscripten_glDrawElementsInstancedNV: _emscripten_glDrawElementsInstancedNV,
                /** @export */
                emscripten_glDrawRangeElements: _emscripten_glDrawRangeElements,
                /** @export */
                emscripten_glEnable: _emscripten_glEnable,
                /** @export */
                emscripten_glEnableVertexAttribArray: _emscripten_glEnableVertexAttribArray,
                /** @export */
                emscripten_glEndQuery: _emscripten_glEndQuery,
                /** @export */
                emscripten_glEndQueryEXT: _emscripten_glEndQueryEXT,
                /** @export */
                emscripten_glEndTransformFeedback: _emscripten_glEndTransformFeedback,
                /** @export */
                emscripten_glFenceSync: _emscripten_glFenceSync,
                /** @export */
                emscripten_glFinish: _emscripten_glFinish,
                /** @export */
                emscripten_glFlush: _emscripten_glFlush,
                /** @export */
                emscripten_glFlushMappedBufferRange: _emscripten_glFlushMappedBufferRange,
                /** @export */
                emscripten_glFramebufferRenderbuffer: _emscripten_glFramebufferRenderbuffer,
                /** @export */
                emscripten_glFramebufferTexture2D: _emscripten_glFramebufferTexture2D,
                /** @export */
                emscripten_glFramebufferTextureLayer: _emscripten_glFramebufferTextureLayer,
                /** @export */
                emscripten_glFrontFace: _emscripten_glFrontFace,
                /** @export */
                emscripten_glGenBuffers: _emscripten_glGenBuffers,
                /** @export */
                emscripten_glGenFramebuffers: _emscripten_glGenFramebuffers,
                /** @export */
                emscripten_glGenQueries: _emscripten_glGenQueries,
                /** @export */
                emscripten_glGenQueriesEXT: _emscripten_glGenQueriesEXT,
                /** @export */
                emscripten_glGenRenderbuffers: _emscripten_glGenRenderbuffers,
                /** @export */
                emscripten_glGenSamplers: _emscripten_glGenSamplers,
                /** @export */
                emscripten_glGenTextures: _emscripten_glGenTextures,
                /** @export */
                emscripten_glGenTransformFeedbacks: _emscripten_glGenTransformFeedbacks,
                /** @export */
                emscripten_glGenVertexArrays: _emscripten_glGenVertexArrays,
                /** @export */
                emscripten_glGenVertexArraysOES: _emscripten_glGenVertexArraysOES,
                /** @export */
                emscripten_glGenerateMipmap: _emscripten_glGenerateMipmap,
                /** @export */
                emscripten_glGetActiveAttrib: _emscripten_glGetActiveAttrib,
                /** @export */
                emscripten_glGetActiveUniform: _emscripten_glGetActiveUniform,
                /** @export */
                emscripten_glGetActiveUniformBlockName: _emscripten_glGetActiveUniformBlockName,
                /** @export */
                emscripten_glGetActiveUniformBlockiv: _emscripten_glGetActiveUniformBlockiv,
                /** @export */
                emscripten_glGetActiveUniformsiv: _emscripten_glGetActiveUniformsiv,
                /** @export */
                emscripten_glGetAttachedShaders: _emscripten_glGetAttachedShaders,
                /** @export */
                emscripten_glGetAttribLocation: _emscripten_glGetAttribLocation,
                /** @export */
                emscripten_glGetBooleanv: _emscripten_glGetBooleanv,
                /** @export */
                emscripten_glGetBufferParameteri64v: _emscripten_glGetBufferParameteri64v,
                /** @export */
                emscripten_glGetBufferParameteriv: _emscripten_glGetBufferParameteriv,
                /** @export */
                emscripten_glGetBufferPointerv: _emscripten_glGetBufferPointerv,
                /** @export */
                emscripten_glGetError: _emscripten_glGetError,
                /** @export */
                emscripten_glGetFloatv: _emscripten_glGetFloatv,
                /** @export */
                emscripten_glGetFragDataLocation: _emscripten_glGetFragDataLocation,
                /** @export */
                emscripten_glGetFramebufferAttachmentParameteriv: _emscripten_glGetFramebufferAttachmentParameteriv,
                /** @export */
                emscripten_glGetInteger64i_v: _emscripten_glGetInteger64i_v,
                /** @export */
                emscripten_glGetInteger64v: _emscripten_glGetInteger64v,
                /** @export */
                emscripten_glGetIntegeri_v: _emscripten_glGetIntegeri_v,
                /** @export */
                emscripten_glGetIntegerv: _emscripten_glGetIntegerv,
                /** @export */
                emscripten_glGetInternalformativ: _emscripten_glGetInternalformativ,
                /** @export */
                emscripten_glGetProgramBinary: _emscripten_glGetProgramBinary,
                /** @export */
                emscripten_glGetProgramInfoLog: _emscripten_glGetProgramInfoLog,
                /** @export */
                emscripten_glGetProgramiv: _emscripten_glGetProgramiv,
                /** @export */
                emscripten_glGetQueryObjecti64vEXT: _emscripten_glGetQueryObjecti64vEXT,
                /** @export */
                emscripten_glGetQueryObjectivEXT: _emscripten_glGetQueryObjectivEXT,
                /** @export */
                emscripten_glGetQueryObjectui64vEXT: _emscripten_glGetQueryObjectui64vEXT,
                /** @export */
                emscripten_glGetQueryObjectuiv: _emscripten_glGetQueryObjectuiv,
                /** @export */
                emscripten_glGetQueryObjectuivEXT: _emscripten_glGetQueryObjectuivEXT,
                /** @export */
                emscripten_glGetQueryiv: _emscripten_glGetQueryiv,
                /** @export */
                emscripten_glGetQueryivEXT: _emscripten_glGetQueryivEXT,
                /** @export */
                emscripten_glGetRenderbufferParameteriv: _emscripten_glGetRenderbufferParameteriv,
                /** @export */
                emscripten_glGetSamplerParameterfv: _emscripten_glGetSamplerParameterfv,
                /** @export */
                emscripten_glGetSamplerParameteriv: _emscripten_glGetSamplerParameteriv,
                /** @export */
                emscripten_glGetShaderInfoLog: _emscripten_glGetShaderInfoLog,
                /** @export */
                emscripten_glGetShaderPrecisionFormat: _emscripten_glGetShaderPrecisionFormat,
                /** @export */
                emscripten_glGetShaderSource: _emscripten_glGetShaderSource,
                /** @export */
                emscripten_glGetShaderiv: _emscripten_glGetShaderiv,
                /** @export */
                emscripten_glGetString: _emscripten_glGetString,
                /** @export */
                emscripten_glGetStringi: _emscripten_glGetStringi,
                /** @export */
                emscripten_glGetSynciv: _emscripten_glGetSynciv,
                /** @export */
                emscripten_glGetTexParameterfv: _emscripten_glGetTexParameterfv,
                /** @export */
                emscripten_glGetTexParameteriv: _emscripten_glGetTexParameteriv,
                /** @export */
                emscripten_glGetTransformFeedbackVarying: _emscripten_glGetTransformFeedbackVarying,
                /** @export */
                emscripten_glGetUniformBlockIndex: _emscripten_glGetUniformBlockIndex,
                /** @export */
                emscripten_glGetUniformIndices: _emscripten_glGetUniformIndices,
                /** @export */
                emscripten_glGetUniformLocation: _emscripten_glGetUniformLocation,
                /** @export */
                emscripten_glGetUniformfv: _emscripten_glGetUniformfv,
                /** @export */
                emscripten_glGetUniformiv: _emscripten_glGetUniformiv,
                /** @export */
                emscripten_glGetUniformuiv: _emscripten_glGetUniformuiv,
                /** @export */
                emscripten_glGetVertexAttribIiv: _emscripten_glGetVertexAttribIiv,
                /** @export */
                emscripten_glGetVertexAttribIuiv: _emscripten_glGetVertexAttribIuiv,
                /** @export */
                emscripten_glGetVertexAttribPointerv: _emscripten_glGetVertexAttribPointerv,
                /** @export */
                emscripten_glGetVertexAttribfv: _emscripten_glGetVertexAttribfv,
                /** @export */
                emscripten_glGetVertexAttribiv: _emscripten_glGetVertexAttribiv,
                /** @export */
                emscripten_glHint: _emscripten_glHint,
                /** @export */
                emscripten_glInvalidateFramebuffer: _emscripten_glInvalidateFramebuffer,
                /** @export */
                emscripten_glInvalidateSubFramebuffer: _emscripten_glInvalidateSubFramebuffer,
                /** @export */
                emscripten_glIsBuffer: _emscripten_glIsBuffer,
                /** @export */
                emscripten_glIsEnabled: _emscripten_glIsEnabled,
                /** @export */
                emscripten_glIsFramebuffer: _emscripten_glIsFramebuffer,
                /** @export */
                emscripten_glIsProgram: _emscripten_glIsProgram,
                /** @export */
                emscripten_glIsQuery: _emscripten_glIsQuery,
                /** @export */
                emscripten_glIsQueryEXT: _emscripten_glIsQueryEXT,
                /** @export */
                emscripten_glIsRenderbuffer: _emscripten_glIsRenderbuffer,
                /** @export */
                emscripten_glIsSampler: _emscripten_glIsSampler,
                /** @export */
                emscripten_glIsShader: _emscripten_glIsShader,
                /** @export */
                emscripten_glIsSync: _emscripten_glIsSync,
                /** @export */
                emscripten_glIsTexture: _emscripten_glIsTexture,
                /** @export */
                emscripten_glIsTransformFeedback: _emscripten_glIsTransformFeedback,
                /** @export */
                emscripten_glIsVertexArray: _emscripten_glIsVertexArray,
                /** @export */
                emscripten_glIsVertexArrayOES: _emscripten_glIsVertexArrayOES,
                /** @export */
                emscripten_glLineWidth: _emscripten_glLineWidth,
                /** @export */
                emscripten_glLinkProgram: _emscripten_glLinkProgram,
                /** @export */
                emscripten_glMapBufferRange: _emscripten_glMapBufferRange,
                /** @export */
                emscripten_glPauseTransformFeedback: _emscripten_glPauseTransformFeedback,
                /** @export */
                emscripten_glPixelStorei: _emscripten_glPixelStorei,
                /** @export */
                emscripten_glPolygonOffset: _emscripten_glPolygonOffset,
                /** @export */
                emscripten_glProgramBinary: _emscripten_glProgramBinary,
                /** @export */
                emscripten_glProgramParameteri: _emscripten_glProgramParameteri,
                /** @export */
                emscripten_glQueryCounterEXT: _emscripten_glQueryCounterEXT,
                /** @export */
                emscripten_glReadBuffer: _emscripten_glReadBuffer,
                /** @export */
                emscripten_glReadPixels: _emscripten_glReadPixels,
                /** @export */
                emscripten_glReleaseShaderCompiler: _emscripten_glReleaseShaderCompiler,
                /** @export */
                emscripten_glRenderbufferStorage: _emscripten_glRenderbufferStorage,
                /** @export */
                emscripten_glRenderbufferStorageMultisample: _emscripten_glRenderbufferStorageMultisample,
                /** @export */
                emscripten_glResumeTransformFeedback: _emscripten_glResumeTransformFeedback,
                /** @export */
                emscripten_glSampleCoverage: _emscripten_glSampleCoverage,
                /** @export */
                emscripten_glSamplerParameterf: _emscripten_glSamplerParameterf,
                /** @export */
                emscripten_glSamplerParameterfv: _emscripten_glSamplerParameterfv,
                /** @export */
                emscripten_glSamplerParameteri: _emscripten_glSamplerParameteri,
                /** @export */
                emscripten_glSamplerParameteriv: _emscripten_glSamplerParameteriv,
                /** @export */
                emscripten_glScissor: _emscripten_glScissor,
                /** @export */
                emscripten_glShaderBinary: _emscripten_glShaderBinary,
                /** @export */
                emscripten_glShaderSource: _emscripten_glShaderSource,
                /** @export */
                emscripten_glStencilFunc: _emscripten_glStencilFunc,
                /** @export */
                emscripten_glStencilFuncSeparate: _emscripten_glStencilFuncSeparate,
                /** @export */
                emscripten_glStencilMask: _emscripten_glStencilMask,
                /** @export */
                emscripten_glStencilMaskSeparate: _emscripten_glStencilMaskSeparate,
                /** @export */
                emscripten_glStencilOp: _emscripten_glStencilOp,
                /** @export */
                emscripten_glStencilOpSeparate: _emscripten_glStencilOpSeparate,
                /** @export */
                emscripten_glTexImage2D: _emscripten_glTexImage2D,
                /** @export */
                emscripten_glTexImage3D: _emscripten_glTexImage3D,
                /** @export */
                emscripten_glTexParameterf: _emscripten_glTexParameterf,
                /** @export */
                emscripten_glTexParameterfv: _emscripten_glTexParameterfv,
                /** @export */
                emscripten_glTexParameteri: _emscripten_glTexParameteri,
                /** @export */
                emscripten_glTexParameteriv: _emscripten_glTexParameteriv,
                /** @export */
                emscripten_glTexStorage2D: _emscripten_glTexStorage2D,
                /** @export */
                emscripten_glTexStorage3D: _emscripten_glTexStorage3D,
                /** @export */
                emscripten_glTexSubImage2D: _emscripten_glTexSubImage2D,
                /** @export */
                emscripten_glTexSubImage3D: _emscripten_glTexSubImage3D,
                /** @export */
                emscripten_glTransformFeedbackVaryings: _emscripten_glTransformFeedbackVaryings,
                /** @export */
                emscripten_glUniform1f: _emscripten_glUniform1f,
                /** @export */
                emscripten_glUniform1fv: _emscripten_glUniform1fv,
                /** @export */
                emscripten_glUniform1i: _emscripten_glUniform1i,
                /** @export */
                emscripten_glUniform1iv: _emscripten_glUniform1iv,
                /** @export */
                emscripten_glUniform1ui: _emscripten_glUniform1ui,
                /** @export */
                emscripten_glUniform1uiv: _emscripten_glUniform1uiv,
                /** @export */
                emscripten_glUniform2f: _emscripten_glUniform2f,
                /** @export */
                emscripten_glUniform2fv: _emscripten_glUniform2fv,
                /** @export */
                emscripten_glUniform2i: _emscripten_glUniform2i,
                /** @export */
                emscripten_glUniform2iv: _emscripten_glUniform2iv,
                /** @export */
                emscripten_glUniform2ui: _emscripten_glUniform2ui,
                /** @export */
                emscripten_glUniform2uiv: _emscripten_glUniform2uiv,
                /** @export */
                emscripten_glUniform3f: _emscripten_glUniform3f,
                /** @export */
                emscripten_glUniform3fv: _emscripten_glUniform3fv,
                /** @export */
                emscripten_glUniform3i: _emscripten_glUniform3i,
                /** @export */
                emscripten_glUniform3iv: _emscripten_glUniform3iv,
                /** @export */
                emscripten_glUniform3ui: _emscripten_glUniform3ui,
                /** @export */
                emscripten_glUniform3uiv: _emscripten_glUniform3uiv,
                /** @export */
                emscripten_glUniform4f: _emscripten_glUniform4f,
                /** @export */
                emscripten_glUniform4fv: _emscripten_glUniform4fv,
                /** @export */
                emscripten_glUniform4i: _emscripten_glUniform4i,
                /** @export */
                emscripten_glUniform4iv: _emscripten_glUniform4iv,
                /** @export */
                emscripten_glUniform4ui: _emscripten_glUniform4ui,
                /** @export */
                emscripten_glUniform4uiv: _emscripten_glUniform4uiv,
                /** @export */
                emscripten_glUniformBlockBinding: _emscripten_glUniformBlockBinding,
                /** @export */
                emscripten_glUniformMatrix2fv: _emscripten_glUniformMatrix2fv,
                /** @export */
                emscripten_glUniformMatrix2x3fv: _emscripten_glUniformMatrix2x3fv,
                /** @export */
                emscripten_glUniformMatrix2x4fv: _emscripten_glUniformMatrix2x4fv,
                /** @export */
                emscripten_glUniformMatrix3fv: _emscripten_glUniformMatrix3fv,
                /** @export */
                emscripten_glUniformMatrix3x2fv: _emscripten_glUniformMatrix3x2fv,
                /** @export */
                emscripten_glUniformMatrix3x4fv: _emscripten_glUniformMatrix3x4fv,
                /** @export */
                emscripten_glUniformMatrix4fv: _emscripten_glUniformMatrix4fv,
                /** @export */
                emscripten_glUniformMatrix4x2fv: _emscripten_glUniformMatrix4x2fv,
                /** @export */
                emscripten_glUniformMatrix4x3fv: _emscripten_glUniformMatrix4x3fv,
                /** @export */
                emscripten_glUnmapBuffer: _emscripten_glUnmapBuffer,
                /** @export */
                emscripten_glUseProgram: _emscripten_glUseProgram,
                /** @export */
                emscripten_glValidateProgram: _emscripten_glValidateProgram,
                /** @export */
                emscripten_glVertexAttrib1f: _emscripten_glVertexAttrib1f,
                /** @export */
                emscripten_glVertexAttrib1fv: _emscripten_glVertexAttrib1fv,
                /** @export */
                emscripten_glVertexAttrib2f: _emscripten_glVertexAttrib2f,
                /** @export */
                emscripten_glVertexAttrib2fv: _emscripten_glVertexAttrib2fv,
                /** @export */
                emscripten_glVertexAttrib3f: _emscripten_glVertexAttrib3f,
                /** @export */
                emscripten_glVertexAttrib3fv: _emscripten_glVertexAttrib3fv,
                /** @export */
                emscripten_glVertexAttrib4f: _emscripten_glVertexAttrib4f,
                /** @export */
                emscripten_glVertexAttrib4fv: _emscripten_glVertexAttrib4fv,
                /** @export */
                emscripten_glVertexAttribDivisor: _emscripten_glVertexAttribDivisor,
                /** @export */
                emscripten_glVertexAttribDivisorANGLE: _emscripten_glVertexAttribDivisorANGLE,
                /** @export */
                emscripten_glVertexAttribDivisorARB: _emscripten_glVertexAttribDivisorARB,
                /** @export */
                emscripten_glVertexAttribDivisorEXT: _emscripten_glVertexAttribDivisorEXT,
                /** @export */
                emscripten_glVertexAttribDivisorNV: _emscripten_glVertexAttribDivisorNV,
                /** @export */
                emscripten_glVertexAttribI4i: _emscripten_glVertexAttribI4i,
                /** @export */
                emscripten_glVertexAttribI4iv: _emscripten_glVertexAttribI4iv,
                /** @export */
                emscripten_glVertexAttribI4ui: _emscripten_glVertexAttribI4ui,
                /** @export */
                emscripten_glVertexAttribI4uiv: _emscripten_glVertexAttribI4uiv,
                /** @export */
                emscripten_glVertexAttribIPointer: _emscripten_glVertexAttribIPointer,
                /** @export */
                emscripten_glVertexAttribPointer: _emscripten_glVertexAttribPointer,
                /** @export */
                emscripten_glViewport: _emscripten_glViewport,
                /** @export */
                emscripten_glWaitSync: _emscripten_glWaitSync,
                /** @export */
                emscripten_has_asyncify: _emscripten_has_asyncify,
                /** @export */
                emscripten_num_logical_cores: _emscripten_num_logical_cores,
                /** @export */
                emscripten_out: _emscripten_out,
                /** @export */
                emscripten_promise_create: _emscripten_promise_create,
                /** @export */
                emscripten_promise_destroy: _emscripten_promise_destroy,
                /** @export */
                emscripten_promise_resolve: _emscripten_promise_resolve,
                /** @export */
                emscripten_request_fullscreen_strategy: _emscripten_request_fullscreen_strategy,
                /** @export */
                emscripten_request_pointerlock: _emscripten_request_pointerlock,
                /** @export */
                emscripten_resize_heap: _emscripten_resize_heap,
                /** @export */
                emscripten_runtime_keepalive_check: _emscripten_runtime_keepalive_check,
                /** @export */
                emscripten_sample_gamepad_data: _emscripten_sample_gamepad_data,
                /** @export */
                emscripten_set_beforeunload_callback_on_thread: _emscripten_set_beforeunload_callback_on_thread,
                /** @export */
                emscripten_set_blur_callback_on_thread: _emscripten_set_blur_callback_on_thread,
                /** @export */
                emscripten_set_canvas_element_size: _emscripten_set_canvas_element_size,
                /** @export */
                emscripten_set_element_css_size: _emscripten_set_element_css_size,
                /** @export */
                emscripten_set_focus_callback_on_thread: _emscripten_set_focus_callback_on_thread,
                /** @export */
                emscripten_set_fullscreenchange_callback_on_thread: _emscripten_set_fullscreenchange_callback_on_thread,
                /** @export */
                emscripten_set_gamepadconnected_callback_on_thread: _emscripten_set_gamepadconnected_callback_on_thread,
                /** @export */
                emscripten_set_gamepaddisconnected_callback_on_thread: _emscripten_set_gamepaddisconnected_callback_on_thread,
                /** @export */
                emscripten_set_keydown_callback_on_thread: _emscripten_set_keydown_callback_on_thread,
                /** @export */
                emscripten_set_keypress_callback_on_thread: _emscripten_set_keypress_callback_on_thread,
                /** @export */
                emscripten_set_keyup_callback_on_thread: _emscripten_set_keyup_callback_on_thread,
                /** @export */
                emscripten_set_main_loop: _emscripten_set_main_loop,
                /** @export */
                emscripten_set_main_loop_timing: _emscripten_set_main_loop_timing,
                /** @export */
                emscripten_set_mousedown_callback_on_thread: _emscripten_set_mousedown_callback_on_thread,
                /** @export */
                emscripten_set_mouseenter_callback_on_thread: _emscripten_set_mouseenter_callback_on_thread,
                /** @export */
                emscripten_set_mouseleave_callback_on_thread: _emscripten_set_mouseleave_callback_on_thread,
                /** @export */
                emscripten_set_mousemove_callback_on_thread: _emscripten_set_mousemove_callback_on_thread,
                /** @export */
                emscripten_set_mouseup_callback_on_thread: _emscripten_set_mouseup_callback_on_thread,
                /** @export */
                emscripten_set_pointerlockchange_callback_on_thread: _emscripten_set_pointerlockchange_callback_on_thread,
                /** @export */
                emscripten_set_resize_callback_on_thread: _emscripten_set_resize_callback_on_thread,
                /** @export */
                emscripten_set_touchcancel_callback_on_thread: _emscripten_set_touchcancel_callback_on_thread,
                /** @export */
                emscripten_set_touchend_callback_on_thread: _emscripten_set_touchend_callback_on_thread,
                /** @export */
                emscripten_set_touchmove_callback_on_thread: _emscripten_set_touchmove_callback_on_thread,
                /** @export */
                emscripten_set_touchstart_callback_on_thread: _emscripten_set_touchstart_callback_on_thread,
                /** @export */
                emscripten_set_visibilitychange_callback_on_thread: _emscripten_set_visibilitychange_callback_on_thread,
                /** @export */
                emscripten_set_wheel_callback_on_thread: _emscripten_set_wheel_callback_on_thread,
                /** @export */
                emscripten_set_window_title: _emscripten_set_window_title,
                /** @export */
                emscripten_sleep: _emscripten_sleep,
                /** @export */
                emscripten_unwind_to_js_event_loop: _emscripten_unwind_to_js_event_loop,
                /** @export */
                emscripten_webgl_create_context: _emscripten_webgl_create_context,
                /** @export */
                emscripten_webgl_destroy_context: _emscripten_webgl_destroy_context,
                /** @export */
                emscripten_webgl_make_context_current: _emscripten_webgl_make_context_current,
                /** @export */
                environ_get: _environ_get,
                /** @export */
                environ_sizes_get: _environ_sizes_get,
                /** @export */
                exit: _exit,
                /** @export */
                getaddrinfo: _getaddrinfo,
                /** @export */
                getentropy: _getentropy,
                /** @export */
                getnameinfo: _getnameinfo,
                /** @export */
                invoke_ii,
                /** @export */
                invoke_iii,
                /** @export */
                invoke_iiii,
                /** @export */
                invoke_iiiii,
                /** @export */
                invoke_iiiiiii,
                /** @export */
                invoke_iiiiiiiiii,
                /** @export */
                invoke_v,
                /** @export */
                invoke_vi,
                /** @export */
                invoke_vii,
                /** @export */
                invoke_viii,
                /** @export */
                invoke_viiii,
                /** @export */
                invoke_viiiiiiiii,
                /** @export */
                memory: wasmMemory,
                /** @export */
                proc_exit: _proc_exit,
                /** @export */
                strftime: _strftime,
                /** @export */
                strftime_l: _strftime_l
            };
        }
        var wasmExports = createWasm();
        var ___wasm_call_ctors = createExportWrapper('__wasm_call_ctors', 0);
        var ___getTypeName = createExportWrapper('__getTypeName', 1);
        var __embind_initialize_bindings = createExportWrapper('_embind_initialize_bindings', 0);
        var _main = Module['_main'] = createExportWrapper('__main_argc_argv', 2);
        var _pthread_self = () => (_pthread_self = wasmExports['pthread_self'])();
        var _wasmfs_create_externalfs_backend = createExportWrapper('wasmfs_create_externalfs_backend', 1);
        var _free = createExportWrapper('free', 1);
        var _malloc = createExportWrapper('malloc', 1);
        var _fflush = createExportWrapper('fflush', 1);
        var _ntohs = createExportWrapper('ntohs', 1);
        var _htons = createExportWrapper('htons', 1);
        var __emscripten_tls_init = createExportWrapper('_emscripten_tls_init', 0);
        var _emscripten_builtin_memalign = createExportWrapper('emscripten_builtin_memalign', 2);
        var __emscripten_proxy_main = Module['__emscripten_proxy_main'] = createExportWrapper('_emscripten_proxy_main', 2);
        var _emscripten_stack_get_base = () => (_emscripten_stack_get_base = wasmExports['emscripten_stack_get_base'])();
        var _emscripten_stack_get_end = () => (_emscripten_stack_get_end = wasmExports['emscripten_stack_get_end'])();
        var __emscripten_run_callback_on_thread = createExportWrapper('_emscripten_run_callback_on_thread', 5);
        var __emscripten_set_offscreencanvas_size_on_thread = createExportWrapper('_emscripten_set_offscreencanvas_size_on_thread', 4);
        var __emscripten_thread_init = createExportWrapper('_emscripten_thread_init', 6);
        var __emscripten_thread_crashed = createExportWrapper('_emscripten_thread_crashed', 0);
        var _emscripten_main_thread_process_queued_calls = createExportWrapper('emscripten_main_thread_process_queued_calls', 0);
        var _htonl = createExportWrapper('htonl', 1);
        var _emscripten_proxy_execute_queue = createExportWrapper('emscripten_proxy_execute_queue', 1);
        var _emscripten_main_runtime_thread_id = createExportWrapper('emscripten_main_runtime_thread_id', 0);
        var _emscripten_proxy_finish = createExportWrapper('emscripten_proxy_finish', 1);
        var __emscripten_run_on_main_thread_js = createExportWrapper('_emscripten_run_on_main_thread_js', 5);
        var __emscripten_thread_free_data = createExportWrapper('_emscripten_thread_free_data', 1);
        var __emscripten_thread_exit = createExportWrapper('_emscripten_thread_exit', 1);
        var __emscripten_check_mailbox = createExportWrapper('_emscripten_check_mailbox', 0);
        var _setThrew = createExportWrapper('setThrew', 2);
        var _emscripten_stack_init = () => (_emscripten_stack_init = wasmExports['emscripten_stack_init'])();
        var _emscripten_stack_set_limits = (a0, a1) => (_emscripten_stack_set_limits = wasmExports['emscripten_stack_set_limits'])(a0, a1);
        var _emscripten_stack_get_free = () => (_emscripten_stack_get_free = wasmExports['emscripten_stack_get_free'])();
        var __emscripten_stack_restore = (a0) => (__emscripten_stack_restore = wasmExports['_emscripten_stack_restore'])(a0);
        var __emscripten_stack_alloc = (a0) => (__emscripten_stack_alloc = wasmExports['_emscripten_stack_alloc'])(a0);
        var _emscripten_stack_get_current = () => (_emscripten_stack_get_current = wasmExports['emscripten_stack_get_current'])();
        var ___cxa_is_pointer_type = createExportWrapper('__cxa_is_pointer_type', 1);
        var __wasmfs_externalfs_record_entry = createExportWrapper('_wasmfs_externalfs_record_entry', 3);
        var __wasmfs_read_file = createExportWrapper('_wasmfs_read_file', 1);
        var __wasmfs_write_file = createExportWrapper('_wasmfs_write_file', 3);
        var __wasmfs_mkdir = createExportWrapper('_wasmfs_mkdir', 2);
        var __wasmfs_rmdir = createExportWrapper('_wasmfs_rmdir', 1);
        var __wasmfs_open = createExportWrapper('_wasmfs_open', 3);
        var __wasmfs_allocate = createExportWrapper('_wasmfs_allocate', 3);
        var __wasmfs_mknod = createExportWrapper('_wasmfs_mknod', 3);
        var __wasmfs_unlink = createExportWrapper('_wasmfs_unlink', 1);
        var __wasmfs_chdir = createExportWrapper('_wasmfs_chdir', 1);
        var __wasmfs_symlink = createExportWrapper('_wasmfs_symlink', 2);
        var __wasmfs_readlink = createExportWrapper('_wasmfs_readlink', 1);
        var __wasmfs_write = createExportWrapper('_wasmfs_write', 3);
        var __wasmfs_pwrite = createExportWrapper('_wasmfs_pwrite', 4);
        var __wasmfs_chmod = createExportWrapper('_wasmfs_chmod', 2);
        var __wasmfs_fchmod = createExportWrapper('_wasmfs_fchmod', 2);
        var __wasmfs_lchmod = createExportWrapper('_wasmfs_lchmod', 2);
        var __wasmfs_llseek = createExportWrapper('_wasmfs_llseek', 3);
        var __wasmfs_rename = createExportWrapper('_wasmfs_rename', 2);
        var __wasmfs_read = createExportWrapper('_wasmfs_read', 3);
        var __wasmfs_pread = createExportWrapper('_wasmfs_pread', 4);
        var __wasmfs_truncate = createExportWrapper('_wasmfs_truncate', 2);
        var __wasmfs_ftruncate = createExportWrapper('_wasmfs_ftruncate', 2);
        var __wasmfs_close = createExportWrapper('_wasmfs_close', 1);
        var __wasmfs_mmap = createExportWrapper('_wasmfs_mmap', 5);
        var __wasmfs_msync = createExportWrapper('_wasmfs_msync', 3);
        var __wasmfs_munmap = createExportWrapper('_wasmfs_munmap', 2);
        var __wasmfs_utime = createExportWrapper('_wasmfs_utime', 3);
        var __wasmfs_stat = createExportWrapper('_wasmfs_stat', 2);
        var __wasmfs_lstat = createExportWrapper('_wasmfs_lstat', 2);
        var __wasmfs_mount = createExportWrapper('_wasmfs_mount', 2);
        var __wasmfs_unmount = createExportWrapper('_wasmfs_unmount', 1);
        var __wasmfs_identify = createExportWrapper('_wasmfs_identify', 1);
        var __wasmfs_readdir_start = createExportWrapper('_wasmfs_readdir_start', 1);
        var __wasmfs_readdir_get = createExportWrapper('_wasmfs_readdir_get', 1);
        var __wasmfs_readdir_finish = createExportWrapper('_wasmfs_readdir_finish', 1);
        var __wasmfs_get_cwd = createExportWrapper('_wasmfs_get_cwd', 0);
        var _wasmfs_create_jsimpl_backend = createExportWrapper('wasmfs_create_jsimpl_backend', 0);
        var _wasmfs_create_memory_backend = createExportWrapper('wasmfs_create_memory_backend', 0);
        var _wasmfs_create_file = createExportWrapper('wasmfs_create_file', 3);
        var _wasmfs_flush = createExportWrapper('wasmfs_flush', 0);
        var _ff_h264_cabac_tables = Module['_ff_h264_cabac_tables'] = 2668796;
        function invoke_ii(index, a1) {
            var sp = stackSave();
            try {
                return getWasmTableEntry(index)(a1);
            }
            catch (e) {
                stackRestore(sp);
                if (e !== e + 0)
                    throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_vii(index, a1, a2) {
            var sp = stackSave();
            try {
                getWasmTableEntry(index)(a1, a2);
            }
            catch (e) {
                stackRestore(sp);
                if (e !== e + 0)
                    throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_iii(index, a1, a2) {
            var sp = stackSave();
            try {
                return getWasmTableEntry(index)(a1, a2);
            }
            catch (e) {
                stackRestore(sp);
                if (e !== e + 0)
                    throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_iiiii(index, a1, a2, a3, a4) {
            var sp = stackSave();
            try {
                return getWasmTableEntry(index)(a1, a2, a3, a4);
            }
            catch (e) {
                stackRestore(sp);
                if (e !== e + 0)
                    throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_iiii(index, a1, a2, a3) {
            var sp = stackSave();
            try {
                return getWasmTableEntry(index)(a1, a2, a3);
            }
            catch (e) {
                stackRestore(sp);
                if (e !== e + 0)
                    throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_viiiiiiiii(index, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
            var sp = stackSave();
            try {
                getWasmTableEntry(index)(a1, a2, a3, a4, a5, a6, a7, a8, a9);
            }
            catch (e) {
                stackRestore(sp);
                if (e !== e + 0)
                    throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_viii(index, a1, a2, a3) {
            var sp = stackSave();
            try {
                getWasmTableEntry(index)(a1, a2, a3);
            }
            catch (e) {
                stackRestore(sp);
                if (e !== e + 0)
                    throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_viiii(index, a1, a2, a3, a4) {
            var sp = stackSave();
            try {
                getWasmTableEntry(index)(a1, a2, a3, a4);
            }
            catch (e) {
                stackRestore(sp);
                if (e !== e + 0)
                    throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_v(index) {
            var sp = stackSave();
            try {
                getWasmTableEntry(index)();
            }
            catch (e) {
                stackRestore(sp);
                if (e !== e + 0)
                    throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_iiiiiiiiii(index, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
            var sp = stackSave();
            try {
                return getWasmTableEntry(index)(a1, a2, a3, a4, a5, a6, a7, a8, a9);
            }
            catch (e) {
                stackRestore(sp);
                if (e !== e + 0)
                    throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_vi(index, a1) {
            var sp = stackSave();
            try {
                getWasmTableEntry(index)(a1);
            }
            catch (e) {
                stackRestore(sp);
                if (e !== e + 0)
                    throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_iiiiiii(index, a1, a2, a3, a4, a5, a6) {
            var sp = stackSave();
            try {
                return getWasmTableEntry(index)(a1, a2, a3, a4, a5, a6);
            }
            catch (e) {
                stackRestore(sp);
                if (e !== e + 0)
                    throw e;
                _setThrew(1, 0);
            }
        }
        // include: postamble.js
        // === Auto-generated postamble setup entry stuff ===
        Module['addRunDependency'] = addRunDependency;
        Module['removeRunDependency'] = removeRunDependency;
        Module['getPromise'] = getPromise;
        Module['FS_createPreloadedFile'] = FS_createPreloadedFile;
        Module['FS_unlink'] = FS_unlink;
        Module['FS_createPath'] = FS_createPath;
        Module['FS_createDataFile'] = FS_createDataFile;
        Module['PThread'] = PThread;
        Module['ExternalFS'] = ExternalFS;
        var missingLibrarySymbols = [
            'writeI53ToI64Clamped',
            'writeI53ToI64Signaling',
            'writeI53ToU64Clamped',
            'writeI53ToU64Signaling',
            'convertI32PairToI53',
            'convertI32PairToI53Checked',
            'convertU32PairToI53',
            'getTempRet0',
            'setTempRet0',
            'growMemory',
            'emscriptenLog',
            'getDynCaller',
            'asmjsMangle',
            'alignMemory',
            'mmapAlloc',
            'getNativeTypeSize',
            'STACK_SIZE',
            'STACK_ALIGN',
            'POINTER_SIZE',
            'ASSERTIONS',
            'getCFunc',
            'ccall',
            'cwrap',
            'uleb128Encode',
            'sigToWasmTypes',
            'generateFuncType',
            'convertJsFunctionToWasm',
            'getEmptyTableSlot',
            'updateTableMap',
            'getFunctionAddress',
            'addFunction',
            'removeFunction',
            'reallyNegative',
            'unSign',
            'strLen',
            'reSign',
            'formatString',
            'intArrayToString',
            'AsciiToString',
            'fillDeviceOrientationEventData',
            'registerDeviceOrientationEventCallback',
            'fillDeviceMotionEventData',
            'registerDeviceMotionEventCallback',
            'screenOrientation',
            'fillOrientationChangeEventData',
            'registerOrientationChangeEventCallback',
            'hideEverythingExceptGivenElement',
            'restoreHiddenElements',
            'softFullscreenResizeWebGLRenderTarget',
            'registerPointerlockErrorEventCallback',
            'fillBatteryEventData',
            'battery',
            'registerBatteryEventCallback',
            'jsStackTrace',
            'getCallstack',
            'convertPCtoSourceLocation',
            'checkWasiClock',
            'flush_NO_FILESYSTEM',
            'wasiRightsToMuslOFlags',
            'wasiOFlagsToMuslOFlags',
            'createDyncallWrapper',
            'setImmediateWrapped',
            'clearImmediateWrapped',
            'polyfillSetImmediate',
            'idsToPromises',
            'makePromiseCallback',
            'findMatchingCatch',
            'Browser_asyncPrepareDataCounter',
            'wasmfsNodeConvertNodeCode',
            'wasmfsTry',
            'wasmfsNodeFixStat',
            'wasmfsNodeLstat',
            'wasmfsNodeFstat',
            'wasmfsOPFSProxyFinish',
            'wasmfsOPFSGetOrCreateFile',
            'wasmfsOPFSGetOrCreateDir',
            'wasmfsFetchFSProxyFinish',
            'wasmfsFetchFSGetOrCreateFile',
            'wasmfsFetchFSGetOrCreateDir',
            'writeGLArray',
            'emscripten_webgl_destroy_context_before_on_calling_thread',
            'registerWebGlEventCallback',
            'runAndAbortIfError',
            'ALLOC_NORMAL',
            'ALLOC_STACK',
            'allocate',
            'writeStringToMemory',
            'writeAsciiToMemory',
            'setErrNo',
            'demangle',
            'stackTrace',
            'getFunctionArgsName',
            'createJsInvokerSignature',
            'registerInheritedInstance',
            'unregisterInheritedInstance',
            'enumReadValueFromPointer',
            'validateThis',
            'getStringOrSymbol',
            'emval_get_global',
            'emval_returnValue',
            'emval_lookupTypes',
            'emval_addMethodCaller',
        ];
        missingLibrarySymbols.forEach(missingLibrarySymbol);
        var unexportedSymbols = [
            'run',
            'addOnPreRun',
            'addOnInit',
            'addOnPreMain',
            'addOnExit',
            'addOnPostRun',
            'out',
            'err',
            'callMain',
            'abort',
            'wasmMemory',
            'wasmExports',
            'writeStackCookie',
            'checkStackCookie',
            'writeI53ToI64',
            'readI53FromI64',
            'readI53FromU64',
            'MAX_INT53',
            'MIN_INT53',
            'bigintToI53Checked',
            'stackSave',
            'stackRestore',
            'stackAlloc',
            'ptrToString',
            'zeroMemory',
            'exitJS',
            'getHeapMax',
            'abortOnCannotGrowMemory',
            'ENV',
            'MONTH_DAYS_REGULAR',
            'MONTH_DAYS_LEAP',
            'MONTH_DAYS_REGULAR_CUMULATIVE',
            'MONTH_DAYS_LEAP_CUMULATIVE',
            'isLeapYear',
            'ydayFromDate',
            'arraySum',
            'addDays',
            'ERRNO_CODES',
            'ERRNO_MESSAGES',
            'inetPton4',
            'inetNtop4',
            'inetPton6',
            'inetNtop6',
            'readSockaddr',
            'writeSockaddr',
            'DNS',
            'Protocols',
            'Sockets',
            'initRandomFill',
            'randomFill',
            'timers',
            'warnOnce',
            'readEmAsmArgsArray',
            'readEmAsmArgs',
            'runEmAsmFunction',
            'runMainThreadEmAsm',
            'jstoi_q',
            'jstoi_s',
            'getExecutableName',
            'listenOnce',
            'autoResumeAudioContext',
            'dynCall',
            'handleException',
            'keepRuntimeAlive',
            'runtimeKeepalivePush',
            'runtimeKeepalivePop',
            'callUserCallback',
            'maybeExit',
            'asyncLoad',
            'HandleAllocator',
            'wasmTable',
            'noExitRuntime',
            'freeTableIndexes',
            'functionsInTableMap',
            'setValue',
            'getValue',
            'PATH',
            'PATH_FS',
            'UTF8Decoder',
            'UTF8ArrayToString',
            'UTF8ToString',
            'stringToUTF8Array',
            'stringToUTF8',
            'lengthBytesUTF8',
            'intArrayFromString',
            'stringToAscii',
            'UTF16Decoder',
            'UTF16ToString',
            'stringToUTF16',
            'lengthBytesUTF16',
            'UTF32ToString',
            'stringToUTF32',
            'lengthBytesUTF32',
            'stringToNewUTF8',
            'stringToUTF8OnStack',
            'writeArrayToMemory',
            'JSEvents',
            'registerKeyEventCallback',
            'specialHTMLTargets',
            'maybeCStringToJsString',
            'findEventTarget',
            'findCanvasEventTarget',
            'getBoundingClientRect',
            'fillMouseEventData',
            'registerMouseEventCallback',
            'registerWheelEventCallback',
            'registerUiEventCallback',
            'registerFocusEventCallback',
            'fillFullscreenChangeEventData',
            'registerFullscreenChangeEventCallback',
            'JSEvents_requestFullscreen',
            'JSEvents_resizeCanvasForFullscreen',
            'registerRestoreOldStyle',
            'setLetterbox',
            'currentFullscreenStrategy',
            'restoreOldWindowedStyle',
            'doRequestFullscreen',
            'fillPointerlockChangeEventData',
            'registerPointerlockChangeEventCallback',
            'requestPointerLock',
            'fillVisibilityChangeEventData',
            'registerVisibilityChangeEventCallback',
            'registerTouchEventCallback',
            'fillGamepadEventData',
            'registerGamepadEventCallback',
            'registerBeforeUnloadEventCallback',
            'setCanvasElementSizeCallingThread',
            'setOffscreenCanvasSizeOnTargetThread',
            'setCanvasElementSizeMainThread',
            'setCanvasElementSize',
            'getCanvasSizeCallingThread',
            'getCanvasSizeMainThread',
            'getCanvasElementSize',
            'UNWIND_CACHE',
            'ExitStatus',
            'getEnvStrings',
            'safeSetTimeout',
            'promiseMap',
            'makePromise',
            'uncaughtExceptionCount',
            'exceptionLast',
            'exceptionCaught',
            'ExceptionInfo',
            'Browser',
            'setMainLoop',
            'getPreloadedImageData__data',
            'wget',
            'preloadPlugins',
            'FS_modeStringToFlags',
            'FS_getMode',
            'FS_stdin_getChar_buffer',
            'FS_stdin_getChar',
            'FS_createDevice',
            'FS_readFile',
            'MEMFS',
            'wasmFSPreloadedFiles',
            'wasmFSPreloadedDirs',
            'wasmFSPreloadingFlushed',
            'wasmFSDevices',
            'wasmFSDeviceStreams',
            'FS',
            'FS_mknod',
            'FS_create',
            'FS_writeFile',
            'FS_mkdir',
            'FS_mkdirTree',
            'wasmFS$JSMemoryFiles',
            'wasmFS$backends',
            'wasmfsNodeIsWindows',
            'wasmfsOPFSDirectoryHandles',
            'wasmfsOPFSFileHandles',
            'wasmfsOPFSAccessHandles',
            'wasmfsOPFSBlobs',
            'wasmfsExternalFSDirectoryHandles',
            'wasmfsExternalFSFileHandles',
            'wasmfsExternalFSAccessHandles',
            'wasmfsExternalFSBlobs',
            'wasmfsExternalFSProxyFinish',
            'wasmfsExternalFSGetOrCreateFile',
            'wasmfsExternalFSGetOrCreateDir',
            'wasmfsFetchFSHandles',
            'wasmfsFetchFSBlobs',
            'tempFixedLengthArray',
            'miniTempWebGLFloatBuffers',
            'miniTempWebGLIntBuffers',
            'heapObjectForWebGLType',
            'toTypedArrayIndex',
            'webgl_enable_ANGLE_instanced_arrays',
            'webgl_enable_OES_vertex_array_object',
            'webgl_enable_WEBGL_draw_buffers',
            'webgl_enable_WEBGL_multi_draw',
            'GL',
            'emscriptenWebGLGet',
            'computeUnpackAlignedImageSize',
            'colorChannelsInGlTextureFormat',
            'emscriptenWebGLGetTexPixelData',
            'emscriptenWebGLGetUniform',
            'webglGetUniformLocation',
            'webglPrepareUniformLocationsBeforeFirstUse',
            'webglGetLeftBracePos',
            'emscriptenWebGLGetVertexAttrib',
            '__glGetActiveAttribOrUniform',
            'emscriptenWebGLGetBufferBinding',
            'emscriptenWebGLValidateMapBufferTarget',
            'AL',
            'GLUT',
            'EGL',
            'GLEW',
            'IDBStore',
            'SDL',
            'SDL_gfx',
            'emscriptenWebGLGetIndexed',
            'webgl_enable_WEBGL_draw_instanced_base_vertex_base_instance',
            'webgl_enable_WEBGL_multi_draw_instanced_base_vertex_base_instance',
            'allocateUTF8',
            'allocateUTF8OnStack',
            'print',
            'printErr',
            'terminateWorker',
            'killThread',
            'cleanupThread',
            'registerTLSInit',
            'cancelThread',
            'spawnThread',
            'exitOnMainThread',
            'proxyToMainThread',
            'proxiedJSCallArgs',
            'invokeEntryPoint',
            'checkMailbox',
            'InternalError',
            'BindingError',
            'throwInternalError',
            'throwBindingError',
            'registeredTypes',
            'awaitingDependencies',
            'typeDependencies',
            'tupleRegistrations',
            'structRegistrations',
            'sharedRegisterType',
            'whenDependentTypesAreResolved',
            'embind_charCodes',
            'embind_init_charCodes',
            'readLatin1String',
            'getTypeName',
            'getFunctionName',
            'heap32VectorToArray',
            'requireRegisteredType',
            'usesDestructorStack',
            'createJsInvoker',
            'UnboundTypeError',
            'PureVirtualError',
            'GenericWireTypeSize',
            'EmValType',
            'init_embind',
            'throwUnboundTypeError',
            'ensureOverloadTable',
            'exposePublicSymbol',
            'replacePublicSymbol',
            'extendError',
            'createNamedFunction',
            'embindRepr',
            'registeredInstances',
            'getBasestPointer',
            'getInheritedInstance',
            'getInheritedInstanceCount',
            'getLiveInheritedInstances',
            'registeredPointers',
            'registerType',
            'integerReadValueFromPointer',
            'floatReadValueFromPointer',
            'readPointer',
            'runDestructors',
            'newFunc',
            'craftInvokerFunction',
            'embind__requireFunction',
            'genericPointerToWireType',
            'constNoSmartPtrRawPointerToWireType',
            'nonConstNoSmartPtrRawPointerToWireType',
            'init_RegisteredPointer',
            'RegisteredPointer',
            'RegisteredPointer_fromWireType',
            'runDestructor',
            'releaseClassHandle',
            'finalizationRegistry',
            'detachFinalizer_deps',
            'detachFinalizer',
            'attachFinalizer',
            'makeClassHandle',
            'init_ClassHandle',
            'ClassHandle',
            'throwInstanceAlreadyDeleted',
            'deletionQueue',
            'flushPendingDeletes',
            'delayFunction',
            'setDelayFunction',
            'RegisteredClass',
            'shallowCopyInternalPointer',
            'downcastPointer',
            'upcastPointer',
            'char_0',
            'char_9',
            'makeLegalFunctionName',
            'emval_freelist',
            'emval_handles',
            'emval_symbols',
            'init_emval',
            'count_emval_handles',
            'Emval',
            'emval_methodCallers',
            'reflectConstruct',
        ];
        unexportedSymbols.forEach(unexportedRuntimeSymbol);
        var calledRun;
        dependenciesFulfilled = function runCaller() {
            // If run has never been called, and we should call run (INVOKE_RUN is true, and Module.noInitialRun is not false)
            if (!calledRun)
                run();
            if (!calledRun)
                dependenciesFulfilled = runCaller; // try this again later, after new deps are fulfilled
        };
        function callMain(args = []) {
            assert(runDependencies == 0, 'cannot call main when async dependencies remain! (listen on Module["onRuntimeInitialized"])');
            assert(__ATPRERUN__.length == 0, 'cannot call main when preRun functions remain to be called');
            var entryFunction = __emscripten_proxy_main;
            // With PROXY_TO_PTHREAD make sure we keep the runtime alive until the
            // proxied main calls exit (see exitOnMainThread() for where Pop is called).
            runtimeKeepalivePush();
            args.unshift(thisProgram);
            var argc = args.length;
            var argv = stackAlloc((argc + 1) * 4);
            var argv_ptr = argv;
            args.forEach((arg) => {
                HEAPU32[((argv_ptr) >> 2)] = stringToUTF8OnStack(arg);
                argv_ptr += 4;
            });
            HEAPU32[((argv_ptr) >> 2)] = 0;
            try {
                var ret = entryFunction(argc, argv);
                // if we're not running an evented main loop, it's time to exit
                exitJS(ret, /* implicit = */ true);
                return ret;
            }
            catch (e) {
                return handleException(e);
            }
        }
        function stackCheckInit() {
            // This is normally called automatically during __wasm_call_ctors but need to
            // get these values before even running any of the ctors so we call it redundantly
            // here.
            // See $establishStackSpace for the equivalent code that runs on a thread
            assert(!ENVIRONMENT_IS_PTHREAD);
            _emscripten_stack_init();
            // TODO(sbc): Move writeStackCookie to native to to avoid this.
            writeStackCookie();
        }
        function run(args = arguments_) {
            if (runDependencies > 0) {
                return;
            }
            if (!ENVIRONMENT_IS_PTHREAD)
                stackCheckInit();
            if (ENVIRONMENT_IS_PTHREAD) {
                // The promise resolve function typically gets called as part of the execution
                // of `doRun` below. The workers/pthreads don't execute `doRun` so the
                // creation promise can be resolved, marking the pthread-Module as initialized.
                readyPromiseResolve(Module);
                initRuntime();
                startWorker(Module);
                return;
            }
            preRun();
            // a preRun added a dependency, run will be called later
            if (runDependencies > 0) {
                return;
            }
            function doRun() {
                // run may have just been called through dependencies being fulfilled just in this very frame,
                // or while the async setStatus time below was happening
                if (calledRun)
                    return;
                calledRun = true;
                Module['calledRun'] = true;
                if (ABORT)
                    return;
                initRuntime();
                preMain();
                readyPromiseResolve(Module);
                Module['onRuntimeInitialized']?.();
                if (shouldRunNow)
                    callMain(args);
                postRun();
            }
            if (Module['setStatus']) {
                Module['setStatus']('Running...');
                setTimeout(function () {
                    setTimeout(function () {
                        Module['setStatus']('');
                    }, 1);
                    doRun();
                }, 1);
            }
            else {
                doRun();
            }
            checkStackCookie();
        }
        function checkUnflushedContent() {
            // Compiler settings do not allow exiting the runtime, so flushing
            // the streams is not possible. but in ASSERTIONS mode we check
            // if there was something to flush, and if so tell the user they
            // should request that the runtime be exitable.
            // Normally we would not even include flush() at all, but in ASSERTIONS
            // builds we do so just for this check, and here we see if there is any
            // content to flush, that is, we check if there would have been
            // something a non-ASSERTIONS build would have not seen.
            // How we flush the streams depends on whether we are in SYSCALLS_REQUIRE_FILESYSTEM=0
            // mode (which has its own special function for this; otherwise, all
            // the code is inside libc)
            var oldOut = out;
            var oldErr = err;
            var has = false;
            out = err = (x) => {
                has = true;
            };
            try { // it doesn't matter if it fails
                // In WasmFS we must also flush the WasmFS internal buffers, for this check
                // to work.
                _wasmfs_flush();
            }
            catch (e) { }
            out = oldOut;
            err = oldErr;
            if (has) {
                warnOnce('stdio streams had content in them that was not flushed. you should set EXIT_RUNTIME to 1 (see the Emscripten FAQ), or make sure to emit a newline when you printf etc.');
                warnOnce('(this may also be due to not including full filesystem support - try building with -sFORCE_FILESYSTEM)');
            }
        }
        if (Module['preInit']) {
            if (typeof Module['preInit'] == 'function')
                Module['preInit'] = [Module['preInit']];
            while (Module['preInit'].length > 0) {
                Module['preInit'].pop()();
            }
        }
        // shouldRunNow refers to calling main(), not run().
        var shouldRunNow = true;
        if (Module['noInitialRun'])
            shouldRunNow = false;
        run();
        // end include: postamble.js
        // include: postamble_modularize.js
        // In MODULARIZE mode we wrap the generated code in a factory function
        // and return either the Module itself, or a promise of the module.
        //
        // We assign to the `moduleRtn` global here and configure closure to see
        // this as and extern so it won't get minified.
        moduleRtn = readyPromise;
        // Assertion for attempting to access module properties on the incoming
        // moduleArg.  In the past we used this object as the prototype of the module
        // and assigned properties to it, but now we return a distinct object.  This
        // keeps the instance private until it is ready (i.e the promise has been
        // resolved).
        for (const prop of Object.keys(Module)) {
            if (!(prop in moduleArg)) {
                Object.defineProperty(moduleArg, prop, {
                    configurable: true,
                    get() {
                        abort(`Access to module property ('${prop}') is no longer possible via the module constructor argument; Instead, use the result of the module constructor.`);
                    }
                });
            }
        }
        // end include: postamble_modularize.js
        return moduleRtn;
    });
})();
if (typeof exports === 'object' && typeof module === 'object')
    module.exports = libmpvLoader;
else if (typeof define === 'function' && define['amd'])
    define([], () => libmpvLoader);
var isPthread = globalThis.self?.name === 'em-pthread';
// When running as a pthread, construct a new instance on startup
isPthread && libmpvLoader();
